/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(170);
	module.exports = __webpack_require__(174);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 2 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(13);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function warning(condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(190);


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var DOMProperty = __webpack_require__(27);
	var ReactDOMComponentFlags = __webpack_require__(100);
	
	var invariant = __webpack_require__(1);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID == null) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(169);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(19);
	
	var warning = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(117);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.createElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	
	    // Create dummy `key` and `ref` property to `props` to warn users against its use
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingKey.isReactWarning = true;
	
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingRef.isReactWarning = true;
	
	    if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	      if (!props.hasOwnProperty('key')) {
	        Object.defineProperty(props, 'key', {
	          get: warnAboutAccessingKey,
	          configurable: true
	        });
	      }
	      if (!props.hasOwnProperty('ref')) {
	        Object.defineProperty(props, 'ref', {
	          get: warnAboutAccessingRef,
	          configurable: true
	        });
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.cloneElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(95);
	var PooledClass = __webpack_require__(18);
	var ReactFeatureFlags = __webpack_require__(106);
	var ReactReconciler = __webpack_require__(23);
	var Transaction = __webpack_require__(33);
	
	var invariant = __webpack_require__(1);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(43);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(13);
	var warning = __webpack_require__(3);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(5);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(215);
	var ReactInstrumentation = __webpack_require__(9);
	
	var warning = __webpack_require__(3);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'mountComponent');
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'mountComponent');
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 25 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(53);
	var setInnerHTML = __webpack_require__(42);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(68);
	var setTextContent = __webpack_require__(123);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var invariant = __webpack_require__(1);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var EventPluginRegistry = __webpack_require__(54);
	var EventPluginUtils = __webpack_require__(55);
	var ReactErrorUtils = __webpack_require__(61);
	
	var accumulateInto = __webpack_require__(116);
	var forEachAccumulated = __webpack_require__(118);
	var invariant = __webpack_require__(1);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(15);
	var EventPluginHub = __webpack_require__(29);
	var EventPluginUtils = __webpack_require__(55);
	
	var accumulateInto = __webpack_require__(116);
	var forEachAccumulated = __webpack_require__(118);
	var warning = __webpack_require__(3);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(71);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(35);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(152);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(17);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 36 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(166);
	
	var _runTransitionHook = __webpack_require__(50);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(22);
	
	var _deprecate = __webpack_require__(49);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventConstants = __webpack_require__(15);
	var EventPluginRegistry = __webpack_require__(54);
	var ReactEventEmitterMixin = __webpack_require__(208);
	var ViewportMetrics = __webpack_require__(115);
	
	var getVendorPrefixedEventName = __webpack_require__(239);
	var isEventSupported = __webpack_require__(73);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(32);
	var ViewportMetrics = __webpack_require__(115);
	
	var getEventModifierState = __webpack_require__(70);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	var DOMNamespaces = __webpack_require__(53);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(68);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var newNodes = reusableSVGContainer.firstChild.childNodes;
	    for (var i = 0; i < newNodes.length; i++) {
	      node.appendChild(newNodes[i]);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 44 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(5);
	
	var _deprecateObjectProperties = __webpack_require__(35);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(21);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _Actions = __webpack_require__(25);
	
	var _computeChangedRoutes2 = __webpack_require__(150);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(147);
	
	var _isActive2 = __webpack_require__(154);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(151);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(156);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  function createLocationFromRedirectInfo(location) {
	    return history.createLocation(location, _Actions.REPLACE);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, createLocationFromRedirectInfo(redirectInfo));
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.transitionTo(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(17);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(45);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(24);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(145);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(79);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(139);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(158);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(140);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(141);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(80);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(143);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(138);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(142);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(144);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(157);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(34);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(146);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(155);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(85);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(148);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(149);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(153);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(82);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 51 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	(function () {
	  try {
	    cachedSetTimeout = setTimeout;
	  } catch (e) {
	    cachedSetTimeout = function () {
	      throw new Error('setTimeout is not defined');
	    }
	  }
	  try {
	    cachedClearTimeout = clearTimeout;
	  } catch (e) {
	    cachedClearTimeout = function () {
	      throw new Error('clearTimeout is not defined');
	    }
	  }
	} ())
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = cachedSetTimeout.call(null, cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    cachedClearTimeout.call(null, timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        cachedSetTimeout.call(null, drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(26);
	var Danger = __webpack_require__(185);
	var ReactMultiChildUpdateTypes = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(9);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(68);
	var setInnerHTML = __webpack_require__(42);
	var setTextContent = __webpack_require__(123);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var EventConstants = __webpack_require__(15);
	var ReactErrorUtils = __webpack_require__(61);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 56 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactPropTypes = __webpack_require__(113);
	var ReactPropTypeLocations = __webpack_require__(64);
	var ReactPropTypesSecret = __webpack_require__(65);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactNoopUpdateQueue = __webpack_require__(62);
	
	var canDefineProperty = __webpack_require__(117);
	var emptyObject = __webpack_require__(28);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var invariant = __webpack_require__(1);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentTreeDevtool
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactCurrentOwner = __webpack_require__(19);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var tree = {};
	var unmountedIDs = {};
	var rootIDs = {};
	
	function updateTree(id, update) {
	  if (!tree[id]) {
	    tree[id] = {
	      element: null,
	      parentID: null,
	      ownerID: null,
	      text: null,
	      childIDs: [],
	      displayName: 'Unknown',
	      isMounted: false,
	      updateCount: 0
	    };
	  }
	  update(tree[id]);
	}
	
	function purgeDeep(id) {
	  var item = tree[id];
	  if (item) {
	    var childIDs = item.childIDs;
	
	    delete tree[id];
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeDevtool.getDisplayName(id);
	  var element = ReactComponentTreeDevtool.getElement(id);
	  var ownerID = ReactComponentTreeDevtool.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeDevtool.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeDevtool: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeDevtool = {
	  onSetDisplayName: function (id, displayName) {
	    updateTree(id, function (item) {
	      return item.displayName = displayName;
	    });
	  },
	  onSetChildren: function (id, nextChildIDs) {
	    updateTree(id, function (item) {
	      item.childIDs = nextChildIDs;
	
	      nextChildIDs.forEach(function (nextChildID) {
	        var nextChild = tree[nextChildID];
	        !nextChild ?  false ? invariant(false, 'Expected devtool events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('68') : void 0;
	        !(nextChild.displayName != null) ?  false ? invariant(false, 'Expected onSetDisplayName() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('69') : void 0;
	        !(nextChild.childIDs != null || nextChild.text != null) ?  false ? invariant(false, 'Expected onSetChildren() or onSetText() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('70') : void 0;
	        !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	        if (nextChild.parentID == null) {
	          nextChild.parentID = id;
	          // TODO: This shouldn't be necessary but mounting a new root during in
	          // componentWillMount currently causes not-yet-mounted components to
	          // be purged from our tree data so their parent ID is missing.
	        }
	        !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onSetParent() and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('72', nextChildID, nextChild.parentID, id) : void 0;
	      });
	    });
	  },
	  onSetOwner: function (id, ownerID) {
	    updateTree(id, function (item) {
	      return item.ownerID = ownerID;
	    });
	  },
	  onSetParent: function (id, parentID) {
	    updateTree(id, function (item) {
	      return item.parentID = parentID;
	    });
	  },
	  onSetText: function (id, text) {
	    updateTree(id, function (item) {
	      return item.text = text;
	    });
	  },
	  onBeforeMountComponent: function (id, element) {
	    updateTree(id, function (item) {
	      return item.element = element;
	    });
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    updateTree(id, function (item) {
	      return item.element = element;
	    });
	  },
	  onMountComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.isMounted = true;
	    });
	  },
	  onMountRootComponent: function (id) {
	    rootIDs[id] = true;
	  },
	  onUpdateComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.updateCount++;
	    });
	  },
	  onUnmountComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.isMounted = false;
	    });
	    unmountedIDs[id] = true;
	    delete rootIDs[id];
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeDevtool._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var id in unmountedIDs) {
	      purgeDeep(id);
	    }
	    unmountedIDs = {};
	  },
	  isMounted: function (id) {
	    var item = tree[id];
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var type = topElement.type;
	      var name = typeof type === 'function' ? type.displayName || type.name : type;
	      var owner = topElement._owner;
	      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeDevtool.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeDevtool.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = tree[id];
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var item = tree[id];
	    return item ? item.displayName : 'Unknown';
	  },
	  getElement: function (id) {
	    var item = tree[id];
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var item = tree[id];
	    return item ? item.ownerID : null;
	  },
	  getParentID: function (id) {
	    var item = tree[id];
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = tree[id];
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var item = tree[id];
	    return item ? item.text : null;
	  },
	  getUpdateCount: function (id) {
	    var item = tree[id];
	    return item ? item.updateCount : 0;
	  },
	  getRootIDs: function () {
	    return Object.keys(rootIDs);
	  },
	  getRegisteredIDs: function () {
	    return Object.keys(tree);
	  }
	};
	
	module.exports = ReactComponentTreeDevtool;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(43);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 65 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactInstanceMap = __webpack_require__(31);
	var ReactInstrumentation = __webpack_require__(9);
	var ReactUpdates = __webpack_require__(12);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 67 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.0';

/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 70 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 71 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(192);
	var ReactEmptyComponent = __webpack_require__(105);
	var ReactHostComponent = __webpack_require__(107);
	var ReactInstrumentation = __webpack_require__(9);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getDisplayName(instance) {
	  var element = instance._currentElement;
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else if (instance.getName) {
	    return instance.getName() || 'Unknown';
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    if (shouldHaveDebugID) {
	      var debugID = nextDebugID++;
	      instance._debugID = debugID;
	      var displayName = getDisplayName(instance);
	      ReactInstrumentation.debugTool.onSetDisplayName(debugID, displayName);
	      var owner = node && node._owner;
	      if (owner) {
	        ReactInstrumentation.debugTool.onSetOwner(debugID, owner._debugID);
	      }
	    } else {
	      instance._debugID = 0;
	    }
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactElement = __webpack_require__(11);
	
	var getIteratorFn = __webpack_require__(120);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(56);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(13);
	var warning = __webpack_require__(3);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(135);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(131);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _objectAssign = __webpack_require__(134);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstantsJs = __webpack_require__(129);
	
	var _PlainComponent = __webpack_require__(130);
	
	var _PlainComponent2 = _interopRequireDefault(_PlainComponent);
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    var reversedPropsList = [].concat(propsList).reverse();
	
	    for (var i = 0; i < reversedPropsList.length; i++) {
	        var props = reversedPropsList[i];
	
	        if (props[property]) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        return innermostTemplate.replace(/\%s/g, innermostTitle);
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");
	
	    return innermostTitle || innermostDefaultTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getHtmlAttributesFromPropsList = function getHtmlAttributesFromPropsList(propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstantsJs.TAG_NAMES.HTML] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstantsJs.TAG_NAMES.HTML];
	    }).reduce(function (html, current) {
	        return _extends({}, html, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstantsJs.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstantsJs.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    var tagList = propsList.filter(function (props) {
	        return typeof props[tagName] !== "undefined";
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = undefined;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstantsJs.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstantsJs.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstantsJs.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstantsJs.TAG_PROPERTIES.CSS_TEXT)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2["default"])({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	
	    return tagList;
	};
	
	var updateTitle = function updateTitle(title) {
	    document.title = title || document.title;
	};
	
	var updateHtmlAttributes = function updateHtmlAttributes(attributes) {
	    var htmlTag = document.getElementsByTagName("html")[0];
	    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	        htmlTag.setAttribute(attribute, value);
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var i = attributesToRemove.length - 1; i >= 0; i--) {
	        htmlTag.removeAttribute(attributesToRemove[i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else {
	        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = undefined;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === "innerHTML") {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === "cssText") {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
	    var keys = Object.keys(attributes);
	    var attributeString = "";
	
	    for (var i = 0; i < keys.length; i++) {
	        var attribute = keys[i];
	        var attr = typeof attributes[attribute] !== "undefined" ? attribute + "=\"" + attributes[attribute] + "\"" : "" + attribute;
	        attributeString += attr + " ";
	    }
	
	    return attributeString.trim();
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title) {
	    var stringifiedMarkup = "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	
	    return stringifiedMarkup;
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    var stringifiedMarkup = tags.map(function (tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === "innerHTML" || attribute === "cssText");
	        }).map(function (attribute) {
	            if (typeof tag[attribute] === "undefined") {
	                return attribute;
	            }
	
	            var encodedValue = encodeSpecialCharacters(tag[attribute]);
	            return attribute + "=\"" + encodedValue + "\"";
	        }).join(" ").trim();
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        return "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (type === _HelmetConstantsJs.TAG_NAMES.SCRIPT || type === _HelmetConstantsJs.TAG_NAMES.STYLE ? ">" + tagContent + "</" + type + ">" : "/>");
	    }).join("");
	
	    return stringifiedMarkup;
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title) {
	    // assigning into an array to define toString function on it
	    var component = [_react2["default"].createElement(_HelmetConstantsJs.TAG_NAMES.TITLE, _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true), title)];
	
	    return component;
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    /* eslint-disable react/display-name */
	    var component = tags.map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstantsJs.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2["default"].createElement(type, mappedTag);
	    });
	
	    return component;
	    /* eslint-enable react/display-name */
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    switch (type) {
	        case _HelmetConstantsJs.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags);
	                }
	            };
	        case _HelmetConstantsJs.TAG_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return tags;
	                },
	                toString: function toString() {
	                    return generateHtmlAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var htmlAttributes = _ref.htmlAttributes;
	    var title = _ref.title;
	    var baseTag = _ref.baseTag;
	    var metaTags = _ref.metaTags;
	    var linkTags = _ref.linkTags;
	    var scriptTags = _ref.scriptTags;
	    var styleTags = _ref.styleTags;
	    return {
	        htmlAttributes: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.HTML, htmlAttributes),
	        title: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.TITLE, title),
	        base: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags),
	        style: getMethodsForTag(_HelmetConstantsJs.TAG_NAMES.STYLE, styleTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    /* eslint-disable react/no-multi-comp */
	
	    var HelmetWrapper = (function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            _get(Object.getPrototypeOf(HelmetWrapper.prototype), "constructor", this).apply(this, arguments);
	        }
	
	        /* eslint-enable react/no-multi-comp */
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2["default"])(this.props, nextProps);
	            }
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2["default"].createElement(Component, this.props);
	            }
	        }], [{
	            key: "propTypes",
	
	            /**
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {String} title: "Title"
	             * @param {String} defaultTitle: "Default Title"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             */
	            value: {
	                htmlAttributes: _react2["default"].PropTypes.object,
	                title: _react2["default"].PropTypes.string,
	                defaultTitle: _react2["default"].PropTypes.string,
	                titleTemplate: _react2["default"].PropTypes.string,
	                base: _react2["default"].PropTypes.object,
	                meta: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                link: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                script: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                style: _react2["default"].PropTypes.arrayOf(_react2["default"].PropTypes.object),
	                onChangeClientState: _react2["default"].PropTypes.func
	            },
	            enumerable: true
	        }, {
	            key: "peek",
	            value: Component.peek,
	            enumerable: true
	        }, {
	            key: "rewind",
	            value: function value() {
	                var mappedState = Component.rewind();
	                if (!mappedState) {
	                    // provide fallback if mappedState is undefined
	                    mappedState = mapStateOnServer({
	                        htmlAttributes: [],
	                        title: "",
	                        baseTag: [],
	                        metaTags: [],
	                        linkTags: [],
	                        scriptTags: [],
	                        styleTags: []
	                    });
	                }
	
	                return mappedState;
	            },
	            enumerable: true
	        }, {
	            key: "canUseDOM",
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    })(_react2["default"].Component);
	
	    return HelmetWrapper;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        htmlAttributes: getHtmlAttributesFromPropsList(propsList),
	        title: getTitleFromPropsList(propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.META, [_HelmetConstantsJs.TAG_PROPERTIES.NAME, _HelmetConstantsJs.TAG_PROPERTIES.CHARSET, _HelmetConstantsJs.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstantsJs.TAG_PROPERTIES.PROPERTY], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.LINK, [_HelmetConstantsJs.TAG_PROPERTIES.REL, _HelmetConstantsJs.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.SCRIPT, [_HelmetConstantsJs.TAG_PROPERTIES.SRC, _HelmetConstantsJs.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstantsJs.TAG_NAMES.STYLE, [_HelmetConstantsJs.TAG_PROPERTIES.CSS_TEXT], propsList),
	        onChangeClientState: getOnChangeClientState(propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var htmlAttributes = newState.htmlAttributes;
	    var title = newState.title;
	    var baseTag = newState.baseTag;
	    var metaTags = newState.metaTags;
	    var linkTags = newState.linkTags;
	    var scriptTags = newState.scriptTags;
	    var styleTags = newState.styleTags;
	    var onChangeClientState = newState.onChangeClientState;
	
	    updateHtmlAttributes(htmlAttributes);
	
	    updateTitle(title);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstantsJs.TAG_NAMES.BASE, baseTag),
	        metaTags: updateTags(_HelmetConstantsJs.TAG_NAMES.META, metaTags),
	        linkTags: updateTags(_HelmetConstantsJs.TAG_NAMES.LINK, linkTags),
	        scriptTags: updateTags(_HelmetConstantsJs.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstantsJs.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType];
	        var newTags = _tagUpdates$tagType.newTags;
	        var oldTags = _tagUpdates$tagType.oldTags;
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var SideEffect = (0, _reactSideEffect2["default"])(reducePropsToState, handleClientStateChange, mapStateOnServer);
	
	// PlainComponent is used to be a blank component decorated by react-side-effect
	exports["default"] = Helmet(SideEffect(_PlainComponent2["default"]));
	module.exports = exports["default"];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]).isRequired,
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(17);
	
	var _PatternUtils = __webpack_require__(24);
	
	var _InternalPropTypes = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(35);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(37);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(90);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(162);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(85);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(35);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(37);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(90);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(36);
	
	var _DOMUtils = __webpack_require__(48);
	
	var _createHistory = __webpack_require__(89);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(25);
	
	var _PathUtils = __webpack_require__(22);
	
	var _ExecutionEnvironment = __webpack_require__(36);
	
	var _DOMUtils = __webpack_require__(48);
	
	var _DOMStateStorage = __webpack_require__(86);
	
	var _createDOMHistory = __webpack_require__(87);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(163);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(22);
	
	var _AsyncUtils = __webpack_require__(159);
	
	var _Actions = __webpack_require__(25);
	
	var _createLocation2 = __webpack_require__(161);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(50);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(49);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(36);
	
	var _PathUtils = __webpack_require__(22);
	
	var _runTransitionHook = __webpack_require__(50);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(49);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import database from './database';
	
	var stripHtml = function stripHtml(str) {
	  return str.replace(/<(?:.|\n)*?>/gm, '');
	};
	
	var Asin = function (_Component) {
	  _inherits(Asin, _Component);
	
	  function Asin() {
	    _classCallCheck(this, Asin);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Asin).apply(this, arguments));
	  }
	
	  _createClass(Asin, [{
	    key: 'render',
	    value: function render() {
	      // console.log("this.props.params", this.props.params);
	      // console.log("routeParams are", this.routeParams);
	      // console.log("this.props", this.props);
	      // const imageUrl = `http://images.amazon.com/images/P/${this.props.asin}.01.T.jpg`;
	      var imageUrl = this.props.images.small;
	      if (imageUrl && imageUrl.length) {
	        imageUrl = new URL(imageUrl);
	        imageUrl.protocol = 'https:';
	        imageUrl.host = 'images-na.ssl-images-amazon.com';
	        imageUrl = imageUrl.toString();
	      }
	      // const reviews = [
	      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
	      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
	      // ];
	
	      // filter out comments that start with HTML (or even better, strip the html)
	      // let reviewList = this.props.reviews.slice(0,6).filter((r,i) => !r.startsWith('<')).slice(0,3).map( (r, i) => <li key={i}><div dangerouslySetInnerHTML={{__html: r}} /></li>);
	      var reviewList = this.props.reviews.slice(0, 6).map(function (r, i) {
	        return _react2.default.createElement(
	          'li',
	          { key: i },
	          _react2.default.createElement(
	            'div',
	            null,
	            stripHtml(r)
	          )
	        );
	      });
	
	      // <div className="name">{this.props.name}</div>
	      // <div className="price">{this.props.price}</div>
	
	      var url = '/asin/' + this.props.asin;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: url },
	          _react2.default.createElement('img', { role: 'presentation', src: imageUrl }),
	          _react2.default.createElement(
	            'ul',
	            null,
	            reviewList
	          )
	        )
	      );
	    }
	  }]);
	
	  return Asin;
	}(_react.Component);
	
	exports.default = Asin;

/***/ },
/* 92 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"name":"LG WT1101 4.3 Cu. Ft. Ultra Large Capacity High Efficiency Top Load Washer with SlamProof, White","asin":"B009WSPRUE","price":"","stars":"2","reviews":["I had no experience with the high-efficiency washing machines at all. I've spent my life using the cheapest possible Whirlpool type junk (I'd actually purchased a new set at Lowe's a while back; the dryer lasted maybe two years). More recently I'd been in a rental with more typical cheap junk, moldy smelling drum that no amount of bleach, vinegar or airing out could kill, and dryer with a squeaky belt.<br/><br/>We moved, and the new complex did not provide washer/dryers, so we took the plunge and bought the LG WT1101CW and the matching dryer. Even though this is the 'cheapest' version LG makes, it feels and functions like a very well-designed and made machine. (Go into your local Best Buy or whatever, find this model, and just spend some time opening/closing it/touching it. Then go do the same with the lowest-priced similar Samsung--you will feel the difference in build quality.)<br/><br/>I was somewhat apprehensive about making the jump to a high-efficiency washer, and this model in particular, due to some of the following concerns I saw in reviews:<br/><br/>1)  Load becomes easily unbalanced; you have to separate clothes carefully or load the drum carefully; washer spends too much time weighing and rebalancing the load.<br/><br/>VERDICT: None of this is true for me. I've done it all: huge loads, light loads, heavy curtains, a king-sized comforter, a load of throw cushions, five pairs of jeans mixed haphazardly with many small/light items, etc etc etc. It spends a few minutes weighing and spinning the load, and then proceeds to wash it. No problems, no off-balance errors, nada.<br/><br/>2) Clothes don't get clean because there isn't enough water; soap still visible; detergent pacs not dissolving.<br/><br/>VERDICT: Yeah, I have no idea what this is about. I've never had anything come out 'still dry', no soap residue, no pac problems. (I wonder if people are putting the pacs in the tray instead of the drum? they go in the drum, read the bag.) During the wash cycle, since they were brilliant enough to put in a window, I can watch and see that the clothes are getting well-submerged and fully agitated. I'm not sure how anything could remain dry anyway, since it spins the drum under the water source while it's filling up. No soap residue, just fresh clean clothes. Don't forget you need to actually use the 'fabric softener' option if you are using fabric softener (you need an extra rinse). Also remember you don't need to use a ton of HE detergent. Less is actually best.<br/><br/>3) Loads take a long time; or they take longer than timer indicates.<br/><br/>VERDICT: Partially true. They do take longer than a traditional washer.  I feel this is entirely negated by the fact that you can do loads twice as large. Drum is huge and no agitator. And yes, the timer does need some tweaking, but the biggest difference I've seen has been about 10 minutes. I've never seen it stop and re-weigh as some people say.<br/><br/>Overall, I love this washer so much it makes me ENJOY doing laundry. It's very George Jetson, especially if, like me, you'd been using tiny/cheap/smelly old-school washers all your life. There are way too many features to list, but some of my favorites are the see-through and slam-proof lid, the fact that you can keep the lid partially open (the top couple of inches fold down) to help reduce mold, the wide variety of cycle options, the extremely quiet operation, and yes, even the silly little song. And if you have arthritis like me, you will definitely appreciate not having to try to haul out clothes that are tangled tightly around an old-style agitator without banging your hands against the inside of the drum or the agitator.<br/><br/>The matching dryer has many similar conveniences and features, and once you figure out some of the tricks you can avoid the dreaded \"pile of slightly damp and permanently wrinkled clothes you forgot about\". Yes, this will set you back a bit more money than going into Lowe's and buying the cheapest possible old-fashioned GE floor model, but if you do a lot of laundry (and note the 10-year motor warranty!) you should view this as a long-term investment that will make your life a lot easier.<br/><br/>UPDATE March 25 2014: Wow, at the time I wrote this there weren't many reviews on this washer. I guess a portion of people are getting ones with balancing issues. I can say that units without this problem DO exist. FWIW, I had mine installed and delivered by Best Buy.<br/><br/>The review above is still accurate and I do not have any significant \"UE\" issues. (I mean, occasionally if I run an EXTREMELY unbalanced load, but it's rare and easy to fix--no different from if you load a normal washer badly.) The gigantic drum and the extremely fast matching dryer more than offset the longer running time (and you can always use speed load). I still consider this to be an awesome purchase. Also, I've really put this thing through its paces (king size bedding, kitchen rugs, accidentally running it once with a bottle of fabric softener inside (it didn't leak but got very banged up) and it still has no problems.","So I got this top-loading LG HE washer as a replacement for my 14-year-old top-loading Kenmore washer that eventually failed. This LG was the highest rated washer by a leading consumer reports magazine, and that's why I bought it.<br/><br/>Can't say that I am thrilled with this new machine :(<br/><br/>Pros:<br/>Supposedly uses less water and electricity.<br/>Higher spin speed gets more water out, resulting in shorter drying times in dryer.<br/>Quieter, and less vibrations at high RPM.<br/>No need to manually set water level; it supposedly figures the right amount of water to use.<br/>Glass window on top, to see what the washer is actually doing.<br/>No back panel like other washers; easier access to front controls.<br/>Electronic controls (not mechanical dials and knobs).<br/>Clothes look and smell clean after wash, but are they really cleaner? (see cons below).<br/>Larger capacity.<br/>Gentler on clothes.<br/>Gives you an indication of remaing wash time in minutes, that could increase during the cycle depending on certain conditions.<br/>Soft-closing lid (doesn't slam).<br/><br/>Cons:<br/>Takes twice the time for a wash. (So where's the energy savings?)<br/>Does all kinds of rotations with the clothes, without water, to try to balance the load before water-intake.<br/>And still gets out of balance during spin (uE code), and does an unnecessary rinse again (during spin cycle), lengthening wash time, to try to re-balance the load.<br/>The Owner's Manual states\" \"Always try to wash articles of somewhat similar weight to allow the washer to evenly distribute the weight of the load for spinning\" (page 30). Really? What BS! All this because of the higher spin RPM? How do I find something similar in weight to my white bathrobe, as my other whites? It was very, very rare for my old washer to ever go out of balance.<br/>Don't watch the clothes too long via the top glass window, or you might get dizzy.<br/>Absolutely needs HE only detergent.<br/>I've seen the same bathrobe pocket on the top of the other clothes at the beginning of the wash, and at the end of the wash. Sometimes smaller items get enclosed in the bathrobe. Are these indications that the clothes are not moving around properly in the water? Never had this problem in my old, agitator-based washer with sufficient water.<br/><br/>Update:<br/>After a couple of months of use, I called the LG Tech Support to look at why I was getting so many uE (unbalanced load warnings). The technician came by and immediately replaced the rotor (with magnets around it), saying that there was a batch of them that had magnets that were not exactly identical in power causing some issues. Well, I still see uE warnings today. He did not indicate that my machine was not level or anything like that. He did say to avoid the default (cotton/normal) cycle because it uses very little water (to qualify for the washer HE rating), and that tends to cause more instances of unbalanced loads. Use Bright Whites, Pure Color and Bulky/Bedding is what he said.<br/><br/>2nd Update:<br/>The washer is ripping our clothes in a different way than my previous agitator-based washer did.<br/>If I use medium or high spin speed, the wet clothes can occasionally get stretched/pulled during the spin cycle, and this causes rips in strange places. I have to manually switch to use low spin speed with every wash load now, and that negates any energy savings of getting the clothes a little more dry by the higher spin speeds.<br/><br/>3rd Update:<br/>I have figured out a way to get more water in the Pure Colors wash: simply pause the washer once it begins washing, open the lid and push/pull/move the clothes around manually, maybe add an extra item to wash. Then close the lid and resume the wash cycle. In a short while, it will intake more water until the max limit, and continue the wash cycle.<br/>It is a pain to have to do this with every wash, but clothes move more freely and tend to wash better this way, I think.","I purchased this washer in October and think it's awful.  The uneven load error message appears on almost every load and as a result, the machine stops mid-cycle. This machine should be taken off the market and redesigned.  Even when it's working, the normal wash cycle takes 57 minutes.  By the time you shift the clothes around each time the machine stops as a result of the UE error message, it can take 3 or 4 hours to do a single load (assuming you're standing by to fix it every time the machine stops).","First off, I purchased this machine at an actual store and not through Amazon. It is, however, the same model. As I know people check the reviews on Amazon as they research products, I wanted to pass on the knowledge we've gleaned after owning this thing for about a year now. We're a family of 4 and seem to accumulate a rather startling amount of laundry on a weekly basis. This machine has a few \"Pros\", but some major \"Cons\". Be aware before you buy.<br/><br/>Pros:<br/>Huge capacity is great. This machine can eat through our Mount Laundry Hamper in just 2 loads, compared to our previous machine's 4 or 5.<br/>Cleans well. Cold cycle is a plus. I've never had anything go in dirty that didn't come out completely clean. No complaints there.<br/>Very quiet. Our L.R is right off our kitchen so a quiet machine was important to us.<br/>Smooth running. No \"jumping\" or \"walking\" issues. It doesn't even shake the floor during high speed spins. No complaints there either.<br/><br/>BUT.......<br/>Cons:<br/>Nearly impossible to keep loads balanced: machine runs on computerized wizardry that is heck-bent on keeping the machine in balance. If a load shifts during one of the (many) spin and \"back and forth\" cycles (which is a common occurrence), it will throw a \"uE\" code and start refilling with water. Even if you're wash time is down to the final 10 minutes, it may suddenly go off balance and start refilling again, adding an additional 10 to 15 minutes while it attempts to shift the load and balance again. If the \"uE\" attempts to re balance the load fail, you'll get a \"UE\" code which will stop the machine. It will wait patiently for you to come and toss the contents (salad, anyone?) and get it going again.<br/><br/>Once a load starts to throw codes at you, you are in for a long laundry day: seriously, no matter what you do, it will keep throwing the stupid \"UE\" and stopping, or you'll be dealing with constant refilling. I once spent a full 4 hours washing a load of whites. One load. Seriously, true story.<br/><br/>Loads need to be large: That whole Large Capacity thing sure sounds great. However, it's less of a perk and more of a requirement if you want this machine to run well. Too small of a load? Sorry, it won't stay balanced. (Codes galore). Too large of a load? Sorry, won't stay balanced. (Codes galore). I feel like I spend a LOT of my time attempting to find the sweet spot between too small and too big. It's a time wasting endeavor that makes me hate doing the laundry.<br/><br/>Some things refuse to cooperate in there. I can wash quilts. I can wash comforters. But blankets? Forget it. Not gonna happen. Whether I put the blankets in the machine alone or with other \"similar weight items\", ( per the manual's tips), I can anticipate a few hours of good old fashioned code throwing fun.<br/><br/>Manual tips are ridiculous. The manual suggests loading the machine with materials of the same weight; however, in our family, and I would suspect in many families, that makes the load size too small for this demented machine. If you try to mix the fabric weights, you may get the invite to the dreaded Code Party. Some loads go through without a hitch, others are like the ghost of some awful cooking smell that you just can't get rid of. No rhyme or reason to it.<br/><br/>LG Customer Support is no help. I've tried telling them what I'm dealing with. Their response is a chipper \"I can help you with that! Be sure all the loads are of the same weight!\" Thanks. Helpful.<br/><br/>In short, this is the first washing machine that we've owned that I find myself hoping will break. And believe me, we will not attempt to fix it when it does. If I had known how impractical it was at the time we bought it....if I had read the reviews a little more thoroughly, this beastly thing would not be taking up space in my home, or on our credit card, right now.","A fine washing machine this is. Quiet, efficient and thorough. Easy to use. Large enough for bulky comforters. I have nothing bad to say about this machine. I purchased it for $627 before a $40 rebate so it actually cost $587. Clothes come out clean and drier than other machines due to the high spin cycle, and as a consequence, need less time to dry in the dryer. 5 temperature settings and the 8 wash settings are plenty. Extremely happy with my purchase and I highly recommend this product.","UPDATE:  I returned my LG Wt1101 and am returning to a conventional washer with a central agitator. The fact that this huge washer is DESIGNED for small loads and has no effective setting for more typical medium-sized loads was central to my decision. The first thing I did with my new machine was to re-wash many of the clothes I'd done with this LG HE washer because they reeked of soap and fabric softener.<br/><br/>ORIGINAL POST  I've had this washer for two weeks and am still deciding whether to keep it. My complaint, like many other people, is that the water level is so low that clothes are not pulled down into the wash water. After an hour on the phone with a LG technician, I learned this: the different cycles are designed to use different amounts of water. Ignore the given names (e.g. Cotton, Heavy Duty) and think of the cycles in terms water levels.<br/><br/>He said that two cycles, Cotton/Normal and Heavy Duty, are designed to add water only up to 1\" above the silver knob in the center bottom of the tub. That equals 5\" of water measured from the deepest pockets in the bottom of the tub, but an average of only 4\" throughout most of the tub. If you put in more clothes than this, the clothes on top might not get pulled into the water. I put in six long-sleeved t-shirts and the top one did not get pulled down into the water in the Cotton/Normal cycle. Apparently this [stupid] design helps LG qualify for the low water/high efficiency rating on this machine. It would take 54 minutes to wash those six shirts.<br/><br/>Two other cycles, Bright Whites and Pure Color, are designed to add a bit more water. I measured it as 2\" from the top of the silver knob and 6\" from the deepest pockets in the bottom of the tub, averaging about 5\" deep throughout the tub. In addition to the six long-sleeved t-shirts, there was enough water to add three lightweight sweat shirts using the Bright Whites cycle. Together, this load was smaller than what I could do in my old-fashioned 2.4 cubic foot washer with a central agitator. The was cycle was longer than an hour.<br/><br/>One cycle, Bulky Items, is designed to fill the tub and it does. It works well for large loads.<br/><br/>The technician recommended always using small loads and selecting Bright Whites, or using very large loads and selecting Bulky Items, and then manually setting the water temperature, agitation, and spin speed to create the wash I want. There are buttons for water temperature and spin speed; the Soil Level button sets the agitation (more \"soil\" adds more time and uses a stronger agitation; it does not add more water like I thought). There is no easy way to wash a medium-sized load on this machine because the cycles provide too little or too much water.<br/><br/>He also said it's important to use the Fabric Softener button if softener is used in the Cotton/Normal or Heavy Duty cycle (the manual also mentions this). In those cycles, the default setting uses a spray rinse that will not remove fabric softener from the clothes. Again, this is a trick to reduce water consumption in order to qualify for ratings; it does not provide an effective rinse. By pressing the Fabric Softener button, you override that default and the rinse will \"fill\" the tub with water in normal rinse fashion. Apparently the other cycles always \"fill\" the tub during rinse so the Fabric Softener button is not needed for them.<br/><br/>The last thing he said is that the Load Sensing period that occurs before the wash begins is simply an attempt to distribute the clothes evenly; it has nothing to do with judging the weight of the load or assessing how much water will be required.  By the way, I've washed some heavy items and have never encountered the unbalanced load problem that others report. I think the trick is to load the clothes as if there were a central agitator in the middle, spreading items around the edges of the tub.<br/><br/>So the bottom line is this:  this huge capacity washer works best for very small or very large loads, and the \"smart\" specialty cycles need to be overridden for almost every load of laundry.  I'll try a few more loads now that I have this information but I'm not pleased.<br/><br/>One last word of advice: the washer does not have a way to filter and remove lint or dog hair from the water.  I washed a load of dog bedding and then, as I explored this topic of water level, I ran several loads of just water (no clothes) to see how much water entered the tub. Even after filling, spinning, and draining several cycles of water, there still was dog hair floating in the water. The only way to remove it seems to be doing another load of laundry and having it stick to clothes, and then being removed by the dryer. The matching dryer, however, is great at removing lint and dog hair as the clothes tumble dry.","The original washer I had was a top loading agitator-style washer. I was wary of making the jump to high efficiency, after hearing mixed reviews from so many people. Cost was also a concern. I had to buy a new washer AND dryer, and wanted to get the job done for less than $1500.00.<br/><br/>I bought this unit after checking the reviews AND consumer reports. Cons/reports gives this the highest rating for a top loader HE washer. It's easy to see why. While it doesn't clean as thoroughly as I expected (but apparently is excellent for HE washers), it is of very high quality and very intelligent. This unit doesn't feel cheap, and it's whisper quiet. The only major caveat that I have refers to the \"unbalanced load\" issue that so many people have.<br/><br/>If the unit is not exactly level, both side-to-side and front-to-back, it can become unbalanced frequently when running. Simply use a proper level, a dollop of care when adjusting the legs during install, and you should have no issue. It's surprisingly adept, and out of 50 loads, I've only re balanced a load once since properly adjusting the legs.<br/><br/>My other recommendation is this: turn the power ON before adding bleach to the fill cup. If the unit is off, the bleach will just flow into the basin and stain whatever it hits. If the unit is on, it will retain the bleach in the cup until it can blend it in properly.<br/><br/>Finally, this is the most inexpensive HE washer you can find. It's one of those rare deals, and totally worth the money. The matching dryer works fine (nothing exceptional about it). I found that sister machines from LG just offered more content, but considering how loaded this unit is, there's no real need to step up.","I waited a few months before I wrote a review on this product.  I wanted to have time to come to understand how this washer performs and what it's challenges were before I wrote down my thoughts.  I think this is a very good washing machine, not worthy of five stars, but surely worth a solid four stars.<br/><br/>This machine has several cycles ranging from 35 minutes to over an hour.  However, the actual time is longer than the 35 minutes if the load goes into imbalance and the machine resets itself.  This might be frustrating to some but the technology wants the machine to correct itself.  Aside from the wash cycles there are rinse and spin or spin only cycles.  Do not put waterproof items in the washer as it will damage it.<br/><br/>The most prominent thing you will immediately recognize is how quiet this washer is.  Standing next to it you can barely hear it washing.  Spin cycles are a little louder, but if your laundry is on the main floor of your house, the machine will not disrupt your activities.  The machine advertises that it saves water and energy which may be true, but without submetering your water or electricity, it would be tricky to come at a firm number.  The fact that it spins at a high rate of speed (there are four spin settings: high, medium, low, and none) removes a lot of water meaning that your dry times will be faster than a conventional washer with agitator.<br/><br/>To operate the machine simply place your items in the drum and add detergent to the dispenser and select a cycle.  The machine will determine load size and the amount of water needed.  Note that if you fill the machine plumb full, it will likely go into imbalance mode.  If the machine cannot correct the imbalance, it will shut down.  This may lead some people to criticize the design, but keep in mind it is not a commercial washer at a laundromat.  Think through how much you put in the machine and do two loads if necessary.  Again, some will say this will not save as much, but overfilling a conventional washer will not get the clothes clean and cause excessive wear on the motor.  Save yourself the hassle and do not fill the machine barrel more than half way.  It has a large capacity, 4.3 cu. ft. so you can get a lot of clothes in it.<br/><br/>When I was considering a new washer I knew I wanted something different than the old standard agitator machine.  Front loaders seemed too low to the ground if I didn't want to buy the base for an additional $200+ so the choice came down to Samsung or LG.  I settled on LG and have been generally pleased thus far.  I say I'm generally pleased as I have overloaded my machine and had it stop.  I've selected lengthy cycles that seemed to take forever to finish.  I've loaded only towels and had the machine go into imbalance.  I've learned from my earlier mistakes and am not displeased with my choice.  I did purchase a warranty plan from my local appliance dealer because this technology is still relatively new.  I may have wasted my money but it seemed like a good idea at the time.<br/><br/>So four or five months into my ownership of this washer I feel like I've gotten to know this machine relatively well.  Would I buy it again?  Yes.  Would I switch to a different brand?  Not necessarily.  As I said at the start of this review, it is a very good machine, but it's not perfect.  I did not buy this from Amazon as I felt more comfortable buying it from a local dealer who can also service my machine should it need repairs.  I like this machine a lot and do not regret my selection.","I am 63 years old and have had numerous washers through the years. This LG washer is absolutely the worst washer I have ever had. I HATE this washing machine.<br/><br/>We constantly get UE errors (uneven loads) no matter how carefully you mix and spread the loads. A load that should take 45 minutes to complete takes HOURS. It does so because the washer attempts to \"correct\" itself before shutting down by constantly draining, refilling, and re-agitating in an attempt to spread the load to its liking; then another UE is experienced and it drains again, refills, agitates. It continues to repeat this cycling until it finally shuts down. You start it back and it begins this process all over again.<br/><br/>This is the worst designed washing machine surely any company has ever released to the public. Buy it only if you enjoy extreme frustration and high water and electric bills.<br/><br/>This is the last washer I will ever purchase from LG.","After reading the great reviews in consumers, we were happy to get a good deal on this machine.<br/>It looks good, and has a window so you can watch your clothes get washed, for those of you who may not have cable.<br/><br/>What a mistake, I am not normally writing reviews about washers. I dont normally care. But this thing is making me crazy. It needs to be constantly monitored, and even then, it barely works. There are days when only 1 load can get done, because it shuts off constantly. We have tried every setting. Big loads, small loads. different temp water. Lighting candles and chanting. Still, nothing works. I am writing this now because it was either vent in this review, or take an ax to it!<br/>We have owned this washer for over 6 months, so I have given it a fair chance.<br/><br/>Since 10 am this morning (it is now 4pm) it has been on a single load. For the past 3 hours I set it to \"spin only\", at the lowest speed. It said 18 minutes. Every time I walk by its full of water again, or turned off or...I just checked, it says 10 minutes to go! Lets see what its doing in another hour.<br/>Listen, you have many fine choices you can make with your hard earned cash.<br/>This piece of crap should not be on the market, period!<br/>You have been warned."],"images":{"small":"http://ecx.images-amazon.com/images/I/31kl7vTEWNL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31kl7vTEWNL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31kl7vTEWNL.jpg"}},{"name":"Summer Infant Heart to Heart Prenatal Listening System","asin":"B008CH3Y38","price":"$18.43$4.86$5.96","stars":"1.8","reviews":["I've read reviews and seen videos that say all you can hear is crackling. That's all I heard with the headphones that came with the product, but I put my own great quality headphones in and could hear the heartbeat perfectly!!!!","I bought this heart listener at Babies R Us. I am 27 weeks along, can feel the baby move all the time but cannot get the heartbeat on this device no matter what time of the day or what position I am in. I used to own Angelsound which was just as cheap as Summer Infant but actually worked and it worked great. I was able to get the heartbeat any time from 20 weeks all the way through my due date. Angelsound is no longer available on Amazon and I see it for way more now in other stores, not sure what the problem is with such limited availability. I am returning this product tomorrow and asking the person whom I gifted the Angelsound to let me use it again :)<br/>This was also the only model available at BRU, so don't waste your time going there, as that's all the have.<br/><br/>By the way, even the way my own heart sounds on this device is so strange and hard to get when compared to how loud and pronounced it was on the Angelsound that I am not surprised my baby's tiny heart just does not register on this.<br/><br/>UPDATE: just received the Angelsouds back and guess what, I could get the heartbeat the moment I turned it on!","I don't understand all the bad reviews. If your decently intelligent you can figure out how to use it. Yes, you need to lie still and in a quite room but it definitely works. I started using it around 25weeks right up until my 3 day labor. It gave me such peace of mind to be able to just pop in and listen to my sweet girls heartbeat a couple mins every day. Daddy wasn't able to go to all the apts so it was cool that he still got to hear her hb. I highly recommended!! JUST READ AND FOLLOW THE DIRECTIONS PEOPLE!","I was not impressed or satisfied with this product. I bought this when I was 22 weeks pregnant, once I felt the baby moving. I tried using this up to my 39th week, when I gave birth, and I could not hear the baby heartbeat or his movements. The only time I got anything from this product was when my son kicked the product itself. I used it exactly like the instructions said and it was a normal pregnancy, with the placenta placement. So in theory it should have worked, but I just wasn't satisfied with the product results.","Absolute crap. The only way you can hear your baby is to lie completely motionless and silent because the slightest movement causes interference and drowns everything out. Total waste of money. I couldn't be more disgusted.","Puh-lease. The most useless gimmick that somehow still floats in the market when they should have long ago recalled it. Bought it in the second trimester, tried it periodically through the 40th week, and nada. It doesn't work, it has never worked, you can't pick up any sounds including the obvious - tried it on my own heart and still couldn't hear a sound. It is a piece of plastic for $15-20. I don't know how Summer Infant can seriously stand behind this product, seriously.","Sadly, did not work at all. I didn't think it would but I wanted to try it. I could hear my own heartbeat with it but nothing else. I even set it over my baby's hiccups and you heard nothing but static. He even would kick the sensor and you wouldn't hear anything different.","I bought it at Burlington Coat Factory and I got to say it worked great for us! It has many negative reviews that she I got home and read em I thought it was a bad buy, but when we started looking for our little peanuts heart beat we found it and it sounded great!","I got this for me and my sister to share, she is 32 weeks ( I'm no where close to that) but all we could hear was static sounds. No heart beat, not movement just static. We even tried to listen to our own heart beat and nothing.","I bought this from BuyBuyBaby. So far I've heard nothing but my own hands moving across the top of the device. I'm going to try it for 8 more weeks just to see if I get anything... Not too optimistic. Don't waste your money."],"images":{"small":"http://ecx.images-amazon.com/images/I/41BpfZhSIXL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41BpfZhSIXL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41BpfZhSIXL.jpg"}},{"name":"Sonic Blade 7865.00 Cordless Rechargeable Knife","asin":"B000MV055M","price":"$61.99","stars":"2.1","reviews":["We bought this knife after watching many television commercials and were very much attracted to it. It came with two interchangeable knife sets.<br/><br/>It wouldn't cut warm butter no matter how hard we tried to get it to work! When we went to return it or get credit for it the seller never answered us so we just contested our credit card charge and finally got it credited when nobody ever responded to our complaints.<br/><br/>A sham and a ripoff! Maybe Amazon has a better version of this knife.","Disappointing.  The battery life is minimal, it is very clumsy to handle.  I will throw it in the garbage.","The sonic blade is not very powerful. It cuts through bread and very light stuff like cake. But forget trying to cut summer sausage or anything frozen or even hard cheese. Does not cut as seen in the info commercials on TV. Also very heavy and awkward to use when battery keeps slipping out. Very disappointed. Check shipping cost carefully before placing your order. Shipping sometimes is more than product!!","<a class=\"a-link-normal\" href=\"/Sonic-Blade-Electric-Cordless-Knife-As-Seen-on-Tv/dp/B000MSHQ5W/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Sonic Blade Electric Cordless Knife As Seen on Tv</a>This is worst product I have purchased.<br/>Even if the blade worked (it doesn't) it would be awkward and difficult to use - near impossible if you have arthritis in your hands. But the product doesn't do what it claims.  Cutting frozen meat is a fantasy - when it was new it was difficult to even cut fresh meat. About the only thing it was good for was cutting fresh bread.  After a couple of months it doesn't even do that.  The knife does not recharge no matter how long you leave it in the charger. Do yourself a favor and stay away from this product","Despite the bad reviews i still like the sonic blade.I have one and it did work great on most everything.ButI also had the one side of the blade plastic brake off.It still worked though.And i got to warn not to use on hard cheese it was the end it will not work at all after that.But i still like the way it works so i bought another one.When i recieved the new one there was slip with a toll free # saying to call if their were any problems to call.So i did and they are sending a new one.Hopefully they are working on some improvements to this device cause when it does work it works great.NOT ON HARD CHEESE THATS A BIG NO NO.","I got my Sonic Blade in August and have loved it since!  I am a baker, and can't get over how it makes a perfect display of my breads while other knives smash delicate items.  I have not tried to cut frozen food yet, but it made an easy and appetizing way to serve our Thanksgiving turkey.  My favorite use is pineapple coring- it slices through the rind with ease and makes the process MUCH faster/ less tiring than using a regular knife.<br/><br/>I've used it at least two times a week for six months and always machine wash.  I also participate in a revolving dinner group and often pack it up for the host's use if I know they do not have one (although several have purchased after using mine).  Through all of this, it has held up beautifully.  I'm disappointed some reviewers have mentioned broken parts; this has not been my experience at all.  I'll update my review if anything changes!","I have had my Sonic knife for a year or so, and when I needed it, it was there to do what I wanted.  However, the red switch would not stay \"on\".  The plastic holders fell off my rounded blade, and when I called customer service they immediately replaced it no charge.  Months later the plastic holder fell off my sharp blade, called customer service and they not only replaced it, but to my complaint about the red button not holding in place, they sent me a new unit.  Again, no charge.  Can't complain about that..","I've owned a cuisinart electric knife and bought the sonic blade because I burnt out the motor on my cuisinart corded knife trying to cut through a 5 # block of frozen fish (which I don't recommend trying with any electric knife).I've had my sonic blade for about a year now and it works as well as my corded knife except without a pesky cord.","I have used this knife twice so far, the last time at Thanksgiving.  It did a wonderful job on the turkey and it was very nice not to have to deal with a cord.  I have not tried it on beef yet but I think it has enough power to handle that as well. I would definitely recommend this to a friend.","I have never had a better electric knife. My favourite part is that it never tears whatever it is that you are slicing. I have used it on very well done pot roast and the slices were even and held together. I have used it for baked goods as well and had lovely results. I really recommend this product. I love the fact that there is no cord to deal with."],"images":{}},{"name":"Schumacher 1224 12V 235W/150W Ceramic Heater and Fan","asin":"B0066CP998","price":"$29.00","stars":"2","reviews":["This is an excellent heater, if you know how to use it. Anyone who bothers to read the instructions will realize it uses a lot of amps (around 20+ on full). Simply plugging it into your standard cigarette lighter in your 4 banger isn't going to produce any heat, except in your wiring. The wiring to your outlet needs to be AT LEAST as thick as the wire the heater cable is made from - the farther from the battery the outlet is the thicker the wire needs to be. This heater works best wired directly to the battery. I have it installed in a small travel trailer, connected directly to the battery and it produces more heat than expected from a 12v heater, just remember when using this in a car the vehicle needs to be running when using the heater else the battery will soon be flat.","Both the 1 star and the high star reviewers have valid points. It says right in the paperwork for this heater that it draws more than 8 Amps and performance is no good if plugged in to just the cigarette lighter outlet. Requires a heavier duty accessory 12V plug ( as in able to carry more electric power ... sorry i am not an electrician, just a home mechanic hacker). In my case, the heater/defroster went out in my old 2000 Hyundai Elantra, and the car only comes with the cigarette lighter outlet, and sure enuf the Schumacher heater produces virtually no heat thru that outlet. I purchased a 12V accessory outlet from Walmart for 6 bucks, and luckily had enuf heavy electric wire to hardwire the new outlet in my Hyundai directly back from the car battery. The heater now works OK, enuf to give a little warmth to the little cabin of my Hyundai and to clear the fog from the windows in a few minutes, but keep in mind i live in inland northern California around elevation 800 feet, so we're not talking about melting sheets of ice off a windshield, at least not yet this winter. I would have given the heater 4 or 5 stars, but i think it is somewhat deceptive, or at least incomplete disclosure/description, to not state upfront in the product description that this 12V heater does NOT perform adequately at all thru the cigarette lighter outlet !!","I sleep in the back of my F-250 long bed when I go hunt in Alaska. Yes, it's usually raining, and cold. I have a blow up mattress which leaves 2' at the foot of the bed, that's where I put this heater/fan. It makes the back of the bed nice and toasty; during fishing season, it's a fan...nice to have the air flow. I would highly recommnend this! I would NOT recommend their 12v coffee pot, unless you like to wait over an hour for your coffee to brew.","I think this is a great heater, but you have to install correctly. You cannot just plug this into your aux port (cigerette lighter) and have it produce enough heat. You need to wire it directly to your 12v power supply (battery) with a 30 amp fuse.","I had hoped for a little greater heat output but it does the job.  I'm using it in a very small space, a lawn tractor cab.  It will put out enough warm air to justify using it so I'll give it 4 stars.  It seems pretty well constructed overall, the switches seem a little dated in design though.  I don't really care for the fan in it. While it works well enough I think a large computer chassis fan would move the same or more air, with way less noise. I may just modify this thing haha.  I'm using mine connected directly to a 325CCA lawn tractor battery.  Lopped off the cigarette lighter adapter and installed some o-terminals on the wiring.","replace the power cord with 8 gauge wire for best safety and performance works well after modification. before I thoughy about throwing it out the window.","I got this heater for $20. First thing I did was cut the cord and hard wired it (fused) to my battery using 5 feet of 10 gauge cable. The cigarette lighter adapter and thin wire just cannot handle 20A needed for continuous 235W operation. Don't expect to heat a large camper with 150 or 235W. This is only about one tenth the amount of heat of a 120Vac 1500W heater you would use in your house.","Even after directly wiring it to my Jeep's battery (Via 8 gauge wire that I run my 410watt inverter off effortlessly. And yes the inverter was turned off), on its highest heat setting, all I'm accomplishing is annoying myself by the awful rattling sound the fan makes. It produced no heat what so ever, and even then took over 5 minutes to heat up. The build quality is horrible as well, the heating element was completely broken off when it arrived, although that was also an issue with how the product box was packed into the shipping box.<br/><br/>I'd return it for a refund, but since I had to chop the wend of the cord off to hardwire it (Yes, lets plug a 30amp heater into a cigarette lighter socket, that'll work really well. No. Sockets on most cars are only rated for 15amps. I'd know, I'm a mechanic.) So I'm stuck with a paperweight, with a blizzard about to hit my town tonight.","I have to give this a one star.  The only way I could feel any heat from this thing was if I held it up about 1 inch away from my face... then I thought I could feel a little heat coming out of it, but I still wasnt sure.  Sending it back, going to look for something else.","This worked great in the car when the heater decided to die. Have a Audi and to get to the eating core will cost a fortune. Thank you Schumacher for great product. Keeps the front seat of the car warm, brings the temp up a good 10 degrees warmer than out side. Takes a while to defrost the windows."],"images":{"small":"http://ecx.images-amazon.com/images/I/41-6TrpHY0L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41-6TrpHY0L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41-6TrpHY0L.jpg"}},{"name":"Whynter WC-211DZ 21 Bottle Dual Temperature Zone Wine Cooler, Stainless Steel Trimmed Glass Door with Black Cabinet","asin":"B003URQGFI","price":"$281.57","stars":"2.1","reviews":["Purchased the Whynter WC-211DZ 21 bottle wine cooler for a couple of reasons. It was sized right to fit in a space just below my kitchen counter top and the reviews giving Whynter products more favorable ratings over competing products. The Whynter is working well keeping both zones at my 58 degrees F setting which is my preferred setting for red wines. I would rate the quality of the Whynter good but not great. The slide out shelves feel kind of cheap. For this price point I'm still waiting for a product with slightly higher quality. The Whynter is fairly quiet although you can hear it running. As another reviewer mentioned the Whynter is designed for normal size bottles. It outputs a little heat out the side vents but nothing drastic. At this point I'm happy with my purchase. I will report back if I have any longevity problems.<br/><br/>Update 11/19/2011:<br/>The unit is still going strong. No real complaints. As I mentioned in the earlier review the only minor annoyance is that the shelves don't accommodate every bottle size but I usually can figure out a way to get 99% of bottles loaded.<br/><br/>Update 2/11/2012:<br/>I started noticing that the unit has been making a noticeable noise and the LED readouts are losing some of their segments. A quick internet search reveals that others have been having some similar problems with the LEDs. I'm still looking for confirmation on the noise. I'm wondering if the fan is failing or its something else. The warranty is one-year so it appears I'm out of warranty. I will contact Whynter on Monday to see what they suggest. I'm dropping my rating from 4 stars to 3 stars as a result and will update again once I figure out the remedy for the problem.<br/><br/>Update 10/8/2013:<br/>I've lowered my rating on the wine cooler from 3 to 2 stars due to some of the \"design\" problems (e.g., fan noise, LED failures) mentioned in my 2/11/2012 update. It may be possible that Whytner has updated the design of the unit to accommodate fixes to these issues since my purchase was in October 2010. The unit finally died and I replaced it with the slightly more expensive<a class=\"a-link-normal\" href=\"/Whynter-BWR-18SD-18-Bottle-Built-In-Wine-Refrigerator/dp/B004HXDLJ8/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Whynter BWR-18SD 18 Bottle Built-In Wine Refrigerator</a>. The quality of the compressor-driven BWR-18SD is an order of magnitude higher than the WC-211DZ. It's quieter, compress-driven versus thermoelectric, and the shelving is high quality. It does store fewer bottles and is only a single-zone wine-cooler but it looks (and sounds) much better under my counter.","UPDATE: October 2013<br/><br/>I was recently asked about the ongoing performance of my Whynter wine fridge and so offer this update.<br/><br/>I've had my Whynter Wine Fridge for almost exactly 3 years years now.  I cannot comment on other users' experiences but, at this point, my fridge continues to function without any problems or changes.<br/><br/>I will note that I still have to clean the filters regularly.  Every so often, probably about once a month, I'll notice the temps start to climb a few degrees from my set points.  When this happens I slide the fridge out, pop the two filters out, rinse them with fresh water and put them back in.  The who process takes about a minute.  If the the fridge were hard mounted this could be a serious issue.  For me it's no big deal.<br/><br/>I will also note that the fridge is still somewhat louder than you might expect.  It is probably as loud as my full sized fridge.  Not a problem for me but others might find it distracting.<br/><br/>I still like the cool blue LED numbers and I usually leave the blue interior lights on.  They make a cool night light and match the blue LEDs on the other electronics in my kitchen.<br/><br/>The interior rack system is not particularly heavy or solid and I stand by my description of it as \"cheesy\" but after three years of light to moderate use everything is intact and functioning properly.  The door handle, hinges, buttons, etc. are all working as they should.<br/><br/>So, my opinion after 3 years?  Again, I cannot speak to other users' experiences but, based solely on my personal experience, I have no complaints and would still feel comfortable recommending the Whynter wine fridge for what it is - a value priced product for novice to intermediary wine buffs.<br/><br/>ORIGINAL REVIEW: August 2011<br/><br/>I purchased the Whynter WC-211 DZ 21 about a year ago after extensive research.  You've probably already read the specs on this item so I'll skip straight to my impressions.<br/><br/>Pros:<br/><br/>Price.  This is by far the most affordable serious wine fridge in this class.  You could easily spend several times more on a \"serious\" unit but for a novice to moderate wine lover who wants to go to the next level this is definitely a viable fridge at a decent price.<br/><br/>Looks.  This fridge looks bonafied in our kitchen. The temp gauges are a tad bright but I don't mind.  With the lights on it looks techy and modern.  It actually makes a decent night light in the kitchen and matches the blue LEDs on our other appliances.  With the lights off it's more subtle but still looks slick and cool.<br/><br/>Dual Zone.  It really works.  My choice? Reds on the top at 55, whites and other colder wines on the bottom at 50.  Nice.<br/><br/>Bottle size.  Other reviewers have lamented the depth of the cooler and the fact that it limits the size of bottle it can hold.  While it's true that you can't fit the longest bottles in this cooler, it will definitely hold bottles that are moderately fat or long.  It's not a big issue for me.<br/><br/>Cons:<br/><br/>Temp limits.  While 44 degrees isn't bad, I wish you could choose to cool all the way down to 35 for champagne and other cold-served wines.  Of course the solution is that you just pop the bottle out of the Whynter and into the refrigerator for an hour and you're set.<br/><br/>Sound level.  I was surprised how loud this cooler is.  It is at least as loud if not a bit louder than the full-sized refrigerator a few feet away. It's not too bad but definitely noticeable.<br/><br/>Cheezy construction.  If you use it much the construction feels fairly cheap - especially the racks.<br/><br/>Filters.  The cooling unit on this fridge is so borderline that the air filters in the back must be almost perfectly clean for it to work properly.  I had only had it a few months when I noticed that the temps had started to inch up.  Over time the temps rose to nearly room temperature.  Eventually, I pulled the unit out and noted that the two filters were pretty dusty.  I cleaned them and within an hour the fridge was down to it's normal temps.  Now, as soon as I see the temps rise a degree above the set temp I clean the filters.  The first time this happened I thought it was a faulty unit and that I was going to have to send it back (a complaint I've seen about these fridges in other reviews) but once I figured out that it was the filters I have had no other issues.  Not a deal breaker but something to keep in mind - especially if your install is such that it's not easy to slide it out and back.<br/><br/>Conclusion<br/><br/>I guess it all comes down to the question \"knowing what I know now would I buy this wine fridge again\"?  The answer is YES.  Despite it's flaws this is a serious entry level wine fridge and for it's price I don't think you could do any better.","I just purchased the Whynter 21 Bottle Dual Temperature Zone Wine Cooler (Model #WC-211DZ) from Amazon.com. As always, there was a quick shipping time with Amazon. This wine cooler looks great. Silver, slim, and nice visual addition to any kitchen or bar area. However, in reality, there are definitely some areas that it falls short.<br/><br/>1. This wine cooler will fit ONLY \"traditional\" bottles. That means it will NOT fit Champagne bottles, sparkling wine, Muscat bottles (longer than traditional bottles), port, traditional chianti bottles, etc.<br/><br/>2. While this cooler holds 21 bottles, the metal racks only accommodate 18 bottles. Whynter designed this unit so that you place the last three bottles on the floor of the unit, NOT on a shelf. There is a track there for a shelf, but the unit only comes with 6 shelves (3 bottles on each) instead of the 7 shelves it should have. Not only does this not look as attractive, it makes it more cumbersome to look at the wine, as you cannot just slide the metal shelf out.<br/><br/>3. The metal trays do not slide in or out easily, making it a bit difficult to look at the wines on each shelf.<br/><br/>If you only drink red wine or white wine in traditional bottles and you are looking for your first wine cooler, than this is likely a good choice for you. If you are more of a wine enthusiast and like to store several types of wine, particularly champagne, I would NOT recommend this unit. I never would have thought that a traditional champagne bottle wouldn't fit in a wine cooler. Alas, I now have no place to store all my sparkling wines.","We ordered this in October 2010 and it has run incredibly well ever since we received it. The two zones works perfectly, and its slim size fits under our counter.<br/><br/>We've been most amazed by how quiet it is: you can hear it when the room is totally quiet, but even then, it's tough to hear. The lack of a compressor makes a huge difference but does not affect the cooling efficiency at all. It's nice to have properly chilled wine and champagne within easy reach.<br/><br/>The digital readout started to malfunction a bit after about three and a half months. I sent an email to their support team, and a new digital display was shipped out via UPS the same day I emailed them! They were polite and responsive in their emails and handled our issue with speed and interest. It does my heart good to see there still really is good customer service in this world.<br/><br/>I recommend this unit highly and recommend this manufacturer even more. They are honest and take customer service seriously.","Chose this one over several similar sized models due to heavier and possibly more durable construction.  It's a very nice unit and does the job silently.  It's having no trouble keeping a temperature of 56F in both zones and I have it situated in my basement storage room. I don't hear it when I stand in the room and it's cosmetically nice enough with the metal finish to keep it in a bar area or family room.  The trays are pretty solid/sturdy, but a non-standard wine bottle might not fit well due to narrow clearances.  Only difficulty I had with setup is that the 4th foot did not come attached, is sized differently from the others, and doesn't screw into an intuitive location.  The brief manual/instructions don't tell you where it goes either.  Customer service was helpful, but it took about 24hr to get a response-- they told me that someone else had just called with an identical question and they were planning to revise the instructions-- the answer is ...it screws into the bottom of the door hinge, not the base of the unit.  Otherwise, not a single problem in the month or so I've owned it.","This is a great product.  I like the two temperatures and the slim profile.  The packaging was very good.  Only downside is that it will not hold some of the odd shaped bottles.","I was skeptical about buying a wine cooler site unseen but after comparing prices with those available at stores, this was kinda of a no-brainer. Package arrived quick and intact, thanks Amazon! I was mildly stunned when I opened the unit. I was not quite expecting something that looked as sharp as what I received. Love the stainless steel racks and handle, extremely sophisticated appearance. Not only was this considerably cheaper than than the in store models but this looked twice as good. I put the pieces together and got it running in no time.<br/><br/>It ran silent as one would expect for a thermoelectric and cooled down decently. Temperatures were spot on too. I was tempted to install this in cabinet but realized that the vents would require some clearance. Not a big deal as this looks great on it's own. The shelves are designed for the standard 750ml bottle but are completely removable so I can mix and match to store whatever size bottles I need to.<br/><br/>This far outweighed my expectations in almost all aspects. AAA+++!","I was skeptical about buying a wine cooler site unseen but after comparing prices with those available at stores, this was kinda of a no-brainer. Package arrived quick and intact, thanks Amazon! I was mildly stunned when I opened the unit. I was not quite expecting something that looked as sharp as what I received. Love the stainless steel racks and handle, extremely sophisticated appearance. Not only was this considerably cheaper than than the in store models but this looked twice as good. I put the pieces together and got it running in no time.<br/><br/>It ran silent as one would expect for a thermoelectric and cooled down decently. Temperatures were spot on too. I was tempted to install this in cabinet but realized that the vents would require some clearance. Not a big deal as this looks great on it's own. The shelves are designed for the standard 750ml bottle but are completely removable so I can mix and match to store whatever size bottles I need to.<br/><br/>This far outweighed my expectations in almost all aspects. AAA+++!","Perfect size for keeping a few bottles chilled for drinking.  Can't believe how much difference a few degrees makes in the taste of red wine.  Shelves are a little difficult to slide but super quiet and convenient.","The Whynter WC-211DZ 21 bottle wine cooler arrived on time and securely.  Unpacking and installing the unit was fairly easy; the most difficult part was leveling the unit on an uneven hard surface under the kitchen cabinets.  Be sure to allow the unit the necessary clearance in the back, sides and/or top.  I had to pull the cooler out slightly to ensure the top unit in which I store white wine would be colder than the lower unit, in which I store red wine.  The cooler maintains a 8 degree differential between the two storage areas (58/50 degrees).  As others have mentioned, wide or unusually shaped bottles will require you to remove a rack.<br/><br/>While I am pleased with the look and fit of the unit, it does operate almost continuously and does generate some noise.  Whether it continues to work over time is the big question.  For now, I am pleased with both the unit."],"images":{"small":"http://ecx.images-amazon.com/images/I/41NEzbvTAGL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41NEzbvTAGL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41NEzbvTAGL.jpg"}},{"name":"Children Room Sky Star Night Light Projector Alarm Clock with Sleeping Music and Thermometer","asin":"B00QHRSW3M","price":"$13.50","stars":"1.9","reviews":["Cheap little plastic thing. The top had come off during shipping, however, it has nice music and stars that my son goes to sleep to. No volume control, does not plug in. I put tape over speakers to make it not so loud. Wish I paid less for it. Would look for something better quality next time.","Very disappointed!  This is so small, it fits in the palm of your hand and so fragile, it was damaged in shipping.  Would not recommend","cheaply made, extremely light, hard to operate, once you put batteries in it is impossible to turn off.... pain in the a** and waste of money. Attempting return, we will see if seller gives me a hard time or not...tbd...","havent figured out a way to have just the starry light on without the noise. The noises are actually kind of obnoxious and not anything I really like to hear. If you get this for a young kid- they may run around the house with it annoying you. Was a sad buy for me- but I'm assuming as my daughter gets older it will at least be a good alarm clock and I do like that it shows the room temperature and can be made to go into military time if you want. (24hr time, vs 12). This does not make a good night light- as she doesnt like the noises (my daughter likes quiet). This product could be better for others- just not really for us.","Not what I expected very small and the music is very loud not soothing and controls did not work properly. Very cheaply made however the stars are lovely too bad it attached to the music.","This is cute, but I don't like the fact that there is no volume control and that you can't just put the night light part on without having music on.  If I could go back and choose a different product, I would.","The batteries wore out quickly and there's NO VOLUME CONTROL. There are a couple sound options and the stars glow great. I will be looking for something that has a plug in option and that doesn't seem so cheap.","\"Children Room Sky Star Night Light Projector Alarm Clock with Sleeping Music and Thermometer + Cellphone Case\" I seriously thouht it would work as an alarm clock. But it has no settings to do so. THen I looked at the box to read instructions and it doesnt mention any thing about the alarm clock like it says in the description.","I don't even want to give it any stars. It's a major disappointment in the least. Tiny plastic junk that is over priced, really wish I read the reviews first. I have one sad 6 year old.","This is a very cheap clock, it doesn't plug in (battery only), no volume control, the time window doesn't stay on so the only way to see what time it is at night is to press one if the buttons but then the loud music turns on! The only reason i even gave it two stars is because my kids love the stars it reflects and the music too. This product has so much potential but until it is improved I wouldn't recommend it."],"images":{"small":"http://ecx.images-amazon.com/images/I/51K%2BkvYYlAL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51K%2BkvYYlAL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51K%2BkvYYlAL.jpg"}},{"name":"Ice Cube Tray with Storage Container Bin","asin":"B008J478JK","price":"$9.90$5.99$4.99","stars":"1.5","reviews":["The only way I've found to remove the ice cubes is to wait until they're half melted.  I think<br/>the bottoms of the cubes are larger than the tops, hence the difficulty in getting them out.<br/>Trying to twist them out just cracked the tray.  A waste of money.","While the design appeared great, the cube portion of this product snapped in two when we were flexing the tray and trying to get the ice out on the very first use. We will use the bottom part for ice storage, but the major idea is lost at this point.","Do not purchase this product. The very first time I used this product I attempted to take the ice out and the tray broke, it cracked in two different places. I informed the seller and they sent me another cheap plastic tray that cracked with the slightest touch. The only good thing is the box it came in, at least I was able to use it more then once.","Horrible design.  You can't get the ice out of the tray, and the tray cracks and is unusable.  Not worth a dime.  Stay away from this one.","I really like this little tray and bin. It's a space saver and the bin holds enough ice for a party of four. The first one I got was cracked, but the sellers were great about replacing it. Fast, efficient, polite--hard to ask for more!","Don't waste your money on this item. After, I took the ice box out of the freezer, I could not get the ice out of the ice tray. I was struggling to get the ice cubes out. Wasn't worth the money for this item, it sucks.","The title says it all.  The ice is almost impossible to remove from the tray, and you end up cracking the tray even on the first use.  Using hot water to loosen the cubes doesn't do much to help the problem.  Do not buy this.","I read the reviews on this about the tray cracking trying to get the ice cubs out and i still wanted to try it out myself. I don't know if they replaced the material but mine doesn't crack or break no matter how much i bend it. The only thing that sucks is it's a little difficult getting the ice cubes out. I usually turn it upside down on the bin and run a bit of hot water to loosen them up so the ones that fly out go into the bin and not the sink, but then i'm able to release the rest.","Similar tray/bin combinations were popular before ice makers became standard in refrigerators , now they are impossible to find .  This will works for my 83 yr old mom, but would not for a family.  It's just too small and designed for cute ice for a cocktail party.","I wish I could  give this a minus review  .In a simple word  NOOO<br/>First time using I couldn't get the ice out of the mold with out having to melt it half way .<br/>So i only got  like half the amount of ice cube  from it.<br/>Second and last time i used it  the tray cracked in the middle and yes folks the ice was still in the mod and would not come out .<br/>So this is not a good fit for  any reason ."],"images":{"small":"http://ecx.images-amazon.com/images/I/41C6Vk5WrEL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41C6Vk5WrEL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41C6Vk5WrEL.jpg"}},{"name":"Motorola Digital Audio Baby Monitor with Room Temperature Monitoring and LCD Display (Discontinued by Manufacturer)","asin":"B004UJO98Q","price":"$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["I think I should start a career reviewing baby monitors at this point, I've tried so many of them. I had such high hopes for this one, I pre-ordered it and waited for it to arrive while using the Angelcare monitor (piece of junk--although at least I could hear my kids even through the static--unlike this one...).<br/><br/>The low down:<br/> It's nice looking and has a lot great features (talk back, temperature, good battery life, clear sound, DECT so no interference and wifi friendly, good range)...<br/><br/>BUT the biggest problem is there is no way to adjust the child unit (box in kid's room) microphone sensitivity. And there is no way to set either unit to hear constant sound from your child's room. The parent unit is sound-sensitive. So it activates when it hears a sound above a certain level instead of constantly playing all sounds in the room. But just in the first week of using it, there have been at least two occasions where my son was crying for me and I heard him from down the hall (after who knows how long) instead of the monitor. The monitor was totally silent. I felt so horrible, knowing he was calling me and I didn't hear him. Isn't that the whole point of a monitor??<br/><br/>I called Motorola and the customer support guy agreed that being able to keep the sound on full time or at least being able to increase the sensitivity would be a good feature. Yeah, I know.<br/><br/>So now, I sit here next to my silent monitor. (if you hit the talk button, you will hear all sounds in the room including ambient noise like our white noise machine--but only for about ten seconds and then it goes back to \"stealth mode\")<br/>So I am compulsively waking up and pressing that button just to make sure it's working. I can't stand this.<br/><br/>Sending it back. I'm going back to Philips DECT.<br/>Don't waste your time with this one. If they get it worked out, it'll be a nice machine. Maybe the next model will work properly.","This unit worked fine for a year and a half then we unplugged it to move furniture and it never worked again. Parent units will not link, spend your money elsewhere.","Had this monitor for almost a year. Unplugged the base unit accidentally and now the parent units will not link. Searching on Google shows hundreds of the exact same complaint and no working solutions. Be warned.","If I could give this monitor a rating of \"0\" i most certainly would.  We haven't even had these 2 years and one day they stopped working completely.  The screen displayed \"Not Linked\" and despite my efforts/ time on the phone with Motorola, their answer to my issues were, \"Well, just go buy another set.  There is nothing more we can do.\"  Gee, thanks.  Do NOT buy if your baby's life depends on it.  What a piece of junk.","Worked fine for almost a year, with the occasional unlinking at random times.  Then this week it unlinked and will not relink.  Called customer service and was told that once they unlink at all they will never relink.  What kind of crap product is that?  What if you need to move the baby unit, which had no battery and must stay plugged in, you lose your link!  Who would make such a product that is limited to linking once and never again, especially for a baby monitor.  JUNK.","This monitor unlinks itself throughout the night and beeps insanely loudly every time!! we live in a small apartment and the monitor is pretty much 10 feet from where the base is in baby's room, and we are all asleep until it happens, so it isn't out of range. so frustrating!! going to return it.","I received it as a shower gift. I had the same problem as everyone else. It worked great for 1 year and then stopped linking right after the warranty expired. Unless you're a fan of buying two for each child, skip this one.","This base unit failed after 90 days of use and can no longer link with the handsets.  It's in warranty but very frustrating, this seems like such a simple type of technology to produce a quality product with, but for some reason brand after brand has had many issues.","Only buy these if you want them for a year. After a year and almost a month of use they just stopped linking to each other. Terrible.<br/><br/>But other than that these units were extremely helpful in our child's first year of life. I liked the temp showing on the unit as our house is old and trying to get a steady temp is impossible.<br/><br/>Extremely disappointed and am in talks with Motorola which will go no where I imagine.","These things are horrendous.  I actually bought them twice because I thought the first ones were busted... nope, they just suck.  The threshold to activate them is so high that your poor child has to be near-implosion before they go off.  I guess if you like that idea then these are for you!  Got the V-tech equivalents and they are lightyears better..."],"images":{"small":"http://ecx.images-amazon.com/images/I/51Cu8Be8MmL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51Cu8Be8MmL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51Cu8Be8MmL.jpg"}},{"name":"Wolfgang Puck WPTPCM010 12-Cup Programmable Coffeemaker with Stainless-Steel Thermal Carafe","asin":"B002TOKA1O","price":"","stars":"2.1","reviews":["I purchased this coffee maker for my nephew as a gift. It was on backorder, but I waited, because this was the specific coffeemaker that he wanted. I received the coffeemaker from Amazon on March 30, 2010 and gave it to him within a week of receiving it....Then the problems began.<br/>From day one, the coffeemaker was spewing coffee all over the counter, instead of into the carafe. He didn't want to involve me in the problems with the coffeemaker, so he called the Wolfgang Puck (WP) Customer Service...Big Mistake! Had he let me know, I could have shipped it back to Amazon, received my money and he could have purchased any other brand he wanted. However, it didn't work that way.<br/>After numerous attempts to \"fix\" the problem over the phone, the WP Company sent a pick-up order for the coffee maker and received it on May 3, 2010.  Since that time, he has been repeatedly told he would have a new machine in \"2 weeks\".<br/>I became involved in July, when he was getting nowhere with the company.  I requested a refund on July 19, and I was told it had to be approved by corporate headquarters.  A week later, I was told the request was denied, because they still have the coffee pots... (Well, where are they?)!!  I then asked for the name of a contact person at the corporate office and they refused to supply me with a name.<br/><br/>Through lots of trials, errors, and frustration, I found a number. I called it and believe it or not, I finally made contact with a customer relations manager. I talked with her and I finally agreed to wait another \"2 weeks\". The time came and went and no coffee maker, so I called and she said the company had just received them and would be shipping his coffeemaker as the first shipment. And....as a thank-you, he would also receive a complimentary gift set of WP Kitchen knives. I waited until September 16 and ended up calling her again.  The manager then checked and found out that the coffeemaker had NOT been shipped, because the coffeemakers were bent and damaged in the shipment.<br/><br/>I received an email later that afternoon, stating that she has requested a refund for me.  It's not here yet, but I have much hope that my money will be refunded.","Unfortunately we didn't read the reviews before ordering this coffee maker.  We had it boxed and ready to ship back when I popped on to see if anyone else was having the flooding issue.  That is when I discovered that EVERYONE was having the overflow issue. My brilliant husband Robert unpacked the coffee maker and promptly went out to his shop area and cut a disc the diameter of the bottom of the coffee carafe from a piece of 1/4\" masonite.  Problem solved!!  The spring on the top of the carafe doesn't get depressed far enough to allow the coffee to flow into the pot properly.  Putting that 1/4\" spacer under the carafe is all it needed.  We are happy, we love the way the coffee maker makes and keeps coffee.  Robert also painted the disc black once he knew it was going to work.  It looks like it belongs to the unit.","Update: This note is being added about 6 months after my inital review. We too have experienced the problem with coffee overflowing on to the countertop. I very quickly learned that is after inserting the pot into the maker I pivot the pot so that the handle is as far left as possible, the spillage does not happen. This method has been successful for the past 200 pots made. It's a weird quirk that shouldn't be necessary, but I otherwise stand by my review.<br/><br/>The best coffeemaker we have ever owned is a long since discontinued Starbucks Barista with a thermal carafe. It was close to perfection for almost 10 years. Even after some trim pieces fell off, it continued to be a reliable performer. After several years of regular use, the plate on the bottom of the carafe top began to break, one piece at a time. The Barista continued to make great coffee, it just didn't hold the temperature as well as it originally did.<br/><br/>Earlier this year we despaired that we would have to go back to buying makers that work for a few months and then die. My wife, after hours of searching spotted this familiar face in the crowd. We ordered in December and it arrived today. To say it was worth the wait is an understatement. We now know that we have years of fresh, hot, reliable coffee making ahead of us. The only difference between this model and the original Starbucks is the it now uses a cone filter instead of a flat bottom. No big deal at all.<br/><br/>Footnote: \"Old Reliable\" the Starbucks Barista worked right through this morning, its retirement day. It's not headed for the trash however, there spare parts to be salved for our beautiful new baby.<br/><br/>When, (and if), this machine becomes available again, click 'n' buy. You won't regret it!","Sadly, this review may be too late to save this great product. I really don't understand the negative reviews on this unit, though it is not a traditional \"Mr Coffee\" type unit, it's also not so complicated that my Rocket Science degree is required to use it. My husband and I may be lucky, but I can't imagine a better performing coffee maker! We've now had the Wolfgang Puck coffee maker for most of 2011 and find it makes excellent coffee, is very reliable, brew excellent coffee (better than Starbucks!), and continues to feel like it's very well made. We purchased this coffee maker after our Starbucks Barista Grande stopped working after over 6 years of honored service.  It was the ONLY coffee maker that has a removable water reservoir, stainless steel carafe that stays hot for hours, a convenient filter basket, and makes a 12 great cups of coffee in approximately 12 minutes. For the most part all parts of this unit that \"touch\" coffee are dishwasher safe--at least they've survived so far and still work as well as when they were new!<br/><br/>We have learned some \"Tricks\" that may have \"increased our luck\"--these are the same tricks we had learned with our Starbucks version. We'll continue to use these tricks on all future coffee makers, because they're just good practices.<br/><br/>1. Don't fill the reservoir beyond the \"max fill\" line that is CLEARLY marked on the vessel. The holes in the container used to secure the reservoir handle are located just above the max fill water-line and not water tight and will leak water if you overfill;<br/>2. The carafe lid does collect coffee grounds (especially if you use the reusable filter that comes with the unit).  Once the lid contains enough coffee grounds, it can leak and spill coffee during the brewing process--no matter how carefully it is placed on the carafe.  To prevent this leakage, rinse the lid before each use in very warm water (hotter water seems to clear it faster); ensure you press the central valve and the serving valve to release the trapped grounds.<br/>3. Rinse the filter and filter basket and carafe and run it through the dishwasher regularly--I've noticed improved flavor when these pieces are kept really clean.  It's also possible leakage is caused with the filter basket valve becomes covered in coffee oils, so keeping it clean could make it perform better.<br/>--I also rinse and fill the carafe with hot water and let it sit for a few minutes while you clean the filter basket and its lid and fill the water reservoir--before I dump out the water, I'll twist on the lid and pour additional hot water out of it, just for good measure. Then, when everything is ready (e.g. the freshly ground coffee beans are in-place and the filter/basket is closed and ready for the carafe and the water reservoir is adequately filled.)<br/>4. The carafe is always the last component to be positioned--that's the intended use for this unit, the filter basked isn't supposed to be opened once the carafe is in-place.  The valve spring on the filter basket is ONLY engaged once the carafe is properly place beneath it, so the basket should be in-place BEFORE the carafe is put in to place.","We've had more coffee on the floor than in the pot since getting this coffee maker.  Coffee's good, but you have to hold your mug under the lip of the counter top and let the coffee drip into it from there.  It takes a long time to get a cup of coffee that way.  The worst part of all of this?  The company won't respond.  No response to emails.  Can't get through on the phone (although while on hold you can refill your cup using the above described method).<br/><br/>Bottom line:  Don't buy it unless you have a lot of towels close by.","I, like so many others, was excited by what appeared to be the return of the Starbucks Barista. I also used my trusty Barista for about 10 years without any trouble. This unit may look like the Barista but that's where any similarity ends.<br/><br/>The Puck model simply doesn't work. Coffee leaks everywhere. Initially I thought just the lid was defective but the coffee leaks from the back/bottom of the unit as well. Simply replacing the lid will not solve all the problems. Had I not thrown away the packing boxes the day it arrived, I would return it. Too much hassle now and I've already been sufficiently inconvenienced.<br/><br/>$100 down the (sink) drain!!!  BEWARE","This coffee maker is flawed in more than a few ways. If I preferred to slurp coffee off of my counter with a straw I would be thrilled. However, I prefer my delicious coffee in the confines of a comforting ceramic mug.<br/><br/>As mentioned by nearly every single reviewer of this coffee maker, I too suffer from the craptastically engineered carafe-to-basket interface that randomly causes coffee to not make it into the carafe but to brew itself all over the counter. I have tried pushing the pour button as I place the carafe into the unit, and it seems to reduce the occurrences of counter coffee. Note I said reduce, not eliminate. I may try shimming underneath the carafe so that the spring loaded stopper in the lid is more reliably depressed, but the thought of having to re-engineer and modify my $100 coffee maker does not make me happy.<br/><br/>Once you manage to successfully brew a cup of coffee you are then treated to the painstaking and messy affair of getting the coffee into your mug. As also mentioned by a few other reviewers it pours slowly. Not only does it pour slowly but it also manages to splash everywhere while it pours.<br/><br/>Also, where the plastic top meets the metal carafe has started leaking.<br/><br/>For those reading this that think everyone who has complained thus far about the shortcoming of this unit are doing something wrong you will be pleased to know that the carafe itself actually works very well. It is a double walled design that keeps coffee at a drinkable temperature for a few hours easily. It also has a wide mouth, allowing one to get their hand inside to clean it. It also brews a decent cup of coffee.<br/><br/>All in all, this was a huge disappointment, as it has all the features I was looking for, removable reservoir and a thermal carafe but it's unreliability is a fatal flaw. Avoid this at all costs.<br/><br/>UPDATE 06-27-2010: above mentioned device has finally made its way into my trash. So long Wolfgang Puck Coffee Maker. You won't be missed.","UPDATE 10/2/7/15: Still loving it!  We use this machine every day and it makes excellent coffee.<br/><br/>UPDATE 05/06/14: I'm writing to say that I have used my Wolfgang Puck nearly every day since I purchased it in November 2010 and it still brews coffee perfectly. I've experienced no problem with an overflowing carafe as many other reported.  Guess I got a good one.  Since the parts of my old Starbucks coffee maker are interchangeable with this one from Wolfgang Puck, I expect to be able to repair the machine when and if it breaks, which is a good thing since these machines are nearly impossible to find.<br/><br/>UPDATE 10/25/13:  I'm writing to say that I have used my Wolfgang Puck 12-cup coffee maker just about every day since I purchased it in November 2010 and it's still brewing coffee perfectly. I'm not sure if it helps extend the life of these machines, but I clean the basket, including the removable basket holder, after each use and I close the filter door before inserting the carafe and hitting the brew button.<br/><br/>After 4 years of faithful service and daily use, my Starbucks Barista Aroma Grande 12-cup Programmable Coffee Maker (manufactured by Saeco for Starbucks) finally called it quits.  As anyone who owns or owns one knows, the 8-cup version of this coffee maker was subject to product recall on 10/17/06, and Starbucks stopped retailing their branded 8  12 cup coffee makers in their stores shortly thereafter.  The boiler generates so much heat that over time the wiring became brittle, corroded and frayed, at least that's what I determined was the cause for my Barista Aroma Grande to stop functioning.  After an exhaustive search for a suitable replacement, for under $200, I came across the Wolfgang Puck 12-cup Programmable Coffee maker bearing a striking resemblance to my beloved Starbucks coffee maker.  Despite a number of brutally negative reviews, many written by consumers who claim to own or have owned the Starbucks coffee maker, I purchased one.  The long and short of it is that, with the exception of the cone filter (Starbucks employed a basket filter) and plastic buttons (the buttons were rubber on the Starbucks), the Wolfgang Puck coffee maker is identical in all respects to the Starbucks coffee maker.  This was obvious to me right out of the box, but to further prove this to myself, prior to writing this review, I went to the extreme of removing the bottom panel to inspect the inner workings and did a side-by-side comparison with the Starbucks coffee machine.  They are EXACTLY THE SAME, so I don't understand the reason for the barrage of negative reviews which, based on my extensive use of this coffee maker (2X daily) over the past month, are unwarranted.  I haven't expeienced any of the problems others have reported, such as overflowing.  Also, on a side note, this is by far the best 12-cup stainless steel coffee maker in this price point [$99]. The majority of coffee makers for the home market are made of plastic made to look like stainless steel or are manufactured with very thin stainless steel panels, and few at that.  That is not the case with this Wolfgang Puck 12-cup coffee maker whereas you will find no shortage of high-quality stainless steel.  My advice to anyone in the home market for a 12-cup stainless steel coffee maker is to look beyond the negative reviews and buy this one and form your opinion of this coffee maker on your own experience with it, not someone elses.  You won't regret it and it you do, I understand that amazon.com has an easy returns policy.","I owned a Capresso for years but it is slowly falling apart. I bought this unit as it is the ONLY coffee machine now for sale with a removable water carafe and thermal pot. As far as I am concerned, that's the only design that makes sense, and I can't believe that everyone else wants to haul a bucket of water from the sink over to their coffee maker every day.<br/><br/>The Puck is taller than the Capresso and not necessarily very pretty or sleek. Coffee brewed much quicker than the Capresso and tastes pretty good. It makes a continuous low-level roar while brewing.<br/><br/>The pot pour button is poorly designed - you have to turn the pot almost upside down to work, and even then it just dribles out. You can't swing the filter in if the pot is in place. And the water carafe seating does not leave me feeling very confident; I have a feeling it will bust before long. My final nit is that the bluish lcd display is way over-kill - enough with blue lights lighting up my house all night!<br/><br/>Update: After 2 months, this machine is not ready for prime time. The water carafe drips if filled more than 1/4 full, the thermos won't go under the basket without violent jiggling, and I don't expect it to last more than a few more months. As an earlier reviewer noted, the manufacturing is \"out of spec\" or something. My suggestion, wait a few months until they get the manufacturing plant in line.","I thought I was getting a quality coffee maker since it had Wolfgang Puck on it. It leaked around the top on first use. The timer didn't work properly. I was able to seal the top leak and use the pot for 6 weeks before the timer would cause the unit to only brew for about 30 seconds and shut off. If you keep working with it you can start it again for a few more seconds.<br/> I called Customer Service and have gotten the runaround much like the other complaints that are all over the web about Wolfgang Puck products.<br/> I don't know of anyone that has had their problem resolved by Customer Service.<br/>I will never buy another product with this name on it."],"images":{"small":"http://ecx.images-amazon.com/images/I/41M3i4TkY7L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41M3i4TkY7L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41M3i4TkY7L.jpg"}},{"name":"World's Smallest Walkie Talkies","asin":"B004F23M6I","price":"$12.02$18.43$4.86$5.96","stars":"1.8","reviews":["I was really disappointed in the quality of this product. It was advertised as if it was capable of performing the regular functions of regular-sized child walkie talkies, but it can't! I stood one room away from my sister, and we couldn't hear each other on either end. It wasn't until I was standing about 10 feet away from her with the antenna directly facing her walkie talkie, that we could hear each other's voices in the walkie talkies. This product just doesn't work. It would be such a fun gift to give a child, or even to have as an older teen just for fun, but the only good thing about it is that it looks good. I give this product 1-star for that. If only it worked too...","You have to be 6 feet away from each other for these to work. There is a lot of static while you talk and you can hardly hear the other person.  You have to press the button real hard to talk. Only the beep works.","These walkie talkies are a complete waste of money. My cousin and I bought them to take on vacation because they were small and easily transported I'll give them credit for that. However you can only be up to 6 feet apart maybe not even that far and it's still very staticy and hard to hear. These walkie talkies work great on morse code but that is it. This is a complete waste of money.","One of the two included walkie talkies didn't work.  Don't waste your time or money on these.  Great idea, poorly manufactured.","Shame on the manufacturer for making such a shoddy and misleading toy!<br/><br/>I saw this item at little boutique, and I thought that it would make a nice Christmas gift for my 5 year old son - I was wrong.<br/><br/>The manufacturer proclaims that their walkie talkie \"Penetrates Walls, Floors, Steel,  Concrete\" with a \"Range up to 150 feet.\"  Yeah, right... What a load of RUBBISH!  At best we had a 10 - 15 foot radius with these talkies, while standing in the same room.  Moreover, the constant white noise coming from the speakers drown out everything being said.  As a final insult, the batteries petered out after about an hour of sporadic use.<br/><br/>The only mitigating factor for these walkie talkies is the beeping \"Morse code\" button; my son liked this feature.  However, this isn't enough to improve my 1 star rating of this item.  I'm very disappointed with this product and I hope that I can get my money refunded.","This product did not work and I would not recommend buying it. We will definitely be returning these and looking for something that actually works as advertised.","These are the absolute worst walkie-talkies in the world. Someone else mentioned that you had to be 6 feet from each other for them to work, but ours did not work at all. My son wanted them for pretend \"comm links\" like he saw on Rescue Bots, so at the price, I thought it was no big deal... but they do not transmit anything but fuzz, even if you're practically sitting on top of each other.<br/><br/>You could literally buy ANY other walkie-talkies and they would work better. Shoot, I could make my own out of a pair of macaroni and cheese boxes and draw little buttons on them and they'd work better.","They don't work at all. I ordered them to use as a mini walkie talkie for some bears that I make for my staff every year. For this purpose it is fine. But, these are in no way shape or form actual walkie talkies. So if that is what you are wanting them for, don't buy them. If you want something for your teddy bear or american girl doll...yes, perfect.","They look swell, but when I used them with my best friend, he sounded like a chicken I once saw with its neck stuck in a fence.  I could not understand one thing that chicken said. Regular talk sounded like, \"Quawket chaw!\"  It was mental.","I JUST WANTED TO PLAY WITH SOME CHEAP WALKIE TALKIES<br/>Whether or not the signal was good, or even worked from more than 10 feet away was not my problem. Heck, the ones I got weren't even the color of the ones PICTURED. They are an awful blue and red metallic. Lacking class. I am seething with hatred of the world for a completely different reason.<br/>I go to play with the walkie talkie with my elderly grandfather. He is sick, so maybe the walkie talkies would have made a good way for him to call my grandma. Who knows.<br/>5 minutes. That's how long my walkie talkie worked until it just stopped. No static even. I tried to turn it on and off again SO MANY TIMES I SWEAR BUT IT WILL ONLY WORK IN SHORT BURSTS, THEN NEVER WORK. It will turn on approximately 13% of the time, estimating.<br/>BUT NO. REALLY. ONE WORKING WALKIE TALKIE. ONE. aND I CAN'T RETURN IT BECAUSE I TOOK IT OUT OF THE PACKAGING. YOU KNOW. LIKE SO I CAN USE THEM. WHICH IS THE ONLY WAY YOU COULD EVEN TELL IF THEY ARE DEFECTIVE. LOGIC. (ahem capitalist pigs ahem)<br/>YOU, WESTMINSTER, ARE ON MY LIST. MAY NEPTUNE HAVE MERCY ON YOUR SOUL.<br/>AS FOR YOU BUYERS, WHATEVER YOU DO, DO NOT BUY A PRODUCT CALLED \"WESTMINSTER WORLD'S SMALLEST WALKIE TALKIES 3997\". IT DOESN'T MATTER IF THE WORLD WILL END IF YOU DON'T.<br/>STAY.<br/>AWAY.<br/>FROM.<br/>THESE.<br/>YOU COULD BUY LIKE 10 CANDY BARS FOR THIS AND HAVE MORE FUN WITH A SUGAR HIGH AND DIABETES.<br/>you have been warned."],"images":{"small":"http://ecx.images-amazon.com/images/I/41%2BBMdg-roL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41%2BBMdg-roL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41%2BBMdg-roL.jpg"}},{"name":"Cuisinart TOB-30BW  Toaster Oven/Broiler","asin":"B00008IHLG","price":"","stars":"2.1","reviews":["I have owned our Cuisinart TOB-30 series for less then 3 months and  we were very happy with it, until one day we noticed the unit would not shut off when turned to the off setting, the light would remain on and there is still being heat generated in the oven in the off position, then within a week, when you would turn the unit to the bake selection, it would not turn on and sparks would shoot out the back, only the toast feature remains working, and if you turn the knob to go through other settings sparks are generated.  If you have the same situation I highly recommend you goto [...] the US Consumer Product Safety Commission and let them know of your concern, maybe we can get these recalled, it appears to be a faulty switch they are using.  Im not hearing positive things about there service, but if you buy one, save your receipt and warranty information, you may need it and be aware of the unit at some point may not shut off unless you unplug it (if you go on vacation, etc)","I bought my Cuisinart 30W Toaster Oven/Broiler on 12/11/2005.  For Two months it worked Great, then I woke up at 8:30 a.m. Supperbowl morning to the smell of an electrical fire.  Ran out to the Kitchen to discover that it was the Cuisinart 30W Toaster Oven/Broiler it had come on even though the switch was off.  My Cuisinart Burnt up, I still had the reciept and returned it for a Kitchen Aid.  Hopefully, the KitchenAid works without the defects of the Cuisinart.<br/><br/>Suggestion:  Unplug the Unit after every use, even if it has an on/off switch.","My toaster oven (Cuisinart TOB-30W Toaster Oven/Broiler) is also malfunctioning as described above.  The oven stays ON all the time, no matter if the dial switch is turned to OFF.  The ON light is on and the upper heating element stays ON.  The bottom heating element does not work now.  It is mandatory to keep the appliance unplugged.  I bought mine exactly one year ago at Christmas, and this malfunctioning switch problem just started this Christmas 2005.  I hope I can find my receipt, however, I think the manufacturer should be notified and they should issue a credit for a purchase of a new revised model, and recall this particular model","I have owned two of these lemons.  The first one experienced electrical sparking and spitting like previous reviewers have explained.  We sent it back to Cuisinart for repair, and, after many phone calls, they shipped us a new one.  The new one has developed the same problem apparently, plus a new one.  The electrical problem has reappeared:  When we returned from a two week trip, having forgotten to unplug it, and having left it in Toast, we were greeted by a loud buzzing noise.  No lights were on, and the oven was cool, but it was making a lot of noise for an appliance that appeared to be \"off\".  But, it still worked, so we keep using it.<br/><br/>Yesterday, I tried to move it, to clean under it, but it had leaked something and 'glued' the feet to the counter, and when I tried to move it the plastic broke.  So now it's propped up on the broken plastic awaiting a replacement oven (anything but Cuisinart).<br/><br/>I heartily agree that the CPSC should ban the sale of these ovens.  They're a menace.","I own the stainless/black version of this and have had more than a year of perfect operation. I don't use a microwave very often or my large oven so this gets used daily. It looks brand new. Food simply doesn't stick to the glass door or the handy crumb tray. So far so good.<br/><br/>UPDATE: after two and half years of flawless operation, the internals of the toast/bake/broil switch are fried. The toaster oven no longer stays on in \"bake\" mode, rendering it useless. I would downgrade the rating to 2 stars.","We like our Cuisinart TOB-30BWFR toaster oven. It's black pebble grain and brushed stainless steel finish is most attractive and blends well with most decor.The unit makes beautiful toast, broils and bakes to perfection. A nice feature is the non-stick coating on insides that makes for easy cleaning.The accessories, ie the trays, go right into the dishwasher with the dishes when soiled. The crumb tray wipes off with a damp cloth for easy cleaning. This toaster oven is of good quality,easy to use and an excellent buy.","My Cuisinart TOB-30BCC Toaster/Broiler oven started to short out and burn when I used the bake option. I took it apart to see why it was shorting out. I found that the knob that connects the circuit was made out of plastic and had melted. Thus, in a state of deformity no longer able to connect the circuit. This is what is happening with all of these reviews. Question: Why would a designer of a toaster oven that has a 500 degree setting make such an integral part out of plastic. Answer: to shave a few dollars off of production costs to squeeze out a little more for the bottom line. And on top of that, have it manufactured in a sweat shop in China. My grandpa has a toaster oven that over 30 years old that was made in America and it still works great. What sad greedy times we live in.","This toaster oven is a piece of junk...I bought this same model # two times before..Each time the product perofrmed worse.  First time I got it I loved it.  I loved the compact size and easy cleaning...The second one kept expanding with the heat and would make a loud scary noise...Still i liked this model for the reasons above...I had to get the 3rd one because of a power surge and it is the most poorly made and the whole process of using it is completely and horribly different...Now it is a month old and the toasting element does not toast...The heat bars don't ever get hot.  I registered the product but am now sure how to get this rectified.  Cusinart should be embarresed to put out such poor quality piece of junk...What happened to the wonderful reputation Cusinart had in the past.<br/><br/>Gloria Galupi<br/>gagalupi@yahoo.com<a class=\"a-link-normal\" href=\"/Cuisinart-TOB-40-Custom-Classic-Toaster-Oven-Broiler/dp/B004JMZGM2/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Cuisinart TOB-40 Custom Classic Toaster Oven Broiler</a>","AVOID THIS PRODUCT AT ALL COST. IT IS CHEAPLY MADE AND THE CUSTOMER SERVICE IS JUST AS BAD AS THE PRODUCT. I RECEIVED THIS PRODUCT AS A WEDDING GIFT A FEW MONTHS AGO AND IT DIDN'T EVEN LAST 2 MONTHS AS THE BOTTOM BUTTON BROKE. NOW 1 MONTH LATER AND 2 SHIPMENTS OF THE WRONG SET OF BUTTONS LATER, I HAVE A TOASTER OVEN THAT CANT BE USED. I CALLED THE CUSTOMER SERVICE DEPARTMENT AND WAS HUNG UP ON TWICE BY TWO RUDE REPS THAT DIDN'T WANT TO HELP ME IN REPLACING THE PRODUCT. THE THIRD REP INFORMED ME I WOULD HAVE TO PAY FOR SHIPPING TO RECEIVE THE NEW TOASTER OVEN AND WOULD HAVE TO PAY TO SHIP THE OLD ONE BACK. THE SHIPPING COSTS ARE NOT WORTH IT TO SEND THIS BACK AND GET A REPLACEMENT ITEM. I HAVE HAD PROBLEMS WITH CUISINART IN THE PAST AND DIDN'T WANT TO USE THIS TOASTER, BUT SINCE IT WAS A GIFT I FIGURED ID GIVE IT A SHOT. AFTER THIS EXPERIENCE WITH THE TOASTER OVEN AND THE HORRIBLE, HORRIBLE CUSTOMER SERVICE I WILL NEVER AGAIN BUY OR USE ONE OF THESE CHEAP PRODUCTS FROM THIS HORRIBLE COMPANY. IF YOU PLAN TO USE THE TOASTER OVEN OFTEN AND WANT IT TO LAST, INVEST A LITTLE MORE AND GET A QUALITY ONE. (BY THE WAY THE CUSTOMER SERVICE REPS WERE NOT FROM ANOTHER COUNTRY THEY WERE AMERICAN, FROM NJ WHERE THE COMPANY IS BASED!!!)","This is possibly the worst and most dangerous kitchen appliance ever created by man.<br/><br/>The dial will break, locking it to 'broil' or some inconvenient setting, it turns on and off unpredictably, and even when it was working it didn't toast anything evenly or heat to the correct temperature.  They need to recall these, they are dangerous.<br/><br/>The only Cuisinart product out of five that I own that works well is the food processor.  I will never buy a Cuisinart product again.  (I have 5 because they were house warming gifts, I would have learned my lesson after the first otherwise)"],"images":{"small":"http://ecx.images-amazon.com/images/I/21gDMOYwLUL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/21gDMOYwLUL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/21gDMOYwLUL.jpg"}},{"name":"Samsung SNH-1010N SmartCam WiFi Video Baby Monitor","asin":"B008J4DQ0A","price":"$12.02$18.43$4.86$5.96","stars":"1.8","reviews":["This isn't bad product.  It does what it's meant to do.  Just not very well, and certainly not to warrant the price.  I'm an expecting new dad shopping around for a video monitor.  My sister recommended the Motorola MBP36 that she's been using.  This and the the Summer Infant Infant model seem to be the mostly highly regarded.  But I really liked the idea of being able to view from anywhere, on iPhones, iPads and Android. (I currently have an iPad and a Samsung Galaxy Note).  So I thought I'd give it a try before spending the big bucks for those dedicated monitors. It wasn't the easiest set up but I eventually got it all set up.  I'm a tech guy, I work in networking.  I actually found this \"easy and guided\" way of setting things up very much trial and error.<br/><br/>Pros:<br/>-It allows you to view from any internet connected device or computers.<br/>-Doesn't need you to know how to configure your router or network to view them.(I Actually consider this Con, but most people would consider this a Pro, more on this later).<br/>-It's small and easily mounts.<br/>-WiFi support, although you have to connected it to the LAN connection for setup unless you have WPS support on your router.<br/><br/>Cons:<br/>-The internet viewing is done via an external service from Samsung's server.  This causes a huge amount of latency so the video is delayed and not smooth at all. You also have to register the device and sign in to there service.<br/>-the night vision is pretty bad.  The infrared LEDs are far too few and weak.  This makes it almost useless as a baby monitor while the baby's sleeping in the dark.<br/>-Normal video quality is barely acceptable.  If you've never tried one of these of devices before, you might think it's not that bad.  After looking at my sister's Motorola unit, it was pretty clear (or not clear).<br/>-Audio, both direction is terrible.<br/>-Doesn't support any sort of Pan/Tilt/Zoom.<br/>-Recording feature is useless, mainly because of the subpar video quality and frame-rate.<br/><br/>With those shortcoming, I had to return it.  I considered going with the Motorola unit first, but although the picture quality and features were nice, it was expensive. I'd asked around and found that baby monitors with dedicated video displays, the display unit often degrade because they use low quality LCD screens.<br/><br/>So I did a bit more research and tried something not even advertised as a \"Baby Monitor\".  The Foscam FI8910W. It a IP Camera with excellent features and performance.  Once I tried this, it was day and night.  The setup is more geeky.  To view the feed from the internet, you'll have to know how to setup your router for port mapping and have either a static IP or Dynamic DNS.  But for a person like me who deals with this stuff all the time, it was quite simple, no trial and error.  Either you know how to do or you don't.  Like the Samsung, you'll need to connect it to your LAN for setup before using it over WiFi. You're streaming directly from the Camera so there no delay and the video quality, although not HD (there's also an HD version the FI9820W but never tried this), is fantastic!  The night time performance is awesome. It supports Pan and Tilt, but not Zoom (some software will allow digital zoom, but this is pretty useless).  On my iPad it looks amazing, way better than even the Motorola unit.  Same on my Galaxy Note and any computer.  The video doesn't degrade when you're connected from outside your home network.  The two-way audio, although not fantastic is more than acceptable.  It's a bigger unit, but it doesn't take up much more room than the Samsung, which is flat. The biggest plus, it's less than $90 on Amazon.  So while I wait for my wife to pop, I'm using the camera to monitor my Dog while I'm at work.  I've even been able to get his attention when he's up to no-good while I'm at the office.","I bought this item, relatively sight unseen, without reading the initial reviews here.  (This was a mistake)  Out of the box, I was able to connect the device to the LAN, set up my account via the website, and get the camera working.  Where the problems started was with the Wireless set up.  I followed the instructions in the quick start guide, and the device was able to detect our network.  When I entered the password, it failed to save the settings.  We tried every different option, ensured our password was entered correctly, and still was unable to connect.  We also validated that it did not work on multiple devices when trying to update via the SmartCam website.  (2 different laptops, 2 different OS's and a tablet) The support site for Samsung was also no help with this error, when we searched their troubleshooting FAQ's.  Because our overall poor experience (usability, time wasted, lack of information from the OEM) we are returning this monitor.  I suspect we can get a better device for the same price.","We use the camera as a nanny cam. The camera is up and running for 4 months continuously and we did not have any issues. A recent firmware update decreased the latency of the camera on a local wireless network from 2 seconds down to maybe 0.5 seconds. The only thing I am unhappy is the android software support. Currently, the app does not support android 4.1 (jellybean). Hence at work, I am forced to use my compute rather than my smartphone. Also I was hopping that I would have an app on my Samsung SmartTV to log into the camera. One important thing: The smartcam is using peer-to-peer connection. Hence, you have to connect do each camera individually. Only if you connect to the camera, you will use bandwidth. This is in strong contrast to the dropcam solution. The dropcam solution is set up as a online dvr (digital video recorder) system. All data is sent via a dropcam server (US based) and hence the local area network will see much more traffic. The samsung smartcam only allows event recording to a private youtube account. If you are looking for surveillance 24/7, certainly the dropcam solution (monthly charge applies) is the better choice. Re-routing the traffic via a server vs peer-to-peer will add up to increased latency (5 seconds). Another note: I could not observe the timeout issues described by other reviewers.","Dont buy this. Any reviews on here that are positive are fake. If I could return it I would. It is junk. It has absolutely no support from the developers, other than the android app that gets an occasional update (which ends up ALWAYS breaking something else in the app). I have been in relay mode for 2 months. A $15 baby monitor works better and more reliable. I had terrible quality and stability when it did work. Both Samsung Galaxy S3 and Galaxy S4 work for about 3 minutes and then disconnect (well not now since the last two updates). Both phones are unrooted and fully updated. For all 3 of those devices being made from Samsung they should work flawlessly. Without WPS you need a windows computer to set it up. Linux support (besides android) is not available. You can change some settings via linux by directing a browser to the ip address of the camera and using the camera username and password to log in. However there will not be any video playback and certain settings fail to save or appear across different browsers (chrome, midori, firefox). Every attempt i have made to contact the developers has been ignored. This is Samsung's worst product I have owned. It was advertised as being a baby monitor. Why use this for watching your baby when it works once out of every thirty times you try to use it? When in relay mode sound is disabled as well, along with the lagged poor resolution video: you will be done changing her diaper before you see yourself on the screen (seriously). I guess my minimum of 30 mbs connection isnt fast enough for a crappy video, but it is just fine to stream 1080 Netflix on three devices simultaneously and 3 computers running nonstop. They cant complain that my ports arent forwarded or router issues either. This product just does not work.","Prior to purchase I read the instruction manual and it specifically stated on page 31 that the camera software worked in Mac OS Snow-Leopard (Safari) browser<br/>\"Web Viewer=Supported Browser : Windows XP, 7 (Internet Explorer 8, 9, Firefox, Chrome), MAC OS X Snow Leopard (Safari)<br/>I have the latest Mac OS on my desktop and server, but on the laptop I intended to use I've maintained OS 10.6.8 Snow Leopard for my Adobe Suite and Quark. I spend an hour trying to view the camera footage with no joy, I call Samsung Service Center and the agent tells me I must have the latest Mac OS software in order to use the camera.<br/><br/>So I move the camera to the office, plug it into the server, pull the websight up on a Mavericks (os 10.9.2) Safari browser and wahlah, there it is. I set all the preferences but for some reason it's not recording and storing data in the folder. It's not recording audio or video, it's just allowing me to view and listen without recording.<br/><br/>I have a number of IP Security Cameras, so setting up cameras is nothing new to me. I open up Security Spy, a custom security software that cn access hundreds of cameras, but for some reason, not this one. It sees the camera's Mac Address, but the camera won't send a video or audio feed.<br/><br/>I have no idea what's wrong with these cameras, nor do I like the fact that Samsung has claimed in writing that they work with a specific OS and then tell you on the phone that they do not.<br/><br/>Every other Samsung product that I have, TV's, monitors, Galaxy phones and tabs work great, which is why I bought this product, the Brand. Samsung has done themselves a disservice with this product, and I hope they resolve it or get out of the surveillance camera business.","If you want to set up a secure camera network to monitor your baby or your home, while at home or away, then this is a good alternative.  Set up is easy and i have experienced no issues.  Can access cameras easily both in network, while at home on the same wifi network, and remotely, while on a different wifi network and cellular...( verizon).<br/><br/>I can access remotely, easily and relatively quickly (ten seconds) from ipad, iphone and android (samsung S2).<br/><br/>Picture quality is poor even on HD thats why it gets 3 stars. But you can hear and see what's going on.  Great for keeping an eye on kids and also for baby room.  Have 2 cameras paid 120 for first one, 90 for second one, now 60 bucks, a steal for what it gives you.  Will add 2 more.","In principle the set up was simple and the camera is good quality and has reasonable features, however, from first set up and use it went down hill quick.  First during setup, the instructions seemed simple and straight forward enough yet when I hit a glitch and called the tech support number supplied I got to a very impatient and unhelpful agent.  I actually hung up on him and called back to try to get a support person a little more friendly and actually got a guy that made the first one seem like dream...total obnoxious ass.  Both agents blamed me for the difficulty getting the camera online but two more calls and finally got a friendlier agent who confided that Samsung's cam server was to blame and that it is frequently down or over loaded.( he also confided that he and his fellow support agents were not Samsung employees but rather subcontractors).  In the end the two problems I face are that I constantly get false notifications of motion in my store after hours and when I try to log on from my iPhone app to see if there's an intruder I'm frquently met with a \"can't connect to the server\" message. So, as stated in the header....this cam it utterly useless as a security monitor.","I bought this Samsung monitor based on the positive reviews.  The price was higher than I wanted to pay, but I'm willing to pay for quality.  I received the device in 2-day with Prime, and followed the instructions to set it up.  Unfortunately, it never worked.  It was never detected on my network, and the light on the front, which is supposed to turn \"white\" when it's ready to operate, never did.  I just packed it back up and returned it.  Thankfully Amazon offers a simple return policy.","I really do like the features this camera offers, unfortunately none of them work very well or are stable enough to be used as a dedicated camera (if you would call this a camera, more like a 30 second preview).<br/><br/>1. Has the ability to notify you via email, twitter, gtalk, etc when it detects motion or sound.  Unfortunately, just viewing the camera seems to set off the alarm.  Also IR mode will constantly notify me something is going on when in fact its just the IR light going off.<br/><br/>2. Wifi was sketchy at first.  Kept forgetting the associated AP.  Firmware updates failed a lot, but after finally upgrading to version 1.12 it seems to be slightly more stable.<br/><br/>3. For whatever reason, sometimes the camera will show as offline when viewed through Samsung's site.  I can still access it directly using its internal IP address.  Unfortunately the latest update crashes Internet Explorer (they no longer have Java, but some shoddy plugin that needs to be updated a lot).<br/><br/>4. Video quality is absolutely horrible when relaying it through Samsung.  Even worse, you can only view like a minute at a time, then you have to click something to keep it playing for another 30 seconds or so or it will bump you back where you have to relogin again.  So this is not a camera you can constantly monitor, which is pretty stupid.<br/><br/>5. The Android app is just as bad.  Have to login twice, wait for it to connect via relay, then I get about a minute of very low quality video.<br/><br/>All in all, this product still seems to be beta.  It's not really usuable, needs a LOT of work to get it to something that I would trust to monitor a pet or baby.  Until they offer an option to completely bypass Samsung and allow phones to connect directly, I don't think the quality will ever improve.  Connecting via browser directly is far better, but the new plugin doesn't work with IE.  So its basically a crippled product with a lot of great features that do not work too well.","The picture is outstanding however, these are the cons:<br/>This may just by MY issue but the camera constantly loses its network connection. I tried moving my router closer to the camera. I will try hardwiring it next (which will be a pain since theyre not in the same room GRR!) Also, it would be nice if the SOUND part of the monitor stayed \"ON\" even when I go to another app on my mobile device. Instead, once I go to another app, the smartcam app stops providing sound. The monitor is \"OKAY\" but the main reason I purchased it is so I have something to notify me of my baby waking up in the middle of the night. Since the camera constantly loses its connection, I  instead, wake up to my baby crying because he's been fussing for awhile and I didnt hear him. Like I said, I'll try hardwiring it but if you're looking for a baby monitor, you might as well get a non IP (non wifi) type. They're sooo much more reliable. We also have a summer video monitor and it is GREAT!"],"images":{"small":"http://ecx.images-amazon.com/images/I/31MKmInhIUL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31MKmInhIUL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31MKmInhIUL.jpg"}},{"name":"Viatek UBF01-B Breezie Table Top Bladeless Fan","asin":"B00DQI2U5G","price":"$12.97","stars":"2.1","reviews":["Pointless little machine. It's about as useful as having someone gently breath on you, and is super loud for almost zero output.","The product is useless. When plugged in with the usb adapter it works but it needs to be within 8 inches from you to feel the air move. Tried to test it with 4 AAA batteries and could not insert them at all. I contacted seller for returning instructions and they told me to keep it, donate it or throw away, and they refunded the cost of the product but discounted about 50% for shipping. So, product not good at all, customer service Ok.","Brought this for my wife who's going through life changes...  She loves it!  It's battery and electric, portable, quiet, and there's a sponge you can freeze to make it feel like an air conditioner!  Worth the money....","I wanted a small fan to sit on my end table to move air while sleeping.  Only thing it will move will be sound to keep me awake.  I literally have to be 4\" away to feel the air, so it's absolutely useless!  Not even worth my time to drive to town to return it!","It is not a heavy force of air, but it is nice to keep the air moving. And, there is a sponge that comes with it to help make it cooler.","Makes a rattle noise!  You get what you pay for!","I am in between several reviews on this item. This is NOTHING like the high end fans, that looks EXACTLY the same.  I knew this prior to purchasing, but several people commented on how (*name of expensive company*) much it cost, due to the price of their other items!!<br/><br/>*Price wise*: Very nice (average price, to me anyway) - especially for what it does, and the prevention of children  fan blades.<br/>*NOISE*: At first I was okay with it, not bothersome at all (when first bought  received it).  Now, weeks later, annoyance level is elevating. It would DEFINITELY make a great low cost travel white noise maker!!<br/>*Air Movement*: Okay/good, considering the size of the actual fan (in back of device) - I have found that the air movement is not consistent all the way around the whole circular fan opening - my fan seems to push 95% of the air from the very top of the fan - aka \" 12 o'clock position \".  To make the air current hit me, I position the fan on its fully adjustable kickstand (included) to angle it better.<br/>*Power Source*: BOTH battery  USB power source (no wall plug in - this is a small, hand-held/desk fan)","A little louder than I anticipated for the medium output I expected.  Batteries took finesse to insert. I like the item and was just as advertised. Using it as a extra computer cooling fan. Without batteries installed will turn on/off with computer via USB port.  It's new and will update review later for lifespan timeframe vs warranty.","Perfect for the pool or beach. I originally bought these to setup next computers, but they quickly started to live in the beach bag. I was skeptical about the power behind a small blade-less that charges on USB, but they're so lightweight, they are almost supercharged handheld fans during lazy days.","This fan is not worth even the small amount of money I spent on it.  I should have read reviews before I purchased, my fault.  I purchased it to have a small, quiet, professional looking fan at my desk at work.  You can hardly even feel the air coming out of it."],"images":{"small":"http://ecx.images-amazon.com/images/I/31WAbJvxwxL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31WAbJvxwxL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31WAbJvxwxL.jpg"}},{"name":"Portable Car Vacuum Cleaner","asin":"B008S3FX1M","price":"$11.39","stars":"2.1","reviews":["Great product to have in your arsenal if you need to quickly vaccum your car without the hassle of a car wash.. It will save you money to have this product. It is easy to pull out and quick to use. Just plug into your phone charger and vaccum away any clutter in your vehicle. I am a taxi driver and I love it. It helps to maintain my car quickly and easily.","Broke thirty minutes of trying to use it, the button to open the container is on the top so when you're vacuuming you could accidentally open the vacuum and spill everything out of it. It was a terrible design.","This vacuum doesn't suck very well. Went to vacuum and the button broke. Not very well made. Cheap and crappy","This sucked in more ways than one. First of all, the little white part shown in the photo kept falling off, the suction really sucked and it just didn't make sense to use it to vacuum since all the dust and tiny specs of dirt sucked in were dispersed right away through one of the little vents, instead of<br/>being held in the frontal section until disposal time. My car was more in a mess after using this than before. I threw it away immediately!","Although I was VERY SATISFIED with the Seller's willingness to satisfy the customer by sending out another, the second one I received has hardly any power.  It doesn't pick up hardly anything.  For a high-power mini vacuum as it's described, it's a great disappointment.","This product is horrible! When I received the package the container was bent and disheveled. I was so surprised by the size of it that I waited to use it until yesterday. It didn't work! It made a horrible noise and it didn't pick up anything! Not worth it....I really want a refund!","It is perfect for cheap price  working nice. I love this vacuum. Lowest weight  easy to carry. I recommend this other customer.","Poor quality vacuum. Does not stand up to its description of high power vacuum. Very disappointed.","Doesn't suck up little crumbs which would be the main purpose, but sucks up little rocks and things easy to pick up. Doesn't have a hard suction, but a very slow one as well. Better off sweeping the dust  dirt out your car....","All biases aside, the fact is my item arrived broken. There were cracks in many key areas of the product. This vacuum  would not work there were many leaks that would prevent it from working properly. I don't want to speculate how it broke before the box arrived. Objectively the box did not contain any cushion materials that would minimize impact. This device is made of fragile plastic. Such product without any impact prevention is just not good service."],"images":{"small":"http://ecx.images-amazon.com/images/I/41ZyuineW4L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41ZyuineW4L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41ZyuineW4L.jpg"}},{"name":"Munchkin Bath Fun Bubble Blower, Blue (Discontinued by Manufacturer)","asin":"B006SFUDTE","price":"$25.40$9.90$5.99$4.99","stars":"1.5","reviews":["I know a lot of you have issues with the bubbles popping before it leaves the mouth. My husband finally figured out how to fix it. First of all, I used regular bubble solution (not bubble bath) and all we had to do was put a piece of tape over the left half of the air output and it will work just fine :)","Well we were most disappointed that the bubbles were popping before they made it out of the mouth, but I could see the problem!  The blower opening is too wide and the air stream is hitting the wand to soon.  A tiny piece of tape on the leading edge of the opening and it works like a charm - we have bubbles everywhere now :)","Amazon.  Please remove this product from your listings.  I have never seen such a promising toy fail this awfully.  I first thought it was my batteries, and rotated in 5 sets of batteries, until I came here to see if I was missing something.  I was.  It might be the worst product I have ever bought.","I got this product after reading all of the previous reviews despite all of the negative ones. I knew going into the purchase that I may have to do some maneuvering with the air spout as previous reviewers stated. This thing is not worth the aggrevation!! I placed tape over the air spout behind yellow blow holes (tricky as it is) and the thing worked 30% of the time to blow a few bubbles. Most of them popped before coming out and was a big disappointment after all of the hassle. Save your money and buy the babies R us brand equivalent....it has worked just fine witout manipulation.","So.....why is this flawed, non-working product still on the market? Munchkin has some really good items, and some crap....this...falling into the latter category.  Strange that  they haven't done a complete redesign with all of the product returns. Mine is definitely going back. I don't give my son disappointing, crappy, non-working toys.<br/><br/>It's a bubble blower. I doesn't blow bubbles, I don't even care what the reason is....fact is it doesn't do the one thing it is marketed for....or anything else, for that matter.","I tried with different bubble solutions and the classic dawn/water and it's just able to blow blobs that sticks to the penguin body and just end up being a mess.... disappointed.","It basically doesn't work period.  Not only did it not blow bubbles the bubble soap leaked out of the bottom.  Total waste of money.  My kids were very disappointed.","DO NOT WASTE YOUR MONEY!  This product does not work.  The bubbles break before even leaving the wand.  Completely useless.  Very disappointing!","Like most toddlers, my daughter is crazy about bubbles. So, when I saw this in the store, I thought it was a great concept and perfect for bath time. I was also sold on their claim on the front of the box that says, \"Hours of bath time fun.\" Just like most of the reviewers said - It didn't work, at first.  But thankfully I read the last review (submitted by Anne Hyatt) - and she's right.  This will work if you modify it the way she described.  Basically, the oval hole (behind the yellow wands) that blows air for the bubbles is too big.  If you're patient enough to take a piece of tape and cover about half the hole, I swear - you will have MANY bubbles coming out.","Horrible at generating bubbles.  Our 10 month old was not impressed at all. Save time and money...don't buy this piece of overpriced junk."],"images":{}},{"name":"Samsung RF323TEDBSR 31.6 Cu. Ft. Stainless Steel French Door Refrigerator - Energy Star","asin":"B008493LD2","price":"$2,499.49","stars":"2","reviews":["A bit of history...  We purchased the Kenmore Elite 31 cu.ft. version last December (2011) from Sears. After dealing with multiple failures and constant service calls (all on the ice machine), we finally traded it in for this one. We basically had three choices for a large capacity French door fridge - the Kenmore Elite, the LG and the Samsung. After nearly a year of dealing with constant service calls and erratic ice, I wasn't willing to give that ice machine set-up another try. So we went with the Samsung. (The LG has the same mechanisms as the Kenmore).<br/><br/>The Good:<br/>I have to say I was a little disappointed at first. I like the open shelf space that the in-door ice machine affords. I also like the three layers of drawers in the freezer. That all changed once I loaded up the new Samsung. The extra space in the door of the Samsung turned out to be WAY more than I anticipated. The Kenmore and LG have the slim shelving on the ice machine side. That seems like it would be enough, but let me tell you, it's not. Those shelves are so slim, that hardly any condiments fit in them. And you can only fit one row. It doesn't seem like a big deal until you are rifling through a full refrigerator looking for a small but too-round-to-fit-in-the-door jar of jelly that has made its way to the back of the bottom shelf because you don't use it that often. Having all of my myriad of condiments, jellies, dressings and miscellaneous jars of whatever that those side shelves are meant for, is worth the less than open feel of the interior of the fridge. And although the interior seems smaller because of the ice machine, the Samsung is actually one cubic foot larger than the LG and the Kenmore - that doesn't seem like a lot, but my full Kenmore Elite was noticeably less full when I transferred everything to the Samsung. That additional one cubic foot along with the extra side shelf space made a HUGE difference.<br/><br/>The other big plus is that you can open the right side drawer on the Samsung even if the left door is closed. You couldn't do that with the Kenmore. To open the drawer on the right side, you had to open BOTH fridge doors. Who's bright design idea was that?<br/><br/>Mixed Review Features:<br/>The doors are SO easy to open. With the Kenmore, there were times I had to really pull to get them open. And sometimes the kids couldn't even get them open - which can be a blessing or a curse. Now my six year old is easily able to get herself another glass of milk... unfortunately, so is my two year old :o)<br/><br/>The only noticeable difference with the doors is how they close. The Kenmore was difficult to open, but easy to close. That meant a LOT of unintentionally slammed doors. The Samsung has a sort of \"catch\" before the door closes. Basically it just means that you have to want to close the door. It definitely won't be closing on its own. Again, that could be a good point or a bad - depending on your preference. Also, the left door is configured in a way that it doesn't stay open on its own. If you can open it and hold it open for a minute, it will stay. But if you just push it all the way open, it WILL close on you. I spoke to a technician and that's how it is - nothing can be changed. It's only a big deal with I'm loading up the weekly groceries. I move a bar stool over to hold it open and it works fine. Small inconvenience.<br/><br/>The ice dispenser (the few times is actually worked) on the Kenmore was fine, but I really am not a fan of push one button, get some ice, push another button, get the water. The Samsung has two separate \"paddles\" - one for ice, one for water. Very convenient - especially for the kids. Not very convenient is the location of the water dispensing tube. I've already soaked the kitchen floor three times. It is very close to the front. I actually find myself holding the glass forward and pushing the water paddle with my finger. Not very convenient. It works fine for large glasses or pitchers, but not standard glasses, and definitely not sippy cups or smaller glasses. Speaking of pitchers - this one is big enough to fit our Zero Water pitcher and the water container for our coffee maker. The Kenmore, while tall, was just barely too short to fill either all the way.<br/><br/>Another nifty feature is that the ice maker will push extra ice down into the bottom freezer into an ice bin. This is a good and bad. It's good because the upper ice bin is small. If you have a large group of people who all use ice, you will probably run out. However, this fridge will automatically fill an ice bin in the top drawer of the freezer. That bad news is that it takes away from some space in your freezer. Even if there is a way to turn this function off (I haven't looked into it yet), there is a chute to contend with. If you put food too far back on that side of the top drawer in the freezer, it will prevent it from closing.<br/><br/>The ONE thing I don't like:<br/>Only having two layers of drawers in the bottom freezer. The bottom section is DEEP. There really is no way to organize such a deep drawer with the irregularly shaped frozen food products. At least no way to organize it and keep it that way while actually using it. I find myself constantly reorganizing or digging for things.<br/><br/>Overall:<br/>Even though it was a pain, I'm so glad we had to exchange our Kenmore. I LOVE, LOVE, LOVE this Samsung. Having had both, I would HIGHLY recommend the Samsung over the Kenmore and probably the LG since it is configured basically the same way. If you are looking for a large capacity French door with a bottom freezer - THIS is your fridge!<br/><br/>Other Notes:<br/>I purchased this from Sears and I cannot emphasize how happy I am with Sears Service. I had the Blue Crew out 6 times over the span of 11 months. During those 6 visits, I only saw two different technicians, both of whom were very knowledgeable and patient and willing to do anything to help get my ice machine to work. One of the techs even went out of his way to take some of the parts outside to assemble them because it would be noisy and my two-year old was taking a nap! Talk about Customer Service!! When I finally threw in the towel on the Kenmore, it was a very quick and easy process to return the old fridge and get a new one. The Customer Service Rep was extremely nice and apologetic and made the return process completely hassle-free!","<div id=\"video-block-RFPNPMOTPQ0QD\" class=\"a-section a-spacing-small a-spacing-top-mini video-block\"/><input type=\"hidden\" name=\"\" value=\"http://ecx.images-amazon.com/images/I/B189M10J5cS.mp4\" class=\"video-url\">\n  <input type=\"hidden\" name=\"\" value=\"http://ecx.images-amazon.com/images/I/91vaudka6PS.png\" class=\"video-slate-img-url\">Samsung French Door refrigerators have an Achilles' Heel. There is a fancy, hinged flange that creates a seal between the doors. When it works, it creates a very good seal. Problem is--it relies on a couple of flimsy springs to pull it into position. After 2 years of totally normal use, one of the flimsy spring housings cracked, and the spring popped out. Not easily fixable. Compounding the problem, our beloved local appliance servicer can't even get parts for Samsung fridges. Spent a long time on the phone with Samsung, asking for some help, such as sending the part for free, I bear the expense of installing it. Seems fair, but they robotically repeat \"it's normal wear-and-tear\". Yeah, sure. I'm 48, have owned any number of fridges, usually they go 20 years with no problems, this is definitely the first where the door has broken! Shame, otherwise it is a nice appliance at a reasonable price.<br/><br/>I will update with cost once I get the part from the place they directed me to.</input>\n</input><div class=\"a-row a-spacing-top-small review-comments\">\n  <div data-reftag=\"cm_cr_getr_d_cmt_opn\" aria-live=\"polite\" data-a-expander-name=\"review_comment_expander\" class=\"a-row a-expander-container a-expander-inline-container\">\n    <a href=\"javascript:void(0)\" data-action=\"a-expander-toggle\" class=\"a-expander-header a-declarative a-expander-inline-header a-link-expander\" data-a-expander-toggle=\"{&quot;allowLinkDefault&quot;:true, &quot;expand_prompt&quot;:&quot;&quot;, &quot;collapse_prompt&quot;:&quot;&quot;}\">\n      <i class=\"a-icon a-icon-expand\"/>\n      <span class=\"a-expander-prompt\">\n        <span class=\"review-comment-total aok-hidden\">10</span>\n        <span class=\"a-size-base\">10 comments</span>\n      </span>\n    </a>\n    <span class=\"a-letter-space\"/>\n    <i class=\"a-icon a-icon-text-separator\" aria-label=\"|\">\n      <span class=\"a-icon-alt\">|</span>\n    </i>\n    <span class=\"a-letter-space\"/>\n    <span class=\"a-size-base cr-vote\">\n      <span class=\"cr-vote-buttons\">\n        <span class=\"a-color-secondary\"><span class=\"review-votes\">\n          49 people found this helpful.\n        </span>\n      Was this review helpful to you?</span>\n        <span class=\"a-letter-space\"/>\n        <span class=\"a-button a-button-beside-text a-button-small cr-vote-button cr-vote-yes\">\n          <span class=\"a-button-inner\">\n            <a href=\"https://www.amazon.com/ap/signin?openid.return_to=https%3A%2F%2Fwww.amazon.com%2FSamsung-RF323TEDBSR-Stainless-French-Refrigerator%2Fproduct-reviews%2FB008493LD2%2Fref%3Dcm_cr_getr_d_vote_lft%3Fie%3DUTF8%26voteInstanceId%3DRFPNPMOTPQ0QD%26voteValue%3D1%26csrfT%3DgOqmoSW9VUhyZrzbrXlq1K%252FfheD4Jy3GPwye4psAAAAJAAAAAFeYRudyYXcAAAAA%26sortBy%3Dhelpful=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=usflex=checkid_setup=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0\" class=\"a-button-text\" role=\"button\">Yes</a>\n          </span>\n        </span>\n        <span class=\"a-letter-space\"/>\n        <span class=\"a-button a-button-beside-text a-button-small cr-vote-button cr-vote-no\">\n          <span class=\"a-button-inner\">\n            <a href=\"https://www.amazon.com/ap/signin?openid.return_to=https%3A%2F%2Fwww.amazon.com%2FSamsung-RF323TEDBSR-Stainless-French-Refrigerator%2Fproduct-reviews%2FB008493LD2%2Fref%3Dcm_cr_getr_d_vote_rgt%3Fie%3DUTF8%26voteInstanceId%3DRFPNPMOTPQ0QD%26voteValue%3D-1%26csrfT%3DgOqmoSW9VUhyZrzbrXlq1K%252FfheD4Jy3GPwye4psAAAAJAAAAAFeYRudyYXcAAAAA%26sortBy%3Dhelpful=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=usflex=checkid_setup=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0\" class=\"a-button-text\" role=\"button\">No</a>\n          </span>\n        </span>\n      </span>\n    </span>\n    <span>\n      <span class=\"a-letter-space\"/>\n      <span class=\"a-declarative\" data-action=\"cr-popup\" data-cr-popup=\"{&quot;width&quot;:&quot;580&quot;,&quot;title&quot;:&quot;ReportAbuse&quot;,&quot;url&quot;:&quot;/gp/voting/cast/Reviews/2115/RFPNPMOTPQ0QD/Inappropriate/1/ref=cm_cr_getr_d_rvw_hlp?ie=UTF8&amp;target=L3NzL2N1c3RvbWVyLXJldmlld3MvYWpheC9yZXZpZXdzL2dldC9yZWY9Y21fY3JfYXJwX2Rfdmlld3BudF9yZ3Qj3D&amp;token=769B4F79A50E11B5D229CC323CD8792293F0CBFD&amp;voteAnchorName=RFPNPMOTPQ0QD.2115.Inappropriate.Reviews&amp;voteSessionID=154-8733237-2591248&amp;type=popup&quot;,&quot;height&quot;:&quot;380&quot;}\">\n        <a class=\"a-size-base a-link-normal a-color-secondary report-abuse-link a-text-normal\" href=\"/gp/voting/cast/Reviews/2115/RFPNPMOTPQ0QD/Inappropriate/1/ref=cm_cr_getr_d_rvw_hlp?ie=UTF8=L3NzL2N1c3RvbWVyLXJldmlld3MvYWpheC9yZXZpZXdzL2dldC9yZWY9Y21fY3JfYXJwX2Rfdmlld3BudF9yZ3Qj3D=769B4F79A50E11B5D229CC323CD8792293F0CBFD=RFPNPMOTPQ0QD.2115.Inappropriate.Reviews=154-8733237-2591248=popup\">Report abuse</a>\n      </span>\n    </span>\n    <div aria-expanded=\"false\" class=\"a-expander-content a-spacing-top-base  a-spacing-large a-expander-inline-content a-expander-inner\" style=\"display:none\">\n      <div class=\"a-section a-spacing-base comment-submission\">\n        <span class=\"a-declarative\" data-action=\"reviews:input-comment\" data-reviews:input-comment=\"{}\">\n          <input type=\"hidden\" name=\"csrfT\" value=\"gOqmoSW9VUhyZrzbrXlq1K/fheD4Jy3GPwye4psAAAAJAAAAAFeYRudyYXcAAAAA\">\n            <div data-reftag=\"cm_cr_getr_d_cmt_txt\" class=\"a-input-text-wrapper a-spacing-top-mini comment-text-area\">\n              <textarea placeholder=\"Talk about why you like this review, or ask a question.\" rows=\"2\" disabled=\"disabled\" class=\"a-form-disabled\"/>\n            </div>\n          </input>\n          <div class=\"a-row a-spacing-top-small a-grid-vertical-align a-grid-top\">\n            <div class=\"a-column a-span8\">\n              <div class=\"a-box a-alert-inline a-alert-inline-error comment-no-text-error aok-hidden\">\n                <div class=\"a-box-inner a-alert-container\">\n                  <i class=\"a-icon a-icon-alert\"/>\n                  <div class=\"a-alert-content\">Please write at least one word</div>\n                </div>\n              </div>\n              <div class=\"a-box a-alert-inline a-alert-inline-error comment-prs-error aok-hidden\">\n                <div class=\"a-box-inner a-alert-container\">\n                  <i class=\"a-icon a-icon-alert\"/>\n                  <div class=\"a-alert-content\">You must purchase at least one item from Amazon to post a comment</div>\n                </div>\n              </div>\n              <div class=\"a-box a-alert-inline a-alert-inline-error comment-submit-error aok-hidden\">\n                <div class=\"a-box-inner a-alert-container\">\n                  <i class=\"a-icon a-icon-alert\"/>\n                  <div class=\"a-alert-content\">A problem occurred while submitting your comment. Please try again later.</div>\n                </div>\n              </div>\n            </div>\n            <div class=\"a-column a-span4 a-text-right a-span-last\">\n              <span class=\"a-button submit-comment-button sign-in\">\n                <span class=\"a-button-inner\">\n                  <a href=\"https://www.amazon.com/ap/signin?openid.return_to=https%3A%2F%2Fwww.amazon.com%2FSamsung-RF323TEDBSR-Stainless-French-Refrigerator%2Fproduct-reviews%2FB008493LD2%2Fref%3Dcm_cr_getr_d_cmt_btn%3Fie%3DUTF8%26expandedComment%3DRFPNPMOTPQ0QD%26openCommentSubmission%3Dfalse%26sortBy%3Dhelpful=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=usflex=checkid_setup=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0\" class=\"a-button-text\" role=\"button\">Sign in and comment</a>\n                </span>\n              </span>\n            </div>\n          </div>\n        </span>\n        <div class=\"a-row a-spacing-mini review-comments-header\"><ul class=\"a-viewoptions-list a-viewoptions-section a-span12\">\n    <div class=\"a-row a-spacing-none a-grid-vertical-align a-grid-center\"><div class=\"a-column a-span6\"><span class=\"a-size-base a-viewoptions-list-label\">Showing <span class=\"review-comment-count\">0</span> of <span class=\"review-comment-total\">10</span> comments</span></div><div class=\"a-column a-span6 a-text-right a-span-last\"><span class=\"a-size-base a-viewoptions-list-label\">Sort by:<span class=\"a-letter-space\"/></span><span class=\"a-declarative\" data-action=\"reviews:sort-comments\" data-reviews:sort-comments=\"{}\"><li class=\"sort-newest a-viewoptions-list-item a-selected a-color-state\">\n            <a data-reftag=\"cm_cr_getr_d_cmt_lft\" class=\"a-link-normal a-selected a-color-state\" href=\"#\">Newest</a></li>\n          <li class=\"sort-oldest a-viewoptions-list-item\">\n            <a data-reftag=\"cm_cr_getr_d_cmt_rgt\" class=\"a-link-normal\" href=\"#\">Oldest</a></li>\n        </span></div></div></ul>\n</div>\n        <div class=\"a-section a-spacing-extra-large a-spacing-top-medium a-text-center comment-load-error aok-hidden\">\n          <div class=\"a-box a-alert a-alert-error cr-error\">\n            <div class=\"a-box-inner a-alert-container\">\n              <h4 class=\"a-alert-heading\">There was a problem loading comments right now. Please try again later.</h4>\n              <i class=\"a-icon a-icon-alert\"/>\n              <div class=\"a-alert-content\"/>\n            </div>\n          </div>\n        </div>\n        <div id=\"TxK8BK2I93SWLY\" class=\"a-section a-spacing-none review-comments\"/>\n        <div class=\"a-spinner-wrapper comment-loading aok-hidden a-spacing-top-medium a-spacing-extra-large\">\n          <span class=\"a-spinner a-spinner-medium\"/>\n        </div>\n        <hr class=\"a-spacing-none a-spacing-top-large a-divider-normal\"/>\n      </div>\n    </div>\n  </div>\n</div>","This refrigerator is spacious beyond all dreams!  I've always had side to side fridges before, so this was new to me. This design will blow your mind.  You no longer have to a) bend over unnaturally to find the milk on the shelf in your parents freezer-on-top model of old. Nor do you have to try to worry about where you're going to put something over 12 inches in width. I absolutely love the extra space that the french door on top affords!  I love that I can put wide things (pizza, big casserole dishes) in the fridge flat and not have to tilt.  There is so much space in this thing it is ridiculous. I was forever running out of space in my old fridge but I haven't even come close with this one.<br/>The downside: I'm not sure what's going on but it makes really loud noises.  It started innocently enough the first few months with louder than expected banging at random times.  That was fine, who was I to look the gift horse of the space utopia in the mouth? I could live with a little noise. It got louder. Then louder. Finally, I thought pulling if I just pull back farther from the wall it would help. OMG!  Once I did that it sounded like the whole house was being under machine gun attack. I have contacted Samsung and I hope they will help, just wanted to let folks know if they are considering it to be aware that this could be an issue for them. Will update as potential fix progresses...","We bought a previous version (RF266) of this imposing but seriously flawed refrigerator. As reported elsewhere on the web, there was a class action against SAMSUNG for problems relating to buildup of ice in the refrigeration compartment. The ice eventually interferes with the operation of the cooling fan, requiring the frequent (about every 6 months) manual defrosting of the unit. Now, there are two possibilities: 1) SAMSUNG knows about the defrost design flaw; or 2) SAMSUNG does NOT know about the flaw. If they know about the problem, why don't they stand behind their product and fix it for its existing customers? If they don't know about the flaw, or have chosen to ignore it, it probably has NOT been addressed, so buying this newer model carries considerable risk of future problems, problems which may or may not be covered under warranty (mine weren't). Luckily, there are plenty of other refrigerator manufacturers to choose from.","I have done a few months research before buying this model and have had it for over a month now. I would buy it again.<br/><br/>CDI's earlier review is absolutely spot on (please read it), I do not want to repeat but will add a couple of points.<br/><br/>Design - it is a sleek looking, clean design. We went back and forth between this and the LG and thought this one wins. It is personal of course. For example the water/ice dispenser cavity edges do not protrude out or overlap with the stainless steel face - think of a under-mount sink in your kitchen vs regular one. Display is cleanly organized and the blue lights are cool.<br/><br/>Noise - it is a fair bit quieter than the old side by side Whirlpool it replaced. Consumers report has the fridge in their top choice category overall and rates noise to be Very Good. Very few have Excellent in that category. Noise level probably depends on the specific setup. My fridge is in a cavity and that muffles the noise for sure. If one of the sides is exposed, noise will be more noticeable. Perhaps going into a quiet store and giving it a listen can help.Not a concern for me though.<br/><br/>A piece of advice. Both LG and Samsung have stainless steel covered ice and water dispenser plates/buttons. If you push the plates a few times with a glass or ceramic cup, plates will scratch. I bought tablet screen protector, cut two pieces shaped like the plates and it worked very well.<br/><br/>The only thing that could be improved is freezer layout. As pointed out before, bottom drawer is deep and could have been split in two levels, i.e. have three levels in the freezer as opposed to two. It would not be fair if I deducted a star for that as there are so many other things done right on this fridge, hence my rating.<br/><br/>AN UPDATE AFTER 10 MONTHS of USE:<br/> - in summary - no regret at all<br/> - noise level has not increased. Not the most silent fridge but noise is easy to get used to.<br/> - amazing space. Right door holds 14 beverage cans per shelf - non stacked!. Left door can hold 4L pack of milk and quite a few tall bottles and jars, unlike the LG (which I was considering at the time).<br/> - never had to deal with stuck ice. In-fridge ice-maker is not in the door (and takes very little useful space in the fridge itself), hence ice never melts and sticks, unlike the LG.<br/> - there is a flap on the cold drawer where you can return or even pull stuff in or out without pulling out the drawer. It works even after opening just one door as the opening space is enough for many things - infinitely convenient for me.<br/> - ice makers can be turned on or off individually. Mine are both off most of the time. I only turn an ice maker on when it is empty while at the same time I never run out of ice as the other ice maker is like a back up.<br/> - ice and water dispensers are very well designed, unlike the LG.<br/><br/>Minor gripes:<br/> - FIXED NOW: left door does not stay open - by design. When I am loading the left side of the fridge, I have to hold it most of the time. NO LONGER A PROBLEM - read the tips I added below.<br/> - drawers in the freezer can be organized a bit better - more specifically, the upper drawer should not automatically come out as I open the freezer as most of the time I have to push it back to access bottom of the freezer.<br/><br/>Tip:<br/> - protect Ice and Water dispenser plates as they can be scratched by class or porcelain cups. I bought a super cheap iPad screen protector and cut two pieces shaped as the two plates and then stuck them on. It looks good too.<br/> - spend the effort and make sure fridge is perfectly level. I did not do very good job the first time so first, the left door would close on its on if I did not hold it - annoying when you load the fridge. Second, it was a bit noisy. After perfect leveling (place level on top of the fridge), sound is low and doors stay at any open position.<br/> - stay away from in door ice makers. My sister has the LG and every other time I visit, they have to open the ice-maker to break up the ice cubes as they slowly melt and get stuck if ice is not used within a day or so. In terms of ice capacity - there is no comparison.<br/><br/>I would buy it again - no doubt.","Refridgerator was great while it worked.  After 14 months, Ice Machine stopped working, wasnt under warranty, so I had to lay out $250 for Part and Repairman fee's.  last week, the Compressor for the cooling system went (this was purchased on 7/3/12)  Around 3 years old.  Compressor and sealed system is covered for 5 years by Samsung.  Great, Called customer service, Literally on the phone for over 7 hours over the course of 2 days, speaking to every department, trying to find a certified repair center on Long Island, NY (literally 20 mins from Manhatten, there are no authorized service centers near NYC? really??  I was blown off, they didnt want to honor the warranty.  Every time you get transferred as an escalation, the rep doesnt give the new department details, so you have to start over all again, whats your phone #?  can you verify the email address? how can I help you? ETC.. it was, by far, the WORST Customer service experience Ive ever had with a company before.  All I wanted was to have a service man come to my house in a timely manner to fix the Fridge.. Fridge broke last Monday, still waiting to hear about a service tech in my area.. aweful, aweful experience.  When I called my service repair guy, he said EVERYONE complains about Samsung's customer service..","OUTRAGEOUS BEYOND BELIEF<br/><br/>On March 22, 2015, our 15-month old Samsung 31+ cu. ft. refrigerator  (model code RF325TEDBSR/AA; serial V35343BD801137P) died.<br/><br/>My wife and I have been assigned abroad since spring of 2014.  Our two sons (in their mid-twenties) have continued to live in our house in Washington DC.  When the unit stopped working, elder son called Samsung, which referred him to one of their contract repair firms (A Factory Service).  A repair technician came a few days later.  He said you need to order a new &#x201C;mother board&#x201D; at your expense.  My son did so; cost: $252.  After the part had been delivered to our home, the tech returned to install it.  Whoops!  Now you need to order a PCB sub service module board.  My son did so; cost: $165.  When that item arrived, the tech returned to install it.  Whoops!  You need a new compressor, but that will be provided at no charge.  After the compressor arrived, the tech returned to install it.  Whoops!  There&#x2019;s something wrong with your evaporator.  At this point the tech called his boss at A, who decided that after 4 attempts A could not repair this refrigerator and instructed him to remove all of the items he had previously installed.  (We are to be reimbursed for the two items we paid for.)<br/><br/>At this point, it was more than four weeks since the unit failed, and my son has used four of his ten days of annual vacation to be at home for the repair.<br/><br/>And, we do not have refrigeration.<br/><br/>I had returned to the United States temporarily on April 16, but was at another location eighty miles away when the repairman made his final visit.  When I heard that A had abandoned the repair, I called Samsung.  After several hours on the phone, I was told that a decision would be made as soon as Samsung had the report from A, but that might take 24 hours.<br/><br/>Two days pass.  Samsung has still not heard from A  Samsung (a nice lady in the Dominican Republic) tries to reach the relevant people at A while I wait on hold.  No luck.  Samsung suggests that I try to reach A and ask them to send their report(s) to me so that I can forward them to Samsung.  Several more hours.  I reach the right person at A  She sends me the reports.  I forward the reports to the email address Samsung gave me.  Several more hours.  I call Samsung.  After more waiting, they find the reports and call A while I am on hold.<br/><br/>Now, it gets even better: A confirmed that they were not able to fix the refrigerator, but according to Jim S. in Samsung&#x2019;s &#x201C;Executive Customer Relations\" (ECR), that does not mean that another Samsung contractor might not be able to fix it!  Another repair contractor will contact us within three to five business days!  But what about the two computer boards and the compressor that were taken away???  Are we facing another month without refrigeration???  No answer.  &#x201C;We will review the situation.&#x201D;  &#x201C;We have to follow our protocols.&#x201D;<br/><br/>And what if any repair that might or might not be accomplished fails after ninety days?  This is all that Samsung guarantees a repair for &#x2013; which is exactly what happened with a Samsung microwave that we had to have repaired after only a couple of years of use.  It died again just outside the ninety-day period.<br/><br/>Samsung should have replaced this refrigerator weeks ago.  I cannot imagine any reputable American firm deciding to do anything less than this.<br/><br/>Of course, I should be punished for buying another Samsung product after the costly disaster with the microwave.  And, indeed, I have been punished.<br/><br/>You can be sure that I will do my best to broadcast Samsung&#x2019;s outrageous behavior as loud and wide as I am able.  I have only begun to fight.","I bought a similar refrigerator to this a bit over a year ago.  It started having problems with dripping water inder the crispers and was just out of warranty.  The service tech who came out said it was a flaw in the original design, that Samsung knew about it and had even designed a special \"fit-kit\" to fix the design flaw.  The total cost was cost was $300!  I called Samsung and went through the usual number of customer service people and they all refused to step up and pay for all or even most of the repair.  They did offer to pay for the part only ($18.00)... BFD. Samsung? Never again!  I was told they now own GE as well.","Purchased Samsung RF323TEDBSR in June 2013.<br/><br/>On November 21, 2013, under the 1 year warranty. Called Samsung about a cracking noise and<br/>air leakage at door.<br/><br/>They approved and sent out a 3rd party company called United State Appliance.<br/>After United State Appliance attempts to call 3 times to make an appointment, you must call Samsung again to request a service order!<br/><br/>He replaced the left door seal that became damaged or a manufactures defect. Samsung said the loud cracking noise is normal expansion and contracting noise.<br/><br/>There was and still is a very loud squealing noise when opening the freezing drawer. It&#x2019;s from the upper tray in the freezer. Called Samsung and they said it&#x2019;s normal and can&#x2019;t be repaired.<br/><br/>There's 2 ice cube making machines. 1 on the door and 1 inside the bottom freezer. The one on the bottom freezer is really loud when the ice cubes dump into the plastic tray.<br/>The nice thing is this refrigerator is huge with lots of space and nice LED lighting. They shouldn't have wasted space on the water filter when it could be install outside of the refrigerator behind in the drywall pocket cutout or at the reverse osmosis filtration system. I'm not into drinking tap water or just using a 1 stage filter from Samsung.<br/><br/>In August 2014, I noticed the freezer door was really crooked, about &#xBC;&#x201D; gap at the top of the pull out freezer drawer while the bottom part had no gap when the door is fully closed.<br/>And the now the right-side refrigerator door seal was leaking air.<br/><br/>On September 17, 2014 I called Samsung customer service. They said it&#x2019;s out of warranty and will have to transfer me to Executive customer service department.<br/>There they approved a one time warranty extension. Service transaction number: 4126641969<br/><br/>This time a 3rd party appliance company called<br/>Service Quick, Inc<br/>18655 Bishop Ave Carson, CA 90746<br/>(310) 747-1360<br/><br/>On October 3, 2014 a repairman Raymond (senior tech) from Service Quick came out and found an error code regarding the defroster sensor. Oh that&#x2019;s why some of the food in the refrigerator had ice on it!<br/><br/>He replaced the damaged refrigerator right seal.<br/><br/>About the bottom freezer door being crooked and leaking air. Raymond said it can&#x2019;t be repaired and it&#x2019;s not a problem. Unbelievable really!<br/><br/>Called Samsung Executive customer service department about the leaking bottom freezer door. First lady said it&#x2019;s normal and not a big issue and will not do anything about it. She was mean and rude.<br/><br/>A minute later, I talked to a different guy from the Executive customer service department. He was really nice and concerned. He said Service Quick didn&#x2019;t put in their report that the bottom door leakage was &#x201C;non-repairable&#x201D;.<br/><br/>So I called Service Quick and they said they will not put &#x201C;non-repairable&#x201D; in their report. Cold air is leaking, there&#x2019;s a gap of about &#xBC;&#x201D;!<br/>Their reason? They said it&#x2019;s not an issue and to call Samsung and request another repair company.<br/><br/>It looks like Samsung and the 3rd party repair companies have some agreement to cut Samsung expenses?<br/><br/>The refrigerator is new with so many problems. It wasn&#x2019;t cheap! $2500! I can see if it was a cheap refrigerator but it wasn&#x2019;t.<br/>You only have 1 year to find any problems. After that there&#x2019;s a possible one time extension.<br/><br/>I thought Samsung being the largest tech company in Korea and heard good things about Samsung TV and cell phones that the refrigerators would be quality also. I thought wrong. Best to stick with quality American made (getting difficult to find but they&#x2019;re out there), Japanese or German.","I bought my fridge from Lowe&#x2019;s because the sales person said that this is the best fridge out there. I wish I read the Amazon reviews before believing the sales rep in the store. This fridge is a nightmare to deal with. The ice NEVER comes out in cubes &#x2013; it crushes it with some snow dust (cannot put it in the drink &#x2013; great for snow cones, I guess). I had service people come out three times and finally Samsung tech support said that &#x2018;this is how this unit runs&#x2019;. I had issues with awful noise when I would try to get some water, but thankfully it got fixed (don&#x2019;t know how long it will last &#x2013; the fridge is only 8 mos old). The freezer drawer does not come out/open easily &#x2013; I have to put all my energy into trying to open the door and then dive into the freezer to get anything out. But then, the drawer door hits me, as it slides back immediately. The double dispenser for water and ice (ice is shorter and water is longer) &#x2013; the design is very unfortunate. The water always leaks when I try to get some water and if I try to get ice, the water runs first. I have called the customer service so many times but they are not willing to help, saying that this is a &#x2018;normal&#x2019; functioning. Now it is too late to return/exchange and I am stuck with this awful refrigerator. I had Kenmore in the past and never had to call a service (one lasted 10 years and the other one is still working at my mom&#x2019;s house, after 8 years and three moves)."],"images":{"small":"http://ecx.images-amazon.com/images/I/41UiZhGVFiL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41UiZhGVFiL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41UiZhGVFiL.jpg"}},{"name":"Pocket Portable USB Humidifier by Aire' (Rose)","asin":"B00MV27T1I","price":"$4.99","stars":"2.1","reviews":["It's a very tiny little thing, just like it looks like on the picture, so that it fits in a regular cup.<br/>The idea is great, but 1.) there's no description with the box to explain what and how it works. It's not rocket science, I get that, but it would be nice to have a little more info than \"plug it in, put it in water\". 2) the little thing doesn't heat up the water or shoots it up high enough, so it just falls right down and makes everything wet around it. Since it's a USB gadget, you probably have some electronics around when in use, so that settling water is bad news.<br/>We tried it with a cup of hot water, it worked a little better that way, but still not perfect.<br/>Fun idea for sure, I wish it worked better.","I bought 3 of these for the ladies in my office. It is really dry there and I was sick of being shocked by everything I touched. Out of the 3, one works. It does shoot out a nice flow, but of course I was stuck since you can't return it. (I should have looked at the fine print.) thankfully Amazon refunded my money.","Personally, as I have some seasonal allergies, having this at my desk would be exactly what I need. And this is perfect for my office; because it is so little and fits in a cup of water. This tiny device produces a natural aroma which helps me to concentrate on my work. Its very effective as advertised and easy to use and highly recommendable. I am pretty happy for buying this.","This worked for a day then filled with water and died. When I looked closer at the donut I noticed the two halves weren't sealed properly. Whatever glue was used didn't do the job. In the trash it went. The hunt for a good usb humidifier continues.","Thought I would take the gamble since it was only $6. Worked great right of the box. I only ran it for 1-2 hours at a time day 1. Day 2 it sputtered out and died. It's a great concept and would be fantastic if it worked for more than a day, but you get what you paid for. $.02 of plastic and a usb chord.","I love this at the fire thing because it helps me breathe better hope things up my nose and my lungs and I bet I have very bad allergy problems so with people is very bad allergy problems or bronchitis or anything I highly recommend this","two stars for the fun element of $7. I got my money's worth as it was intriguing. Died after 4 weeks. no instructions on how to run it. Not very stable in a glass of water and water easily fill the center hole and clogs it. The mist is not high enough to escape a small 4 inch glass unless you fill it to the top where it becomes a waiting water disaster to happen.","Its a very tiny little product, never thought it would do any good. But it&#x2019;s only 7 dollar worth. So I thought of giving it a try. Trust me it works amazingly. Its quality is better than my expectation. You can use it anywhere. Very easy to use and reasonable price. Thanks for this great product.","An easy humidifier with USB cable, you can plug it with your laptop it is so refreshing with air purifier and aroma diffuser, works all over my room! Making me relaxed like never before, I recommend this product and fully satisfied with my purchase.","An Excellent product. I usually sit before computer for a long portion of day time. After purchasing this little humidifier, I feel very comfortable in front of computer. My lips, eyes and hands are now not getting cramped or rough. It is easy to use- just plug in the usb to computer and of course easy to place anywhere. I love this product!"],"images":{"small":"http://ecx.images-amazon.com/images/I/41ZFPJ30m6L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41ZFPJ30m6L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41ZFPJ30m6L.jpg"}},{"name":"Emerson Combination Machine","asin":"B001AS12KI","price":"","stars":"2","reviews":["Wow! I am a student, so money is not too abundant; however, my wife and I love coffee and dig good espresso, but don't like paying $4+ for a latte. When I saw this combo unit I was skeptical that I could make a good espresso. Machines that friends have are $500+. However, it does a great job.<br/><br/>Pros:<br/><br/>1. Coffee has an automatic brew timer.<br/><br/>2. Good sized water reservoir, especially if you are making a load of espressos.<br/><br/>3. Has a frother. The frothing wand could be longer.<br/><br/>4. The PRICE is the best out there for a good beginner espresso machine. I've had cheaper ones that break easily and do not produce a good espresso WITH crema.<br/><br/>5. Simple operation. You'll read some reviews about the instructions, but come on-it's not rocket science...it's coffee. Water in the water reserve. Check. Grounds in the mesh filter (no more paper-yah!). Check. Push the on button. Check = Coffee. For espresso: Water in reservoir. Push espresso on button. Make sure that you are set for the cup and not steam (pictures). Pump should be off. Put empty portafilter in machine and turn the pump on when green indicator light is on. Run water through for 5 seconds and then turn the pump off. Remove portafilter and put finely ground beans in. Lock portafilter into machine. Turn on the pump. Here is the confusing part: How long do I run the machine for? The manufacturer does not say. I run it until the brown crema gets too light (yeah, subjective-I know). Turn the pump off and turn the machine to steam production. Wait until the green indicator light turns on and then turn the dial ever-so-slowly to flush out water in the line. Then bring your milk to the frothing wand (that you have perfectly placed the rubber tip onto according to my advice below) and turn the steam on ever-so-slowly. When the green light turns off, it's still ok to keep running the steam (if you check, sculding hot steam is still coming from the machine) unless you go way too long. You should be able to steam and foam with this machine in one pass (I started out requiring two warm ups of the steam boiler to get this right, but I guess I really wasn't getting it right-it should take you one pass).<br/><br/>6. Looks attractive.<br/><br/>7. 15 bars of pressure is competitive with very expensive machines.<br/><br/>8. Has a removable drip tray under the espresso machine.<br/><br/>Cons:<br/><br/>1. Only makes 10 cups of coffee.<br/><br/>2. The frothing tip is rubber and sits over a single-walled metal wand. The wand gets very hot, which can burn the milk (so I am told by \"experts\"-can't tell the difference except for the dried milk that requires a quick and easy rub with a wet rag for clean-up). Nonetheless, the metal part does not have a side spout, which is needed for microfoam production. So, if you want microfoam, you have to place the rubber tip over the wand ever-so-perfectly. Looking inside the rubber tip, there is a groove along the inner cylinder. If the metal tip is just a little higher than this inner cylinder groove exit, then you can actually produce microfoam with this machine and do it quickly-complicated? Sorry. You'll understand when you make a dozen lattes and can't understand what you're doing wrong and then start to experiment.<br/><br/>3.If you get leakage out of the portafilter (the part where ground espresso goes) then you are probably not tamping the grounds down hard enough (requires ~30 lbs of pressure) OR have grounds in the groove. The machine is sensitive in this regard. Also, make sure you do not remove the portafilter until the pressure dissipates (just leave it off for a few minutes) otherwise when you unlock the portafilter grounds are shot into the groove and makes a small mess.<br/><br/>4. There is not a carafe temperature control knob.<br/><br/>5. There are no temperature gauges to tell you what the operating water temperature is (good to know for perfect espresso).<br/><br/>6. Portafilter is fairly small, so making double shot espressos is hard.<br/><br/>Tips:<br/>1. Get coffee flavoring-vanilla, hazelnut, caramel, mocha-whatever you prefer and put 1/2 a shot glass amount into each latte. It really changes everything.<br/>2. Tamp a little ground cinnamon onto the final product for a little extra. It adds flavor and a good smell.<br/><br/>I hope this helps. I do not usually write reviews, but this machine is very impressive for the price, so I wanted to help you out by giving more details.<br/><br/>Follow-up 2/14/10: Unfortunately, the Emerson boiler broke just a few months after purchase. I was still able to produce coffee, but could not make espressos. I contacted the manufacturer and they gave me a return number. I packaged everything up and mailed the entire unit to Emerson's repair department. I didn't have all of the required documentation of purchase, but they did not hassle me. The representative was very polite and effective. She understood the problem and just told me to send it back with a note on the defect. About a week or two later, a brand new Emerson arrived on my doorstep. Haven't had any problems since. Great customer service. The only complaint I could muster if forced to was that I had to eat the shipping cost to Emerson for the unit (~$20); however, they have a $15 charge for all returned products for mailing back to your home. They waived this fee without me even asking about it!","Okay, so the instructions are less than clear.  Do yourself a favor, throw away the brown 'quick start' sheet that came in the box.<br/><br/>Using the instructions in the book, I had this baby up and brewing in no time.  I wish the steamer arm were a little longer to reach deeper into my frothing pitcher, but c'est la vie.<br/><br/>I looked around all over for a reasonably priced espresso machine for a beginner, and I'm glad I picked this one.  It brews well both on the drip side and the espresso side.  The steamer works great, everything cleans up easily and it just looks cool sitting on my counter!","Update- 1/2011<br/>Would definitely not buy this machine again. The \"start\" button broke off inside so now I have to stick a pencil tip in the hole to turn the dang thing on. Again, it makes a decent cup of coffee but it's very poorly made. Pass on this machine. Spend the $ on something more substantial.<br/><br/>Update- 3/2010<br/>A year on and I have to revise my review. It does make a decent cup of coffee on the drip side, but in retrospect I wish I had invested in a nicer machine. This one is fine for awhile, but like other inexpensive coffee makers, it doesn't hold up.<br/><br/>The most annoying thing about this is the reusable filter basket. It's a white mesh (not gold tone) filter that has fallen apart. I cannot find a replacement and the other reusable filters I've tried simply don't fit in this machine. The filter is oval shaped and other cone and basket replacements are round.<br/><br/>I've also had issues with the coffee not going into the pot...waking up to find coffee all over the kitchen counter. It doesn't happen every time, but it's still annoying. After a year, I still can't figure out why this happens. The overflow issue has also caused the heating plate to rust, which is exactly why I had to replace my last coffee maker. :(<br/><br/>I have only used the expresso side once or twice, but I'm not really impressed with it either.<br/><br/>Bottom line...I'd pass on this one and invest in something nicer.","I bought this unit at Target after much research. If you like your coffee hot, don't bother getting this machine.  Also the Carafe is paper thin.  The spot to pour the water in, is in the very back of the machine which is awkward due to the size of the machine.  It also brews very weak coffee.  We did not try the espresso maker, so I can not comment. I took the machine back today. For the price I paid I expected a better quality machine.","We bought one of these at Target for $95.  The drip coffee side worked as advertised, but the espresso side doesn't steam and no water will come out of the espresso cup.  We're taking it back  getting something different.<br/><br/>A combo machine for this price would be great, but only if it works.  With all the bad reviews (here  at Target), my guess is they have some problems with the design or manufacturing process.<br/><br/>Buyer beware.","buyer beware-- Unit is:  attractive - and worked well---- for TWO MONTHS before S-L-O-W-L-Y discontinuing service and now it doesn't work AT ALL--3 months post purchase.  Attempts to contact for replacement under warranty have resulted in:<br/>Amazon:  'Not my job- contact seller' - /  Seller Daves Electronics - Not us--contact manufacturer /  Manufacturer.. left email message, phone message and a postal service letter is ON ITS WAY-- no return contact to date.<br/><br/>01/01/16-- Mfg. Emerson--- \"we discontinued making 2 years ago\" - we will not be responsible for replacement\"--- NOTE TO BUYER:-- I was OUT of pocket for every penny paid for this machine - nobody-- Amazon- i.e. (we don't guarantee- contact seller/  Daves Electronics - seller-warranty is by mfg. we are not responsible/ Emerson who supposedly 'guarantees' it's product has advised THEY are not responsible for the warranty since they discontinued mfg. --- NOBODY is standing good for this guarantee - NOBODY will refund or repair. --- BAD.... I expected more from both seller and distributor-- and most certainly expected the manufacturer to STAND BY ITS GUARANTEE.... --- Very sorry I purchased and am out the entire purchase price. -- NEVER GOT TO TRY the 'expresso'--","This coffee and espresso machine is decent. The reservoir where you pour the water for coffee is a little awkward  if you are making more than about 5 cups (or half a pot) of coffee, it spills everywhere. It has lasted a while now though, so that's good. The espresso part seems more complicated than necessary - so it never gets used. I had another machine that was both coffee/espresso that was much more simple to use - and I made lattes at home often then. Now... never. It's probably not that difficult once you get used to it, but... who wants to read the instructions every time you try to make espresso. I would rather just drink coffee.","Product received looks used! Worse then a 2 page carbon copy paper for instructions! Which you can't read with a maginfier! For the copy is smeared! In addition, says to see pg 9 or 7 etc.. would be nice if I had those pages. Now going to try online to get insturctions for the espresso part...since I've never had one of these machines. Have a house full of guests for Thanksgiving and don't want to look like a fool!!!! Had pies in mind for today, guess that's onhold till I figure out the maching. Extremely disappointed in product and price! Since it was used! Really people!","The coffee pot is adequate at best, brewing a mere 10 cups, and takes up to ten minutes to brew an entire pot.<br/>The espresso side is nearly useless. The controls are not intuitive. I'm never quite sure I've pushed the correct buttons in the correct sequence; or that I've waited a long enough time for the steam to build before trying to steam milk...<br/>Overall, I do not feel this machine delivers the dollar value at this performance level.","I may just have a solution to your problem. If the frother is no longer working then please read. I have a some simple suggestions that will fix your machine so you don't have to buy another one. Even if your espresso machine is not an Emerson, this solution will help you as well.<br/><br/>I got my Emerson machine from a friend. After only a couple of months the frother stopped working. I am not sure how long my friend had the machine, but I was very disappointed. I didn't want to have to buy another machine. Luckily others have had similar problems. It turns out that the frother wand can get clogged. You can take a pin and unclog the head by removing the outer rubber piece (which you should be removing and cleaning anyway).<br/><br/>If that doesn't make the frother work then you can open up the machine. It is not as scary as it sounds and it is actually quite easy to fix. I was pleasantly surprised to be able to fix this machine myself without having to pay to ship it back to the company.<br/><br/>First of all, make sure you unplug the machine. On the top of the machine you want to open the lid on the coffee side. There are some plastic covers over some screws that you need to get to open up the machine. The screws are hidden underneath the plastic covers. They appear to be sealed, but they actually pop right out with a little muscle. Underneath you will find the screws. Now unscrew the machine. Once the machine is open it will look a little bit scary, but it really isn't. There is a thick plastic tube on the right side that has most likely popped off due to preasure. You must carefully, without disturbing the wiring, put the tube back on the metal pipe that looks like it goes to nowhere. The tube goes over the metal pipe, I promise.<br/><br/>AND if that doesn't work then your lines are most likely clogged and you need to flush the system with a water/vinegar solution as described in the manual. If your machine keeps getting clogs then it is because you are not using distilled water and minerals are getting stuck in the tubing. You should only use distilled water on these types of appliances or you will be sorry."],"images":{"small":"http://ecx.images-amazon.com/images/I/31lUVzi28xL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31lUVzi28xL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31lUVzi28xL.jpg"}},{"name":"Mommy's Helper - Curtain and Blind Cord Wind Up - 3 Pack","asin":"B00E9EPMXS","price":"$14.34$12.02$18.43$4.86$5.96","stars":"1.8","reviews":["This is a horrible blind cord winder.  I would give it 0 stars if possible.  Every time I tried to open the blinds, it fell apart if I touched the cord wind up.  Don't bother with these.  Get the Kidco Blindwinder instead.  It ratchets the cord up and is easy to open your window up while the Blindwinder is still on the cord.","It's a horrible product. If you want to raise and lower your blinds, they don't work at all. An alternative: Buy cord cleats at Home Depot.  [...]<br/>You screw them into the trim on the side of your window and wind the cord around.  Low-tech, low-cost and it works.  If you get the ones in the link with 2 pieces, you can mount them 6-12\" apart, and you don't have to wind so many times.","The twisting feature doesn't work according to package directions- the caps just lock in place and only turn about a quarter of a turn in either direction. You have to wind the cords BEFORE placing the cap back on, it's a little tricky to keep all of the cord wound around the tiny little axle in the middle without the cap. Very cheap, but hey, I guess it didn't cost that much. Still better than nothing and they seem to stay in place ok.","These are just one of many cheap child safety products out there than may serve the intended purpose, but may be more trouble than they are worth to make work. It's not rocket science, but it's a total pain in the ass to get the cords lined up in the right direction, with an adequate length of cord, and to get it all wound up and snapped together. You think you finally got it, and then you pull the cord to adjust the blinds and the caps pop apart and now you've got a tangle of strings to untangle. Maybe 'm just missing the magic touch, but..<br/><br/>I'm plenty happy rolling the cords into a ball and securing them with a hair clip. it's less work and plenty effective.","We have blinds in every room of our house and have anywhere from 3-6 cords on each set of the blinds.  These work great and scrolling up the excess cords so my little ones can't get at them.<br/><br/>They are so simple, inconspicuous, and safe.  I have them in every room!  I would highly recommend!","What a disappointment.  This product does not seem to work.  I can't get it to turn more than a centimeter or two in either direction, so it won't wind up.  I tried more than one, and still had the same issue.  Very frustrating to purchase a baby safety product that does not work.<br/><br/>When I tried to determine if this was user error or product error by contacting the company, they didn't even know how to use it.<br/><br/>I do not recommend purchasing this product.  I am returning this product.","I do like how these Wind-Ups hold the cord up out of baby's reach. However, I move my shades up and down throughout the day, and the Wind-Ups couldn't take it for long. Within a few days they were popping off every time I pulled the shade cord. I gave up and now I just loop the cord around the window lock to keep it out of reach instead.","I read the reviews that said they didn't stay on.  I thought I could do better an ordered them anyway. They were ok if I separated the double strings into singles. Then I tried to open the blind. They flew off. It was a nice idea. If you don't plan in using the blinds they might be for you.","I needed a dozen roman shade cords to be taken out of the reach of my 2 and 4 year olds. The Mommy's Helper cord wind up was inexpensive and simple to install. Other reviewers cite problems with the product falling apart if the cord is pulled to open the blinds, but I have had no such problems. Our cords were very long and it was faster for me to manually wind them around the spindle inside the bottom half of the housing instead of spinning the closed housing to wrap the cord. Also, when closing the unit, a significant amount of force was necessary to get them to snap securely (this may be where the other reviewers are having problems with the Wind Up falling apart when touched). I've had them up for two weeks, opening and closing them daily, and have had no issues at all. They unobtrusively blend into the decor and require no special hardware to install. I'd recommend them to anyone.","Does not work well with blinds that have thick cords. Hard to rotate to make shorter or longer to open/close blinds, and toddler was able to easily pop them open to get cords out. It was more dangerous to have these on than the cords dangling or me looping them up on blinds frame because it could only handle so much cord when blinds were up, and created a lower loop to get caught on and choke than my loop I created doubling the cords back up on blinds frame :("],"images":{"small":"http://ecx.images-amazon.com/images/I/41iNQbpedEL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41iNQbpedEL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41iNQbpedEL.jpg"}},{"name":"Munchkin Deluxe Auto Bottle Warmer, Colors May Vary (Discontinued by Manufacturer)","asin":"B000SES0IW","price":"$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["This bottle warmer takes forever and I've never gotten it to warm anything in a reasonable amount of time. From my experience (I'm a mother of 2 and I exclusively fed my babies breastmilk and travelled a lot while doing so), there is NO car/portable bottle warmer that can effectively warm milk in a reasonable amt of time (30 to 40 mins is not reasonable when baby is hungry) !!<br/><br/>After trying numerous travel warmers in vain, I finally figured out a simple way that really works.<br/>I use a wide mouthed vacuum thermos flask and fill it up with very hot water. When baby is ready for bottle, I place the bottle right inside the thermos flask and cover the lid for about 4 to 5 minutes. The result is perfectly warmed up milk !!<br/><br/>Some tips:<br/>- I have the Ozark trail Vacuum bottle (bought it at Walmart for under $20) - [...]<br/>U can find any wide mouthed vacuum flask that works for u<br/>- I can fit a Dr.Browns 4oz bottle (without the nipple and cap) or a medella 5oz bottle (used with medella pump) inside it. With the Dr.Brown's bottle, I remove the nipple and cap and place it in with just the stopper - I do securely close it with stopper and the rim so there is no risk of either milk spilling or worse yet water getting inside bottle. Its also possible to use the medella bottle cap securely on Dr.Brown's bottle. After warming, I fit in the nipple.<br/>- While placing bottle in flask for warming, I use just the top lid of the flask and do not use the mouth portion : it allows me extra height to fit bottle in. I do use the flask mouth and all its pieces to securely carry the hot water but while warming, I remove the mouth and use just the bottom and lid.<br/>- I boil water on stove top so it stays very hot (rather than just filling hot water from the tap). I usually take refrigerated breastmilk (if frozen, I thaw it a little to make it liquid).. I carry the milk with a cooler and ice pack so it stays cool and fresh until I am ready to thaw it in the flask.<br/>- Fill flask with very little water, so that when bottle is placed inside, excess water doesn't fall out<br/><br/>This method is so much more reliable, simple and portable (u don't even need to be near a car) and it really really works.<br/><br/>I hope this helps other moms/dads out there !","I can't believe that other reviewers gave this item one star!  I use Avent bottles with it and it works great. My only complaint is that sometimes it works too well and makes the bottle too hot.  I used another bottle warmer with my older kids, but it took forever and just didn't get the job done.  This one is fast.  Another great feature is that after the bottle is warm, you can stow the cord in the back and take the bottle in the thermal case with you (as we often do to a restaurant).  And it fits in my cupholder while heating!","It will keep an already-hot bottle warm, but it will not heat a bottle up, which was disappointing. I guess I can still use it to keep bottles warm for short trips.","I've never written a product review before, but this product was such a disappointment, I wanted to spare other moms... As a previous poster noted, the heating wrap gets warm, but never warm enough to heat the contents of a bottle. After 45 minutes, our formula had inched its way up from cold to barely room temperature, and after that much time, I started to worry about food safety. Going through the Starbucks drive-through and asking for an extra cup of piping hot water to warm a bottle in is more practical than using this product.","Excellent product!!! Why is this discontinued...??!!!???<br/>So we us Dr. Brown bottles, and my son is not a timed eater- he eats different ounces at different time intervals. I usually warm up a bottle before I leave the house and put it in this warmer. It keeps it the perfect temperature!!!! Always!!! I prefer having a warmer w-o an automatic shut off so I always know there's a bottle ready when he wants it. Yes it takes about 20 min or so between warming for room temp bottles but a bottle of formula is good for an hour after you make it and usually holds temperature for 10-15 minutes... So I have no idea why this would be a problem? Unless you kid eats 4 oz and turns around wanting another bottle back to back. But this problem can be solved with a little planning! Make bigger bottles when you travel!!!! I would much rather waste a scoop of formula or two; rather than listening to a screaming baby!<br/>I own 3 of these just for backups!!!<br/>Also*** I'm just now replacing the first one; in which survived 2 of my SIL infants and 6 months of constant use from my son.<br/>I also love that the warming pad can be easily removed from the insulating bag and cleaned. The bag is also washer friendly.<br/>Also a huge pro for me is the little fabric handle on the top of the bag- I love that I can hook it on my cup holder in my truck to keep it upright. No more tipped over bottles no matter how crazy I drive.<br/>*** stop looking for travel bottle warmers and get this one!","I bought this because I travel from FL to Ohio a lot and thought this would be great for my new borns bottle. Unless you know approx 1 hour before your child will be awake and screaming for a bottle it's not worth it.","I love this bottle warmer. The negative reviews are because this bottle warmer is not meant to \"warm\" your bottle up. It keeps an ALREADY HEATED bottle warm. What I do is for a shorter trip I heat my baby's bottle in the outlet bottle warmer then I put it into the Munchkin car bottle warmer to keep it warm until we reach our destination. For longer trips I keep a thermos of hot purified water and pour it into the bottle ahead of time, mix the formula, then put it into the car bottle warmer until we get to our destination. It's great for already heated bottles to keep warm but NOT for full heating of a bottle.","we all usually feed our babies before we leave home, i use bottled water and put a bottle in the warmer before i leave home, it takes a while to heat that way it is ready  for me when i am ready for it. if i leave it to long it gets a little too warm i just adjust how much cold water to add so it isnt too hot.  after the bottle is heated it keeps it warm for a long time and i can generally get 3 bottles out of one bottle of bottle water. I read all of the reviews prior to purchasing and am so glad i did purchase it.  I will buy another one when this one quits working it is defiantley worth the price you just have to think outside the box.  I especially like that since i heat the water seperately i dont feel like i am wasting any formula by premixing large bottles that have to sit to cool and then get to old before i can use them.","Buen artculo, pero para alcanzar la temperatura ptima para 9 onzas, se debe esperar una hora. De resto todo bien.<br/><br/>Good article, but to achieve the optimum temperature for 9 ounces, wait an hour. For the rest everything well.","I have this warmer and was very disappointed. We got the Parent's Choice warmer as a gift and thought it too a long time to warm. It was nothing compared to this one. I thought sure that since it could be zipped up it would take no time at all but I don't think my bottle ever got warm. I had my baby on a good schedule and put the bottle in 20 minutes before her feeding time thinking it would be equal to the amount needed in my other warmer. Not so. It was very hard to get the wrap tight around my bottle and then get it back in the pouch. Maybe it was because I used wide mouth bottles. I paid $17 for the warmer and got frustrated and chunked it after the second time of trying to heat a bottle. I know that travel warmers aren't always great but I thought I might have a little better luck with this one."],"images":{}},{"name":"LG LMV1683ST Over-The-Range Microwave Oven with 300 CFM Venting System, 1.6 Cubic Feet","asin":"B007XZ8FNO","price":"","stars":"2.1","reviews":["We used this brand new microwave for 3 weeks, and last night it caught fire while we were microwaving food.<br/><br/>The food was not burnt, or overcooked. In fact it still had a minute more to go, when I noticed flames inside, at the top fan assembly region. We were able to put it out with a damp towel, but the entire top section was melted to reveal the electrical wiring inside.<br/><br/>We googled to see if anyone had a similar problem and found the review posted just a week earlier hear on Amazon. This is clearly not some random freak accident, but a recurring problem with this microwave.<br/><br/>If you have this microwave, do not leave it unattended while microwaving. If you are considering purchasing it, please please do not do it.","I didn't buy this online either.  But I'd like to warn the people who are looking at it.  After 4 days of light usage, this burst into flames.  The fan assembly in the top melted, and only quick thinking saved us from having it ruin our just finished kitchen.<br/><br/>LG is blaming me for using it incorrectly.  Veggies in a Glad container, never an incendiary combo before.  They will replace the parts and clean up the \"cosmetic\" damage, but 2 of the replacement parts are out of stock and there's no telling when they'll manufacture them in Korea.<br/><br/>So, no microwave...  Plus, I'm understandably leery of using this model ever.<br/><br/>Buy American, folks. Luckily I learned how to speak enough Spanish to help explain it to the nice folks at the call center in Panama City, Panama.","I didn't buy this from Amazon, I bought it from Lowes. The microwave worked fine for the first couple of months I had it. It stopped working 3 days ago though :-(. It acted like it was on but the turn table was not working and it was not heating at all. But all was not lost! I called LG's warranty service where I got through to a person almost right away and they quickly determined the need to send a technician out. He arrived today and was very friendly and personable. He replaced a defective relay with a different one, which was a problem they were already aware of and now the Microwave works again!<br/><br/>I also asked the technician about fire hazards with the top fan since I saw some reviews on here mentioning that. He knew about that issue and the cause and showed me how that problem was already fixed on the microwave I bought new. I know having an appliance that catches fire is a little disconcerting but at least LG was proactive about it. I can't say the same for many companies, foreign or domestic.<br/><br/>I know it's kind of odd to rate something 5 stars that broke after 2-3 months of usage. But also out of the ordinary is customer service. I've seen a lot of products reviewed on Amazon where people had problems but couldn't get through to support or customer service. To me, that's worse than having a product that doesn't work because anybody should know the old phrase \"_____ happens.\" The only question is, what is a company going to do about it when _____ does happen? From this experience, I would not hesitate to buy more LG products because I know they will help me out when/if there's a problem.","Another Fire Starter...<br/>After 3 days of being installed by a licensed contractor, the top fan assembly region caught on fire.<br/>My daughter has the exhaust fan blowing, while she was cooking cookies in the Gas Stove below.<br/>about 1 hour into her cookie \"bake off\" she saw flames inside the Microwave.<br/>Luckily she acted quick, used our fire extinquisher and called me.<br/>Cookies ruined, now have to pay contractor to come back to reinstall a DIFFERENT BRAND<br/>of Microwave Oven.  NOT SAFE AT ALL.","I haven't had the microwave burst into flames and that is certainly really scary. What I don't like about it is that the fan is so loud even if it is on low, and the light below for the stovetop is not bright at all. And unless you are looking for a romantic relationship with your pots and pans I would skip this model.","We bought this Microwave at Lowes.  I think I would have a better chance at solving a Rubik's than installing the thing over the stove so we hired our handyman to do it.<br/><br/>The microwave performs OK but the stainless steel began rusting in 9 months.  It is now pockmarked with rust and getting uglier every day.<br/><br/>I regret this purchase.<br/><br/>UPDATE:  Here I am a little more than a year after posting my original 1-star review, and I'm wishing there was zero star option.  One day about 2 hours after dinner the light inside the microwave randomly came on all by itself! The unit was previously off. Upon closer inspection we noticed not only was the light on, but the turntable was also turning. If we open the door, the turntable stops spinning. If we close it, it begins again. And the light remains on.<br/><br/>Sometimes when we're done cooking something it will power off normally like its supposed to and we get lulled into a false sense that it fixed itself. But then it will randomly come on again later.<br/><br/>It's acting like its possessed.  My guess is that all LG products are pure evil, and should be avoided.","Bought this 23 months ago and it works just fine till today. LG chat suggests the magnetron failed. The microwave appears to work but the food does not get hot and the turntable isn't turning. Another reviewer had the same problem and their technician replaced a faulty relay. I hope the fix is simple. For the last 23 months it works well but it is very loud with the vent fan on even on low as others commented. Also it would be nice to turn off the turntable which you can't. Lastly, there is no timer to time your baking cookies or dinner. Our oven has a timer but often it would be nice to have two timers. I wouldn't have even believed a kitchen appliance made would not have a timer. All in all, ok but loud. By the way, the fire issue was fixed in 2014.","We are currently on the third microwave from LG. The first microwave failed after 2 weeks.  It took 2 weeks for LG to get us a new microwave.  The next microwave lasted 11 months.  It went out on thanksgiving, we bought a 69.00 off brand microwave, it has worked perfectly for last 18 months. The LG failed again after 18 months.  Lowes and Home Depot should replace microwave.  Reading the blog, I have never had a brand of microwave failed this often.  I am going to take LG to court.  They have to know there is a major problem, if so many failures, yet they continued producing this worthless piece of junk.  This appears to be another bean counter situation, cheaper to give new machine and fix damage, than recall product.","I wish I could give this zero stars. Bought this last year to go with my kitchen remodel. Every appliance I own is LG, washer and dryer included. Luckily, they still work. I work ALL the time and prefer my food grilled. I rarely use the microwave. Just bought it as a just in case method of heating leftovers. My microwave died today. Just stopped heating. Everything else apparently works on it. Apparently, a faulty magnetron is a wide spread occurrence. I did a live chat with an online rep. She wanted to send me to a service tech over an hour away. I declined. I explained to her similar issues from most owners of this model and stated this should be looked at as being recalled. No way we all messed up our units. I forwarded her to the Amazon reviews. She was basically like yeah, ok, do you want me to find you a service center? At the end of our conversation, she just ended the session. I wasnt finished chatting with her. I will NEVER buy an LG appliance<br/><br/>Chat log:<br/>Chat Transcript<br/>Time of chat: 7/2/2015 4:54:35 PM<br/>Length of chat: 00:18:41<br/>Your name: rafael vazquez<br/>Chatted with: Michelle, Paulsen<br/><br/>4:54 PM Michelle: Hello rafael vazquez. Welcome to LG Electronics U.S.A. Support only. How may I provide you with again. excellent service today?<br/>4:55 PM rafael vazquez: Hello. My microwave stopped heating today.<br/>4:55 PM Michelle: Hi Rafael<br/>4:56 PM Michelle: I am sorry to hear about this.<br/>4:56 PM Michelle: Let&#x2019;s perform some simple troubleshooting steps to see if we can resolve this issue.<br/>4:56 PM rafael vazquez: I'm sorry to experience this...lol<br/>4:56 PM rafael vazquez: ok<br/>4:56 PM Michelle: When the microwave oven does not heat, it may be caused by entering the wrong settings or inadequate power supply.<br/>4:56 PM Michelle: Let's Test the unit:<br/>4:57 PM Michelle: 1. Place a microwaveable safe cup, mug, or bowl of water inside the microwave oven.<br/>4:57 PM rafael vazquez: ok<br/>4:57 PM Michelle: 2. Press CLEAR/OFF or RESET to clear the keypad.<br/>4:57 PM Michelle: 3. Press COOK and enter 60 (seconds).<br/>4:57 PM Michelle: 4. Press START/PAUSE.<br/>4:57 PM Michelle: Did the water heat?<br/>4:58 PM rafael vazquez: In just started it<br/>4:58 PM rafael vazquez: I just started it<br/>4:58 PM Michelle: Ok<br/>4:59 PM rafael vazquez: it did not heat<br/>5:00 PM Michelle: I see. Did the keypad respond and the microwave start?<br/>5:00 PM rafael vazquez: yes<br/>5:00 PM Michelle: Did the timer count down at an accelerated rate?<br/>5:00 PM rafael vazquez: no<br/>5:00 PM Michelle: Is the unit on a dedicated circuit breaker?<br/>5:01 PM rafael vazquez: yes<br/>5:01 PM Michelle: Great!<br/>5:01 PM Michelle: Please Turn off and back on the circuit breaker. Will the unit heat now?<br/>5:01 PM rafael vazquez: ok. Give me a minute<br/>5:01 PM Michelle: Sure<br/>5:01 PM Michelle: Take your time<br/>5:03 PM rafael vazquez: no heat<br/>5:03 PM Michelle: Thank you for your cooperation and your patience in answering all of my questions regarding your unit, Rafael. We are now done with the troubleshooting steps. The unit may require a visit from a professional service technician to diagnose and correct the issue.<br/>5:03 PM Michelle: May I have the exact date of purchase for the unit please?<br/>5:04 PM rafael vazquez: That sucks. I've looked around online and this appears to be a common issue with this model<br/>5:04 PM rafael vazquez: 5-9-14<br/>5:04 PM Michelle: Did you purchase any extended warranty?<br/>5:05 PM rafael vazquez: no<br/>5:05 PM Michelle: I see. I would be delighted to provide you with Authorized Service Centers in your area to help you out with the repair. May I know your zip code please?<br/>5:05 PM rafael vazquez: 76306<br/>5:06 PM Michelle: Thank you so much. Kindly give me a moment.<br/>5:06 PM Michelle: Upon checking, you may call FREEMAN'S APPLIANCE - 580-255-2676 to set up service for the unit<br/>5:07 PM rafael vazquez: where are they located?<br/>5:07 PM Michelle: 4325 N. Highway 81<br/>5:07 PM Michelle: DUNCAN OK<br/>5:09 PM rafael vazquez: no thanks. That's over an hour away. probably cost more to fix than the microwave is worth. It's terrible that a microwave barely lasts a year.<br/>5:09 PM Michelle: I understand and do respect your decision if you do not want to have the unit serviced, Rafael.<br/>5:09 PM Michelle: Is there anything else I can assist you with today?<br/>5:11 PM rafael vazquez: Nope. I'll never buy an LG product again. From the horrible reviews of owners(rated 1 star on Amazon), with similar problems that are online after a year of use, it looks like this model should be recalled. It obviously has faulty components.<br/>5:12 PM Michelle: I will file a report for your complaint.<br/>5:12 PM rafael vazquez: They either stop heating or catch fire<br/>5:12 PM Michelle: It has been a pleasure to assist you today. Should you have any further questions or concerns, please do not hesitate to contact us again via Live Chat or phone at 18002430000. Thank you for choosing LG Electronics. We appreciate your business. Have a great day!","So far so good, but I've only had it a couple of months.  It is a bit smaller in capacity than the one I replaced (due to a pizza fire started by my stepson) and a lot less expensive.<br/>UPDATE 7/12/16.  I recommend this unit. It is well built and economy priced. 2.75 ounce Act II butter lover takes 1:55 for perfect popcorn."],"images":{"small":"http://ecx.images-amazon.com/images/I/31WDNWp6a-L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31WDNWp6a-L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31WDNWp6a-L.jpg"}},{"name":"Safety 1st Cushioned Sof'Knee Protectors","asin":"B000SOUCQA","price":"$2.99$5.22$5.22$8.00$138.54$14.95$10.00 - $13.00","stars":"1.7","reviews":["Very thin, rough material. Definitely not worth it. Do what I did... go buy a pair of wrist sweat-bands (found in the sporting goods section) at your local walmart. Cut a little hole out of the \"back\" of each band and then cut a little slit above it and then below it (this gives the band some give). Slide those over your baby's knees and you'll be set. Much thicker and softer!!!","I purchased these knee pads along with a pair of much more heavily padded ones that have two velcro straps that secure them.  Much to my surprise, the more expensive ones with the velcro just won't stay on my 10-month old son unless I have them so tight that he can't bend his knees!  These ones, however, while not providing the level of padding of the others, stay on regardless of whether I put them on over his trousers or straight onto his bare knees when he's wearing shorts.  Sure, I do have to adjust them from time to time when they inevitably slip down a bit, but that happens about every ten minutes or so rather than the two-to-three minutes of the velcro ones.  The bottom line, for me, is that they allow him to explore over 2300 square feet of tile with no injury to his knees.  And they're infinitely washable, which is a must.  As soon as I get off this review page, I'm going to order another pair!","My baby has bruises on his knees and legs from crawling on my hard wood floors. I was trying to find \"baby knee pads\" and took a pair of adult socks and cut the feet off and used these on his knees. The home made knee pads didn't work very well and chaffed the inside of the back of his knee. I searched on Amazon and found these.<br/>Basicly what these are is EXACTLY what I made at home with the socks as described above. There is NO padding. It is probably thinner then my sock material. They also rub the inside of his knee because they bunch up as they crawl.<br/>I would give these no stars if I could.<br/>Don't waste your money...","I did quite a bit of research and tried different things to prevent my son from getting carpet burn. The expensive pads did not convince me and went ahead and bought these cheaper pads after I tried recreating these with one of my old tube socks which did not stay in place.<br/><br/>When these arrived I was very concerned that they were too small/tight as some reviewers mentioned so I used 2 plastic water bottles (the 24 oz ones) and put these on the bottles to stretch out overnight.<br/><br/>The next day, I put these protectors on my son and at first he kept on trying to pull them down but as the morning went by he got used to them. I do have them removed when he is not crawling too much or busy playing with a toy to let the knees \"breath out\".<br/><br/>Overall this product is worth the money, I would not have payed more as another easy solution would have been to keep him wearing pants :)","My 7 month old summer crawler needed something to protect his knees from carpet burns, etc.  I thought these would work, but they are very small and don't stretch much. If your child has healthy legs, don't use these as they can cut off circulation. My baby is much smaller than the boy in the ad, too. Very disappointed.","This one is just waste of money and I never used this protector in my baby's knee. It not only makes irritation to my kid but also block his blood circluation to the leg. I suggest every parents to keep little one's knee free for them to crawl on bare skin and really feel that sensation of touch to ground. Do not put this back across his legs and make him uncomfortable","Picture shows a healthy size baby, who has thighs and is crawling.  The Sof'Knee are very very skinny and could be used on a small foot, but definitely not a baby who has any leg size at all.  Perhaps for a newborn infant, but definitely not for a baby who is 6 months or more, as the picture implies.  Also, they do not stretch very much, so again, no way they will fit a baby of crawling age unless the baby had tiny thin legs.","These are a wonderful length but they are a little tight on the thigh.  I expected them to be somewhat tight in order to keep them up but these are seemingly a little uncomfortable.","I bought these but love my child too much to put them on. They are severely rough and course. Imaging putting on a deep knit/ribbed sweater and kneeling. It would dig into your skiing and hurt. These things are horrible. Not sure what they're made for, but certainly not for babies, and certainly not for their knees as they crawl. I would give a zero star rating if it were an option.","We live in a hot climate, so it's not always practical to put the baby in jeans. These stay on well and keep him from banging up his knees too bad when he's crawling. They're also about 75% cheaper than the other brands."],"images":{"small":"http://ecx.images-amazon.com/images/I/41DDGSdqBWL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41DDGSdqBWL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41DDGSdqBWL.jpg"}},{"name":"Bright Starts Spin 'N Slide Ball Popper Toy","asin":"B00E192PYU","price":"$47.78$2.99$5.22$5.22$8.00$138.54$14.95$10.00 - $13.00","stars":"1.7","reviews":["My mother bought this toy for my 8 month old at Christmas.  The toy is incredibly loud and the balls don't stay in it.  They fly out almost violently and you have to chase them back down.  I really wanted a ball popping toy for my daughter but this one is the worst I've ever seen.","We got this for our son's first birthday. Yes, its very loud. Yes, the top yellow piece can, and will, be yanked off by your tot. Yes, the balls don't always stay within the toy and go flying. However, this was our son's absolute favorite toy and didn't mind at all that the balls went everywhere, and loved that he could take the yellow piece off by himself. So isn't that really all that matters, that the kid loves it? I mean, its not a toy for us...","This thing worked for about 5 minutes, then the motor stopped spinning and it became useless fast. My son really enjoyed it for those 5 minutes. We could hear the motor grinding and trying to work but obviously something inside of it stopped working.","I constantly have to turn the toy off and back on to get it to work continuously.  Also, my 1-yr old daughter can pull both 'rings' (yellow and red) on the top of the funnels off with little or no effort, no matter what I do, they don't stay on, so when the balls pop up they just go all over instead of back into the toy. There is also a purple plastic piece that comes loose and prevents the balls from rolling down the red spiral back to the whirlpool. She's only been playing with it for 5 minutes at most and I already want to return it.","The first two months we had this, our daughter loved it.  She got it when she was 11 months, and her favorite thing was to stop and start the spinning blue part by putting pressure on it.  She also enjoyed sticking her hand down the blue shoot and stopping the balls from popping out.  The green ring she treated like a stacking toy, taking it off and putting it back on.  The red ring also came off easily as other reviews have noted so I super glued it in place and it stayed that way the last month.<br/><br/>By the third month, she had put enough small stuff down the blue shoot that the inside was full of rattling sounds when the toy was shook.  It also was getting very hot and smelled like melting plastic when turned on so I gave a two star review and put the toy away until I could find a screwdriver to open it and clean it out just in case there was the potential for it to start a fire.<br/><br/>I've increased my rating to four stars because it works again after cleaning it out.  While I was seeing if any of my screwdrivers fit, of which none did, I discovered that if you can tip and shake at the right angle you can get most of the stuff out.  To get the bigger things out, I had to use a stick to push down on the plastic piece that pops the balls.  Once almost everything was out it quit overheating except when she kept the blue part from spinning for too long.  She's now 18 months and still has fun with it.  I recommend buying<a class=\"a-link-normal\" href=\"/Bright-Starts-Having-A-Ball-Toys-Bunch-of-Balls/dp/B008PPQ7GI/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Bright Starts Having A Ball Toys, Bunch of Balls</a>as an addition later on but not right away since they work but sometimes get stuck and need a nudge to go through.","This is the second one I purchased. My kids and other kids (even ages 3 and 4 years old), loved it. But the first one I bought stopped spinning after a week and was NOT in continuous use, so I was able to report it and got a new one. I assume these things happen sometimes, and gave another chance. I was given a new one, and now that too has stopped spinning! When it worked, the balls popped out at a good pace and my kids loved everything about it! But now all else works great, but for the the spinning and popping - the thing that makes the toy exciting to young kids. That doesn't work! So I assume that this product in general does not work and I would recommend NOT buying it and wasting your money.","My 12 month old got this for her birthday from grandma. I thought this looked like the funniest you. Which, I think it would be if it ever worked. Like other reviewers have stated, it's always a gamble if it's going to work or not. I haven't figured out what to do to fix the glitch-- it won't spin or pop the balls. The motor just runs, and the music plays. At that point, it's a tray to put balls on. My baby just drops the balls down the slide for a few minutes, and then crawls away shortly after. Such a disappointment.","Ugh! Wish I had read the reviews before buying this. I bought this for my 14 month old daughter. Within 4 days of having it, the plate stopped spinning which prevented the balls from moving or popping up. I thought we just got a bad one. So I returned it to Amazon and got a replacement. On day 3 of having the replacement, that one also broke. Same problem: the plate stopped spinning. I'm very angry that a toy marketed to one-year-olds would break so quickly and so easily. This toy was way too expensive to be so cheaply made. My advice: save your money or spend it on something else!","This toy is loud, and the balls sometimes fly everywhere, but my son loved it. Unfortunately it only worked for about 10 minutes. He leaned on the blue disk and it stopped turning. I figured it had to be just bad luck, so i returned it and got a replacement. Again it worked for about 10 minutes before the blue disk stopped spinning. My son it 2 - he's not any crazier than any other 2 year old out there. This toy is junk. Don't waste your time.","We are on our SECOND one in as many days.  The spinning and popping just stop working for no apparent reason.  No rough play or the wrong things being put in.  In my opinion, this toy is junk!  The 2nd one is going back too!!"],"images":{"small":"http://ecx.images-amazon.com/images/I/51Kr-PO4mUL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51Kr-PO4mUL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51Kr-PO4mUL.jpg"}},{"name":"Chefmate 12-Cup Coffeemaker","asin":"B0019FG57M","price":"","stars":"2.1","reviews":["I've read a number of reviews on this item...there are folks who seem to buy one and it lasts and works well forever.  But there seem to be more that have the same problem I did.  I bought this yesterday at Target for under $10.  It worked exactly twice and then stopped working completely.  The red power light works, but nothing brews and the hotplate doesn't heat up.  I read on another web site that it's a switch inside that goes bad.  It said you can try and press around on the top to activate that switch, but you might have to keep doing it during the whole brewing process.  Another review suggested it was a fuse that was too small.  Either way, I'm taking mine back to Target and going back to a Mr Coffee.","I had this coffeepot for about 3 weeks and it was working fine.<br/>Unfortunately one day I was using it, and it had been on for about an hour or so (to keep my coffee warm) and I noticed an odd smell. My window was open so I thought it may have come from outside. I turn and look at my coffeepot and realize it was SMOKING. I immediately turned it off and unplugged it from the outlet. The smoke was curling from the bottom of the machine.<br/><br/>Everything was fine, and I threw it out the next day, but it completely freaked me out. I mean it could have started a fire if it was left on any longer. What if I had happened to go in the next room for a little while? I know you're not supposed to leave appliances on unattended but really? An hour and it short circuits?<br/><br/>Dangerous product!!!!","My Ancient Mr. Coffee 8 cup died after 5 years of use and countless times being left on all day / overnight. I needed something new and cheap, as money is tight this month with the daughter's birthday coming up. I saw this coffee maker at Target for under $10.00 and made the purchase. I did not think that it would last a long time, or make particularly good coffee, but I thought it would be on par with my old basic skills Mr. Coffee and would last long enough until I was ready to spring for a more serious coffee maker.<br/><br/>On day 3, I got up, filled it with coffee and water, hit the power button, and stepped away for about 10 minutes. When I returned, nothing had happened. The heating element went out in it I assume, after just 2 days of coffee making.<br/><br/>I guess you get what you pay for, but for $10 bucks, it could have at least lasted 2 weeks. Don't waste any money on this machine.","I cannot recommend this coffee pot enough. It not only brews strong, good coffee in a timely manner, but it is also a very effective ballistic missile.<br/>It has survived one of my drunken roommates hurling it across not one, but THREE rooms at another roommate's head! HOW BADAASS IS THAT?!<br/>It is also quite effective as a melee weapon when the original target recovered the missile and proceeded to demolish the kitchen with it.<br/>Kitchen: trashed<br/>Coffee Pot: INTACT!!!<br/><br/>Good to keep in the home for a cup of GOOD MORNING AMERICA! and also good when the Nazis invade.<br/><br/>See Facebook for more details.","I bought this coffee maker for under $10 at target.  I am on my 2nd one! the first one (bought 4 months ago) lasted a month.  It was perfect in the beginning and I was very happy with my purchase! it was cheap, and brewed fairly quick.  until it just didn't brew one day!  being still new, I had the box so I took it back to target and swapped it for a new one.  that one was working good and lasted 3 months, until today, it didn't want to brew! I should've read reviews on here before I purchased it!<br/><br/>if you don't mind spending $10 every month for a new coffee maker go for it. Personally Im over wasting my time!  Im going to purchase a better quality coffee maker!<br/><br/>You truly do get what you pay for!","AMAZING value...UNDER $10!. Our first one lasted almost 4 years... we're ready to buy another.<br/>Found them again at Target this week (7/2010) and bought two for $7 each! Great value.. GREAT coffee.. great as gifts too!","I bought one from Target for $10.  I didn't expect much, but needed a coffee pot for a couple months while doing a renovation on my house.  The first one worked for 10 days.  The 2nd one worked for 4 days.","I bought this exact model at a Target store about four years ago  have used it almost daily since then. It has worked without a hitch. It is simple: put the paper basket liner in, put the coffee in, put the water in, close the lid, press the button,  wait for the coffee to come out into the pot. It makes great coffee, keeps it warm,  has the interrupt function in case I can't wait for the entire pot to brew (and some mornings, I can't!). It's still plugging along four years later, making great coffee. I guess I'll get a Proctor-Silex when this one eventually croaks, because it looks like the current versions of this model are pretty hit-or-miss. That's too bad. Looks as if Chinese quality assurance now is where Japanese quality assurance was back in the 1950s: pretty poor. All I want is a cheap  simple coffee maker that'll last a few years. Thanks fellow Amazon reviewers for the warning about the spotty quality on this model! Glad I got lucky four years ago...","Same problems as other folks. Just got this tonight at Target for just under 10 dollars. Was looking forward to some good coffee on a cool evening. Put in the water. Put my coffee in the filter, hit the switch.....and nothing. Light comes on and thats it.","Same story as others - worked for about a month, then this morning the red light came on and... nothing.  Don't know if Target will take it back (I - thankfully - paid under $10 for it), but if not it's going straight to the dumpster."],"images":{"small":"http://ecx.images-amazon.com/images/I/41D666c8PZL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41D666c8PZL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41D666c8PZL.jpg"}},{"name":"Cookinex Kung Fu Master Electric Can Opener","asin":"B00AL2ZRLO","price":"","stars":"2","reviews":["I purchased this to replace a electric can opener, the kind you had to hold the handle down to make it work. It turned out to be a weak point of can-openers. This product does not require you to hold anything down, you just get started and it finishes the job on its own. This works really well, also it is not very loud. One more thing, you just cant go wrong with that name.","This is an easy-to-use can opener for the most part, but occasionally it doesn't latch on to the can properly and the can drops off, sometimes causing a mess.  The other thing I don't like is that the lid, once detached, has extremely sharp, rippled edges which could cut your hand if grasped wrong.  I think it could be improved.","No matter how we try to use this can opener, no matter what size can we try, the opener does not hold onto the can and it takes several, several attempts to open a can.  We have resorted to a hand operated opener.<br/><br/>If possible we will be returning this item.","it is the worst can opener i have ever had, i replaced a oster with this one what a mistake. the first can i tried to open was a can of diced tomatoes from costco, i had to hit the handle and i mean hit not push down several times to get it to puncture the can. once the can was punctured it kept falling out of the can opener didn't even grip the can i had to hold the can and turn it to get it to open. what a waste of money. and as far as having a knife sharpener it is a piece of something white that you are supposed to pull the knife blade over i tried it did not feel any grit or resistance of any kind. going to walmart to buy a can opener that works.","Great opener, with bottle opener and a Knife stone. Only way it could be better is if it was side cutting. The motor is wicked powerful, will cut any size can just about.","Kung Fu all those unopened cans with this can opener.....I've been using a hand held and got TIRED OF IT....So I bought this one....It arrived promptly and I love it!.....The sharpening feature is an extra good one!....I would recommend..","This product worked fine right out of the box.  After opening a few dozens cans it binds up and bogs down and will not open a can.  Too much time has passed to return it, so I've thrown it away and gone back to using my handheld can opener.  At least it works!!  Amazon should stop selling this product.","I replaced my perfectly good electric can opener with this one because I wanted the black and stainless look to match my kitchen appliances.  However, this can opener is the most difficult thing to use ever!  Forget about opening LARGE cans completely!  I tried to open a can of vegetables this evening - a simple task - and it took SIX tries to finally get it to open the dang thing!  It has been so difficult and frustrating, we have started using a hand operated can opener!!<br/><br/>Should have kept my old one!<br/><br/>Update:  I found one at the local Goodwill for $5 and it does a fantastic job - as opposed to this fairly expensive Cookinex Kung Fu Master!","Very difficult to use. Does not work properly. Starts to open the can then stops and drops the can. You have to have man strenght to make it work correctly. Wish I did not waste my money on this piece of junk!","Most electronic can openers are a pain to work and die before you think they should, but this one is the worst I've ever used. My mom, a seasoned can owner expert, agrees this thing was either defective out of the box or a bad representation of Cookinex. I threw it out and went with a hand powered can opener that opens the can from the side of the rim, this one works flawlessly."],"images":{"small":"http://ecx.images-amazon.com/images/I/41Aqo6gbRaL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41Aqo6gbRaL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41Aqo6gbRaL.jpg"}},{"name":"BUILT Big Apple Buddies Sandwich and Snack Bag Pack, Astor Owl","asin":"B00BANON4K","price":"$6.85$47.78$2.99$5.22$5.22$8.00$138.54$14.95$10.00 - $13.00","stars":"1.7","reviews":["I was really surprised--and not in a good way--when I got this product, because it's not as pictured or described on Amazon. (Update: The photos are now *mostly* correct--note the varying appearance of the smaller bag in the photos--but the descriptions still seem to be wrong.) It appears the product description is possibly referring to other product(s) made by the same company, not this baggie set. I'll try to explain the dimensions and other aspects about the product.<br/><br/>The description here claims they're polyester--I believe referring actually to a different bag--but as someone who sews, I can say with almost-certainty that these are plastic. The \"weave\" is an embossing in the plastic, done to mimic the look of fabric.<br/><br/>The bags close by a plastic zip. They're like a traditional sandwich baggie in this regard.<br/><br/>One baggie has a black and white checkerboard pattern on the front. The back is blue. This bag is about 3 1/2 tall x 7\" wide, though curved on the bottom.<br/><br/>The larger baggie has Delancey Doggie printed on it. The top section of the front is blue; a little more than halfway down the front is the same checkerboard pattern as on the small bag. The back is blue. This bag is approximately 6 3/4\" tall x 7\" wide, though curved on the bottom (meaning, less room than the stated dimensions).<br/><br/>The product description on Amazon is inaccurate. There's no side-release buckle, no handle, and the bags will not insulate. The bags do not stand upright or expand. They're flat, like a traditional sandwich baggie, and there aren't any gussets in them for this to be possible.<br/><br/>One of the things worth pointing out is that this seems to be a plastic product. A lot of people who use reusable bags do so in order to avoid plastics. Although that's not a concern to me, I have other reusable baggies (including homemade ones, and one by Bumkins), and these are my least favorite. They might be good for people who want a slight upgrade from plastic baggies with possibly more chances for reuse than a throwaway baggie, since they have the same type of easy zip. That being said, they can only be hand-washed, so they're not as convenient as many other reusable baggies, which can go in the dishwasher and washing machine. The odor alone, though, is going to keep me from using them for food for a long time to come.","I was excited to get these baggies because I much prefer to use re-usable bags for my kids' lunch boxes.  They are adorable.  The sizes are perfect for our use.  I appreciate that they are PVC, BPA, and phthalate free.  So that was my first impression.<br/><br/>We used these for the first couple of days of school.  They were great.  I simply washed them in soapy dish water and dried them.  Then, on the third use, they would no longer close!  No matter how I tried to re-align, the zippers will no longer close the bags.  I even tried to press and seal like a ziploc bag.  I was able to partially close a few small portions, but even that didn't work very well.<br/><br/>I still use them occasionally for foods that are ok left unsealed, packed in a lunchbox so they won't easily spill.<br/><br/>This disappointing bag would be a good idea if they rework the cheap zipper to make it last.","These bags are nice. they are not as sturdy as I would have liked but they serve their purpose.They are more like a heavy duty plastic bag then a true reusable sandwich pack but it will work for what I need it for.it may need to be replaced quicker then I would have liked. The design is super cute though and I love the colors.","This sandwich and snack bag may be appealing to young children with its cute design. In addition, it wipes clean, and has a zip lock closure. However, it is poorly made, not durable, and will not last. The sandwich and snack bag compartments are extremely thin. You can fit a sandwich in the sandwich pack, but the sandwich will barely fit, and it must be a very thin sandwich. The snack bag pack will only hold a very small snack, limiting several desired snacks. There is no support for either one of the packs, as they are extremely thin. This product is not durable, and will not last for a long time. The material is so thin, it will tear after a few uses.I have had much better results with a paper lunch bag, using zip lock plastic bags for sandwiches, and snacks. One can purchase 50-100 paper lunch bags in the dollar store, in addition to zip lock sandwich and snack bags, also sold in the dollar store. This product is made too thin, and simply will not last. I would not purchase this in the future.","Look for a better product. After using only 2 times the slide lock became damaged and will no longer seal at all. Also, soaking them in warm water causes the slide lick to pull away from the bag. I wasted money on these. They've all been tossed in the garbage.","The zipper to the snack pack broke after using it for only a few weeks. The sandwich bag is good for traditional, dry sandwiches, but these don't do well for any food with moisture. Same with the snack bag - dry, cereal type of snacks only. And we're paleo and don't eat traditional \"bread\" or processed salty snacks, so we probably should have purchased something that can withstand a little moisture...<br/>But they sure are cute and match the lunch box!","I bought these to go with the \"big apple buddies lunch sack, astor owl.\"  The pieces work great together.  They tuck in nicely and are easy to clean.  There is a spot on each of the bags to write the little one's name.  Very cute!","This is basically a reusable snack size and sandwich size zip lock bag.  We don't use zip locks anymore, preferring various reusable products like tupperware, snack taxis and wrap n mats.  These are a really nice addition to our collection.  I like them better than the heavy snack taxis for things like grapes, pretzels, cheese sticks, celery sticks, etc.  They are easy to wash as they are nice and sturdy.  They do need to be propped open to dry on the drying rack, but can also be very easily wiped dry.  The zip closure is really easy to use, though my sense is that it will eventually break... I don't have a feel for how long it will last, but it actually does feel a lot sturdier than I would expect..it might surprise me and last a good long time.  Also, for those with concerns about plastic, the packaging does specify \"Tested for lead safety and phthalates.  PVC, BPA and latex-free.\"<br/><br/>However, be aware that these are more for the types of snacks I described.  The snack size bag is too narrow and trim to fit a half sandwich and the sandwich bag won't actually fit a full sandwich.  For those, we stick with the wrap n mats or snack taxis.<br/><br/>Also, as other posters have described, this has nothing to do with the description currently listed with this product, which I imagine will eventually be fixed.  They do not stand for loading and are not insulated, among other mis-described things in the listing.<br/><br/>UPDATE: After about one or two more uses the zip closure on the big bag broke.  :-(<br/><br/>If you are looking for a reusable-type zip lock bag, this does seem like a cute one.  In the past month, I have grabbed it as my first choice several times when running out of the house for a snack.  One final caveat.. great for early elementary school, but probably too \"cute\" for older elementary school and above.","The plastic closure on this item is perfect for kids, however the plastic body is too flimsy to support any kind of filling then closing.  It tore from seam the very fist time I used it. Too bad, they are only a bit better than the throw away.","These bags are basically a glorified ziploc. They are very cute, and with a slightly better zipping mechanism than ziploc, they will last for about 20 uses perhaps.<br/><br/>Price: Too much for the product. For $10 for two, I would expect to get 50+ uses, and I can't imagine these lasting as long as cloth baggies.<br/><br/>Advertised ability: \"In addition the bags were designed to stand upright and expand for easy filling.\" These do not in any way stand upright for easy filling.<br/><br/>Washability: Not supposed to be machine washed. If you're like me and you don't get to the lunchboxes every day, you like to wash the baggies in either the dishwasher or washing machine. These are not designed for that, and I don't need more hand washed products.<br/><br/>Bottom line: Two stars for the cuteness and the durability.<br/><br/>I've got some from etsy that were $3.80 each, and while I love them, the one negative is that they have velcro. This means that sometimes the velcro sticks to the inner lining and it's not as easy to open or clean.<br/><br/>I've got some that just fold over, and they are pretty awesome too. They cost me about $4 each.<br/><br/>The Dr. Seuss Bumkins bag is a little more per bag ($5 when I last checked), which would turn out to be a lot more if you buy ten or fifteen, but the zipper function is awfully nice. It is a lot easier for little hands than the velcro.<br/><br/>Note: I turn all my sandwich reusable bags inside out to wash, and just throw them in with my regular wash. Then I line dry."],"images":{"small":"http://ecx.images-amazon.com/images/I/41xZjO5VZ6L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41xZjO5VZ6L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41xZjO5VZ6L.jpg"}},{"name":"Safety 1st Baby On Board Flip-Down Childview Mirror","asin":"B004GCJMJS","price":"$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["Didn't last.  Fell off within 24 hours (and yes I followed the directions)  Also, image was very distorted.","This mirror mount is great, mounted easily and was easy to adjust.  The problem I had with this mirror is it tries to give you a widescreen view of your whole backseat causing everything to look far away and distorted,  I could not tell if my baby boy was awake or asleep.  Waste of money.","it looks like a circus mirror.  I couldn't see anything my baby was doing.  Only 5 buck but so junky I wouldn't even pay that for it.  Don't buy this thing.  As someone who already purchased it, I would never buy it again.","This isn't a mirror. It's a wavy, distorted image, more like a circus fun house mirror where you are stretched long and then pulled wide. It doesn't give a good image of what's behind you. I returned it so I could buy one that's a real mirror.","This didn't last very long in my van.  It doesn't stay suctioned with a change of temperature and kept dropping out of the window.  I would suggest the baby mirror that attaches (without stickers or suction) to the rear view mirror.  I got tired of having to find this and get it to suction again.","Works really well and I'm able to now see one child in my rear view  mirror and the other in this drop down.  My husband likes that it is velcro'd on so he can move it out of sight when he doesn't have both kids with him.","The mirror itself looks like the \"mirrors\" that come with the infant play mats. It's super distorted and it makes it very difficult to see anything. In addition, after installing it, it only stayed up for a couple of hours before falling down. The temperature was in the 60s (not too hot, not too cold), and the car was sitting in the garage, so it's not like it melted off due to heat. This was a great reminder of why I should always take the time to check reviews BEFORE I buy something instead of just throwing it in my cart because it looks good.","The mirror portion was somewhat distorted. The adhesive that was meant to hold the mirror to the car's original rear view mirror kept sliding off.  I Would come out to the car in the morning and the new mirror would be somewhere on the floor after the adhesive pads slipped off.","This didn't stay put behind my mirror.  It keeps sliding down/falling off and only staying on like a week at a time.  When on, however, it's very convenient to see my kids in the back seat albeit a little blurry I can still see them all and enjoy it.","I love this mirror! I love being able to see my baby in the backseat without taking my eyes off the road. I also love that it goes under my rear view mirror instead of next to or on the visor like other products. I'm sad that this item has been discontinued! I've had this mirror in my Jeep for over a year now, this last summer it's been super hot and the glue on the velcro melted making the mirror slip off. That's probably why it's been discontinued! Other than the glue melting issue, it's super! Definitely buying another while I still can!"],"images":{"small":"http://ecx.images-amazon.com/images/I/51U19%2BC-llL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51U19%2BC-llL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51U19%2BC-llL.jpg"}},{"name":"Soleus #TDA70E  Energy Star Rated Air Dehumidifier, 70-Pint","asin":"B00JS480RO","price":"","stars":"2.1","reviews":["Bought the unit to remove excess humidity in my office. Worked great for a few months, then started freezing up. Called customer service and they said I was exposing the unit to excessively cold temperatures and the &#x201C;frost&#x201D; was normal. My office thermostat is set at 70 degrees so I can uh&#x2026;.. work in it. After arguing with them for weeks they finally told me to cut off the plug and send it to them. They sent me a new unit and it worked great- for 2 months. New unit started freezing up like the first so I called customer service and spoke to Cindy. Cindy told me that there&#x2019;s nothing she could do because the 1 year manufacturer&#x2019;s warranty only covers the first year from the date you purchase the initial unit. Since the replacement unit got me past 12 months from the original date of purchase I&#x2019;m stuck. I told Cindy that I have a 2010 Frigidaire dehumidifier still going strong and she told me that was nice. Yes, it is nice- buy a Frigidaire!","Great while it lasted, but it quit functioning properly after 18 months.  Quiet, effective, well-designed.  Good features.  Plastic is somewhat cheap, but doesn't break.  Liked the option to be able to bypass the bucket and continuously drain it by garden hose (though lots have this feature) (I used a pvc pipe) to route the water out of my crawlspace. It appeared simply to quit after 18 months.  I bought another (another brand) to replace it.  Out of curiosity six months later, I plugged it in and messed with it.  I discovered that it was the humidity sensor that was bad, while the dehumidification still worked.  I'm using this again now on the \"continuous\" setting, and it's fine.  But, not being about to have it automatically sleep at a certain humidity means it is not fully functional.","This the review for the Soleus 70E pint dehumidifier. I  purchased this item on June 29, 2015 and have been running it about 3-4 days a week.  On humid days I empty it 2 times a day.  Less in the cooler days.  The filter light will stay on when the filter needs cleaning, and you have to reset the filter light manually with a button push.  It was quiet until a month ago, and now it's a little noisy.  FIVE (5) times in 5 months (3 in the past 2 months) it failed to shut off, allowing water to cover the floor around it.  This is VERY IRRITATING.  Another issue the past 3 months is getting the tray out.  It's like its frozen, and has to be hit hard with the base of a hand, or the kick of a foot to get it to release.  Right now as I type, its flooding and I cannot get the the tray released.  Finally,  who in their right mind designed a WATER TANK THAT CANNOT BE SAT ON THE FLOOR WITHOUT TIPPING OVER .. I mean really .. set it down and it rolls over dumping water every where .. like 3 gallons worth.  Idiotic design.","OK first let me say I survived the Soleus recall and THIS IS NOT A RECALLED UNIT.  I actually bought 3 of the 45 quart units several years ago and they had been functioning perfectly well.  Then, via an email from Amazon, I became aware that those units had been recalled.  I have to say that Soleus (and Amazon) handled the recall extremely professionally and generously.  How so?  Well, I had to go to their website and request a recall package.  Then I had to cut off the power cord and a label from the unit and mail them back to Soleus.  A few weeks later I got refunded the FULL RETAIL PRICE for my units - the units that were several years old.  IMHO Soleus is a stand-up company and, given the recall costs, is going to be darn careful not to ship anything now that is likely to be defective.  BTW - had I a mind to, I could have stuck another power cord on those units because I was darned if I could see how they were defective - but, instead, I junked them.<br/>NOW the new 70 quart unit.  Well it works about as easily and well as my old 45 quart units.  I live in a part of the country where it gets pretty humid for several months of the year.  I find I need to have a dehumidifier in my non-air conditioned garage to prevent mildew.  Inside my house, I reckon it is cheaper to do some dehumidifying as needed than to do air-conditioning.  So we do run the a/c but at a higher temperature than we would without the dehumidifiers.  (\"It's not the heat, it's the humidity\").  These units can be wheeled easily from room to room and are simple to operate.  The bucket is easy to remove and empty as long as you don't get too careless in handling a fairly heavy load of water.  I would have given this unit 5 stars except for the fact that is does NOT have a power drain like the Friedrich D70BP has.  You can attach a hose to it and it will drain as long as you are draining downwards - that means being careful with your hose positioning if you want it to drain long-term successfully and to forget about needing to empty the bucket.","not a good choice.  for what we paid for it.  wow.  with it's internal pump one would expect to turn it on and leave it, as it should continuously drain from the pump.  not ours.  the pump would kick on right away, then at some point it would stop sending the water out the tubing.  the bucket would fill up, but since the pump button was on, the full bucket would not register, and the fan would just run, doing nothing.  nothing at all except drain water out onto the basement floor.  I would dump the bucket, and start the process over, to recheck in about 8 hours and again, water on the floor, bucket full and no water draining from the tubing.  needless to say, we are returning it right now.  we are going to need to use a cart to take it back to menards since the bottom of the box ripped out when husband was trying to load it in the back of the truck.  also, after we unplugged the unit for return, that is when the unit started draining water out the tubing AND about a gallon of water poured out onto the floor when husband picked it up to take it outside.","Good for nothing piece of junk stopped pulling water from air. Humidity reader at 75 percent so there was no reason for the tub to fill with some liquid from the room.  Only had for a year  and several months and use sporadically, not very often at all.  There are too many complaints about this item. Has anyone filed a consumer fraud complaint.  I can't believe this hasn't been reported to the company yet they continue to sell it with the same issue that arises just after the warranty is up.  I want my $230.00 back and an apology from the company.  Wish there was an option to rate this a ZERO.","Didn't last one season, not one. That's only 4-5 months in my location.<br/>I had it hooked up to a hose for constant draining and the full bucket light comes on stopping the unit. That was the end of last season, I left it go. Fast forward to this season, I locate the switch for the sensor reset it and it's now running. I'll look later to see if all that noise is translating into water in the bucket. No. No it's not. The bucket full light keeps coming on, with or without the bucket or hose and I've not seen a drop of water out of it.<br/>My last one was a Soleus Air DP1-70-03 (recalled) that one worked perfectly for two seasons, that seems to be about all you can expect anymore. The one with a recall on it for catching fire worked better than this one. I'm done with this brand and will be buying as long of a warranty as I can with the next. I've seen 5 year warranties.","I have had 2 of these in the last 4 years. They only last 2 years. They spring a leak on the refrigerant side and quit dehumidifying. At that point they just run the fan.","The Soleus HCT-D70E-A only took a few minutes to unpack. The unit weights over fifty pounds, so if you are not capable of lifting that amount of weight on your own, be sure to have a helper nearby.The only setup required is to install the four casters. They are inside drain bucket. Click those into place in the four holes on the bottom of the unit and you're all ready to go.<br/><br/>There are seven buttons on the top on the unit. Beginning from the right, you have:<br/><br/>-Power (I think that one is self-explanatory)<br/>-Timer (sets the timer for how lone you want the unit to run. you adjust the length with the humidity up/down buttons.)<br/>buttons<br/>-Mode (Allows you to alternate between Sleeping Space (55% rh), Living Space (50% rh), Basement (45% rh), and continuous.<br/>-Humidity% (Allows you to manually adjust the humidity level setting. Highest setting is 80 % rh and lowest is 35% rh.)<br/>-Fan (Allows you to alternate between the Low, Medium, and High fan speeds.)<br/>-Filter (There is a light that will let you know it's time to clean the filter. After you clean the filter, press this button to reset the light.)<br/>-Blank Button (This button has no label on it and appears to have no function on this particular unit.)<br/>modes<br/><br/>What I liked:<br/>-The filter is easily accessible on the back of the unit, making it easy to remove and reinstall for cleaning.<br/>-The unit runs rather quiet in comparison to other 70-pint dehumidifier models I've used in my home.<br/><br/>What I didn't like:<br/>-The plastic chain that connected to the cap covering the drain hose connector was broken. Not a big deal if you're going to use the dehumidifier with the bucket. However, if I were to use it with a drain hose, I fear I'd lose the cap very quickly.<br/>-When you power down the unit, you lose the mode setting, so you need to remember to turn the desired mode back on when you power the unit back up.<br/><br/>At the time of this review, the Soleus HCT-D70E-A sells for $189.99, which puts it on the more affordable end of the 70-pint dehumidifier market. My rating is four out of five stars.","I've used a lot of dehumidifiers. This one is especially powerful. More so than my previous, smaller Soleus's.<br/><br/>The previous Soleaus dehumidifiers I've had lasted for several years before breaking down. I've gone through three of them. (And one from Sears, which didn't last very long -- less than one year.) I use my dehumidifiers every day in my bathroom that has no windows. So my dehumidifiers work long and hard.<br/><br/>This latest Soleus is powerful. Its tank fills up in less than a day. (It's been pretty humid this summer in Los Angeles.) It's louder than my three previous, smaller Soleus's, but not as loud as the Sears. It generates hot air, as do all dehumidifiers.<br/><br/>Its biggest drawback is its water tank design. This dehumidifier shuts down when the tank is full, which is fine. But by then the tank is filled to the rim. In removing a full tank, which is pretty big, I always spill water onto the floor. And the top design makes it a hard to properly aim the water as you empty the tank. If you empty it into a toilet, some of the water will spill outside the toilet. Easier to empty into a bathtub so as to avoid spills.<br/><br/>Still, you're only spilling water, so it's not that big a deal. However, I recommend that you empty the water tank before it gets full. It'll be easier and less messy."],"images":{"small":"http://ecx.images-amazon.com/images/I/31F40zUYwzL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31F40zUYwzL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31F40zUYwzL.jpg"}},{"name":"Icibgoods Home Décor 100 Pcs Small Squares 3D Acrylic Mirror Wall Sticker Classic Design Silver","asin":"B00J9B5ZD8","price":"$5.00$42.50$2.00","stars":"1.6","reviews":["The square mirrors are much smaller than the picture depicts. If you were to try to replicate the heart in the picture it would be about half that size. I was able to use them for the purpose I bought them for and they do adhere well. I would recommend them if you don't mid that they are much smaller than advertised.","So for the record these are small. The 2.2cm converts to 3/4\"x3/4\". I knew they were small and I ordered 400 of them to make sure I could do something with them but I was still surprised by the size when I opened the package. The mirror quality is good and I am sure it will be cool once I get it all set up but don't be fooled by the photoshopped picture in the description. That is a dime next to the mirror square in my picture (just to be clear).","I hate this mirror because so many pieces missing I can't complete the heart I'm mad don't know about shopping here again","Squares are way smaller than the pictures shown... cant do anything by just buying one set... u will have to buy atleast 3-4 sets to be able to design that heart or something noticeable !!","Wasn't what I expected.  Haven't used them. I thought they'd be 1x1 inch squares but they're smaller than that.","this squares are less than an inch each side....each side is eactly 2.5 cm long.","The squares were much smaller than they appear in the picture but overall I really like it","Very disappointed in the size. I thought they might be 3\" x 3\" or 4\" x 4\"; instead they are 1\" x 1\". I cannot use them for what I intended, so the grandkids found a use.","I agree that the photos with the designs are misleading, they have clearly been photoshopped to appear larger. However, the photo with the \"A\" as well as the product description clearly states the tiles are 2 cm (.78\") squares... Clearly nobody got past the first picture with the heart. I'd consider the $7.00 price tag to be a literacy tax to anyone angry that they were too small.<br/>I'm super excited to use these to make a mosaic border on an otherwise blah mirror I have. Awesome that you get so many for so cheap!","the picture gives the appearance that the mirrored pieces are large enough to create the size of the heart shown but the piece are not they are very tiny and looks like paint chips so i suggest if you order this product to really do your measurements first to gauge the amount needed"],"images":{"small":"http://ecx.images-amazon.com/images/I/51RKfEKAACL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51RKfEKAACL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51RKfEKAACL.jpg"}},{"name":"Large Tree of Life Hang Your Pictures Wall Sticker Decal for Kids Room Living Room","asin":"B007HTNZCM","price":"$10.99","stars":"1.8","reviews":["Deceptively marketed.  Much, much smaller than expected.  Very unhappy with this.  Photos shown on tree would not even be wallet sized.","Poor quality and much smaller than pictured.  In the item description it says \"will be much larger when assembled on the wall.\"  However, one look showed that everything is smaller than pictured, including the little photo frames.","Picture was deceiving. Thought the tree was larger. Will not recommend it.<br/>Too bad send to my niece outside us. can not return product.","You better like jigsaw puzzles!  This comes sorted on the roll without any guidance or reference.  I had to go back to the order photo  print it out and even then it was hard to distinguish which leaf or branch I was supposed to use where.  Will NOT stick to a wall with ANY texture.  I ended up using this and every other WallStickers decal on mirrors or windows.","Would have given ZERO stars but I cannot submit the review without at least 1 star. I bought this item and when I tried to put it on my wall the tree trunk and branches became a jumbled up mess and all stuck together, basically resulting in a waste of time and money. This is a horrible product, the tree NEEDS TO BE EASIER TO PUT TOGETHER i.e. have the branches separate from the trunk. The picture frames are useless, too small for even wallet size pics. Also, I was under the impression that the decal was LARGE but it's not even 4 feet tall and would look quite odd next to the couch where I intended it to go. Please be more descriptive in your product description.","This product was shipped from CHINA - which took a very long time to arrive. WHen it did, the vinyl was very soft - almost melted. the tree is very small and will not cover the area i purchased it for. Very unhappy","The description and images are misleading. Even the packaging has a picture of the tree next to a couch where the trunk is the height of the couch. The only way this would be possible is if it was a doll's couch.","This decal is much smaller than it looks, Max height is 34 inches and width of the tree itself is 22 inches.  There is a picture with it beside a couch, what they don't tell you is that it is a doll house couch.  Other than that the decal is as pictured and is nice, just beware of the size!","Disappointed with product, not at all what I expected! Quality is poor , it fell off of wall within hour. It did stay after gluing it to the wall, however it is very small. Picture on website is very misleading and very poor quality! wish I had listened to the reviews I had read about it.","I have no problem with the decal itself - the tree is cute and I love the idea of putting pictures on it... but the picture they use to illustrate the wall decal is VERY misleading. It is so small!! The couch in the picture must be a couch for Barbie or something!! If you have only a small space to fill, this would be a great decal, but if you have a normal sized wall, I'd definitely look elsewhere!"],"images":{"small":"http://ecx.images-amazon.com/images/I/41jUcIOScJL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41jUcIOScJL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41jUcIOScJL.jpg"}},{"name":"Women Messenger Shoulder Bag DZT1968 Leather Satchel Handbag Tote Hobo Messenger (A)","asin":"B0196DAHHW","price":"$5.68","stars":"1.8","reviews":["From a distance, this bag may look kinda like the picture. The \"leather\" is very thin and smells like chemicals. This will never be a cross-body bag because the strap is too thin to hold the purse if I tied it to the side rings, one of the side clasps was already broken. Quite shabby, even for under $6.","Cute but the strap is really short and the purse sits above my hip at its longest. Also, the metal fixture that clips the strap to the bag broke the first day, I ended up tying the strap to the bag...","I am feeling ok about the purse. the actual purse is very cute and the color is just like in the picture which is always great bcz you know what you're getting. the quality of the material is decent. the only downside is the purse strap. it is very cheap and almost feels like it will snap if you strain it too much. over all not bad.","I was expecting something like the picture, smell bad chemicals I don't think is leather","I like this bag, but it could be a lot sturdier.<br/><br/>The hardware used to hold the straps is a little flimsy, but so far so good, the straps are holding steady.  Can't put too much inside that has any amount of weight, because the straps will pop at anytime it seems.","The strap for the bag was a lot shorter than it appeared. I'm 5'6\" and the strap was too short to wear in a crossbody style. I ended up giving the purse to my 10 year old daughter. It was a great fit for her....but 1 week into wearing it, the strap broke.  Would recommend for a kid who is only putting 1-2 items inside due to the strap not being sturdy. Cute purse tho","I should've listened to the reviews better. It is very small. Looks bigger in the pictures. Although I do love the color I can't tell that it's leather? Usually leather has a leather smell? Anyway, guess you pay for what you get. Just be careful ordering online. :)","Don't waste your money. The strap is extremely short. The metal clips that hold the strap to the bag broke while I was trying to attach. I was going to return it but decided to keep as a makeup bag. I'll use it if the chemical smell dissipates. Not worth 2 cents. Giving it one star because I have to select it in order to be able to write this review.","The bag I received looks nothing like what is displayed. Totally deceiving. I ended up giving it away.The material is super cheap. Guess you get cheap at $5.00. I consider it a donation to the seller.","cheap plastic. came bent and won't straighten out, embarrassing if I were to use it. I ended up donating it to the thrift shop."],"images":{"small":"http://ecx.images-amazon.com/images/I/518SxzGvPcL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/518SxzGvPcL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/518SxzGvPcL.jpg"}},{"name":"Early Star Monkey Tunes Window Shade (Discontinued by Manufacturer)","asin":"B0026K6P6A","price":"$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["This never worked. The monkey plays music for 3 seconds, not long enough to keep my baby happy. Do not waste your money.","I don't think this unit is particularly well made or functional.  First off it offers no \"real\" window shade protection and secondly the suckers don't stick well at all. The monkey and plastic housing is heavy and just pulls it away from the window.  A bit dangerous given if you actually get it to stick it will at some point just fall off possibly on to your baby.  The music is also rubbish.  It's cheap plinky plonky electronic classic stuff.  One track (on mine) descends into a tuneless mish mash of sounds before picking up the original tune again.  However, I bought if for a particular purpose and for that it has worked just fine.<br/><br/>I never intended to put it on the side window, as another reviewer stated Baby can't see it there anyway. My intention was to string the whole thing up from the head rest of the seat facing my daughter.  I have actually taken the monkey part off the shade (It just slides off, the rectangular shade just slides down the back of an opening in the plastic housing)and strung it up around the seat like that. I ended up embellishing the monkey (as it's a bit boring) by stitching colourful ribbons to monkeys arms,legs and head to add some interest when it rotates. It rotates only slowly but enough to capture my daughters interest.  She's not a fan of the car and this helps to reduce some of the fussing when she's struggling. As I said the music is pretty awful so I have put a piece of tape over the speaker (on the back of housing) to reduce it's output.  My only niggle is that the unit switches itself off after three hours of none use.  Brilliant saves batteries! However you have to remember to click the switch up and back down to remote control mode before you next set off in the car as if you don't it won't respond to the remote.","The Early Star Monkey Tunes Window Shade was a terrible purchase.  First, it is too heavy to be held up by the two suction cups provided.  Secondly, nothing on it works.  We tried changing the batteries, trying the remove from different angles, nothing happened.  I&#x2019;m not pleased that I spent this money on something that I had hoped would not only block the sun from my child&#x2019;s eyes but would entertain him while rear facing in his car seat.  I do not recommend this to anyone &#x2013; and I will do my best to not purchase anything made by this brand again.","Surprised at the other reviews regarding the suction cups  especially the one that says the monkey  music only work for 3 seconds. (That is ONLY true if you don't have the remote and only use the buttons on the side of the product. But if you have the remote you can control how long it is on and it's really nice to have the remote control since who wants to have to stop to turn it on)?<br/><br/>After using this for my 1st baby for close to a year, I found this product to be a savior when baby was fussy in the car. Generally I would keep it off unless he became fussy - then the remote comes in handy to just click the button turn it on and instantly baby would have a nice distraction to entertain him  help him calm down until I could pull over to tend to whatever was making him fussy. It plays a few different tunes to keep baby interested too.<br/><br/>Also - the way to keep the suction to hold is to first clean your windows (with windex or even better an alcohol wipe pad) - then put a little - just a couple drops of - moisture on the suction cup itself before pressing it very firmly to the window and then moving the lever down to suction it.  Yes it may come loose again eventually from opening  closing the door - but I was able to get it to stay on for at least a month or so at a time typically.<br/><br/>The only reason I'm not giving it 5 stars is that you do have to have the remote to make the thing stay on for more than 3 seconds. We lost our remote after about a year, and it eventually prompted me to just replace with regular shades I already had instead since there was no longer any music to distract/entertain baby when getting fussy.  And he was getting big enough to almost reach the monkey  I was afraid he might pull it down.<br/><br/>I also agree with the review that it isn't the BEST shade out there for sun protection - though I do think it provides a good amount. The shade is not huge - but that actually worked better for me since we drove a smallish car (4 door sedan) not a big SUV for baby #1. But for baby #2 I'm actually planning on buying this product again to use in addition to the regular shades we already have which will provide a little better sun protection for the bigger windows we now have with our SUV. Not sure how I will hang both shades up at once yet - but I think I can make it work.","This looks like it's great an has bells an whistles as such and a remote but it stopped working almost immediately. I thought it was the batteries but nope an other people say the same thing that the monkey stops turning and the music goes off. Totally a waste of money. Get a regular shade an something that connects to the head rest.  Those have remotes too an they are in stores so you can see it an see that its sturdy","The sun shade was too small and didn't block the sun.  The monkey moved eerily slow and made a loud gear grinding noise.  Even with fresh batteries the music sounded distorted.  I have tried to sell it in a yard sale twice...","Even with new batteries the monkey never did spin or light up. It would make a slow quarter turn and stop..not a very big cover so not that much shade protection  provided. Life got too hectic to return it.","we love these shades we go two, and i had to replace the batteries  no biggy tho. then we got them done to the car for the most part they stick but some come off only cause we live in Wisconsin and it is very cold. all so it is not very loud so that is a + we love them and my little one loves the monkey.. would of given 5 stars but cause it is cold the sticking of one of the middle stick.","The two suctions at the top will NOT stick to the window! No matter what I try they will not hold.","YES! THIS ITEM IS A MUST !!WE GOT ONE FROM A FRIEND OF OURS. SHE HAD ONE FOR HER BABY AND WAS SO HAPPY WITH IT SO SHE BOUGHT ONE FOR OUR BABY AS WELL. OUR RIDE IN THE CAR TURNED FROM NIGHTMARE TO PLEASURE BABY GIGGLES AND GURGLES WHILE STARING AT IT....GET ONE AND ENJOY YOUR TRIP"],"images":{}},{"name":"Kitchenaid KUDE70FXSS Superba Series EQ Dishwasher","asin":"B004D9910Y","price":"","stars":"2.1","reviews":["Our first d/w was a Maytag that cleaned very well.  Unfortunately, in 2 years time we had to replace the latch handle twice, it was recalled because of a potential fire, and ultimately, the tub warped and we replaced it with this Kitchenaid.<br/><br/>Having done extensive research, there is no one d/w that everyone loves.  That being said, Kitchenaid comes up as one of the brands that most people prefer.  Why not go with a middle level Kitchenaid?  Again, all the research I turned up said that it was necessary to go with the higher end in order to get better quality.  The higher end uses a different drying and washing process than the mid-range.<br/><br/>Another consideration was that only the top two models have the third tray for utensils.  Both my husband and the appliance salesmen minimized the importance of this feature.  Having now had the d/w for a month, it's one of my favorite features.  Because of food allergies and because we homeschool, we run our d/w four times a day.  I need every bit of space available for larger items.  By using the upper utensil draw, I can place more items in the bottom drawer.<br/><br/>As I mentioned, I cook a great deal and use a 12 quart stock pot about once a week.  I was concerned about being able to fit it in this d/w.  Our previous Maytag was a tall tub and had a very large clearance from the bottom rack to the sprayer.  No problem with the Kitchenaid.<br/><br/>There are several different options of cleaning cycles, and I do find myself using them. There's even an option for a shorter wash cycle.  It's just as efficient, just not as energy-conscious.  I haven't used it yet, but am thrilled to know it's available.<br/><br/>As everyone mentions, it's quiet as a whisper.  I can talk on the phone right next to it with no problem.<br/><br/>When researching, I did turn up some concern over the side venting of the door.  Have to say that our install left the vent just outside the cabinetry.  No problems whatsoever.<br/><br/>If you do a great deal of cooking, this is the dishwasher for you!<br/><br/>Update: I wanted to post an update that as time has gone by my love for this dishwasher only continues.  I run it roughly four times a day and have now used the 1 hour wash cycle.  It's been an invaluable time saver.  I've even washed our super large stock pot on the 1 hour cycle and it comes out clean.<br/><br/>My husband had expressed concern over the lack of a food grinder and my habit of not scraping the dishes immaculately before loading them.  However, we've had no problems.  I rarely remove the filter to clean it, and when I do I'm just rinsing it.  It really isn't even necesssary.  Almost a year later, and I still couldn't recommend it more.","This is the quietest dishwasher I have ever owned.  We can run it while watching TV without any disturbance (our kitchen is open to the living room).  It also gets dishes very clean.  However, the drain pump went out after only 7 months of daily use.  The warranty covered it but I was without a dishwasher for 2 weeks (by the time a service call was set up, then the part had to be ordered  took another week to come it).  I am concerned that pump will go out again  the warranty will be expired.<br/><br/>I am not a fan of the 3rd shelf for small items.  Tall glasses do not fit in the 2nd shelf because of that extra shelf  we rarely use that 3rd shelf.  I finally pulled it out  keep it out.  No need to pay extra for this feature.","Most of these reviews are accurate. It is quiet, looks great, and has mediocre cleaning capabilities. However, I have had my unit for just over a year and can tell you what it is like to own one of these dishwashers for more than the first month.<br/><br/>The first time my Kitchenaid Dishwasher had problems, it was a complete shutdown, just a month after owning the unit. The dishwasher stopped in the middle of the dry cycle and was completely unresponsive. The Bi-metal thermal fuse went out. It was replaced and it lasted me 10 months.  Then it went out again. This time, they replaced the control panel, wiring harness, and the same fuse.<br/><br/>The machine didn't make it through the first cycle after the technician left. He came back and replaced the fuse again. It went out again.<br/><br/>I called whirlpool to take further action and they said my warranty was now out. Even though it was the same problem. One of the times they came out and replaced the fuse was a \"courtesy warranty service\" Thanks Whirlpool! However, the same problem exists and the problem has never been fixed.<br/><br/>So now I'm stuck with this machine and I've opted to buy a handful of fuses and replace them ever so often. It's cheaper than buying a whole new machine. However...<br/><br/>I started researching Kitchenaid/Whirlpool Dishwashers and as it turns out, Whirlpool uses the same set of electronics in most of their dishwashers. This problem exists in many of their dishwashers. In fact Whirlpool has had a string of issues with their control boards. Even to the point that many of the control boards allegedly caused fires. Check out the website kichenaidfire. I'm considering now replacing the unit and staying away from any type of Whirlpool Product.<br/><br/>I highly recommend looking into all whirlpool product reviews if you are considering buying one. More than likely they will have the same electronics and same problems and same poor service.","I had done a lot of reading about dishwashers when I decided to replace my Frigidaire Professional that came with my house.  The Frigidaire never seemed to clean as we thought it should.<br/><br/>Long story short this is an amazing dishwasher.  my mom cooked some lasagna we left the dish and merely put it into the dishwasher in front of the pot scrubbers.  from caked and baked on sauce to perfectly clean.  Trust me this is an amazing dishwasher and to top it off it is quiet.  It also has a ton of room and a 3rd rack for small utensils.<br/><br/>you get what you pay for, buy it if it is in your budget.","We are a family of 2 that does one load of dishes every other day.  Bought my kitchen aid dishwasher 3.5 years ago.  I love the stainless interior and the rack design.  After 6 months warranty put in a new mother board.  Then the front latch needed to be replaced.  Then the dispenser assembly melted ( $110. + shipping and service) and now the control circuit board won't run cycles (sometimes it sticks in a cycle indefinitely and other times it won't turn on).  Only refurbished circuit boards (one that has previously gone bad) are available for a repair, no new replacement part is availabe (a cost of $300.00 + shipping and service). And to top it off the front plastic control panel screw holders have fallen apart from taking it on  off  so many times for repairs (another $190.00 + shipping and labor if you want to fix it. They don't make kitchen aid dishwashers like they use to.  I will NEVER BUY another one. This one is beyond being a lemon. It is a piece of S_ _T!","Love the dishwasher. Quiet, quiet, quiet. And super clean results. Recommend it highly. However, the vendor had to send three units before we got one that was undamaged. I'm not sure it was their shipper's (Manna Distributing) fault.  The boxes were undamaged but the dishwashers were dented and severly damaged.  Might have been damaged at the factory and boxed that way.  Who knows. But at least the vendor kept trying and never questioned that the damage was there.","I can hardly hear it running!<br/><br/>It cleans dishes much better than our 19 year old KitchenAid.<br/><br/>Hate the controls and indicators.  They're on the top of the door where they can't be seen.  Can't tell if dishes were washed, rinsed, or nothing.","This washer cleans amazingly well and is super quiet.  I love the upper tray, but do wish you could put smaller bowls in the top rack.  Still, the fold down shelves on the top tray are handy to keep light/short items from flying about (because the jets are strong!).  My only real complaint is that the door sometimes won't close and you have to notice this and it usually seems to be because the top tray isn't pushed in all the way.  It's not obvious, so it's annoying.  Otherwise this washer runs and performs like a dream.  The only time it leaves food on the plates is if they've been sitting in the washer for days with food on them before we run it.  I'm confident I can put dirty (food covered) dishes in it and run it immediately and they'll be sparkling clean.","I bought dishwashers that tout their silent operation and found that, while they were more quiet than the unit I'd replaced, they didn't run as quietly as I'd hoped.  That is just not the case with the KitchenAid KUDE70FXSS.  This is the first dishwasher that I ever felt lived up to the claim of quiet operation.  When the installer came into the living room to tell me he was finished with the installation of the KitchenAid he said \"I bet you never even heard me turn it on\".  I was amazed as he walked into the kitchen, opened the door and showed me the stainless steel washing tub dripping with water.  He'd tested the operation as part of the installation.  I was literally 40 feet away in the living room and I never even heard the unit turn on!<br/><br/>First and foremost, the dishwasher is refined in it's simplistic elegance. The controls are mounted on the top of the door so they are hidden under the countertop when the dishwasher is closed.  The only thing that breaks the stainless steel monolith on the front face is a very small light near the upper right hand corner of the door.  At first, I questioned what it was and wondered why it was there when I learned it was a light.  I wasn't sure why KitchenAid would interrupt that stainless facade with it.  Now I know.  It's there so you will know when the dishwasher is actually running.  I'm not even kidding!  When the machine is running, that light glows blue.  When the unit is in the drying cycle, the light is red. Finally, when the dishes are clean and the washing/drying cycles are complete, the light is green.<br/><br/>To test the dishwasher, I had some dishes that I'd let wait in the sink all day.  I had a pan with dried on egg and cheese from an omelet.  There was a bowl with dried grits and other assorted plates, utensils, cookware, and so on.  It really went against the grain to not pre-wash any of these items before loading them into the dishwasher.  I'm so used to not only removing food, but also, in effect, basically cleaning the dishes before loading them into the dishwasher.  However, I wanted to really test the ProScrub option on this unit.<br/><br/>I've read a few reviews with people that complained that the dishwasher didn't clean effectively.  I have to admit, those reviews made me somewhat hesitant seeing that this dishwasher comes at a premium price.  However, all those fears were quickly dispelled with this one wash.  As a caveat, I will say that I read the instruction manual (an online PDF) and there were directions about how to properly load the dishwasher.  If you plan to allow the dishwasher to scrub dried on food on plates and cookware, there is a specific way to load the unit to increase the efficacy of the cleaning.  I can imagine that if these directions aren't followed, the results may not be as expected.  That being said, I loaded the pan with the dried omelet and grit-encrusted bowl, and all the other items facing towards the back of the unit.  The ProScrub jets are mounted on the back of the dishwasher and truly dirty dishes and pans need to be loaded at the back facing those jets.  There are also instructions on the optimal way to load plates, bowls, etc. and I pretty much followed the suggestions with the rest of this load.  I even had some cooking utensils loaded into the third tray above.  I ran the unit on the Heavy Duty cycle with the ProScrub option and selected ProDry.  Once I pressed start and closed the door, I waited.  The blue light came on and I eventually heard the slightest noise indicating the unit was actually in operation.  Given that I had selected the most aggressive cleaning cycle and option, I was completely floored that the dishwasher was actually running.  The blue light is obviously a smart idea that is there to prevent somebody from opening the dishwasher door while the unit is in operation.  Suffice it to say that the entire time the dishwasher ran, nobody in the house really knew it was running.  Upon completion of the cycle, every single dish emerged spotless and without food particles.  Another important tip I gleaned from reading the manual is that the use of rinse aid is highly recommended with this dishwasher.  Again, it increases the efficiency of the unit especially with regards to drying.  It provides a sheeting action that will help the KitchenAid not only with the drying cycle, but also with leaving glasses and flatware completely without spots.  We had some glasses that had become rather white in appearance from years of use in the old dishwasher (which I foolishly didn't use rinse agent with).  The KitchenAid did not remove that white deposited material by itself.  For glasses and items that have become laden with mineral deposits over time, I ran them in the dishwasher with two Affresh dishwasher cleaner tablets.  I put one in the main dispenser and one table in the bottom of the tub itself.  That not only cleaned the dishwasher (not that it needed it), but also cleaned the glasses and they came out crystal clear.<br/><br/>So the bottom line for me with this dishwasher is this: KitchenAId has produced a VERY sleek, elegant dishwasher that will operate so silently you'll need to see an indicator light to really even know it's running.  It absolutely will not intrude on your TV watching or entertaining while it's running.  With operation this silent, you can run your dishwasher at any time of the day or night and never once disturb anybody in the house.  As expected, this KitchenAid cleans dishes completely and effectively.  I don't know that I'll be loading dirty dishes like I did with my trial.  It goes against years of ingrained pre-cleaning for me.  However, suffice it to say, it's nice to know that for those evenings when I just don't feel like pre-washing, I can load this dishwasher full of the dirtiest dishes and they will emerge spotless and dry.  With dishes that I've already rinsed off before loading, they will emerge even more clean than I ever could have achieved by hot water and Dawn alone.  If I had it to do all over again, I'd purchase this dishwasher without hesitation.  I highly recommend this KitchenAid!","I have had this machine 9 months, it failed and dumped all the water under the machine and ruined my kitchen floor.<br/>The service company said it was a failed pump/motor.<br/>When I called KitchenAid Whirlpool to see if there was anything they could provide other than simply replacing the parts. I received a well rehearsed and scripted response that they would replace defective parts only and recommend you purchase the extended warranty.<br/>I understand they wouldn't take care of the floor, they recommended a homeowners insurance claim. ok.<br/>I'm thoroughly disgusted with the company response...it's just not human...but that is just the way it is with these large corporations. The individual customer is just a fly speck on the wall to be summarily dismissed.<br/>I design kitchens for a living and have been doing so successfully for 25 years. Since my experience with KitchenAid is as described above I will no longer recommend this brand to my customers. That's it! Done!"],"images":{"small":"http://ecx.images-amazon.com/images/I/3199Ga47szL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/3199Ga47szL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/3199Ga47szL.jpg"}},{"name":"150 x134cm Nursery Forest Animals Birds Fox Squirrel Mushrooms Trees Wall Art Stickers Decal for Nursery Home Decor Boys and Girls Children Courtyard Baby Room","asin":"B00F3WWQVG","price":"$12.50$6.85$47.78$2.99$5.22$5.22$8.00$138.54$14.95$10.00 - $13.00","stars":"1.7","reviews":["Though I still think this decal is adorable, I must say I was very disappointed in its inability to stay on the wall. The decal is very thin and though appears to be sticky, it lifts around the edges and eventually falls off. I must add that my walls are swirled plaster and has a higher gloss paint, I don't know if that was part of the issue but a different decal for my daughter's room sticks great so that attested to the difference in quality. Whatever you do, I recommend thoroughly cleaning your wall before applying any decal.","The stickers did not stick on our wall.<br/>When we came to the nursery the next morning after we stuck them to the wall the night before about 80% of the stickers fell on the ground.<br/>I wish I would have paid attention to the reviews before ai orderd this product.","I have bought similar products they stick to the wall fine.<br/><br/>This one however begins to peel slowly off the wall within MINUTES of application.<br/><br/>Seller then wanted to refund me HALF!  I don't understand why I should lose money for something that doens't work in the first place!","This sure is a pretty decal.<br/>Firstly, it doesn't stick to a painted wall.  I think perhaps it would stick on gloss paint or perhaps a big window, but not on a normal wall. It is such a let down after meticulously hanging each part, trunk, branches, leaves mushrooms and checking in an hour later to have pieces dangling from the wall and lying on the floor.  We tried a number of methods, short of gluing it down, and it didn't work.  Maybe we can paint the room again and place it on wet paint.  Too late, it is in the trash. A big waste of money.","again very disappointed with woodland theme wall sticker purchase. This is the second attempt to buy something pretty for my kids bathroom and I feel that I am wasting my time. The biggest problem with this one is that it'd stick together and after pulling apart the color was coming off . So my tree trunk color was so inconsistent that I had to throw it away. I kept  branches leaves and animals. After I am done with their bedrooms I plan on redoing the whole thing. I will post pictures when i get a chance. Would not recommend.","Well, what can I say for a product that costs $1 and shops for another $8!?!?  I guess to be fair, I got what I paid for it.  If you just want it for the animals, it's still a pretty good deal if you can wait for the shipping.  It took over 1.5 months to get mine in the mail, direct from China (hence the shipping cost).  Not recommended if you have a decorating emergency!<br/><br/>Also, the stickers are so thin that when you try to peel them off of the backing, the paper portion of the backer peels off with it.  It is next to impossible to remove them to create your masterpiece.  Once you do get them off, they do appear to be fairly sticky, so you shouldn't have too much trouble with the smaller items.  I think my tree will probably go in the next few days though but I'll put some  tape to hold them on the top.  If you do get this one, make sure you have plenty of finger nails and patience!","The animals went on the baby room walls very easily.  The tree, however, came unstuck during the night and the tape stuck together.  We tried to fix it (it wrinkled) and put it back up, but it did not work. :(  So, long story short, the animals were a YAY and the tree was a BOO.","Worst product I've ever bought on Amazon! Don't waste you money like I did! All the printing was off the cut-line and so when you pull the stickers off they actually show only half of the inked image and sometimes included the numbering on it... I decided to use it anyhow since it was suppose to be up for just one day. Pre-stuck all the pieces the night before following the directions, even though it looked horrible from up close, I let it be. The next morning almost all the pieces had fallen off. Would not recommend this for one-time use, let alone for a nursery or anything like that...","The decal looks very nice and in a good size. My daughter loves the decal!<br/>However it does not hold on very well on the wall. After I turned on the humidifier in her room for a few hours at night, the trunk fell off completely. I had to put the clear sticky tape over a few spots on the decal to keep it in the place.","I read the reviews before I bought this and all the reviews stated that it wasn't a very good sticker because it didn't stick to the walls.  However, it looks adorable in my daughters bathroom.  I put parts of it on the mirror, in the shower, and on the toilet lid.  Very cute!  Just don't stick it on the wall.  I matched it with http://www.amazon.com/Splash-Shower-Curtain-72-Inch-Grass/dp/B008ROE9OO/ref=sr_1_1?ie=UTF8=1423286143=8-1=grass+shower+curtain this grass shower curtain to stick to the woodlands theme.  :)"],"images":{"small":"http://ecx.images-amazon.com/images/I/51lGZVee65L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51lGZVee65L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51lGZVee65L.jpg"}},{"name":"Plum Organics Stage 2 Hearty Veggie Meals Starter Pack Baby Food (each 3.5 oz) (4 FLAVORS Pack)","asin":"B00ETOULRU","price":"$14.95$5.00$42.50$2.00","stars":"1.6","reviews":["I was comparing a range of plums organics meals when I selected these and for the same price the others had 4 of each. I was SHOCKED when this product arrived with one pouch of each flavor. That is 4 dollars per pouch!!!!<br/>Total rip off!!!!!","inclusive of shipping, I spent over $20 for FOUR POUCHES of baby food.  I misread this and assumed there were 16 pouches.<br/><br/>THEY CARRY THESE AT YOUR LOCAL Target or walmart for between $1.38- $1.68 each.  DO NOT PURCHASE THIS ITEM, IT IS A TOTAL RIP OFF.","I expected 12-16 packages as well.  Clearly I should have read closer when I order this product.  The flavors were mostly acceptable to my 7 month old, but the price does not even come close to being worth what you get in product.  Do not recommend ordering this particular assortment for the price!","SCAM!!! outrageously overpriced, incredibly misleading, only four pouches total unlike most of these variety pack where there's three or four each. You can return them, but they'll charge you $8.00 to return it. They need to be shut down by Amazon.","Where to start! I liked these products until they were recalled and the company handled themselves horribly. Enough so that it has turned me off from the brand completely. I spoke with someone after the recall and the person I spoke lithe acted like she was doing me a favor by answering my questions. Really? I am giving your baby food to my precious little one and  you are the one that does not have good quality control and you are doing me a favor by answering questions about something that could possibly make my daughter sick?? Well, My daughter had gotten sick and when I tried to discuss hr symptoms they just dismissed my comment and concerns.  I bought 40 pouches of their food in a variety of flavors and had to discard all of them. This was two months ago and I still have not received my so called vouchers. I just emailed the company today and told them about my dissatisfaction. I also explained that my daughter is now 11 months and refuses to eat mushed up food anymore and I would like a refund and this is what they replied&#x2026;.<br/><br/>\"Thank you for contacting us.<br/><br/>We apologize for any inconvenience. We have your information in our system. Your vouchers should arrive within 2-3 weeks.<br/><br/>Warm Regards,<br/><br/>Plum Web Team\"<br/><br/>So I am out the money I paid for the pouches and all I get are vouchers for mushed up food that will be useless since my daughter will not eat them anymore. I am more than upset and should get a monetary refund not vouchers at this point, especially when it's three months later! When things get recalled they will usually offer money back or a replacement! I would not trust giving my precious little ones food from a company that doesn't even care about the consumers questions and concerns.","I bought this for my son, and he loves the food.  The problem is, this is SO expensive.  The set only comes with one of each flavor -- four total.","$20 is far too much for this. I found them much, much more cheaply at Babies R Us.<br/>That said, these are delicious healthful veggie pouches. My 18-month-old loves them for a snack or to round out a meal when we're out somewhere that doesn't offer great veggies. I'm happy that Plum is making great, tasty substantial meal options for vegetarian babies.","I bought these as an alternative to some of the sweeter combos 'cause I didn't want my 7 month old to need sweet with every meal.  He loves these, eats 'em with gusto!  They are more expensive than other ones though and you get the same amount.  I'd purchase more if the cost comes down.....","As almost everyone else says, this product is labelled in a misleading way and only comes with 1 pouch of each flavor, four pouches total. A complete rip off, DO NOT ORDER. They are less than half this price anywhere else you can buy them.","I should have read the reviews - I am not sure how Amazon allows this! This is a huge CON JOB. I thought it was 4 of each - it's just 4 pouches!! DO  NOT BUY! You can get this a lot cheaper at several different places - Target included."],"images":{"small":"http://ecx.images-amazon.com/images/I/51-JZeXdDzL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51-JZeXdDzL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51-JZeXdDzL.jpg"}},{"name":"MKPLY 5 PCS Blue Adhesive Kids Baby Child Safety Cabinet Door Fridge Drawer Cupboard Locks","asin":"B00IZ9KP1W","price":"$2.70$14.95$5.00$42.50$2.00","stars":"1.6","reviews":["Product is dangerous! My 10 month old popped of the little smiley face (it is a button sized cap that holds the thing together) the first time he tried it. One of the others fell off when I was installing it. Good idea but very poorly made. My son would have choked on the button piece if I hadn't seen him first. He is still at the stage where everything goes in his mouth. Please do not buy this product. If this review can save one childs life than it was worth the time to write it.","Didn't work at all. My son figured out how to open it in less than a second, and then proceeded to take it off of where it was completely. Might work for animals, but definitely not for toddlers.<br/><br/><a class=\"a-link-normal\" href=\"/MKPLY-5-PCS-Blue-Adhesive-Kids-Baby-Child-Safety-Cabinet-Door-Fridge-Drawer-Cupboard-Locks/dp/B00IZ9KP1W/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">MKPLY 5 PCS Blue Adhesive Kids Baby Child Safety Cabinet Door Fridge Drawer Cupboard Locks</a>","Used these on my toddler's closet doors. They don't work at all. When my toddler tries to open the door when the latch is closed, the blue circle piece on the opposite side just pops off and she can open the doors. Was hoping that these would be good with how highly rated they were, but they don't work one bit!<br/><br/>Took a while to ship too!","I have brilliant young cats. So have them on all the lower drawers and cupboards in the kitchen. The cats can't get in and I have had toddlers over that couldn't get in either. They create a less tricky opening solution than old fashioned inner ones as well as less opening space so little fingers don't accidentally get in the open crack. They were easy to apply with a super grip sticky back. So messed up on the first one I put on, and it was easy to remove right away with a butter knife. I haven't had any problems with them. The push clamp solution works easily for adults and saves you from standing there for a few minutes simply trying to open a cupboard. I will definitely be buying more when I move!","Got these to keep my son out of cabinets. Not only did he have it disassembled in less than .5 seconds, he also managed to rip off the rubber sticky back on it. If you're looking for a good quality childproof lock, your best bet is going to Walmart and getting Safety First locks.","These are by far the worst items i have ever bought, all five units the blue smiley face popped right off. i even accidentally dropped the first one, as it hit the floor both buttons popped right off. so i checked other four and they all came off with no effort at all. so i tried to super glue the pins an put them back on, next morning tried one on cabinet doors, and tried to open, the sticky part gave up on one one door, the other door had to scrape it off. tried second one one on two door fridge, stuck real good on the metal, but when tried to open, both buttons popped right off, super glue didn't help. so peeled the base off, and the complete round black sticky pad was left on the fridge, took 15 minutes of scraping and rubbing to remove, what a pia. these are going in the trash, what a waste!","I guess you get what you paid for. The adhesive was the strongest thing about these things and it still didn't hold the locks together. My two year old took the thing apart with no effort. All she had to do was take the little push pin from one end. They are brittle and not worth it.","Took my two year old exactly 5 seconds to pop off the little blue button, these things don't work, don't waste your money","The pins with the smiley faces fall off easily and the glue that comes in it, is not at all strong to hold itself onto the cupboard doors.  My 18 months boy, figured out to open de doors in just 2 seconds.  Do not buy.","HORRIBLE!!! Cheaply made. Dangerous broke the minute I tried to use it causing choking hazards! This product is a joke I will never buy from them again!"],"images":{"small":"http://ecx.images-amazon.com/images/I/51d9IJxQMML._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51d9IJxQMML._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51d9IJxQMML.jpg"}},{"name":"Diono See Me Adjustable Rear View Mirror, Black (Discontinued by Manufacturer)","asin":"B005PK1DQA","price":"$9.49$5.68$10.99$14.34$12.02$18.43$4.86$5.96","stars":"1.8","reviews":["Not sure who came up with the idea to make a baby mirror that magnifies, but it was a bad idea. This mirror magnifies so badly that you can only see the eye balls of your kid in it. And as if that wasn't bad enough, it distorts the image so badly that it gives me headaches while driving.<br/><br/>The only good thing about this mirror is the suction cup, they got that one right. I think I'll keep it just for that, and improvise something with a better mirror...<br/><br/>Lesson learned: don't buy something online that has no reviews, unless you've seen it in person...","My husband surprised me with this mirror after we turned our son around.  It was great.  I attached it to my front window and found the suction cup to be very secure.  I was able to pick up my son that evening and see him all the way home.  It was the same in the morning.  However, after a day sitting in the sun, the heat warped the mirror and the reflected image was lost.","Bought 2 of these at a local department store. First of all, the instructions on the box specifically say \"Do not moisten suction cup,\" but that was the only way I could get it to stick at all. Second, the mirror image is magnified (or maybe just very narrow?); all I can see is my 2-year-old's eyeballs! Or his nostrils, depending on how I adjust it.<br/><br/>Worthless!!! Returning both of them to the store!","We purchased this mirror when we moved our son to his forward facing car seat. HUGE MISTAKE!!! It was very difficult to install and the locking mechanism for the mirror broke on the one time we tried to adjust its placement and would not come off of the windshield. About 1 month later we walked out on a warm day to find it hanging from a now melted and shredded suction cup. We had to forcefully pull the mirror from the windshield leaving a rubber ring of material still clinging to our windshield. HORRIBLE PRODUCT!!!","This is a very good product.  I drive a Volvo SUV and most of rear view mirrors (that attach to the windscreen instead of the rear view mirror) are not able to give me any view of my baby's car seat.  I reckon it is because of the slope of the SUV front windscreen, compared to sedans, and the poor rotating angle of most mirrors.<br/><br/>The other thing that I love about this product is the magnifying ability of the mirror.  A few other reviewers had commented negatively on this aspect.  I am able to see my baby's entire face and upper body, not just the eyes, as one reviewer claimed!  Either the reviewer had an extremely small car, or extremely big kid!<br/><br/>The only reason why I had to purchase this product for the second time was because the rubber on the suction cup melted away after 1.5 years of usage. Considering I park (without any shade) under sweltering tropical temperatures of more than 30 degree Celsius (not Fahrenheit!) for more than 300 days in a year, I was surprised it even lasted beyond a year!<br/><br/>The last thumbs up - it is so lightweight that even if the mirror does fly off, as others claim, it will not hurt your child.  Think about it.","We've attached this mirror to our back window several times.  It falls off before we can even go a few miles.  It will not stay in place, and is a falling hazard.  Save your money.","Holy distortion! The mirror is anything but flat. Depending on the spot you look at in mirror you can sort of see through it. It's cheap plastic. The mount is pretty compact which is why I ordered it. I'll probably find another mirror to glue over the crappy one it came with.","Not sure if it melted or what, but this thing will not stay stuck to the windshield. I've gone through two of them and they don't work. Was more of a hassel than I'd have ever imagined. Also, the image was so distorted, it wasn't even worth seeing when the thing actually woudl stay up.","The lady at the boutique baby shop said this mirror was the best.  The only one she will carry, she said.  I'm skeptical about the suction cup, I said.  she reassured me that this one had really great suction.  I bought it, brought it home and presented my bounty to the wife, who said, \"i don't think a suction cup is going to hold.\"<br/><br/>I did read all of the previous user reviews who said the suction cup sucked.  I assumed they had not followed the directions properly (you have to twist a little ring and pop it into place to get the suction going).  I installed it properly (my apologies to those who i doubted at first).<br/><br/>1.  if you intend to install it on your windshield, be aware that if you have a more sloping windshield, it will be very difficult to find a position in which this mirror will afford you a view of anything other than your center console.  We have a nissan murano and it was pretty hard.  When I did pick a spot, I was fairly satisfied, but it was not where my wife wanted it.  I had to put it off to the side of the rear view mirror, not directly beneath it.<br/>2.  It fell off.  Within five minutes.  the first time we drove with it.  it fell on my leg.  it hurt a bit.<br/>3. It is a bit small and not very clear, but I really just need to be able to tell if the kid is alive, so I would have been fine with that.<br/><br/>bottom line is that it's worthless if it won't stay stuck.  avoid if possible.","This is the worst mirror ever! The suction cup stopped working and the locking tab on the suction cup does not work anymore. keep in mind Ive had this for 3 weeks. The plastic is cheap and the frame the holds the \"mirror\" keeps coming off. They advertise their \"Flat panel safety mirror to see larger area with no distortion\" but the mirror isnt even glass its a cheap piece of plastic. Not only that but its distorted as hell. I am not happy with this purchase at all, but in hindsight you get what you pay for."],"images":{}},{"name":"Sunshine Kids See Me Rear View Mirror, Black (Discontinued by Manufacturer)","asin":"B000KN4SKA","price":"$2.99$9.49$5.68$10.99$14.34$12.02$18.43$4.86$5.96","stars":"1.8","reviews":["Not sure who came up with the idea to make a baby mirror that magnifies, but it was a bad idea. This mirror magnifies so badly that you can only see the eye balls of your kid in it. And as if that wasn't bad enough, it distorts the image so badly that it gives me headaches while driving.<br/><br/>The only good thing about this mirror is the suction cup, they got that one right. I think I'll keep it just for that, and improvise something with a better mirror...<br/><br/>Lesson learned: don't buy something online that has no reviews, unless you've seen it in person...","My husband surprised me with this mirror after we turned our son around.  It was great.  I attached it to my front window and found the suction cup to be very secure.  I was able to pick up my son that evening and see him all the way home.  It was the same in the morning.  However, after a day sitting in the sun, the heat warped the mirror and the reflected image was lost.","Bought 2 of these at a local department store. First of all, the instructions on the box specifically say \"Do not moisten suction cup,\" but that was the only way I could get it to stick at all. Second, the mirror image is magnified (or maybe just very narrow?); all I can see is my 2-year-old's eyeballs! Or his nostrils, depending on how I adjust it.<br/><br/>Worthless!!! Returning both of them to the store!","We purchased this mirror when we moved our son to his forward facing car seat. HUGE MISTAKE!!! It was very difficult to install and the locking mechanism for the mirror broke on the one time we tried to adjust its placement and would not come off of the windshield. About 1 month later we walked out on a warm day to find it hanging from a now melted and shredded suction cup. We had to forcefully pull the mirror from the windshield leaving a rubber ring of material still clinging to our windshield. HORRIBLE PRODUCT!!!","This is a very good product.  I drive a Volvo SUV and most of rear view mirrors (that attach to the windscreen instead of the rear view mirror) are not able to give me any view of my baby's car seat.  I reckon it is because of the slope of the SUV front windscreen, compared to sedans, and the poor rotating angle of most mirrors.<br/><br/>The other thing that I love about this product is the magnifying ability of the mirror.  A few other reviewers had commented negatively on this aspect.  I am able to see my baby's entire face and upper body, not just the eyes, as one reviewer claimed!  Either the reviewer had an extremely small car, or extremely big kid!<br/><br/>The only reason why I had to purchase this product for the second time was because the rubber on the suction cup melted away after 1.5 years of usage. Considering I park (without any shade) under sweltering tropical temperatures of more than 30 degree Celsius (not Fahrenheit!) for more than 300 days in a year, I was surprised it even lasted beyond a year!<br/><br/>The last thumbs up - it is so lightweight that even if the mirror does fly off, as others claim, it will not hurt your child.  Think about it.","We've attached this mirror to our back window several times.  It falls off before we can even go a few miles.  It will not stay in place, and is a falling hazard.  Save your money.","Holy distortion! The mirror is anything but flat. Depending on the spot you look at in mirror you can sort of see through it. It's cheap plastic. The mount is pretty compact which is why I ordered it. I'll probably find another mirror to glue over the crappy one it came with.","Not sure if it melted or what, but this thing will not stay stuck to the windshield. I've gone through two of them and they don't work. Was more of a hassel than I'd have ever imagined. Also, the image was so distorted, it wasn't even worth seeing when the thing actually woudl stay up.","The lady at the boutique baby shop said this mirror was the best.  The only one she will carry, she said.  I'm skeptical about the suction cup, I said.  she reassured me that this one had really great suction.  I bought it, brought it home and presented my bounty to the wife, who said, \"i don't think a suction cup is going to hold.\"<br/><br/>I did read all of the previous user reviews who said the suction cup sucked.  I assumed they had not followed the directions properly (you have to twist a little ring and pop it into place to get the suction going).  I installed it properly (my apologies to those who i doubted at first).<br/><br/>1.  if you intend to install it on your windshield, be aware that if you have a more sloping windshield, it will be very difficult to find a position in which this mirror will afford you a view of anything other than your center console.  We have a nissan murano and it was pretty hard.  When I did pick a spot, I was fairly satisfied, but it was not where my wife wanted it.  I had to put it off to the side of the rear view mirror, not directly beneath it.<br/>2.  It fell off.  Within five minutes.  the first time we drove with it.  it fell on my leg.  it hurt a bit.<br/>3. It is a bit small and not very clear, but I really just need to be able to tell if the kid is alive, so I would have been fine with that.<br/><br/>bottom line is that it's worthless if it won't stay stuck.  avoid if possible.","This is the worst mirror ever! The suction cup stopped working and the locking tab on the suction cup does not work anymore. keep in mind Ive had this for 3 weeks. The plastic is cheap and the frame the holds the \"mirror\" keeps coming off. They advertise their \"Flat panel safety mirror to see larger area with no distortion\" but the mirror isnt even glass its a cheap piece of plastic. Not only that but its distorted as hell. I am not happy with this purchase at all, but in hindsight you get what you pay for."],"images":{}},{"name":"Philips B120E/37 InSight Wireless HD Baby Monitor Video Camera (White) (Discontinued by Manufacturer)","asin":"B00AALO9Z6","price":"$58.87$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"2.1","reviews":["This product is specifically marketed as a baby monitor, and I will review it as such.  I purchased the In.Sight baby monitor this past Saturday for our 8-month-old daughter's room.  She is teething right now and sometimes wakes up at night crying very loudly as if something traumatic has happened.  We have an Angel Care audio monitor, but we also wanted a video monitor so we can quickly and easily discern whether her life was truly in peril or if she was just having another episode of teething pain.<br/><br/>We bought the monitor from an Apple retail store and brought it home.  It took about 30 minutes to get it installed, set up, and running.  Not too bad.  However, I noticed very quickly that sound from the In.Sight monitor lagged about 10-15 seconds behind the sound from the Angel Care monitor.  Additionally, the video signal seemed to lag another 15-30 seconds behind the already lagging audio.  On top of all that, from the time I open the App on my iPod Touch 5 to when it finally displays live video ranged anywhere from 1-5 minutes!  Sometimes it wouldn't display live video at all until I closed and relaunched the app.  This did not seem like a very functional monitor, and I was already debating if I should return it.<br/><br/>The kicker came in the middle of the night Saturday night.  We awoke to my daughter's loud crying through the Angel Care monitor (we had the audio off on the In.Sight since we didn't need two audio sources).  I attempted to bring up the video on my iPod Touch to check on her.  However, the app just sat there with that annoying circling graphic that means \"loading\" for about two minutes.  Finally, the video came up, but the screen was all black.  The infrared night vision wouldn't activate.  After another minute of thumb-tapping and cursing, I gave up and went in to the baby's room.  Turns out she was already almost back asleep, and me entering the room just woke her back up.<br/><br/>Anyway, I took it back to Apple the next day.  This In.Sight monitor SHOULD NOT BE USED as a baby monitor!  If you insist on using it, make sure you have a secondary \"regular\" monitor running in parallel.  This product is a lawsuit waiting to happen.  The potential exists for someone's child to be dead before they ever get any warning that there is a serious problem via the In.Sight monitor.  I expressed my concerns to the kind gentleman who helped me with my return at Apple.  Believe it or not, he ACTUALLY told me I should tell other potential customers about these issues.  So, that is why I am posting here!","As the father of 18-month-old twin toddlers, they're getting a little old for a panicked 'CHECK THE MONITOR' moment, but its nice to have one handy when they take a nap and wake up, or for piece of mind.  We have a monitor over my daughter's crib, but the monitor battery is constantly dying, so we leave it plugged in most of the time.  My son screams a lot, so we can usually hear him on her monitor anyway, but I was interested in a monitor like the In.Sight where you can watch the feed on mobile devices.  That way we can check in even on date night, to make sure grandma puts the kids to bed on time.  And we don't have to worry about keeping the monitor charged.<br/><br/>The In.Sight has a LOT of features, but the interface is a dud.  It's got night vision, recording, photo capabilities, temperature and humidity readings and some pan and scale features, but the interface is not very intuitive so it's hard to find many of the settings.  My initial frustration came with the app.  On the iOS app store (it also has an Android app) there are TWO 'identical' In.Sight apps.  One has a one star review, the other has no reviews.  I downloaded both and it turns out the one star reviewed version is 2.8.x while the 'new' version is 2.9.  Why not just remove the other app from the store?  The new app doesn't say 'new' or 'version 2.9' or anything on the icon.  They're identical.  When you start, you have to register and create an account.  I did this on the 'old' app, and when I figured out which was which, I deleted and was able to log-in to the new app without having to redo anything.  Even my camera was still set up.  Then I went to update the camera software through the app.  At this point, the whole thing fell apart.  The camera was then 'offline', the app kept crashing or would freeze.  I was about to give up and throw a one-star review down as well, but I reset the app a half-dozen times, unplugged the camera and reset everything and then it started working.<br/><br/>In the app, you get a view of your different monitors, with the temperature and humidity and a little volume bar next to the monitor display.  Sounds good, but you can't adjust the camera volume!  I tried swiping, I tried the settings on my phone.  No dice.  When my son gets up and screams, I usually mute our old monitor just so I don't have to hear it in stereo.  With this, I guess you just close the app.  Not cool.  I checked the manual, and nothing on adjusting the volume.  Also, the actual physical camera is always warm to the touch.  I get that it's doing a lot of work, but it had me a bit freaked out the first night.  AND if you want to change any settings, you go into separate settings menus in the app to change this or that. Why not just tap the volume and turn it down?  OR tap the temp to swap between Celsius and Fahrenheit?  (It comes set to Celsius, and it took a few minutes to figure out how to change it.) EDIT:  The In.Sight also advertises a pan and zoom feature for the camera.  The zoom works, but I was thinking that the camera would pan around.  It doesn't.  When zoomed, you can 'pan' around the image by swiping.<br/><br/>Oh, great...I just picked up my phone to check on the volume issue for the review and its asking for another software update to the camera... In the app, there is no way to tell how progress is going on the update, so it just looks like its offline and trying to sync the whole time.  It's 'updating' right now.  The last time is when it crashed and froze.  EDIT: successfully updated in about 10 minutes.  Still can't figure out the volume issue.  I did hit the microphone to 'talk' to the kids and it flipped out.  It unsynced the camera, then gave me an alert, then resynched but gave me a 'network down' message, then came back on.  On our old, cheap monitor you HOLD A BUTTON AND TALK.  THAT'S IT.  AND IT WORKS.<br/><br/>I really want to love this, and I want it to work well, but the interface has me confused.  They clearly spend some time and money developing this unit, this isn't even the first version of the camera, but the interface is worse than most apps PERIOD.  I've played a lot of free games on iOS with better settings and interfaces.  Confusing. I will be updating this review if it sorts itself out or burns my house down.<br/><br/>EDIT: Adding another notable issue here.  I mentioned the warmth of the camera, and sure enough, it effects the temperature displayed in the app.  It showed 74 degrees F, while out thermostat in the room had a temperature of 69 degrees F.  Our weather station clock also reflected 69 degrees F.  Heads up if its important to you.<br/><br/>And after using the camera a bit more, the lack of volume control totally kills it for me.  I have to mute my phone before I open the app because its near our sleep sound machine and its super loud if I open the app to check on the kids.  No good if you plan on monitoring them throughout the night.","the good: image quality is great and the infrared night function work beatifully<br/><br/>the bad: The iPhone app that is part of this product is the most buggy piece of software that I have ever seen. Even though it is version 2.2, its quality is clearly 'pre-alpha': it crashed all the time and requires constant restarts. On top of that, it takes ~2 minutes or more for the video to start showing up on the screen (using an iPad 2), which completely defits the purpose of having a baby monitor and having the peace of mind that I can leave my baby alone on his room.<br/><br/>the ugly: The talk back feature is not functional - it very poortly tries to mimic a push-to-talk which does not work properly on the iphone. The 'auto' setting for the night/day is very bad - it chooses day mode when the room is dark and vice versa. the motion sensor don't work. the noise sensor does not adjust for ambient noise.<br/><br/>I live abroad, so returning is a hassle and will probably keep it to use as a (very expensive) security camera.","Initially, I was not able to get this set up with the Android smart phone, our preferred device.  Looking at the reviews of the app, apparently I am not the only one; lots of people seem to have had trouble. *** Update:  An Android update/debug was JUST added.  It makes a significant difference.<br/><br/>I was able to get the monitor set up with the iPad app, and  to get it to work, but only once, and briefly. Then the connection failed, and the tablet just searched and searched for the monitor (which was two feet away, and both devices were right next to the router/wi-fi connection). It  repeatedly delivered a 'wrong password' verdict for the wireless connection despite the fact that we did NOT log in with the wrong password, checked it several times, etc.<br/><br/>Maybe our wi-fi is not strong enough to reliably run the monitor.  Maybe the problem is with the app--which the reviews would lead one to believe--and it will get fixed soon.  ****Update:  the app for Android has just gotten significantly improved.  But the iOS app still has problems; it still  struggles to pick up and hold the wi-fi signal. As things stand now, I can't recommend this monitor.  We don't need a  baby monitor often, since it for our niece's baby, who visits but does not live here.  Still: a baby monitor has to be completely reliable or it's worthless.  The electric non-wi-fi model that we are currently using is low-tech, to be sure.  But it works, reliably.  This wi-fi model?  It's now BETTER, to be sure.  But it still has a way to go.<br/><br/>We'll keep trying.","I use it to monitor the outside of my house and know the inside house temp.  I travel a lot.  I can use my IPad 3  and iPhone 4S and see the outside weather. I get notified if a car pulls up via alerts. I can see the current temp in the house.","Our dog suffers from separation anxiety so whenever we were out of the house we wanted to try and keep an eye on him.  Generally he doesn't destroy things but with all of his nervous energy he unfortunately chews, licks and scratches himself until we return home.  We've had to start using a plastic cone, dog boots and socks with Velcro ties just to get him to stop hurting himself when we're gone.  Even with all of these methods he still manages to give himself skin infections resulting in hundreds of dollars in veterinarian bills every few months.  We felt adding a wireless camera to help monitor his behavior while we're out would be helpful. Enter the Philips B120E/37 InSight Wireless HD Baby Monitor Video Camera (White).  Here are my thoughts;<br/><br/>Pros<br/><br/>+ Temperature  humidity sensors<br/><br/>+ WiFi viewing while you're in and outside the home.<br/><br/>+ Relatively easy set up  ability to share the camera view with other users.<br/><br/>Cons<br/><br/>- Overpriced for the poor performance of the product.<br/><br/>- Constantly disconnects after only a few short minutes of use.  Most of the time I receive an error stating that I've reached my 2 hour viewing limit.<br/><br/>- 8+ second delay on the camera, even in my home on WiFi.<br/><br/>- Night vision stopped functioning after 2 days.<br/><br/>- Both online and app routes take exceptionally long to connect with service being exceptionally spotty.<br/><br/>- Subscription service necessary to record video or to upload them to Dropbox.<br/><br/>We were extremely excited to receive the Philips B120E/37 InSight Wireless HD Baby Monitor Video Camera (White), however after many weeks of use I'm sad to report that we were extremely disappointed in its performance.  Immediately the phone application would consistently crash or fail to connect and after only 2 days the night vision stopped functioning.  An update to Android came roughly a week later but it did very little to fix the stability of the camera.  Add other annoying things such as the long camera delay, the viewing limit errors and high list price makes this unit very difficult to recommend.  At the end of the day for $150 there are much better and more reliable wireless camera options available.","This monitor is easy to setup.  It involves plugging it in after assembling the plug and hooking in the included usb cable.  The usb cable connects the camera to the plug.  No computer is required, but instead you need a smartphone or tablet (either Android or Apple).  From unboxing to installing the app and seeing video, it took me about 5 minutes.<br/><br/>I did have one issue. WiFi configuration of the camera occurs withing the Philips InSight app.  My smartphone was connect to my 5GHz Wifi, so the app tried to get the camera up and running on the 5Ghz network.  It failed each time.  Apparently this camera only supports the 2.4 Ghz frequency band. Once I switched my phone to my 2.4 GHz network, it connected quickly.<br/><br/>I setup and tested this monitor in the same room that I was in at the time.  There is a delay of 3 to 4 seconds between what happens in real life and what happens on the monitor.<br/><br/>The app has an option upsell for $25/year for added benefits of 2 hour uninterrupted audio and video streaming live.  That it cannot do this by default seems like an arbitrary business decision unless something has to traverse a Philips' network (and I'm not sure why it would need to).  If the audio and video is riding on the cellular network, I should not have to pay Philips for it. You can also share the monitor with 10 people, and see a week of alerts history.  You have unlimited viewing if your device and the camera are on the same WiFi network.<br/><br/>Overall, I'd say tis is a pretty useful monitor.  I like that it displays the temperature of the room and that the audio and video are clear.  I have seen worse when it comes to baby monitors.  This one has better quality and was easy to install.<br/><br/>Update:  After using this several nights, I am somewhat disappointed in the infrared video quality.  It is hazy, almost as if I am looking through a foggy window.","This product is a terrific idea, with horrible implementation.  The basics: instead of a baby monitor with its own dedicated video receiver, why not use wifi and our ubiquitous smartphones for the receiver?  You could, theoretically, just whip out your phone and check on your little one as needed.  There is night vision, HD video, sound and temperature monitoring, and you can even talk back to your baby if you want.  Sounds great?  Yes, yes it does.  The problem is that it simply doesn't work.<br/><br/>As other reviewers have correctly noted, there is ridiculous audio and video lag.  Not the \"badly dubbed film\" type of lag, we're talking multiple seconds of lag.  Secondly, and this was the deal breaker for me, the app is a buggy piece of software, and is prone to disconnections, even if you're within a few feet of the camera (and router).  It crashes, and the app reviews on the app store highlight all of these issues, going back to last year... and they still haven't been fixed!<br/><br/>Setup/connecting is also unnecessarily long.  I have used multiple baby monitors and also wifi cameras, and it's ridiculous that the Philips B120 takes so long to connect to the network and/or app.  Since it's prone to crashing and disconnecting, it means you'll be trying to connect a lot.<br/><br/>Finally, be aware that this monitor only connects to 2.4GHZ wifi networks, and that your phone and monitor need to be on the same network.  This means that if, like us, you have a dual band 2.4 and 5 GHZ, it simply cannot connect to the newer, faster 802.11ac network.<br/><br/>All in all, this is a definite pass.  A great idea, but terrible, terrible implementation.  You'd be better off setting up an old-school webcam in your baby's room than using this.","I wish I could give this negative stars.<br/><br/>The iOS and Android apps are buggy.  The unit continually drops off the network.  You must have your phone and the unit on a 2.4 Ghz network, so no blazing ac stuff here.  We wanted to use this to keep an eye on our puppy if we needed to leave for a short time and couldn't bring him.  We thought it would be good to keep an eye on him and be able to give him a reassuring voice if he became upset....wrong.<br/><br/>Sound doesn't work, camera is always dropping.  Pan seems to only be swiping around a zoomed image and not panning the camera...or it doesn't work either.  I could go on and on about the negatives of this device, but I will sum it up with don't even think about buying this to help you watch over anyone or anything!<br/><br/>I definitely would not recommend this device.","Didn't like this at first but as I've played around with it.. It's been great! I wish it had a hand held with it besides the app. I need my phone sometimes for other things. I moved the sensitivity to notify me and it does every time. Even if my baby moves his hand.. Coughs.. I've tried a couple different ones that had really great reviews and they ended up being junk. Once you figure this device/app out, it is really easy and has great viewing. I didn't get this one on Amazon but I'm glad I got it."],"images":{}},{"name":"Proudbody My Little Prints Baby-Safe Ink Pad, Vibrant Pink","asin":"B001879AOG","price":"$6.95$58.87$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["I bought this ink pad to use for footprints and handprints in a baby book. I pressed hard and never could get the ink to work. I even tried with my own  finger and still couldn't get any ink out of it. It was very disappointing. Horrible product. I bought another ink pad for less at a craft store and it worked much better and was also safe for babies.","I thought that the pink ink would be perfect to take the prints for my new baby girl. I am glad that I prepared several months ahead of her due date though, because if I hadn't it would have been a big disappointment.<br/><br/>There is just not enough ink on the pad, and the ink is not dark enough to create prints that would be very visible on a piece of white paper at all. The pink shown in the picture is not how the print looks in real life. It is a very delicate pink instead (pretty, but not functional for visibility purposes). You would have to rub baby's hand back and forth several times on the ink pad to even pick up enough ink to try to make a visible print. When you do make a print, the delicate pink color is not functional for any sort of display purpose.<br/><br/>I sent the first ink pad I ordered back and received a replacement. Both ink pads were the same quality - low amount of ink, not dark enough pigment.<br/><br/>I have given up on my \"dream\" of pink prints, and have decided to go with the boring, but more practical shade of black.","The ink is hardly visible on paper. Don't waste your money on this product.<br/>I brought a black inkpad from office depot and got my baby's hand impression (its not harmful as long as you throughly washes baby's hands in soap).","I don't now how far in advance the product was ordered before it was needed by the critical reviewers. They made me skeptical, but I've never had any issues with anything I have ordered from Amazon. So we ordered this product the same week we planned on using it, and our ink pad was far from dried out.<br/><br/>We were able to make prints of our daughters feet and her hands, and the clean up was super easy with the Johnson  Johnson's baby face and hand wipes. I am so very happy that she now has prints on her wall and in her first year memory book. The color is brilliant, and is the perfect bright pink hue for a little girl.","I ordered two and they were dry when I received them, even attempted to add some water to hopefully moist the ink pad still a no go, I wanted it for my newborn twin girls foot prints and hand prints on certain memory keepsakes.  :(","I completely regret purchasing this item. It was completely dried out when I opened the seal, and it ruined my opportunity to get my daughter's feet and hand prints into her baby book. I would NOT get this, and I would not recommend anyone to purchase this item.","Arrived a little dried out. The prints were very light. Obviously I didnt crush my newborn's palm and feet trying to get a strong print, so given that, this product failed me. Maybe a darker color would have worked better","I just needed an ink pad for a little art project for Mother's Day. I saw several reviews here about how dry this pad was when they got it, but I somewhat wrote them off thinking that you can probably just splash some water on it and it'll work fine. Well, mine was dry when I got it, and even after wetting it with water, it barely gave off any ink. I was able to salvage my Mother's Day art project, but the hand print it made is very light and disappointing.","I like the fact that this product is baby safe but it didn't really work out for us.  It kind of bleeds a bit and you don't get a really clear print. We were using it to take foot prints of our daughter.  We tried several types of paper and it still didn't look right. Mabye someone else will have better luck with it.","Works like it should... you just need a bit of elbow grease to clean your kid up with the pink ink... or she'll be walking around with pink feet.  Seems strange but it was easier to clean the black ink off her feet than the pink ink.  We used baby wipes."],"images":{}},{"name":"Danby DBC514BLS 5.3 Cu. Ft. Silhouette Beverage Center - Black/Stainless","asin":"B001CAXQPS","price":"$939.00","stars":"2.1","reviews":["This fridge looks great, and it is the right size for under the counter in our kitchen, we bought it to keep all the drinks out of the big fridge.... but man! It drives us crazy constantly turning on and off, literally 10 times a minute. We have tried turning the temp up and keeping it full, but to no avail. It is really noticeable and bothersome in the quiet moments of the morning and evening...just when you want to relax and enjoy your kitchen. It's almost like it's breathing and straining. We are bummed about it.","Noisy fan, started failing at 24 months (loss of cooling) and totally failed at 27 months. Buy at your own peril, Danby does not support customers. See [...]","This is a beautiful bev fridge that looks sleek and modern in our new wetbar.  The blue light definitely has the \"wow\" factor and it does not warm the fridge like a traditional bulb can.  The temperature is holding true at 39 degrees (which is the lowest setting since it is really the wine fridge with different shelves).  It does exactly as promised and looks amazing doing it.","Three Evaporators replaced in 2.5 years. Total Junk. Four months prior to the manufacturer warranty expired and it failed. Evaporator replaced. Six months later under a service contract, it failed again. One week after receiving it back, failed again. I'm convinced that the service companies are milking the service contract for low hanging fruit on this product, but aren't actually finding the real leak. Danby all but said, sorry about your luck and were no help. I don't recommend this product or any purchase of a Danby product as a result. This thing has been a total lemon. It's currently unplugged and awaiting yet another repair under the service contract. I plan to replace it with another name brand product.","I hardly ever write reviews, but wanted to reiterate what other reviewers have already stated. This is a beautiful looking frig on the outside and holds a lot of beverages, but the cooling system is total junk. The first unit completely failed in less than a year. Since there's no Danby service in my area, after three months of back and forth with Danby \"customer service\" they finally shipped me a new unit. I was skeptical. Sure enough, almost 2yrs to the day later, it has failed again. Over the past two years, the frig has run for weeks or months at a time, but then will just stop cooling while I watch the temp drift higher. In these cases the compressor becomes too hot to touch and is really a fire hazard concern. Unplugging the unit overnight and plugging it back in the next morning has worked about 10 times, but now its done. Another issue is that, when it does work, if I put too many warm beverages in the frig it can't handle the load and stops working. Since it came with a 5 yr service contract, I'll get another one assuming the service contract company honors its commitment.","We purchased our Danby beverage center in Nov. 2011. We shopped a long time for the right one for our small family room area (12 x 20) and found this Danby to be the best product for the price. We had a little bit of an awkward space to fill under a granite countertop and our selections were between this unit and a Frigidaire, which was shorter by a few inches. We would've settled for the Frigidaire if the Danby didn't fit our space, but we were very happy we didn't have to.<br/><br/>One of the biggest selling points for us was the noise, or lack thereof. If our room is completely silent, you can barely hear the fan running. At first, when it was setting temperature, the fan would run, then turn off, every 7-10 seconds. We had read other reviews that listed this as a problem. However, once the desired temperature was set, it ran less often.<br/><br/>This unit is in a room where there is a fireplace directly across from it. The fan does run more often when the room is warmed by a fire, but we saw this as a pro, not a con. We want our beverages to be cool when the room is warm, and because the fan noise is so minimal, it's not an issue for us. When there is a little bit of other noise (ie, a TV on), you can't hear the unit at all. We actually wondered if it was still working! (It was.)<br/><br/>It's very spacious inside. It fit everything we expected and then some. It's a bit tricky with taller bottles, but adjusting the shelves is a nice feature. You just have to make the very top shelf kind of short and the second shelf a bit shorter, too. Then it all fits. We put plastic water bottles on their sides on top and then were able to stand up the beer bottles and 20-oz soda bottles on the 3rd shelf.<br/><br/>The blue LED light was a great selling feature to us. When it's on, it gives the unit an upscale look.<br/><br/>We've noticed that it holds a steady temperature of 44 degrees just fine, which is perfect for beer, soda and water. We keep only a few bottles of wine on the very bottom and while those should be properly chilled at a higher temperature, we prefer our wine pretty cold. It's just our preference.<br/><br/>If this unit has a downside, I'd say it's the plastic wine sleeves at the bottom and the construction of the shelves. If you don't move them around a lot, they should last, but in the store, we noticed that they were falling apart-- probably from too much use. We hope ours last!<br/><br/>We highly recommend this beverage center! Danby did it right with this one.","Three Evaporators replaced in 2.5 years. Total Junk. Four months prior to the manufacturer warranty expired and it failed. Evaporator replaced. Six months later under a service contract, it failed again. One week after receiving it back, failed again. I'm convinced that the service companies are milking the service contract for low hanging fruit on this product, but aren't actually finding the real leak. Danby all but said, sorry about your luck and were no help. I don't recommend this product or any purchase of a Danby product as a result. This thing has been a total lemon. It's currently unplugged and awaiting yet another repair under the service contract. I plan to replace it with another name brand product.","The only reason why I gave it 1 star was because I can't give it 0. After about a year the fridge wouldn't cool below 50, and then it not only stopped cooling, but actually began heating - going up to 82 degrees in a house that had a temp of 68. This fridge is a piece of junk and a waste of money.","I wish I read these reviews before I bought this fridge.  It is absolute junk.  I can't blame Danby for the fact that the installer couldn't make it fit the space and removed the back legs, scratching my floor in the process, but I do blame Danby for the NOISE!  As the other reviewers stated, the interior fan cuts on and off continuously, and it's REALLY annoying.  When a fridge turns the compressor on, you can understand the noise, it's just part of normal operation, but this fridge is most annoying when the compressor is NOT running.  The interior fan cycles on and off constantly.  In less than a year of service, the fan died (no surprise based on the constant cycling).  I looked the fan up on Amazon and it's a $5.00 fan!  I bought a much quieter fan with higher CFM and replaced it.  While I had the fridge apart I was horrified by the terrible construction.  Wafer thin plastic attaches with self tapping screws into the plastic back.  Runs quieter now (almost tolerable), but I'm guessing within a year this fridge will be chilling in a landfill.  I will never buy anything Danby again.","Over 6 years ago i purchased 2 of these Danby beverage coolers to go under my kitchen island.<br/> Last week one stopped working.For several weeks it didnt seem to get anything cold anymore. So my first thought was time to replace it. I looked on Amazon to see if they were still available and was happy to see that they were. Before pushing the cart button i wondered how much to have it serviced so i called a repair co.<br/> He was an honest man,, he told me what to look for to see what it might be causing the problem.<br/> I pulled it out and unpluged the unit and discoverd the first thing he told me to dop, make sure the coil is clean and that the compressor turned on, it did and the coil was dirty with common dust.<br/> Unpluged again and vacumed the entire underneath were the working parts are located. Pluged back in waited 2 hrs and the temp was back down to 45,, done deal.<br/> Very happy with these , they do what they are suppose yo do. These are for beer, soda and wine not perishable items.<br/> The only thing i dont like about these units are the fact they are digital with no memory back up,, so when the electric goes off and comes back on they reset to the highest set temp witch is around 63 deg. so not suitable for perishables."],"images":{"small":"http://ecx.images-amazon.com/images/I/51Pvb2QnxpL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51Pvb2QnxpL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51Pvb2QnxpL.jpg"}},{"name":"FANOR Freedom Clip for Keurig 2.0 Series Brewers, Allow All K-cup Pods and Competing Single Serve Cup/pods to Brew","asin":"B016B3S75Y","price":"$6.20","stars":"2.1","reviews":["Well, as others have observed, this trinket works. Once.<br/>Due to the poor choice in thermoplastics, this will deform due to the heat produced by the brewing and more-or-less flatten out, losing its spring for the clips. One can re-form it to fit by hand, but how many times will this work before it snaps?<br/>Take another shot, guys. You'll get it.","This product does unlock the Keurig 2.0 brewing options. Only stayed attached for 1 day before failing. Product catches on Keurig handle when closing which bends the product. Now it falls off after every use.","Can I give this item zero stars? The short/inside clip bent and nearly broke off with the very first use, rendering it essentially useless after. It was difficult to insert and didn't have a positive fit. Pay a few dollars more and get the Solofill METAL adapter. It's larger, easier to install, more durable and has a positive fit.","This did not work as specified; I only got the oops message with it installed. However, I was able to use it to permanently mount a piece of one of the approved foil lids in place over the camera, which lets me use all my old and non-approved K-cups without having to tape the foil onto every K-cup first. It gets 2 stars instead of one because I was able to make it useful despite it not working.","UPDATE:  After finally getting a Keurig 2.0 of my own and getting to use this clip, I am completely underwhelmed by the product.  After using it ONE TIME, the plastic melted and it fell off.  I was able to get it back on, but it again fell off.  This clip is great, when it's on and not melting, but it doesn't last past your first use.  Find one that's going to stand up to being used over and over.<br/><br/>ORIGINAL:  Were you left with tons of coffee pods when you replaced your Keurig 1.0 with a 2.0?  You no longer have to worry about having product that you can't use.  This is a brilliant little clip that fools your Keurig 2.0 to brew non-Keurig pods/carafes.  It is so simple to install and remove that anyone can do it.  Instructions on proper insertion are included.  You will not be sorry that you spent the money on this great little clip.  Highly recommended!<br/><br/>I'm a product review blogger and I received this product in exchange for an honest review.","I've been using my<a class=\"a-link-normal\" href=\"/Keurig-117644-2-0-K200-Brewer-Black/dp/B00WWEAXPY/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Keurig 117644 2.0 K200 Brewer, Black</a>for some time now, and while I love my machine, I hate that I have to keep paying at minimum $0.30 per cup for fairly mediocre coffee/tea blends that Keurig puts out. For a while I utilized the \"Keurig Hack\" by taping a small piece of a k-cup foil lid to my machine so I could utilize \"off brand\" k-cups, but the tape would sometimes get steamed off, and I would have to reposition and apply the taped foil in again.  Using the Fanor Freedom Clip helped rid me of \"tape duty\".<br/><br/>The Fanor Freedom Clip was a great solution to my problem.  The clip is easily installed over the opening where the camera is located.  The camera on the Keurig interprets the color as one of its own k-cups, and thus will allow any pod to be used in the unit.  I've tested out the freedom clip with various non Keurig pods with great success.  Also, if you simply want a cup of hot water, the clip will allow you to dispense, even if nothing is in the unit.<br/><br/>Overall, I'm very pleased with the Freedom clip.  It's easy to install, easy to remove should you want to use a carafe sized pod in the unit, and can be used with a reusable<a class=\"a-link-normal\" href=\"/Keurig-My-K-Cup-Reusable-Coffee-Filter-Single/dp/B000DLB2FI/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Keurig My K-Cup Reusable Coffee Filter (Single)</a>(which actually will not work with Keurig 2.0) in place.  I would definitely recommend this Freedom clip to any Keurig 2.0 user.<br/><br/>FYI - I was selected for this opportunity to review this item free of charge. The content and opinions expressed here are all my own.","I received this product for free in exchange for my HONEST review. I already had the awesome purple reusable filter cups, and since they worked so well in my Keurig 2.0, I agreed to test out these little clips. The item arrived with perfectly clear instructions on how to install, and I did so accordingly. It popped right into place very easily, although it was not a super snug fit, and seems it will need to be removed if I use my reusable filter cups. I found a box of regular k-cups at a local discount grocery store for about four dollars and figured for that price, I need to try them! This clip worked beautifully. I got no error messages from my keurig when I put the non-2.0 cup into my brewer and it made one of the best caramel macchiatos I have ever had ;) I am definitely happy with this clip, even though it is a bit thin, and will have to be removed when I use my reusable cups. I can handle that if it means I am saving a bunch of money on k-cups!","It worked ONE time.  The plastic gets stretched out and then doesn't stay in place.  It is a great idea but needs to be made out of something more sturdy.","This thing doesn't work at all.  I have made double sure that it is installed correctly and it only gives me the OOPS message, no matter what K Cup I use.","Good idea, but Flimsy construction.  Only lasted two weeks, then fell off and wouldn't go back into place."],"images":{"small":"http://ecx.images-amazon.com/images/I/41yWTMQ8cPL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41yWTMQ8cPL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41yWTMQ8cPL.jpg"}},{"name":"Sunbeam Ultrasonic Visible Mist Humidifier","asin":"B004VTX990","price":"$12.50$6.85$47.78$2.99$5.22$5.22$8.00$138.54$14.95$10.00 - $13.00","stars":"1.7","reviews":["I bought this after going thru many filters on other humidifiers. Thought it was a good idea, wrong. Worked well for the first few days, now no mist. I have cleaned it did everything the instruction manual, another big joke, suggested to do. So now I have this thing that doesn't do anything but make noise. Next time I'll spend the money and get filters.","This is a good humidifier, not great. I'll keep this simple:<br/><br/>Pros:<br/>-Large enough tank so you don't have to refill often, once every couple days if you run it for 3-5 hours in the evening<br/>-Very quiet, can't hear the fan but you can hear the bubbler (ultrasonic metal disk in the bottom)<br/>-Doesn't require filter<br/><br/>Cons:<br/>-If the water runs out, the ultrasonic disk will get VERY hot (trust me, I touched it) and mine didn't shut off automatically -- Now it only puts out half as much vapor<br/>-Blower isn't large enough, the bubbler puts more vapor than the fan can blow, so the water vapor will get your floor soaked if you turn it on high<br/>-approximately $40, too much. should cost about 20-30.","When we put a wood burning stove in our house, we needed a humidifier big time. I bought an ultrasonic bc the heat type have calcified over in one night with our well water. I've used it nonstop all winter for 3 years now.","Keeps the humidity in my house up to par.  I dropped the first one I owned and cracked the tank so had to discard it. 5 days went by till I finally looked it up on Amazon and there it was,same product.Shipped to me and now the house is happy again,as is my skin and my dogs.  Love Amazon !","I paid $80 for two of these at a large dept store in the fall of 2013.  I've had no problems.  Yes, you do have to keep it cleaned especially if you have hard water.  I use a bit of bleach with every fill.  I have small fans set behind them and they blow the mist out into the room and we do not have a wet floor/table problem.","I wish I would have read reviews before purchasing this piece of crap....it worked for about 2 weeks then something in the motor broke and now all it does is make a horrible whining sound while water shoots out the back of it. And of course I no longer have the packaging or receipt so I am out he $35 I wasted on it...","It has helped my allergies immensely ( or so it seems). I like everything about it except that it loses a small quantity of water when I place the tank on the base. I have to drain the base each time I fill the tank. Otherwise, it does its job very well.","- Small tank: the tank is only 1 gallon and the output is only 1 gallon per day.  The other humidifiers I have are three gallons and the output is three gallons per day.<br/> - Lousy tank shape: the tank does not stand upright when filling it with water and there is no handle to hold on to when filling it with water.<br/> - It leaks: It leaks when you fill it with warm water.  It even says so in the instructions.<br/> - No humidistat - When the room humidity is at 100%, it just keeps going and going and going and getting the floor all wet.<br/> - I took it back and purchased a better one (not Sunbeam)","I tried to be optimistic not expecting the greatest humidifier. But I will put it like this, don&#x2019;t waste your money. There my be some units that work as designed but they are few and far between, don&#x2019;t take your chances. I got two on clearance from Walmart. The first works great for about 5 or 10  minutes and then the base starts to overflow with water despite being level and undisturbed. I tested it repeatedly and it always started to overflow. The second unit didn't overflow but the ultrasonic vibrator that creates the mist lasted about 30 or 40 minutes before dying. It is criminal that they charge money for these pieces of non functioning garbage.","I wish I could give this product zero stars. I've had this thing out of the box for maybe an hour and I can tell you already that it's a piece of crap. The gasket cap doesn't thread on all the way allowing more water to enter the reservoir than it discharges. This created a huge puddle on my daughters bedroom carpet. And on top of that the damn thing DOESN'T WORK!!! The fan is pushing but no must is coming out. Save yourself the money and head ache. If you want to know what it's like to own this product pour a gallon of water on your carpet and punch a hole in your wall."],"images":{"small":"http://ecx.images-amazon.com/images/I/31sb7J8SbvL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31sb7J8SbvL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31sb7J8SbvL.jpg"}},{"name":"I Play Phone 4 Toy Cell Phone with Sound New Improve 2014 Model","asin":"B009MRQ2UO","price":"$5.99","stars":"1.8","reviews":["This was a piece of dirty painted cardboard which looked unsafe for children and not the toy I had expected. I was very disappointed and felt tricked!","I loved the concept for my 3 little grand daughters but unfortunately none of them worked.  I even took to Battery+ and they replaced the batteries and they still did not work.  However; on the bright side they were very easy and quick to refund my money with no problem.","I was very pleased with the toy cell. I bought it for my niece. She loves to play with family members cell phones. I thought this will make a good gift for her.","my 3 year old loves to play with my iphone so i got this to \"trick\" him into thinking its a phone. Really cute idea. The buttons are kind of har for him to push he had to use both hands and really squeeze button. Other than that cute sounds little light on bottom. It is amusing:)","I bought this item and I was very unsatisfied with this product. The product did not do anything that was described in the product description. I was very upset I would never buy from them againg. I contact the seller and they agreed to refund my money and just ship the product back.","UNSAFE!! They idea of this toy is very cool. Other than that it is UNSAFE. The reason why it has a metallic feel is because is is made from a candy tin. It has nothing to lock the inner electrical components away from curious hands. It is very hard to squeeze to get the lights and sounds to work, but very easy to just pull the phone apart exposing key pad, battery chamber and circuit board. It also dents easily.","purchased so my great grandson would leave all our phones for us to play with. He loves it.  Well worth the purchase price. Found to be exactly as advertised","It was just a rip off it should be taking off the market. It's like a piece of cardboard, it doesn't even deserve a star.","i ordered this for my grandson and he loves it, it looks like a real iphone 4.. glad i came across this product thank you..","The phone is plastic an when i got it,it worked for about 20 mins then got no sound out of it.Cost more to send back then what I paid for it"],"images":{"small":"http://ecx.images-amazon.com/images/I/31R73AqOQBL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31R73AqOQBL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31R73AqOQBL.jpg"}},{"name":"Eggling - Wild Strawberry","asin":"B000OMKOHI","price":"$12.98","stars":"1.9","reviews":["This product is a total disappointment.  Purchased several for hostess gifts for the holidays, and after talking to the recepients, not a single one sprouted. I have emailed the company, and hope I get a satisfactory response.  DO NOT ORDER.","I bought this with high hopes of being able to grow a plant for my younger cousin. I am a gardner myself so I was pretty excited. However the plant NEVER grew no matter what I did. To me it was a waste of money time and resources. DO NOT BUY. Get a plant from a florist or even from Home Depot- it'll be better than this piece of crap.","Choose this rating because it never grew.  Was a novel idea but definately would not recomment it to anyone.  Very disappointed in this product.","Defied all odds! Despite what a majority of reviewers say, this does actually work! HOWEVER, I agree with one reviewer and to use a zip-lock bag as a makeshift greenhouse. Keep it heavily moistened, and leave it on a window sill that has a lot of sun exposure. If too much steam builds in the bag, lift off for a few hours and replace when it's cooled down. Given a little time, little sprouts will grow!<br/><br/>Update: 5/17/15 Still growing strong &#x2665;","Was this toy fun...  Well not really since nothing grew out of it.  If an egg full of dirt is your thing then you're all set.<br/>Educational value...  This might confuse kids with the whole chick and the egg thing.<br/>It's an Egg..  It's not durable.<br/><br/>Over all the concept is neat.  Great present for someone who likes plants and eggs, but the execution sucks.  I'm getting Sea Monkey's next time.","Our daughters gave us a basil eggling for Christmas!  We thought it was so cute that my husband and i had to buy some as New Years gifts for our friends.  So even after reading all of the 'do not buy, doesn't grow' reviews, we bought eight egglings because it made a cute gift giving gift!  Our eggling sprouted, here is what we did...At first I just watered it everyday to keep that top paper wet, then after about ten days I decided it needed to keep warm, so I put it in a ziplock Baggie!  After a few days in the hothouse Baggie it started sprouting!  Now I have baby basil!&#x1F331;&#x1F331;&#x1F331;&#x1F331;&#x1F331;","Notice that the only 5 star review is from someone who has never actually tried to grow one? lol<br/>I bought several plants for my daughter for Easter this year on Amazon. The Wee Enchanted Garden, Tickle-Me Plants, and this Eggling (despite the bad reviews.)<br/><br/>The little garden is doing marvelously, the Tickle-Me plants are all growing and thriving...and I have an egg with dirt in it on the counter.<br/><br/>Cute idea, but total waste of money. :(","Was hoping for some home-grown strawberries this summer but I guess that's what Strawberry Farms are for.<br/><br/>In theory this concept is really cute and should be very easy. Crack egg, water egg, sun egg and then plant egg w/sprouts to final resting place. I didn't expect the final resting place to be the trash can.<br/><br/>Not only did the Eggling not sprout, but the additional seeds they included (for \"added success\" according to the instructions) did not sprout.<br/><br/>Don't waste your money on this product.","This product sounded like a cute item. The first one I tried was the herb thyme. It never sprouted. Then I tried mint. A few strings appeared after weeks. Still it struggles, but I do not expect it will get beyond the few strings that sprouted. I will go and buy a mint plant.","Most reviews claim the thing never grows, but seriously it's not that hard. I'm not an excellent gardener and I got it to grow with little issue.<br/>Here's what I did:<br/>Crack the egg like instructed. I left the shell bits IN THE EGG.<br/>Water the thing as instructed.<br/>Place in a window with pretty direct sun.<br/>Put a plastic bag OVER THE EGG. Like a ziplock bag for sandwiches.<br/>Water every day, seriously. But not too much at a time. A little in the egg, a little in the dish.<br/>Wait.<br/>When it starts to grow, let the shoots come out of the egg a few cm's, then move it to a window with less sun.<br/>Don't remove the bag yet, let it stay a few more days.<br/>Take the bag off after it's good and situated. If you notice the leaves wilting, put the bag back on for a few days.<br/><br/>That's about it. The thing grows well. Don't give this thing a bad review because you can't grow a plant."],"images":{"small":"http://ecx.images-amazon.com/images/I/41bu3wHcNiL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41bu3wHcNiL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41bu3wHcNiL.jpg"}},{"name":"child safety cord","asin":"B00261QNA2","price":"$7.99$5.99$2.99$9.49$5.68$10.99$14.34$12.02$18.43$4.86$5.96","stars":"1.8","reviews":["Your child would be safer with a shoelace. This thing is so cheaply made and flimsy, it's a JOKE that they dared market this thing. There's one tiny square of velcro as a safety line that any child would yank off in a second and bolt. This product is really unsafe. Skip it","Poor quality! I dont recomend this product at all.<br/>Also, I dont know how big the child has to be but the hole for the kid's side is very big - my son is 5 yo the hole was even big for my wrist.","This item is a zero. Does not stay and does not fit child. Waste of money and time. Your child is not safe.<br/>Are they allowed to market something like this?","Got used item. I have contacted the seller. The item had dirt pots all over. Soiled all over the velcro and the band. Very gross to look at and even touch. Who would put that on your child. I did not even feel like touching it.Seller is sending another one.","We bought these for our five and three year-olds at Disneyland.  We presented them as \"buddy bracelets\" and were able to get initial buy-in from the kiddos.  The five-year-old was fine, but as soon as the three year old didn't want to hold hands, she easily broke the cord and was running free.  They were also difficult to maneuver around in the close quarters of a line when the kids want to jump from one uncle's arms to another's.  If you take them off to put the kids in strollers, you have to store them somewhere.  All that being said, once we stopped using them, we lost the two kids a total of three times, so maybe they would have been worth giving another try.","Total rubbish<br/>Useless waste of money<br/>Flimsy cheap<br/>Do not buy<br/>How dare a product like this be allowed for sale<br/>A rip off<br/>Velcro straps that are too big for child wrists<br/>Unsafe<br/>Do not buy","Worst product in the world!  I put it on my son and all he did was turn in front of me and it snapped in two pieces!  He didn't pull from me or anything.  Extremely unhappy that I paid in good faith for something not worth two cents","This thing is junk.  I bought these for my grandkids for vacation.  I had one when my son was little it was awesome. But this one the velcro won't stay together the slightest tug and it comes right off child","I feel I was taken to the cleaners on this item.  On the child's end, there is no way to keep the child from undoing the velcro.  And the adult wrist band is so huge I can put it around both of my wrists.  And don't be fooled by the picture of the American flag on the package as I was.  If you read the small print below it says \"MADE IN CHINA\".","This is JUNK dont waste your $$ the straps dont adjust its one size and the Velcro is junk.  Not worth my time to return it, but I might modify it to work for us."],"images":{"small":"http://ecx.images-amazon.com/images/I/21tNa0q3cwL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/21tNa0q3cwL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/21tNa0q3cwL.jpg"}},{"name":"Hisense DH-70K1SJE4 Energy Star 70-Pint 2-Speed Dehumidifier with Ionizer","asin":"B00B75QGX2","price":"","stars":"2.1","reviews":["Well I bought this de-humidifier based on all the good reviews and am left wanting to like the de-humidifier and rate it five stars. Firstly the thing does suck water out of the air a lot better than my frigidaire. There is no doubt this machine is taking a lot of water out of the air. It is also very well built and looks sleek and stylish. The downside is far to great though to give this de-humidifier anything more than 2 stars. I first started this on normal mode and it gets the humidity to 3% the desired set percentage. But the compressor never kicks off. If it is set at 45% the humidity will be 42% with the compressor still running. If I then reset the humidity to 50% the compressor will kick off till it is at 47% and then continue to run. I do not know if it is just maintaining the level and the compressor runs at half speed or something but it is killing my electrical usage. Last night I looked at my electrical box and it measured 49090 and over a seven hour period it measured again at 49098. So this machine along with the rest of the household sucked 8 Kilowatts of energy in seven hours. I unplugged the machine and left everything else in the house the same and after seven hours the meter read 49100. So this machine sucked 6 kilowatts over a seven hour period. Over the course of a month this machine would suck 540 kilowatts costing me almost 70 dollars to run based on our rate. That is ridiculous and I cannot believe the company did not test this out or at least think about it before sending this unit out. I threw out the box already since it was shredded through the shipping and probably cannot even return this machine. What I will have to end up doing is setting the timer in the morning so it runs for 2 hours and at night. Just a pain that I have to run into the basement twice a day to turn this thing on. Anyhow this machine sucks out the water great from the air however also sucks the money out of my wallet. I would recommend something that is better in the energy department<br/><br/>EDIT: So a little over a year the compressor is no longer kicking on. I am so upset right now as I have paid good money for this product and it seemed like a reputable brand......What crap what happens is you can hear an electronic buzz from the De-humidifier and it seems like the compressor kicks on than it sticks the lights dim in the house and than the compressor kicks off. I tried researching the product on the companies website and nothing, they do not even have dehumidifers on the company website for sale. Oh well should have stuck with something from home depot instead of venturing out for a new brand. I will update if I can fix it or if the company does something to make this right<br/><br/>EDIT: I ended up having to buy a digital timer to turn the humidifier on and off at selected intervals through the day. I put it on the conitnous setting and have it set to turn on for one hour at 6:00am, 2:00pm and 11:00pm. Anyhow hopefully this does the trick and keeps the humidity at a desired level.<a class=\"a-link-normal\" href=\"/GE-15402-SunSmart-Digital-7-Day/dp/B007BJUKVM/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">GE 15402 SunSmart Digital 7 Day</a>","I am updating my review after using this product for upwards of a year.  It is still performing flawlessly, often pulling 20+ gallons/ day out of the air.  It has made a huge difference for me: no mold or mildew, no waking up congested, no damp sheets or clothing.  If it were not so expensive to run, I would have one in every room! (note, power charges in Hawaii can be 20x as much as they are in other parts of the country, so for many this will not be as much of a burden).  I did stop using it briefly because of the cost of running it.  When our 2 other units needed to be destroyed as part of a mass recall of dangerous units, we went back to using the Hisense, thinking it was a temporary solution.  It works so much better than anything else I have tried, that we decided to keep it plugged in, and attempt to compensate for the high power consumption in other ways.<br/><br/>My original review appears below.  This update was added to note that after a year it is still running smoothly, and I am still happy with its' performance.  I thought, given that it is not a particularly well known brand, and that far too many small appliances quit after a short time, it was worth adding an update after a year of use.<br/>________________________________________<br/><br/>I have to admit that before plugging this in I joked that it would get a real test in this environment.  I essentially live in the rain forest: on the windward side of Oahu and am plagued by the constant humidity: mold, mildew, congestion... the list goes on.  We have tried a number of solutions, including several other dehumidifiers.  In fact, for the past 2 years I have been running 2<a class=\"a-link-normal\" href=\"/SoleusAir-Energy-Star-45-Pint-Dehumidifier-with-Straight-Bucket-DP2-45-03/dp/B005814LAG/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">SoleusAir  Energy Star 45 Pint Dehumidifier, with Straight Bucket, # DP2-45-03</a>dehumidifiers 24/ 7.  They work OK, pulling 10 or more gallons/ day of water out of the air, but aren't enough really.  prior to buying those, I had several Eva dry products, including :<a class=\"a-link-normal\" href=\"/Eva-dry-Electric-Petite-Dehumidifier/dp/B000H0ZDD2/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Eva-dry Electric Petite Dehumidifier</a>and<a class=\"a-link-normal\" href=\"/Eva-dry-E-500-Renewable-Wireless-Mini-Dehumidier/dp/B000H0XFD2/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Eva-dry E-500 Renewable Wireless Mini Dehumidier</a>.  The petite worked ok in a little bathroom until a power surge took it out, the \"renewables\" did nothing much.  All that said, I have tried a number of things with minimal result.  It rains, pours almost every day.<br/><br/>When I plugged this unit in in my bedroom, where I was running one of the large Soleus units, the digital read-out read 80% (That is 80% humidity, with a large dehumidifier running!).  Within 5 minutes it was down to 59%.  In another hour, down to 53%!  I have NEVER gotten close to 50% in  my house, not ever.... which is why I am comfortable writing this up after using it for one day.  I have now emptied the bucket 4 times in 24 hours and the room is at 49%  Only trouble is that I do not want to leave my bedroom ;)  Clearly I am going to have to get a few more units.<br/><br/>Beyond the fact that it works exceptionally well, not only better than anything else I have tried, but actually achieving my objective of getting the humidity below 50%, I like that it is energy star compliant, has a good warranty (1 year parts  labor, 5 on sealed system).  It is also easy to set up, easy to use, empty and clean.  It has a digital read out and the ability to set fan and compressor level or desired humidity and let it automate the fan speed and compressor.  It has the option of using the built-in bucket, or attaching a garden hose.  I do not want a hole in the wall which will let in more moisture, but may ultimately run the hose into a sink, shower or bathtub.  I will see if after running it for a few days it still requires being emptied 4x/ day.  It may well because of the ambient environment.  That, alas, can not be helped.  This however, has made my home livable!  I can not recommend it highly enough, and will likely be purchasing several more myself.<br/><br/>Note, the unit is large and heavy, but not unattractive, and it does have wheels, making it easier to move.  Check the dimensions to make sure you have the space for it.  if you do, it is absolutely a worthwhile purchase.<br/><br/>Edited to note that after running it for a week, we unfortunately had to turn it off.  1.  It is *VERY* loud.  We could not watch a movie with it running in the next room.  I would say it is 2-4x as loud at the Soleus.  2. The reason we shut it off and are using the Soleus: although the Hisense pulls twice as much water out of the air, it costs 4x as much to run!  My husband was concerned about power usage because of how loud it was (I thought it was just the fan), so we plugged it into a<a class=\"a-link-normal\" href=\"/P3-International-P4400-Kill-A-Watt-Electricity-Usage-Monitor/dp/B00009MDBU/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">P3 International P4400 Kill A Watt Electricity Usage Monitor</a>and discovered that it draws 4x as much power as the Soleus! , 1,000/ watts/hour :O  At the rates we pay in Hawaii that is $200-300/ month!  3) It puts out a lot of heat, making it even more expensive as it is fighting the air conditioning :O<br/><br/>I'm sad to have to sideline this, but will save it for emergency use (during the winter rains when we have 100% humidity virtually every day).  It is hard to justify using something which draws so much power, particularly with our rates (10-15x what people pay on the continent).  That means that running this unit would pay for a portable air conditioner every month!  {sigh} so long Hisense, it was nice to have a dry room.<br/><br/>In sum, it does an exceptional job, but at a cost, a very high cost.  It is very very loud (much louder than any of the dehumidifiers we have used, or any of the air conditioners).<br/><br/>It might be a good choice for someone in London, Oregon or Washington state where the heat might be desirable and the power charges are lower.  In Hawaii it is just too expensive to run and puts out so much heat that it makes the room uncomfortable in a different way.<br/>-------------------------------------------------------------------<br/>edited to note that we had a flood a few weeks back from a plumbing back-up.  The company which came in to dry the place out left a dehumidifier which failed after just a couple of hours.  I plugged in the hisense and had it dry in less than 24 hours!  It actually did a better job than an industrial unit 4x the size! I may not be able to use it daily because of the high power costs here, but it is still useful to have around for emergencies.<br/><br/>_________________________________________________________________________________<br/>Updated to note that there was a massive recall of dehumidifiers last month affecting half a dozen brands, dozens of models, millions of people (ourselves among them).  Both of our Soleus units had to be destroyed (as they apparently had the bad habit of bursting into flames).  The Hisense was not among the recalled units (neither the brand nor the model).  If you are looking at this because yours was recalled, know that this brand was no included in the recent recall.<br/>and, as we are back into rainy season again, yes we are using it, 24/7.  I am glad we had a back-up!","(Update at bottom of review)<br/><br/>The Hisense 70 pint dehumidifier with Ionizer is definitely powerful.  It pulls much more water from the air than my 2 Frigidaire humidifiers.  I was very excited to use a dehumidifier with an ionizer, because I actually use 1 dehumidifier inside my living space during the warm months from spring through fall.  I rent an old house that lacks insulation, and it can get very humid (even with central air).  I originally went with the Frigidaire brand after my 2 very old units quit working, because my mom had one and I noticed it didn't seem to put out quite as hot air as my others did.  That was something important when using the unit in my living space.  It didn't really matter one way or the other for the dehumid. I use in my laundry area (think it was just a porch that was enclosed with zero insulation).<br/><br/>While the Hisense extracts more water than the Frigidaires, here are the negatives I saw in it --- the unit needs to be turned off for a couple minutes before attempting to empty the bucket.  If not, water will pour onto the floor when you remove the bucket (not just drip, but pour).  Also, it doesn't have indentations on the sides that make it easy for your fingers to grab the bucket and pull out.  It can be a little difficult, especially when it is full -- pretty large bucket compared to my others, so having the easy removal is much needed.  It puts out a LOT more heat than my Frigidaires.  Granted, it is a larger unit with stronger moisture extraction, but I will probably end up using this one in my laundry or storage area because of the heat issue once the summer heat really hits.  I only use mine on continuous operation, but a few times an hour it cuts off slightly, comes back on, cuts back off completely, and then runs correctly.  It's the same cycle each time.  It's strange.  I don't know why it happens, but I would think it shouldn't be doing this.<br/><br/>The controls are extremely easy to figure out.  The ionizer can be turned off and on with the simple press of a button.  If I do move this unit into my laundry or storage area, then I doubt I will use the ionizer.  So, if you are not concerned by the heat it generates, I would highly recommend this Hisense 70 pint dehumidifier, especially for large areas.  It pulls out an incredible amount of water from the air, is very easy to operate, and has a large handle that does make it easy to move around.  Even though I don't plan to use it in my living/dining area once it gets really hot out, I'm still very glad that I got this Hisense dehumidifier, because it does remove and incredible amount of moisture -- which is, after all, the most important feature of a dehumidifer.<br/><br/>------------------------------------------------------------------------------------------<br/>UPDATE --- 7/27/13<br/><br/>After using my Hisense dehumidifier for a while, I now absolutely LOVE this unit!!!! I decided to leave it in my living space and use my other 2 Frigidaire units in my laundry room and spare storage room that is closed off from main living space.  I made this decision based on the fact that the Hisense pulls out SOOOO much more moisture from the air.  The bucket on it fills completely in about 10 hours.  The other units take over 12 hours, and the buckets are approximately half the size as the Hisense (rough estimate from looking at the buckets and feeling the weight when they are full).<br/><br/>I have worked around the 2 issues of the Hisense that I had --- the heat it puts out and the water it spills on the floor when emptying.  I turned the dehumidifier around so that the heat exhaust points back towards an out of the way corner.  It still puts out the heat there, but it no longer blows the heat directly into areas that I use.  When I need to empty the bucket, I turn it off a minute or so ahead of time (if it hasn't shut off yet from being full).  Either way, I then kind of spin the unit back and forth in slightly circular motions.  You can hear the water coming out and going into the bucket.  When it stops doing this, I then remove the bucket to empty it.  I am now extremely happy with my Hisense dehumidifier.  It is now my dehumidifier of choice!!","This is a nice unit if you want the convenience of being able to set auto humidity levels and leave the machine running on and off to keep the humidity level where you set it.  If you want to run it continuously be warned that it draws a lot of power (my reading near 600 watts and with continuous use that translates to about 400 kilowatts a month).  If noise isn't a problem and electricity in reasonable where you live this unit does an absolutely outstanding job.  It removes moisture quicker than any other unit I've ever owned.  It is heavy but on wheels.  The 70 pints mean you'll empty it less often but in real humidity it also has a hose outlet (standard garden variety and that's nice) to let you run it without having to check it periodically.  It does a very good job of maintaining the level you set and it took the basement down from 65 percent to under 50 percent in less than an hour.  But that power comes with a catch when a unit is this big...it is loud...tolerable on low...but loud on high and you won't be watching TV near it.  It's nicely built even tho I had never heard of this brand.  Solid and works well.  I'd recommend it as long as you're aware of the potential cost of it's use and the noise level.","The unit arrived double boxed. One box was the manufacturers with styrofoam pads and the other was Amazons with wadded packaging paper for protection. Glad they doubled up as the manufacturers box didn't hold and the bottom was out when it arrived. The secondary packaging kept it intact.<br/><br/>Unit worked once plugged in. 70 pints is a good size for a 1000 sq foot or so basement. 25-50 sometimes can't quite keep up if the humidity gets high. The unit lets you set it to auto run at 50%, continuous run, or set your own auto run levels. Fan speed of low and high. It also has an air filter in front of the coils which is nice as dust build up on the coils hurts efficientcy over time. You vacuum the filter to clean it. Controls are all digital which is nice. The unit looks modern and visually is about as nice looking as you will find.<br/><br/>Moving it is accomplished via wheels or a handle. For a young adult the unit is moveable but if you lack strength it can be a bear as it is heavy.<br/><br/>Energywise on full run with compressor on, I measure it as drawing 523 watts. High fan only it drew 53. 523 isn't bad for a 70 pint machine, but if plan to run this 24/7 with the compressor going, it will add up quickly to around 360 kilowatts a month. My whole house right now uses about 360 a month so this would double on full continuous draw. 70 pints is big enough though to probably let it cycle on and off as long as you don't set it to low. A smaller unit forces you to run it continuously in a large space.<br/><br/>It also adds heat to the room. Unlike an air conditioner that removes moisture and sends its heat outside dehumidifiers vent the heat inside. Not an issue if you aren't also simultaneously running AC but something to keep in mind. Low temp it is rated to 38 degrees but functions best when it is warmer than that.<br/><br/>Noise wise it isn't bad for suh a large unit. The fan sounds like a fan running and the sound of the compressor cycling on isn't that bad either. Not something you'd want to sleep by but it does have a timer setting to help you control the run times so the noise isn't that bad.<br/><br/>Update May 2014: It sat inside, unmoved, and unused over the winter. Humidity getting up again this spring so I plugged it in looking for it to pick up where it left off last year. I am guessing the coolant leaked out over the winter as this thing is now pulling zip for moisture and at the humidity level my basement is at, it should be fillmg the bucket very quickly. Nothing on the coils, bucket is bone dry after a few hours. Too bad a this thing was awesome last year. Again I did not move it from its spot last fall when it was working well. Fan, compressor, electronics all working fine just no moisture removal at all now. I had this rated a 5 star product last year as it was great. Had to downgrade to 2 stars now as it has failed.","Having an old and humid home, I am no stranger to mold or musty odor, which are not good for my health or furniture.  Still, I never purchased a dehumidifier because of my fear that it would be too hot and noisy.  With the Hisense DH-70K1SJE4, I put those issues to the test in the scariest environment: my bedroom.<br/><br/>BUILD<br/><br/>For a dehumidifier, the DH-70K1SJE4 is surprisingly modern and attractive.  The plastic is glossy white with black accents, and the top panel is minimalist.  The very heavy device feels sturdy, though it would be nice if it rolled more easily.  When the water tank is full, it can be removed without too much trouble, and otherwise is disguised.  Alternately, a garden hose attachment allows continuous draining.  I did not test this feature, since I have it in a living area with no drainage.<br/><br/>FUNCTION<br/><br/>Setting the desired humidity is as simple as it could be, with a very intuitive interface.  Once on, water is removed from the air very quickly.  This is a big advantage over lighter duty units, particularly for large/multiple rooms.  My A/C unit barely makes a dent in the humidity, but the DH-70K1SJE4 shatters it.<br/><br/>When the power is turned off and on, the dehumidifier remembers the settings and turns on automatically.  This makes it compatible with timers.<br/><br/>SOUND<br/><br/>As with a window air conditioner or purifier, you will likely want to keep the fan on low if you are in the room with it.  The high settings are more useful for quickly reducing humidity when at work.  Also similar to an A/C unit, the compressor cycles off and on, adding extra noise.  I find that more annoying when I am trying to sleep than the white noise of the fan.  Still, on low it is something I can adapt to.  I would prefer it to be quieter, though.<br/><br/>CUSTOMER SERVICE<br/><br/>My first unit had a humidity reading stuck at the minimum, so I sent an email to support.  The very kind support representative (thanks Shaunette!) kept me informed throughout the replacement process, which ultimately took around three weeks.  While a more streamlined and fast process would be nice, I highly preferred this personal service to most experiences I have had with companies.<br/><br/>CONCLUSIONS<br/><br/>The DH-70K1SJE4 is a beast that will knock the humidity down in large rooms quickly.  This power means that it can cycle off more frequently, reducing noise and power consumption.  If you don't mind moderate noise and are aware of the energy cost, it is highly recommended.","I have mixed feelings about the Hisense 70-pint humidifier. There are some aspects that are great, but some that are so-so.<br/><br/>The construction is one of the strong points. The humidifier is made of sturdy, heavy-duty plastic. It weighs ~20 lbs, which is not heavy in comparison to the Kenmore humidifiers that it is replacing (~30 lbs). (Note that these weights are without water, which adds a significant amount.) It has solid wheels and is easy to move around, which is helped by the solid, comfortable handle on top. It is possible to set up automatic empyting, or to manually empty the collected water. Unlike some other machines, automatic emptying is easy to set up, and is via a standard-sized garden hose (rather than a proprietary size). In addition, my other humidifiers, for manual empyting the drawer slides easily out, and is easy to replace.<br/><br/>I'm using the humidifier in a basement, so noise isn't a huge issue for me. I've had both louder and quieter humidifiers, but I certainly wouldn't want the noise of this humidifier in any living areas.<br/><br/>The controls and settings are another area with mixed results. The controls and display are located on the top of the humidifier, and are easy to read, and relatively simple to figure out. The settings allow control of the following- fan speed (low, high, and auto), desired humidity (continuous, normal, and auto dry), and timer. The display also provides information on actual humidity. (There is also an ionizer, but as I'm using this in a basement, I haven't used it.) The timer is very simple, and is one of the biggest drawbacks of the humidifier in my opinion.<br/><br/>There are several ways the humidifier can be controlled-<br/>-You can set it to maintain a particular humidity, leaving it on constantly.<br/>-You can turn it on with a particular fan speed, leaving it on constantly.<br/>-You can set it on a timer to run for a certain length of time. However, unlike other humidifiers I've used, this is a one-time setting. I.e. It can be set to turn on for 2 hours, but cannot be set to automatically turn on every day for 2 hours.<br/>-You can set it to turn on at a certain time. However, when using that setting, as far as I can tell, you can't set the length of time it will run; you need to come back to turn it off.<br/><br/>Update- Sorting through the papers, I have realized that this dehumidifier does not have any warranty. This is a very important consideration when purchasing!","Hisense's 2-speed, 70 pint Dehumidifier with Ionizer is a really effective product that manages to get my 550 square foot basement from 65 percent humidity to under 30% in a few hours.  Setting this unit up is as easy as removing it from the box (unit weighs about 40 lbs but is wheeled and has a collapsible upper handle) and plugging it in.  The unit has a very modern and stylish form factor with rigid, black and white molded plastic and a top facing display with lit controls and LCD displays.<br/><br/>The dehumidification controls are relatively straightforward with 2 fan speeds or an automatic option to get to your desired level of humidity as soon as possible.  If you have previous experience with similar products you should be accustomed to the expected level of noise (about as loud as a cheap, wall mounted air conditioning unit) and warmth that is emitted through the air venting.  As far as such standards go this Hisense model is well within the expected range with slightly quieter operation than other units I've experienced.  Where it excels is the speed at which it can dehumidify provided you run the fan at hi-speed.  The ionization option is a nice feature as well and works effectively provided that you clean the air filter (via a vacuum scrub) every couple of weeks or so.  The 70 pint tank capacity is a good size and for those who plan on running it continuously there is a hose mount option.  Overall a decent workhorse with nice, high tech styling.","Update 4/1/16, bought this 6/2013, just died on us, so almost made it three years, but only two summers.<br/>It has been working for six weeks now with no issues. It pulls the humidity level down within a few hours and then maintains, we have it set for 55% it is fully customizable or you can set it to auto. We had it set to empty the bucket at first but with our basement mid summer, that was twice a day so we went ahead and hooked it up to a hose near the drain for continuous drain, it is as simple as taking the plug off the back and screwing in the hose. It defiantly warms the air, I wouldn't want this on a main level of the house completing with the air conditioner, but our basement is naturally cool and the extra heat is acceptable down there. It is similar in sound to a small window air conditioner, fine in the basement; I doubt I would want it on a main level. The ionizer makes the air smell \"clean\" for a lack of a better term, we live in a 113 year old house and depending on humidity old house smells pop up yet this keeps them down by drying them out and when ionizer is on, it does smell clean. Its on wheels and easy to move. It has a sensor to tell you to pull out filter, I just vacuumed it and replaced. I hope to get a few years out of it, and would so far use this company again.","This is a very effective dehumidifier. Within an hour reduced the humidity level from 68 to 41!  Very quiet - just a low hum. But it does throw out a bit of heat. It will be great in our Minnesota winter!"],"images":{"small":"http://ecx.images-amazon.com/images/I/411Ri5EP9TL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/411Ri5EP9TL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/411Ri5EP9TL.jpg"}},{"name":"Sous Vide Supreme Vacuum Sealer, SVV-00200","asin":"B003EGIIN8","price":"$84.95","stars":"2.1","reviews":["First of all, I have used vacuum sealers, notably FoodSaver, and I am familiar with sous vide methods (which require a good vacuum and seal that stays sealed).<br/><br/>I received the SousVide Supreme Vacuum Sealer with the Demi Water Bath. Well, first of all, it does not seal well. The controls are only \"seal only\" and \"vacuum seal\" (and of course, a \"cancel\").<br/><br/>The instructions state that you shouldn't use liquids, however, in sealing ANY meat there is some liquid and even this tiny bit of liquid completely prevents a vacuum and seal. So you would need, one supposes, only to use frozen meat. The FoodSaver on the other hand, has a separate vacuum control that allows you to vacuum only to the degree that you want (so you can seal before any liquid interferes with your ability to seal), and then you can select a \"seal\" separately from \"vacuum\" -- this allows one to totally control the degree of vacuum which is highly desirable.<br/><br/>I'm sending this back.<br/><br/>PS: I am enjoying the SousVide Demi Water Bath A LOT however.","EDIT: Well, the sealer is not standing up all that well.  It now no longer seals automatically after pumping out all the air.  I can still manually press the seal button and it works, so I'm not too upset, but the quality isn't as high as I initially thought.  I'd still buy it for the extra control that you have (independent seal vs vacuum pump controls).<br/>--<br/><br/>I recently bought this bag sealer.  It's about the same price as some of the more basic FoodSaver vacuum sealers and does almost exactly the same job: you place a bag in the jaws, press both sides to look the lid in place, press one button and it sucks all the air out and then seals the bag.<br/><br/>There are sealers available from other places/refurbished that will do the same thing for substantially less money.<br/><br/>However, I like this particular sealer for two reasons.  First, it's really simple to use.  Second, there is a \"seal only\" button that will let you make a seal without generating a vacuum first.  This button is the extra feature that separates it from some of the cheaper vacuum sealers.  Why so important?  Well, again there are two reasons: first, if you want to save money buying the bags, you can instead buy a roll of plastic tubing, cut off as much as you need, seal one side to create a bag that is sealed on three sides, fill it, then seal it as you normally would.  Second, and perhaps more importantly, when you are trying to seal a bag with liquid in it, there is no need to freeze the liquid first (although that does work well).  Instead you can begin the sealing process by choosing \"seal and vacuum\".  After all the air has been sucked out and you begin to see liquid being sucked away, press the other button (\"seal only\"), the vacuum stops and bag is sealed with very little air left behind.  It works well enough to trust and makes everything just a little less fiddly.<br/><br/>The sealer is very well designed: it feels fairly foolproof.  There's room for a few ml of liquid to be sucked out of the bag before you're in danger of sucking liquid into the vacuum pump mechanism (which would be bad) because of the clever design of the nozzle.  The bag lock is secure and effective.  It does require a little force to close the lid, so probably not suitable for the extremely elderly or infirm.  There's also some force required to press both buttons to release the locks at the end of the process.  Again, probably not ideal for someone with severely restricted finger mobility or kids under 10, but just fine for 85% of folks.<br/><br/>Final little notes: The machine has a very small footprint: about the size of a jumbo box of tissues (about 12 inches by 4 inches).  It's pretty quiet - no overly annoying beeps, etc.  It is color-coordinated to the black SousVide ovens, but I'm sure it would not look out of place next to the other colors.<br/><br/>I am very pleased with it although, like the actual oven, can't help feeling that it's just a little pricey for what it is.  Also, I've only had mine for a couple of weeks.  The key to these machines is whether they last more than a year or two.  On that count, the jury is still out.","We got this sealer as part of a package deal, with the Sous Vide Supreme water oven, and some Sous Vide Supreme vacuum sealer bags.<br/><br/>For FREEZER / PANTRY STORAGE our machine is not functional. We've sealed ten bags for the freezer. All of them start out looking good, but not one of them held the seal airtight overnight.<br/><br/>For SOUS VIDE it can be made to work. We've found sealing each bag three times at each end holds the seal long enough to cook the food.","One of the worst designed products I've seen in a while. Got it anyway despite the reviews because it matched the Sous Vide Supreme. While that is an amazingly designed product that's built well, this is a disaster. The main sealer gaskets will fail almost immediately, stick together or disintegrate, necessitating ad hoc repairs that look uglier and uglier. I have to hold it down with all my weight now to get it to vacuum seal. Made of cheap plastic, it's an unworthy companion to the main cook chamber. Take my word, select another sealer from someone else.","The reason why sous vide needs vacuum, is quite simple: too much air in the bag and it will float on top of the water bath with poor and uneven heat transfer.  Having said this, you don't need to apply a huge amount of vacuum and compress the meat.  In most cases, a ziplock bag and a straw will do.  The problem with this device in particular, is that the suction is so strong (and you can't regulate it), that unless you have a very dry piece of meat, there will always be some small amount of juices that will be sucked into the area where the seal is to be formed.  If the entire line of the seal is not 100% dry, the seal will not be made properly and then you will have hot water coming into the bag from the water bath.  Poor design and typical example of overkill.  There should be a button where you can override the vacuum pump.  I end up always double sealing (i.e. seal once with vacuum, then clean the insid area of the bag beyond the first seal to ensure it is clean and dry, and re-seal only.  Finally, the bags are hugely expensive.  I assume sous-vide supreme wants to go with the razor / razor blade model.","The sealer worked adequately at first.  I'll agree with some other reviewers that you had to be careful with any amount of liquid in the bag, but we found that refrigerated [non-frozen] meat worked fine.<br/><br/>However, after about six months [say 25-30 uses], it completely stopped working.  Makes a loud noise, but doesn't create a vacuum or do any sealing. Very frustrating.","EDIT:<br/><br/>When I first got this, it worked great. But, one of the small plastic clips that hold the machine shut during sealing has broken off. I repaired it using superglue and a layer of epoxy resin. I've downgraded the item to three stars; I was hoping for a longer lifespan before something broke.<br/><br/>(ORIGINAL REVIEW FOLLOWS)<br/>I got mine free as a package deal with the Sous Vide Supreme. I've sealed lots of meat and vegetables in bags and cooked them just fine using this vacuum sealer.<br/><br/>As with any vacuum sealer in its price range, this will suck up all the air in the bag... and then, if there is any liquid, it will suck that up too and fail to seal properly. But it works great if you freeze the bag slightly to solidify any liquid first. I did not remove a star for this problem as every countertop vacuum sealer does this too.","The vacuum sealer worked very well and is easy to use with my Sous Vide Supreme oven. It has a very strong vacuum and seals food quickly. Since it does have a strong vacuum, I had to be very careful not to let liquids from meats or veggies get sucked into the unit. It has a \"Seal Only\" button which is very useful when you don't necessarily need a vacuum seal.<br/><br/>Unfortunately, the machine stopped working after 3 months as it no longer has the ability to suck out the air from the bags. It's quite unfortunate since I took good care of it and tried my best to prevent liquids from entering the unit. Bottom line is that this unit isn't built to last.","Got this unit for use with the SousVide Demi and while the water bath works great, the vacuum sealer does not.  The vacuum mechanism chokes on even the smallest amount of liquid (such as the marinade left after draining the marinated meat) and I only got the \"Vacuum and Seal\" feature to work once, on a rib-eye.  Didn't work on any other dish, on at least a dozen attempts.  The \"Seal\" mechanism often left air holes, no matter how careful I was.<br/><br/>To be fair, I don't know if other vacuum sealers work better, but I am returning this and intend to find a better rated and functional unit.","Bought the Sous Vide Supreme and sealer as a package about a month ago.<br/>At first the vacuum sealer worked fine, but after several uses (10 times or so), the sealer doesn't work as well as when it was new. Now, the vacuum seal function is inconsistent. Sometimes it seals, sometime it doesn't. You have to manually press 'seal' during the suction or it'll auto shut, leaving the bag unsealed. Agreed with a lot of reviewers that this vacuum sealer does not work well at all with liquid in the bag. Yet, SVS website recommends recipes with meat/fish in marinate while sealing. For those recipes, I now notice they use a professional cryovac machine and not this piece of cr*p."],"images":{"small":"http://ecx.images-amazon.com/images/I/31DDt0N%2BVRL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31DDt0N%2BVRL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31DDt0N%2BVRL.jpg"}},{"name":"Hunter 44920 Universal Internet Thermostat, White","asin":"B00A16RCQS","price":"","stars":"2.1","reviews":["**** UPDATE ****<br/><br/>**** DO NOT PURCHASE ****<br/><br/>**** HUNTER HAS DISCONTINUED THIS THERMOSTAT! ****<br/><br/>**** REMOTE INTERNET SERVICE WILL BE DISCONTINUED AUGUST 1, 2013. ****<br/><br/>(original review)<br/><br/>I have read several mixed reviews about this thermostat, so I would like to add my 2-cents about my experience thus far.<br/><br/>NOTE: unless you wish to use the iPhone app, website/mobile site, don't get this thermostat since it is not programmable from the panel. This is not a flaw, it's a feature. If you don't like that, move on.<br/><br/>INSTALLATION:<br/>Installation was a breeze. Make sure to write down the device number on the back of the thermostat before you mount it, you'll need the number in a few minutes to set up your account with Hunter. The thermostat did feel a bit wobbly with the two screws provided, but that was an easy fix since I had an extra sheetrock screw on hand. Wire terminals are labeled and color coded, yellow to yellow, red to red, etc. It came with a setup booklet which gives clear instructions for mounting, wiring, wireless setup, etc. The thermostat can be bus powered or use batteries or both. Batteries are supposed to last a year or so with normal use. The thermostat snaps in and out of the wall mount, so changing batteries doesn't require messing with screws.<br/><br/>INITIAL SETUP:<br/>You'll need the device number from the back of the thermostat in order to set it up on Hunter's website or iPhone app. Plug the wireless gateway into your router with the included CAT5 cable and hook up the AC/DC power adapter. The LED on the gateway will blink red. Create an account with Hunter (which is $10/year after your free trial is over) and add the thermostat to your account. Within a minute or so, the thermostat will connect and the gateway LED will be green. You're good to go.<br/><br/>PROGRAMMING:<br/>The device is meant to be programmed from Hunter's website or iPhone app, not from the panel itself. It has a few buttons on it such as auto/cool/heat/off, temp up/down, stay/away, schedule on/off, fan on/off.<br/>NOTE: changing the settings from the panel will not override the schedule unless you turn scheduling off! If scheduling is on and you set the temp manually from the panel, the thermostat will go back to the scheduled settings unless you turn scheduling off! It's simple, but many negative reviews have been written about this thermostat because of this. THIS IS A STANDARD FEATURE FOUND ON PROGRAMMABLE THERMOSTATS AND NOT A DESIGN FLAW! If you want to manually adjust the temp, turn scheduling off!<br/>Ok, back on topic. I prefer using the computer with a mouse and keyboard for the initial setup. Windows or Mac is fine for the website. There is only an app for iPhone, not Android (what's up with that, Hunter?), but you can also use the mobile website from your Android or smartphone which works like the iPhone app. Or if you're a computer geek like me, you can easily create your own Android app (using webview).<br/>You can have multiple, separate schedules throughout each day/night for each day of the week. You can also save your custom schedule as a template and apply them to whichever day you wish. All seven days of the week are programmable. You can heat or cool till your heart's content. I found the website, mobile site and app to be easy to use (not sure what's up with the neg reviews on iTunes).<br/>NOTE: the iPhone app doesn't talk straight to the thermostat through your router, it goes through the internet to Hunter so you'll need internet access on your phone and thermostat in order to make changes to the thermostat.<br/><br/>FEATURES:<br/>The thermostat has a lot of features such as auto heat/cool which automatically turns on the heater or AC, whichever is need.  You can also program the temperature span which allows you to set how far the temperature can rise/fall before the thermostat kicks in. If you have the thermostat set to cool to 75 and have the span on 3 degrees, it will allow the temperature to rise to 78 before the AC is turned on. You can lower the span down to 1 degree. There is an away mode which turns the thermostat on savings mode while you're out of the house.<br/>There's too many other features to mention here. You can read the product description to see all the features.<br/><br/>CONCLUSION:<br/>I have been completely pleased with this thermostat. I will say though that if you are computer illiterate, you will probably find this thermostat very challenging to setup. There's a lot of features to play with, so take your time to read and reread the manual. Hunter also has a few videos on their website showing how to set everything up. I give this thermostat a big thumbs up.","I contacted Hunter customer support with a few questions regarding this item and was told that this model is discontinued and has been pulled off the market. The internet and iPhone app functions will no longer be supported within a few months. It will then be a non-functional item since it can only be programmed online or via app. Hunter will reimburse those that already own it.<br/>(Contact Hunter customer support and they will confirm what I am writing here.)","I picked this thermostat up in January.  I was originally looking at the Hunter 44905 which was rated well, but decided to go with the 44920 for the wifi feature thinking I would get similar features with the wifi added.  That was definitly not the case.  Beware, upon picking it up i noticed a label on the box that mentioned a subscription required for the app or online account.  I did not notice this on Amazon and it is buried well within the Hunter site.  It costs $9.99/yr or $50 lifetime after a 3 month trial.<br/><br/>The look of the thermostat and the instilation was both nice and easy.  I was shocked to discover that you can not program the thermostat from the device.  You have to program it from the app or online.  The app is horrible and glitchy.  You can not set the time or date.  It is supposed to auto set for you by zip or postal code, but never worked right and had the wrong day. Tried multiple postal and zip codes.  Setting up the schedule seemed easy at first, but later trying to edit the schedule caused numerous errors requiring me to delete my programs and start over.  The app would also crash often and had long delays and time outs while trying to make changes on it.  I emailed Hunter to see if there are any plans to imporve the app but they never responded.  I refused to pay a single cent more for the subscription on this useless app, and without the subscription the thermostat basically reverts back to a basic thermostat and can not be programmed.  Returned it and decided to put the money and extra $50 for a subscription towards a Nest 1st gen on sale and I'm very pleased.","We have a home that we're fixing up, and so only spend every other weekend there. This review is thus oriented to the needs of someone with a vacation house. From that perspective, this is a really handy product. You can call up the app and see what temperature it is inside the house, and what your heater is doing. There's also an estimate of what the temperature is outside.<br/>PROS: Easy to install. Works. Easy to fire up the Internet connection, and the app.<br/>CONS; The back plate is kinda flimsy, but that's not a big deal. You must might worry a bit you are going to snap the thing.<br/>When you plug the device in, it says 'disconnected.' if you are like me, you try to re-plug it in. Actually, what that means is \"disconnected\" from the Internet. once you fire up the Internet connection, that goes away.<br/>Auto-program: The device comes with a built-in program that will heat your house to at least 60. You need to shut the settings off, a couple of times, from the phone. I was still not sure I had the damn thing off, so I just created a setting at which every time is 50 degrees. I think Hunter would have happier customers if they walked someone through the process of shutting down the auto-programming.<br/>This brings up a final point, which is that the lowest you can set this thermostat via your app is 50. I would save a lot more money if I could set it to 40. But ... hey, the darn thing works. It was a good investment.","Today is October 17, 2013 This thermostat is no longer supported by the company, so you can not get internet access to control it, Which makes it worthless. Nice to look at, and works 3/4 of the way can't set the time or date, but everything else works except the internet function which again makes it worthless.","I have had two of these installed at my vacation home for over two years and have never had a problem with them.  They allowed me to control the heat and A/C remotely with no problems.  Unfortunately, Hunter decided to drop this product line.<br/><br/>The following is the text of an email I received from Hunter Fans today.  At least they are reimbursing me for the two thermostats that I purchased.<br/><br/>************************************************************************************<br/>Dear valued customer:<br/><br/>We regret to inform you the Hunter Fan Company has decided to discontinue our Universal Internet Thermostat Services.<br/><br/>Our records indicate that you purchased X product(s) that qualify for this reimbursement program.<br/><br/>Because we value your loyalty to the Hunter brand, we want to ensure as smooth a transition as possible.  First, Hunter Fan will provide you with full compensation for your unit.  You will also be able to continue controlling your thermostat via the internet until August 1, 2013.  This will allow time to locate another thermostat for your home","The thermostat itself works well.  It is accurate and easy to work when used without programming from the Internet app.  It connects wirelessly to a separate dongle that you plug in to your router using a short length of Ethernet cable.<br/><br/>So let's talk about the Internet app.  It's lousy.  I've complained to the company and they just say we're working on it.  The iPhone app may be better but I don't own an iPhone.<br/><br/>First off you can't tell what time is set on the thermostat unless you look at the thermostat.  If I am programming for the time zone, it would be helpful to know the time of the thermostat when it last checked in.<br/><br/>Second, the time options don't fully work.  If I select CST, it sticks.  If I click the DST checkbox, it won't stay on.  So your thermostat is off by 1 hour.  The setting for local time doesn't work at all.  So the only way to set the thermostat is to set for your local time zone during the winter and a time zone ahead for DST.  You also have to click save several times for it to take the setting.<br/><br/>Third, setting the schedules for when the thermostat heats and cools is not very intuitive.  It is flexible but I don't like the way the programmers set it up.  It could be improved.<br/><br/>Lastly, you have to pay a yearly fee past the first 3 months for service to program your remote.  With the bugs I listed above, this is a bad deal.  You can pay $50 for a lifetime or $10 a year.  My feeling is that Hunter should provide the service for free to all those that currently own the device because we are basically beta-testing their software for them.<br/><br/>There also needs to be apps for Android, Windows Phone, and Blackberry.  The world doesn't revolve around only iPhones.  Mac and Windows 8 apps would be nice too.<br/><br/>The thermostat has potential but Hunter needs a better development and support staff if they want to break into Internet-enabled devices.  Definitely not a Nest but if you can figure out ways around the bugs it does work albeit barely.","Hunter Fan Company has discontinued this product and shut down the network that allows these devices to work. The smartphone apps no longer function and the device is now useless except for very basic thermostat control (no schedule, only manual temp. adjustment at the panel).<br/><br/>Here is the message from Hunter Fan:<br/><br/>istat.hunterfan.com<br/><br/>\"Important Information from Hunter Fan Company<br/><br/>We regret to announce the Hunter Fan Company has decided to discontinue our Universal Internet Thermostat.  This is part of our strategy to focus solely on the ceiling fan business (even though they still sell other thermostats).  We will no longer produce or sell any other type of products.<br/><br/>Because we value our customers' loyalty to the Hunter brand, we want to ensure as smooth a transition as possible.  First, Hunter Fan will provide all Universal Internet Thermostat owners with full compensation for their unit.  Secondly, Hunter Fan will continue to allow thermostat owners to control their thermostat via the internet until August 1, 2013 allowing time to locate another thermostat for their home.<br/><br/>Request Your Refund<br/><br/>Click on the \"Submit Your Claim\" button above to enter basic information so a Visa prepaid card can be mailed to your attention.  Once you submit the information, you should expect the Visa prepaid card within 21 days.  The amount to be refunded will include the cost of the thermostat and all applicable sales tax.  Please note: Do not return your thermostat unit(s) to the retailer. Retailers were instructed that all returns must be processed by Hunter Fan.<br/><br/>The information required to process your refund includes your name, address, serial number(s) of your thermostat(s), and the email address used to register your thermostat(s) online. The serial number for your thermostat is located on the circuit board on the back of thermostat and starts with the letters HFTS.<br/><br/>Please request your refund very soon.  Your internet thermostat will continue to work only for a limited period of time.<br/><br/>We apologize for this inconvenience and we appreciate your loyalty to the Hunter brand.\"","I already had a programmable thermostat...actually two since I have an upstairs and a downstairs unit.  After reading various reviews about internet-aware thermostats, I settled on this one due to the vary large display and that IT COULD NOT be programmed from the unit.  I have had problems in the past with my programmable thermostats being \"re-programmed\" by other fingers in the house much to my dismay.  All the other people in the house need to know to use it is to use the large bar below the display to temporarily override the program when they wanted a little extra heat or cool.<br/><br/>I also liked the price-point.  MSRP is $99 but Amazon sells it for about $75.  There is an additional cost of $50/lifetime or $10/year for the internet access, so in fact a single thermostat cost me $125, which is still in the price range of a good programmable thermostat.  Since I have upstairs and downstairs units, the second thermostat will cost me another $75 but I don't have to pay another $50/lifetime for the internet access.  The $50/lifetime covers multiple places and multiple devices per place.  Therefore, the total for replacing both of my units will be about $200.<br/><br/>Installation was easy.  As long as you make sure you use the included stickers to label all the wires that are connected to the old thermostat, it is very easy to reconnect it to the new thermostat.  I would also recommend taking a photo (you can use your phone) of the old thermostat still attached to the wiring, just in case a sticky label falls off while you are installing the new thermostat.  I liked the level that is built-in to the back plate.  It made it easy to avoid my wife telling me that it wasn't level, when I could show her it was.  Also take a photo of the serial number of the unit.  You will need it later when you setup the app on your phone or on the website.<br/><br/>With the wall unit all installed, I plugged in the gateway (a send/receive unit) to my router and then to power.  It does not use your home's WiFi so you don't need to know the SSID/Password of your home WiFi, you just plug in the Ethernet cable and power.  It took a few minutes to show a green light on the gateway and then for the wall unit to show \"connected\".  Once that happened, I downloaded the iPhone app, added a place (My Home), and then a device, using the serial number that I had taken a photo of during installation.  It took a few minutes for the app and the device to sync up and then all was working.<br/><br/>By default, the unit uses an Energy-Star schedule.  This didn't work for me because it assumes that no one is home during the day because the heat/cool range is like 65/85 degrees.  I live in Texas and if it gets 85 in the house, that is a problem.  My wife is hot, but she doesn't like to be hot!  :-)  I setup another schedule (it was very easy) and then added that schedule to each of the days.  You only need to define a few schedules (mostly week days and Saturday/Sunday for me) and then associate them with the desired day of the week.<br/><br/>It was also nice to be able to set an Away mode which expands the heat/cool range for when you are going to be away long term.  This is handy when you go on vacation, even for the weekend.  This allows you, with the press of a button, to quickly set the away range (saving money) and then set it back to the desired schedule maybe the morning that you are returning to the house.<br/><br/>Another handy item is that when I am in bed and my wife wants it to be a little warmer or a little cooler, I can do this without getting out of bed...very handy.<br/><br/>All that is left now is to buy my second unit and replace the downstairs unit.  I am very pleased.","So this was about 98 bucks at Walmart. It actually worked ok. The Universal interface was ok. The Problem is they REQUIRED you to through their servers to control it. FAIL. They obviously did not take into the account of a massive undertaking to support the infrastructure. This caused an average of about 5 to 10 minute latency for adjustments. Had they simply NOT tried to sale a service and sold the unit as home wifi accessible it would have been ok. Personally I did a packet capture and caught the encrypted string for the pass back to the unit so I could just keep using it if I wanted to code something up, but for that effort I already An Arduinio board, LCD Display, Wifi shield and thermometer that I can rig up for no cost to me. I plan to sell the house so I will likely just toss this thing and put in a cheap LCD unit. Having control over your HAVAC from the web is a great concept but be aware of what your getting into. Avoid units that require a monthly service. The neat little round one that you see with so many stars is VERY over priced and full of hype. It cost them about 40 cents on the dollar to build it. Avoid.......  Go with a reputable brand or build something your self. It really is not rocket science. I will add that Hunter is doing a FULL reimbursement program ( the right thing) and I have talked to them about the API on several occasions. They were responsive and never argued about the issues. Hunter is not a terrible company this was just a bad implementation of a good idea."],"images":{"small":"http://ecx.images-amazon.com/images/I/41R4jGhXZJL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41R4jGhXZJL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41R4jGhXZJL.jpg"}},{"name":"Jeep Baby View Mirror","asin":"B003JBHLGI","price":"$5.99$12.98$6.95$58.87$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["I was trying to find a mirror that would stay suctioned to my back window in the heat (I had a really good one with my first child but I threw it away). All the ones I have tried including this one fall off. Also this one moves position when you hit a bump. I would leave my house being able to see  my child and by the time I got to the store about 5 min from my house I was looking at his feet!! Do not recommend at all!!","Buyer beware, when I took my car to state police to have car seat inspected they said no mirrors. If in a crash the mirror would weigh many times its weight and hit your baby in face. However I let my eight month old play in house with it. I just cut off the straps and he loves looking at himself and kissing the mirror and since its safe and not glass I love it for this use. I recommend it to buy for this source of entertainment","This has to be THE cheapest product I've ever seen. The suction cup sticks to NOTHING. And the only view you are going to get is anything on the floor because the way it tilts is so loose....that's the only direction it faces. It also comes with a \"clip\"... except it too is cheaply made so the second you work the handle to open it, it promptly broke with one piece flying off into oblivion. Save your money and do NOT buy this item. I ended up throwing it out.","This mirror is hard to see with. It's not easily adjusted either. Going down the road the mirror vibrates and bounces so I can never see clearly what is going on in the backseat.  Needs to be locked down better to work well","Does not stay attached, mirror is like a kids play house sticker mirror, very foggy.<br/>We could not get it angled to see our baby.","My boyfriend went to install this in his car and first it wouldn't stick to the back window at all and when he finally did get it to stick the mirror wouldn't stay in the correct position. While he was fiddling with it to make it stay it fell off the window again. It doesn't stay and my biggest worry would be it falling on my son while driving.","This is possibly the cheapest, most terribly made plastic junk I have ever seen. You literally cannot see anything but a distorted blur in the mirror, which isn't even a mirrior but a reflective film placed over the plastic. You will seriously be wasting your money buying this product and the manufacturers should be embarrassed to make something so useless.","can't see anything in it, the mirror is too small! plus I have an SUV and there is no option of fastening it to the back of the seat instead of the window. I ended up buying a much bigger one in another brand.","This mirror was cheap, reflection was horrid and it didn't stay attached.  I returned to Walmart within 2 days.  I wanted the First Years Mirror that attaches to the rearview mirror, was inexpensive and works. But no one seems to sell it anymore.","The order itself went off without a hitch - shipping, price, etc. However, the mirror did seem like cheap quality (I know it was cheap in price, so I guess I should have known). It did not seem to want to stick to the rear window for very long and kept falling. Window was clean and should have held it well. I tried it for only a week before giving up. Not saying it won't work for anyone else, but I was quite disappointed........."],"images":{"small":"http://ecx.images-amazon.com/images/I/41gpVrJ-MoL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41gpVrJ-MoL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41gpVrJ-MoL.jpg"}},{"name":"Igloo FR465 4.6-Cu-Ft Refrigerator, Stainless Steel Door","asin":"B000EPN8ZK","price":"","stars":"2.1","reviews":["I purchased an Igloo refrigerator and within a few weeks it completely stopped working. Curtis International (Igloo's parent company) has terrible customer service and will not honor customer warranties. After a year of trying to ge this resolved, I have found out that they have an unsatisfactory record with the Better Business Bureau and have many of these types of complaints. STAY AWAY FROM IGLOO PRODUCTS!!!","Do not buy this item. Igloo refrigerators are made by curtis intl. No one, NO ONE makes parts for it. And they break fast. Mine is about 1 year old. A $12 part broke. I have to throw it out because I can't get the part. Call curtis and you'll speak with someone in Bangladesh who will make you repeat your name 40 times, repeat your phone number another 30 times and then tell you \"we don't have that part, no, no one makes that part, no we can't tell you what to do.\"","I did not read the reviews before purchasing, and I paid the price. My refrigerator was dead-on-arrival (DOA). I had to send it back. Shame on me for not reading the reviews ahead of time.<br/><br/>I echo the statements of others. DO NOT BUY THIS PRODUCT!","I agree with the others who had trouble with the Igloo fridge.  I tried to order an $8 part from Curtis International and got nowhere!  What a big waste of money!  Highly recommend you shop for another brand.  No one sells parts for this fridge, including the company who makes it.","Completely nice looking shelf with a door on it - that's what I have left. Worked fine for a few weeks... then stopped completely. No warranty support - I'd have to pay to ship it back and forth to have someone examine it to see if they could fix.<br/>Never will purchase another Igloo product. I have a completely useless refrigerator in my office now - a stainless steel cabinet with a door on it.","after reading other reviews, I was hessitant to buy this.  Sure glad I did.  It works great, is fairly quiet, and meets all expectations for a frig.  It maintains the refrigerator compartment at 33 degrees while being set just below the middle of the thermostat.<br/><br/>My only complaint are 2 very small dents in the stainless door.  This cosmetic flaw was too small to complain about, but did not happen in shipping - the frig was packed with the small dents.<br/>Even so, it is still pleasant looking.<br/><br/>Overall, very good product.  What a great surprise!<br/><br/>UPDATE JULY 2011 - constant use for 2 1/2 years.  works great.  no problems.  Just be sure you read the manual and follow instructions about leaving enough air space around the coils to provide adequate ventillation.<br/>I know anyone with a frig this good will be pleased.","Refrigerator arrived missing a foot from Amazon.  Called Igloo direct to receive front right foot and waited 3 weeks for the part to arrive.  Then they sent the wrong part.  So still no working refrigerator.  Very disappointed.  Not an easy item to return since box had to be ripped to get the refrigerator out.<br/><br/>Bad marks for Igloo And Amazon!","It stopped working after 3 months.  We called and they told us to turn the knob from high to low 5 times unplug for 2 hours then plug back in and turn on.  That actually worked.  BUT  it stopped working again after another month.  I called and told them and asked where to take it to get repaired.  They said we had to ship it to Michigan for repairs, pay shipping send them check for $10 to pay for insurance to ship it back after repairs.  I told them I could not ship it back, I do not have box and she said that was my problem.  I said what company and she replied any company feded, ups, or contact a shipper.  I told her it was not worth it.  I told her I was going to post this and that I would take it to the  dump.  I will never buy this brand again.<br/><br/>I see alot of people have had the same problem with it breaking in the first few months.  I wished we had checked this out before buying it.","This is a beautiful mini fridge and it holds a lot. Two cases of water and a case of 12 pak soda. Light in fridge. Really works well the only issue is the humming. Not as quiet as stated but after awhile you get use to it.","What can I say, it's a refrigerator! It works as described, finish is<br/>fine  it gets cold. No complaints"],"images":{"small":"http://ecx.images-amazon.com/images/I/31kp-ZYZwdL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31kp-ZYZwdL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31kp-ZYZwdL.jpg"}},{"name":"ALEX Toys Rub a Dub Score & Learn","asin":"B0035A1RPE","price":"$25.60$5.99$12.98$6.95$58.87$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["I guess I didn't see the reviews when I bought this for my son.  It was so cute when we opened it and used it for the first time.  Unfortunately, that was the only time as it stopped working after that.  It is stuck on \"0\", and doesn't do anything.  I would just use the basketball net but that isn't even sticking.  Oh well - waste of money.","This toy sucks!!! It barely worked before we put it in the bathtub where it is meant to be then after that it will not work at all!!! DO NOT BUY THIS!!! It stops working at the slightest bit of moisture.","This toy has a great concept but it's execution is horrible. Bath time is one of the only times I can get my 2 year old son to be still. I typically read bath books and indulge in teaching colors and numbers by using fish. We were excited upon this toys arrival because it recites the alphabet and numbers. My first impression was that this toy was extremely flimsy. It reminds me of a toy that is outsourced in China and sold at a U.S. Dollar Store. I placed the toy on the bathroom wall and to no avail It didn't work. The suction to the bathroom wall was solid, but that's it. I am awaiting a refund on this product.","It works fine, just only in low light. It uses a laser sensor that only picks up the ball going through the hoop in low light (or even the dark, but the kids don't like that). So if we dim the lights in the bathroom it works great and the kids love it.<br/><br/>Kinda lame that we have to dim the lights though, and that they didn't mention this on the box.","We use this just as a basic basketball goal for the tub (also works well on our sliding glass doors in the living room) without the scoreboard function because the light and sounds only work in a dimly lit room. My son is 14 mos. old and loves it, regardless.","This toy lasted about 2 weeks. Now the counting and alphabet don't often work.  I too changed the batteries thinking this was the problem (expensive)... to no avail.<br/><br/>Bummer, this toy has awesome potential. My son loves it when it works.","I bought this in a store and didn't read any reviews first. The suction cups would not stay stuck, and the toy kept falling into the tub. After 2 bathtimes, it stopped working. I decided to replace the batteries thinking that the ones that came with the toy must have run out. It takes 3 watch batteries, which are very expensive. The toy worked again for half a bath, and then stopped working again for good.<br/><br/>This toy is a total waste, which is too bad because my son really enjoyed it for the short time it lasted.","My 1 and a half year old loves basketball and so he was so excited about this toy.  He loves the balls and the basket but the light and sensor do not work and he tells me everyday how it is broken.  I tried switching the batteries and that didn't work.  Then I called Alex Toy company and they were very nice... they sent me another one... it didn't work either!  I called the company back and asked them what the deal is!  They said the sensor only works in super low light (not likely to be that way in a bathroom)... they were very nice and told me to pick a toy of equal value and they would send that to me instead.  She did say that they are working on fixing the sensor (it's May 2012 today).. If you buy this in the future I would at least call first and make sure they have fixed the problem.  A ball and basekt can be bought at wal-mart for 2 dollars instead of twenty something!  It would be super cute if it would work!  I was very impressed with how the company took care of me though!","Sticks really well to tile walls, but the sounds are finicky---sometimes the counting and alphabet works and sometimes it does not.  The balls included are the squirting kind, so you need to make sure to squeeze them out so they don't get mildewy on the inside.","I ordered this toy twice for my son and both times it stopped working after the first day.  The first night we got it and tried it out in the bathtub it would not count or do anything else and the next day it stopped working completely! I sent it back for a replacement and it did the same thing! I am going to send the second one back for a full refund!"],"images":{"small":"http://ecx.images-amazon.com/images/I/51UOsneThQL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51UOsneThQL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51UOsneThQL.jpg"}},{"name":"Capresso CoffeeTEAM Pro Coffee Maker with Glass Carafe","asin":"B00N2XQ8Q2","price":"","stars":"2.1","reviews":["I had the Capresso 464 and really liked it until the heating element went out.  It would grind but not heat the water to brew, so I contacted the company.  I found the customer service to be excellent.  They offered to repair mine for $75 including postage both ways.  Not bad since there are no small appliance repair places anymore.  But for a bit extra, I could get a new machine, either like the one I had or for a bit more, an upgrade to the fancier version.  I opted for the fancier version, the 477.  I am no going to return the third one of those.  The grinder is just plain awful.  Even with careful cleaning, it just won't work.  I'm replacing it with the 464.<br/>Negatives:  The 477 is not worth the money at any price.<br/>Positives:  Customer service has been terrific.<br/>  The 464 is a really good coffee maker.<br/>Don't overshoot the market.  Go for the cheaper and more reliable 464.<br/>Katherine Sharp","Same as the other comments: it does not grind enough beans. I have cleaned the upper conical burr. I have put in 8 cups and told it to grind 12 and still the same result. Every 1 in 5 pots is good. That's wasting a lot of coffee. Morning coffee is sacred in our home and this product fails. So sad because it's such a good looking machine and such a good idea. I just wish their product development team would have tested it more before bringing it to market and charging us a pretty penny for a machine that performs 20% of the time. BTW - the first machine of theirs that I got did not work. And I had a heck of a time trying to get their customer service team on the phone to help me (I live on the West Coast). After 2 weeks, I got a machine that actually worked (above), but only 20% of the time. The more I think about it, they should do a recall and replace our machines with ones that work. Like that's going to happen! That would be the actions of a responsible company who is looking at protecting their brand name and image. Based on the shoddy customer service and machine that doesn't work very well, I am not going to hold my breath. Unless I have something better to report in the future, save your money and purchase a different brand. Can you tell I am writing this as I stare at another poorly brewed pot? So disappointed.","I for one have really enjoyed using my Coffee Team Pro, and am surprised by some of these reviews.  I love the fact that it grinds my beans fresh, right before brewing, and when I did have an issue with clogging, I called their customer service department, and they solved the issue right over the phone for me.  I have owned a few different Grind and Brew machines over the years, including the Brevile YouBrew and an older Cuisinart model, and every single one of them have had clogging issues.  The difference I find with the Capresso, is that I have total access to all the areas that get clogged!  When I spoke with customer service, they showed me how to use the brush to clean the little chute on the inside of the machine behind the swing out filter basket.  The Rep I spoke with was very helpful, and she advised me to simply use the brush to clean out the chute once or twice a week, even if the grinder seems to be running fine.  Since I started doing this, I have not been clogged once and I have been running the pot every day for well over a month.  The Customer service rep also pointed out a special function that was hidden in the instruction manual that helps keep the grinder clear by pushing and holding the Auto button and the ground coffee button at the same time.  I am not sure exactly how this helps, but it seems to run the grinder while cutting off the beans. The rep told me that this will clear out the little bits of grounds that could lead to a clog, but since I started brushing out the chute more frequently, I haven't noticed much build up anyway.<br/><br/>The pot also has a removable water tank and bean container which makes things easier, and to me the coffee is plenty hot.  I will take off a star because I was charged by Capresso for shipping, but I can't seem to find this unit directly from Amazon, and I really wanted to try it. (Capresso even sent me a free bag of coffee when I called with my questions, so who am I to complain!) While there is a little bit of maintenance required, I love the way my coffee tastes from this machine!","I have to admit.<br/><br/>I have had the first Capresso, and it still brews fine.  The only reason I was looking to upgrade is because frankly the digital display is going out on it.  I've had it going on 5 years now, and it's been absolutely perfect in every way.  Yes, the grind is loud, yes, the swivel arm is a bit silly, but it brews hot, flavorful, and wonderfully.<br/><br/>So I figured, hey, let's stick with Capresso.  I noticed the reviews were mixed, and thought maybe it was just some one offs.<br/><br/>First, my background.<br/><br/>I've been making coffee, from several machines, throughout my life.  Nearly 40 years of coffee making, using siphon, various drips, cold brew, slow drip brew, dozens of espresso machines, manual, semi-automatic, and automatic.  French press, turkish, you name it, I've tried it.  I even roast my own coffee, so to say I have some idea of what makes a good pot of coffee is acceptable.<br/><br/>With that in mind.<br/><br/>This machine is an absolute piece of filth.<br/><br/>I put in some Sumatra coffee.  City+ roast, no added oils, something to bring out the woodsy and blueberry tones when I roasted it.<br/><br/>the grinder choked.  I wanted a strong pot.  I set it for course grind.  I set it for 12 cups.  I hit grind.  It started to smell like the grinder was overheating.  It would stop, grind, stop, grind, then speed up and slow down.  Keep in mind.  This was my VERY FIRST GRIND on this machine.  On course.  On a city+ (medium light) roast.<br/><br/>So fine... after a ton of stop and go, and tinkering, it got me enough coffee in the basket for a pot of coffee.  Bully for it.<br/><br/>Ok... waiting... waiting.... beeps twice... stops... no water.<br/><br/>It didn't brew.  At all.<br/><br/>I tried it with grinding (obviously), specifying my own grinds, took the basket out and put it back in empty, insured the water basket was securely down (it lit up like it should).<br/><br/>No brew.<br/><br/>This is absolutely unforgivable.  I have been an absolutely diehard fan of Capresso, their name went with excellence.  Good quality, excellent brew, excellent  coffee.<br/><br/>Frankly, I'll never look at them again.<br/><br/>The worse part of it?<br/><br/>I emailed customer service and technical support PRIOR TO PURCHASING THIS UNIT to verify if the grinder had issues or this model had mechanical issues.  They confirmed it did not, and that the machine, taken proper care of, would provide coffee as documented.<br/><br/>So not only is the machine a piece of filth, but the company are a pack of liars.<br/><br/>It's time to let this company crash and burn.  If this is how they treat long-term customers, and this is how their equipment runs, go somewhere else.<br/><br/>Absolutely horrible.  I'd not suggest this unit on an enemy.<br/><br/>Maybe I'll look at a Saeco.","Over engineered P.O.S. Had for 8 months, and something is always wrong with it. When it works it makes great coffee, but the best thing it makes is coffcrete.  You have to constantly keep cleaning the drop chute from the grinder to the basket and even then there is a 50/50 chance you will make coffcrete in the chute. When that happens Get the vacuum cleaner, cleaning brush and a small screw driver to clean it out. I've gotten so good at it that it only takes me 15 minutes now. I could go on and on but be for warned. DO NOT BUY!!!","Would have been a 5 star review, if the burr grinder didn't go out on it after the first week.  I basically got 4 glorious GLORIOUS 12 cup pots, and then WHAM grinder took a crap on me.<br/><br/>While it worked though, excellent consistent grind, easy to tailor the extraction.  No muss no fuss...","I don't understand the way products are made anymore. With the amount of money they charge - its not too much to ask that it works. It is so disappointing the lack of pride in manufacturing and selling a good product.  Did not even make one pot of coffee. Grinder failed out of the box.","this coffeemaker is by far the worst item I ever purchased. To grind 4 measuring spoons of beans for 6 cups of coffee you have to run the grinder<br/>at least 3 times to get all the beans out of the hopper . the setting for the grind is on coarse.the beans I am using are medium brown none oily next<br/>I check how much coffee is in the filter basket.so I clean out the chute and add the grounds to the filter a half hour later I have 6 cups of coffee.this morning I used French roast setting is on coarse and oily bean started the grinder and it completely plugged up.in the quick reference guide it said to let the beans dry out over night. are you kidding  me. perhaps I should call the coffee comp. to make sure that every bean has ben wiped down.so the machine is going back to  Capresso for Service the dealer left me hanging here because I did not return the product within 30 days.by the way I had a capresso for 16 years without any problems but it finally gave out","Capresso really?  What did you do.  Awaiting the new, updated one  I have 5 Capresso machines.  I returned due to reviews that the Burr grinder had to be cleaned each time machine used.  Even though Capresso states one can use oily beans, you can't.  Look at the online videos from coffee pros.","Purchased this machine and it didn't make me one good pot of coffee either. The concept is great. I was excited to wake up to a fresh pot grind and brew coffee that I set up the night before. This was not the case and came downstairs to Water as the machine didn't grind enough beans. I tried three or four other times with the same response and then I returned it. Still in search for the fastest best cup of morning coffee and this isn't it."],"images":{"small":"http://ecx.images-amazon.com/images/I/31lNZxheHyL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31lNZxheHyL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31lNZxheHyL.jpg"}},{"name":"Safety 1st Cover Clamp Toilet Lock","asin":"B000058DIF","price":"$12.47$25.60$5.99$12.98$6.95$58.87$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["This product's design relies entirely on a piece of double-sided adhesive to attach the latch hook to the toilet bowl rim.  The adhesive simply isn't strong enough to do the job.  It *is* difficult to open the toilet lid by opening the latch (as it should be:  that's the whole idea), but this merely encourages the user to easily rip the entire latch and hook off the toilet rim.  Once the adhesive has been ripped off the rim, the adhesive has lost much of its sticking power: you've got yourself a piece of plastic junk.","I need to start this by saying that my son is Houdini.  He has NOT figured this out yet.  But it broke when he was trying.  So take that however you want.  The four-year-old (who is NOT a Houdini) could do this in her sleep.  So at some point we will need to find another latch as I figure our time with this one is limited.  Also, there is a strange issue: if your child scoots the part-attached-to-the-bowl all the way towards the back of the toilet bowl, its possible to mostly open the toilet.  This may or may not be a problem, depending on how wild your child is.  My son has enjoyed the chance to throw all manner of toys in through this big crack... but as long as he can't actually get his own head into the toilet, I'm not too worried (yep, my standards are that low.  Its what having a 2 year old boy has done to me!)<br/><br/>In sum, this is not the best latch out there.  Given a choice, I would not choose it again.  But we have a spare on in our garage, so I'm going to give it another go just until this spare breaks... but then its on to better things.  We have used and like the latch that's a rotating arm which twists to the side.  It eventually broke, too, but it took longer to break and there's no way my 4  year old could have figured it out (we had to give her a special, private lesson).","I was really unhappy with this lock.  It not only kept the one year old from opening the lid but kept everyone else in the house from opening it as well.","Complete garbage. Clunky, difficult catch that adults won't be able to figure out. The locking mechanism is stronger than the adhesive which obviously just leads to it being torn off. If you have a 100% perfectly square toilet, and a lid that is completely flat on both sides with no rim then you may at least be able to get this to work, but you'll still struggle with the 8 hands required to open the catch. I don't understand why they made this so complicated. And if you're going to make something with a really difficult catch, you have to use good materials (hint: they didn't). A precision engineered catch with a smooth mechanism, maybe, but this is just cheap plastic that is too snug and risks breaking when you try to use the bathroom. Plus with the arm coming up, it just grosses me out, you can accidentally brush against it when getting TP. Eww.","Wow, this item is really a waste of time and money. The adhesive worked for about 30 seconds and then it became a doorstopper. it went from the box to the toilet to the trash in about 15 min. you do not need more time than that to realize what a piece of garbage this thing is.It is meant for people who have square toilet bowl lids and then it stayed on one time while I close the lid then the adhesive would refuse to stay on secured. seriously some other review suggested duct tape that would be probably work better. The good news is that whatever other lock you buy it cannot possibly be worse than this one. Headed out to the store to buy a new one right now. Oh and my did come with instructions which make an what should be an easy process sound like you are doing major work with 8 small paragraphs and 12 illustrations which ended up alonside their friend in the trash. Zero stars. 00000.","Can I just say ditto to the other reviews.  Whole thing depending on a small strip of adhesive tape that will only work if your toilette happens to have flat sides on the outer rim.  I can't believe they released this product.  Mine did have instructions.  Too bad the product is a piece of junk.  Stay away.","Did not fit well on our toilet seat. I contacted the manufacturer and they were not very friendly about my comments and refused to refund my money. They did give me and Amazon credit, but I was less than satisfied.","My local hardware store didn't have any toilet tot locks,  the chain store only had this brand, one kind, no choices.  The first one broke after 1 month of NORMAL use.  The second broke after one month of NORMAL use.  I would happily pay thirty bucks for one that would last more than a month  that I could give to someone else once my toddler is old enough to not try flushing toys down the toilet, but cheap sells.  :-\\  I refuse to pay for a THIRD one of these so I just hope we're not snaking toys out of the toilet at all.  (I would put a door knob lock on the doors, but we have door knob covers from the same brand on our door knobs  those suck too!!  If my toddler hits them hard  long enough, they just FALL OFF!!)","This was the only toliet lock that has worked for us (we've tried four...) It certainly is not easy to use, but it does accomplish it's primary objective - keeping the baby safe.<br/><br/>Two warnings: if you are lazy, you might get complacent and not use it because of the difficulty - not wanting to undo it each time. Same thing if you have a tiny bladder - don't wait till the last minute to pee!!!","I bought two of these locks, one for each of our toilets. The first one had inadequate adhesive, as several others have remarked in their reviews, and would never adhere to the toilet. The other one worked for about 2 weeks before one of the little knobs you have to press down to open the lock broke off. A week later, the second one broke off, basically locking us out of our toilet. My husband had to break it off with a hammer so that we could use the toilet. Terrible product."],"images":{"small":"http://ecx.images-amazon.com/images/I/31L06aDUA8L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31L06aDUA8L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31L06aDUA8L.jpg"}},{"name":"Ecoolbuy Colorful Bathroom LED Light Toys Kids Funny Bathing Toys Waterproof in Tub","asin":"B017CLKMRA","price":"$3.99$25.40$9.90$5.99$4.99","stars":"1.5","reviews":["Very poorly constructed. Shipping took six weeks. The screws wouldn't come out. After three separate attempts, we got the screws out, only to put in batteries and it won't light up. It deserves 0 stars. Amazon, you really need to allow for that. With supporting evidence, some crap deserves no stars. This is one of those purchases.","This is definitely not something I would buy again.  It is cheaply made, arrived with one of the plastic screw tubes was broken and would certainly not be water tight.  The \"water tight seal\" that is indicated in the instructions is nothing but a plastic ring that flops around the inside of the unit.  I can't think it would be something that would be that interesting to my toddler.  I didn't bother to send it back because the price wasn't worth the trouble.","Junk. Ordered 3 of these. Striped the screws on all 3. The battery compartment fills with water. Not safe.","I'm not happy.  It took about 6 weeks to get here when they originally said 2 weeks.  It finally came and does not work at all.  No instructions of any kind were included.  Do not waste your money.","Unit does not work. Switch is defective.","Very cheaply made and too afraid to put it in the tub.  Took over a month to be delivered and if my son hadn't seen it when I opened the package (which was just thrown in a manila envelope with little care) I would have returned it.  Not worth your money!","I ordered this for my grandson before Christmas. It arrived at the end of January. Was suppose to be waterproof. It worked for 3 baths, and then quit working because water had leaked into the battery compartment. I was not happy with this product.","What a waste! Waited a really long time for this to come on the slow boat from China and it didn't work right out of the bag, and even if it had worked it probably would have quickly failed because of two hairline cracks in the housing. Water will always find a weak spot. Not worth the trouble to try and get my $7 bucks back. Should have bought my granddaughter a lottery ticket instead!","Got this today - shipping wasn't an issue for us since we knew it was coming from China and that it would take longer. The kids love it (1 year and 5 years). They wanted the lights off while in the bathtub and lots of fun with it. Great toy!<br/><br/>Update - It lasted one bath and started to fog up now the battery/lights are all wet.","This toy came and after we got the screws out and placed the batteries it didn't work.Heart broken lost my paper work to send it back.no star but it wouldn't let me post without marking one"],"images":{"small":"http://ecx.images-amazon.com/images/I/51ZqhFuFeEL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51ZqhFuFeEL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51ZqhFuFeEL.jpg"}},{"name":"Bell COCOON 500 Deluxe Child Carrier","asin":"B00EQUVIYC","price":"$12.47$25.60$5.99$12.98$6.95$58.87$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["This seat is truly the worst consumer product I have ever put together. I am a 36 year old father who has lived in three different countries around the world and bought build it yourself furniture or some type of equipment in all of them. I haven't actually walked around my house to count, but more than half of our furniture is IKEA or some other comes in a box with a dizzying array of screws and proprietary attachment systems. I have burned through two Dremel Tools building random stuff and taught myself to weld. All of this learned knowledge was practically useless on this seat as it defies all logic. The engineer who came up with the plastic POS needs to be fired, rehired to address all the problems at a lower salary and then fired again on principle when he fails. The cost saving measures taken to ensure some profit margin was hit are astounding. The plastic is softer than my kids Play Do and the color is truly blah inspiring. The bolts rip right through them and I had to cut notches in the top with the aforementioned Dremel to keep them from spinning to tighten the lock nuts down. The screws attaching the two halves of the chair barely made contact and more than on it hanging on by two or three threads, much like myself after building this thing. I had to modify the down tube to fit my wife's bike, and to add insult to injury, the retention system is some kind of nylon stitched bulge that slips through a plastic slit. The crotch one broke when I pushed it through. This seat makes me truly sorry I didn't keep the receipt as I bought if from a store instead of Amazon. Next time, I will know better. Thanks Bell for ruining your reputation and my evening.","I purchased this seat for my 2y/o daughter to ride with, so needless to say I was concerned about the other reviewers comments on this seat. However, I was able to install it successfully and felt no concern for my or my daughters safety while riding. It is a sturdy product if installed correctly--and that's the part where I place my critique...<br/><br/>The instructions call for an adjustable wrench and a screw driver. Let me tell you, I used ratcheting wrenches, deep-well sockets, flexible bit extension, 1/4\" and 1/2\" ratchets, and I'm about to use a angle grinder with a cutting wheel to cut down a \"too-long\" bolt. More about that one later.<br/><br/>I understand that this is a universal (and relatively inexpensive) product which has to adapt to many different styles of bicycles while still remaining functional. Remarkably, I was able to install it onto my front fork suspension mountain bike successfully. Here are some of the issues I ran into: First, the instructions are HORRIBLE. The description is rather vague, but at least they could show a picture of the item installed correctly. Rather, they give you just the bare minimum to install the seat correctly. You really need to have your spatial analytic skills down to figure out the correct orientation for each mounting point. Second, if you have a rear derailleur, it will be tricky to mount the rear support tube if any wires run down near any of the mount points suggested in the install. Third, don't tighten down any bolts until you have most of the seat installed since you will be adjusting them constantly. Fourth, once you install the seat, take it for a test run because you'll see that you'll need to adjust it once again depending on your riding style. Fifth, the plastic doesn't like it too much if tighten any screws or bolts against it (as other commenters have noted). Lastly, perhaps its just me and my big fat leg, but there is one bolt near the seat post which despite any amount of adjustment, rubs the inside of my leg as I pedal. I'll be taking the angle grinder to that bolt and cutting off the excess.<br/><br/>BUT... like I said, AFTER it's installed, I felt safe and comfortable riding with my child int it.","So I wish I had seen all these reviews on Amazon before I purchased.  Unfortunately I wanted right away so went off of 3 reviews on ToysRUs and picked it up (normally I would still check Amazon reviews but was just a little hasty on this one).  If you can get this on, it is a decent product for the price.  Is the effort required to get it on worth it compared to spending another $50-100...probably not.  That said, I was able to get this installed.  It just took me about 3 hours, bloodied up both hands, and about 4-5 more tools than they mention.  The people that pointed out that the assembly relies on square nuts/bolts being held by plastic and they give way is spot on.  Here's my recommendation to avoid it.  Use a wrench and pliers or two pliers to put each nut onto the bolts before you actually assembly them.  The nuts have plastic on the inside of a couple of the threads which make them extremely hard to turn.  This force causes the plastic holding the other component to give way and if this happens now you are in a really bad situation.  This happened to me once, but I was able to power through it holding the bolt with a needle nose while turning the other side.  This is where I bloodied my hands and swore a lot (probably ~1 hour fighting this one bolt).  But if you put them on first it seems to reduce the tension a little where you don't strip the plastic.  You'll see how difficult it is to put the bolt on the nut when there is nothing in-between as well.  Still not a super fun product to install beyond that but I'm guessing no child bike seats are complete walks in the park.  Now that's it's on, it fine.  I don't really have any issues with the product.  But I wouldn't purchase this if I went back and did it over again.  They could make it a ton easier by improving the hardware for assembly.  Just give the bolts something to hold on each side.  I attached a picture of one of the bolts that stripped on me.  You can see I had to completely destroy it to try and get a needle nose pliers around this end of the bolt so I can actually turn the nut on the other side.  This was a pliers in each hand and all the force I had reaching around a big bulky plastic car seat.  I consider myself both handy and strong.  If you are not handy, I would avoid this product like the plague.","I've had this seat for 2 years and my 3 year old still loves bike rides. I'm not going to lie, I actually attached it to a mountain bike with rear suspension lol. I use the trailer for my schwinn hybrid. I installed this product myself without any issues. I have taken it off and put it on my husbands mountain bike with rear suspension, put it back on mine, removed the seat leaving the bracket...etc... On my own.  It isn't that difficult to install.  My only complaints are, I wish it went up to at least 50lbs and that he wasn't so close to my butt lol. I feel like I have my butt in his face. Other than that, it's a good seat.","I wish I had checked Amazon before purchasing at the store. Like others, I must insist that you do not purchase this child seat. Even if by some miracle I managed to put this thing together, I would never place my son in it.  Approximately one minute into the build I could go no further. The bolts they include do not have slots for a screwdriver, instead they have square heads that are supposed to rest in the cheapest and flimsiest plastic on the planet. I stripped the plastic while trying to tighten the nuts with my fingers. Simply, this is the worst design ever. I can't imagine that anyone could assemble this seat. I am a DIY person, have worked construction in the past, and had a job as a huffy bike assembler at Targets and Walmarts the year after graduating college. This is absolute garbage, and I will stay away from any Bell products in the future thanks to this eye-opening experience.","HORRIFIC!  I haven't even finished putting the seat together, and I am already writing this review.  This is the worst assembly experience ever. You thought a three hour experience with IKEA furniture was a test.  This is three times worse than anything.  EVER.  Metal bolts strip right through the plastic and make installation nearly impossible.  I have loads of tool-savvy general contractors in my family, and we are astounded by this installation process.  I am very disappointed Bell even brought this product to market.  I will avoid Bell products after this experience.  Period.  The end.","The hardware that connects to the seat post is a poor design. It is too bulky. I do not have a heavier frame but it constantly rubs against my legs. There is no easy way to fix this. I dont mind the instructions as much but the design is poor. Also the bolts that they give you to secure to the seat post may be too short. I had to bend some of my brackets to get it to fit. I will be returning tomorrow.","Bolts are suppose to be held by a square that is cut in the plastic so that you can tighten the nuts down. The plastic gives way and the bolts spin when you try and tighten the nuts. Poorly thought out installation and hardware. Will be returning right away.","Was really a pain to assemble, two of the screws had to be done at a slight angle which I luckily had a flexible tip socket. But once it was together it was very sturdy and our sone absolutely loves it. Photo us before we took him out so the front rail is off and straps are loose.","Please take the reviews seriously, especially the ones with one star.  This is not a well built seat, metal on plastic, not a good combo.  I tried putting this seat together and readjusting and it is impossible due to bolt spinning and stripping out the plastic.  STAY AWAY from this so called Child Seat."],"images":{"small":"http://ecx.images-amazon.com/images/I/41rSgBYupLL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41rSgBYupLL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41rSgBYupLL.jpg"}},{"name":"green sprouts 12-24 Months Best Bib Pullover, Lavender/Pink, 2 Pack (Discontinued by Manufacturer)","asin":"B004K6LNRY","price":"$13.33","stars":"1.5","reviews":["If your baby is not pin headed, these things are useless.  Our 9 month old couldn't get her head in the neck hole of these, and she's well below 50th percentile in head circumference for her age.  Baffled why these are labelled for 12-24 month olds.","I had ordered these because I had 2 in the pink that I loved. However, these came with smaller head holes. I can't even get it over my 16 month old's head! And she does not have a big head (17 inches-she's in the 5 percentile for her head circumference)! I washed and tried to stretch them out, with no luck.  I don't understand how the same product from the same company, just a different color can be so different! This is true of all other colors too. The first 2 I bought in pink approximately 4 months ago are awesome. But all the other colors I received now are worthless if I can't get them over her head.","These bibs don't fit over my 20-month-old daughter's head, so we can't use them.  We have lots of other bibs by green sprouts.  I'd recommend the ones that velcro in the back, rather than this pull-over kind","These bibs do not fit over the average 12-month-year-old's head.  I had to rip the seam to fit over my son's head.  I called the company and they replaced the item with one of their velcro bibs.  However, I had purchased the pull-over style for a reason and will have to keep looking.","These bibs are adorable but absolutely not big enough to go over my 6 month old baby's head.  Had to cut notches in both sides and still really difficult to get on and off.  Donated to our daycare for small headed babies.","I saw the other reviews, but assumed since my daugther is petite and only 9 months that the bibs would fit over her head.  Nope!  They are way too tight and don't have enough stretch.  I stopped using them after a week.","These are NOT PULLOVER bibs as it says in the headline! Read further it does say they are Velcro. I missed this in the description and was very disappointed when I received these in the mail. The only reason I am keeping them is because they are nice and large for when my daughter gets older.","I can't say I wasn't warned about the size of the neck holes on these bibs, as most of the other reviews had mentioned that. I got these anyway since I liked the idea of a pullover nylon bib, and they also look cute. I didn't think the neck size would be an issue for me since my 15 month-old has a little head (15th percentile). But alas, I could not get these bibs over her head. They fit okay now that I've cut slits in the cotton neck lining, but I don't think this would work for babies with larger heads. Also the white cotton neck lining has gotten stains from the very first use -- something I wanted to avoid by going with a nylon bib. That said, I do like the softness of the fabric. The bibs also wash well and seem to fit the body better than other nylon bibs that are even just a little more stiff (e.g., Bumkins). Really not a bad bib aside from the neck issue. But it really is an issue that the manufacturer should address!","The previous review about the neck size is very accurate. The hole for their head is waaaayyyy too small and my little one just turned 12 months last week and she's tiny! Disappointed but product is cute otherwise. Sad to have to cut slits in something that's brand new!","Cute, nice fabric but neck hole way too small for my 12 month old!!  My babysitter had to cut notches to make it go over his head!"],"images":{}},{"name":"Baby Fanatic Dozer - Tangerine","asin":"B00JCAAH8Y","price":"$12.47$25.60$5.99$12.98$6.95$58.87$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["Worked OK when it worked.  I only used it 4 times when it stopped working after a week.  I had to change batteries 3 times in 4 uses.  Maybe I used it wrong, but I was not very impressed once I got it.","If the company stood by there product and used better materials this would be a five star product. This is an awesome product however the build quality is poor and the customer service is nonexistent. The arm that rotates to make it work is made of lowgade plastic and gave out after less than four months. I contacted the company and have received  no response. It eats batteries so if you get it get the cord; wasn't available when I bought mine.<br/><br/>Update<br/>The company finally responded and replaced the dozer","This was such a let down.  I was so excited when I saw this - I thought, FINALLY, I can stop rocking my baby while out to eat, etc.  Nope.  This is awful.  When it works, it barely moves the car seat - and it's jerky and not fluid at all.  Also, half the time I put it under the seat, the weight of the baby and the seat I guess are too much for the weak motor and it won't even work.  I have to pull it out far enough to where it barely moves the seat to get it to work.  I wish someone would come up with something like this that works.  Sadly this isn't it.  Save your money.","Simple and easy to setup/use. After experimenting for a couple minutes with placement, I eventually found the contact point that generated a smooth rocking motion. Marked the spot with a pen and now we're rocking. White noise is hardly noticeable when out in public.","<div id=\"video-block-R46ML61UKWC8H\" class=\"a-section a-spacing-small a-spacing-top-mini video-block\"/><input type=\"hidden\" name=\"\" value=\"http://ecx.images-amazon.com/images/I/91Qy%2B3qXsvS.mp4\" class=\"video-url\">\n  <input type=\"hidden\" name=\"\" value=\"http://ecx.images-amazon.com/images/I/A1jd9r2rm4S.png\" class=\"video-slate-img-url\">This is a great idea with extremely poor execution. First, it advertises white noise. In reality, there is no such thing, rather there is a whining cadence rhythm caused by a straining tiny motor with a gear box put under a load it cannot handle, and accordingly, the sound is akin to a Transformer Robot death march. No joke, pick any transformer movie battle scene and try to get your baby to sleep using that as white noise, this is the same thing minus the machine gun fire.<br/><br/>In terms of the actual motion this product generates, I would describe it as agitating at best; it is extremely jerky and less than soothing. You might have better luck strapping your baby to the leg of a border collie playing fetch.  All in all, this is the fastest returned product I have ever had from Amazon and the marketing material from this product is a lawyers dream for misrepresentation. I included a video because it was that unimpressive. I also note that the lifting portion of the device slowly migrates so about after five minutes of the robot death march jerking motion/sounds, it will move out of position and be completely useless. Great idea, poor execution.</input>\n</input><div class=\"a-row a-spacing-top-small review-comments\">\n  <div data-reftag=\"cm_cr_getr_d_cmt_opn\" aria-live=\"polite\" data-a-expander-name=\"review_comment_expander\" class=\"a-row a-expander-container a-expander-inline-container\">\n    <a href=\"javascript:void(0)\" data-action=\"a-expander-toggle\" class=\"a-expander-header a-declarative a-expander-inline-header a-link-expander\" data-a-expander-toggle=\"{&quot;allowLinkDefault&quot;:true, &quot;expand_prompt&quot;:&quot;&quot;, &quot;collapse_prompt&quot;:&quot;&quot;}\">\n      <i class=\"a-icon a-icon-expand\"/>\n      <span class=\"a-expander-prompt\">\n        <span class=\"review-comment-total aok-hidden\">0</span>\n        <span class=\"a-size-base\">Comment</span>\n      </span>\n    </a>\n    <span class=\"a-letter-space\"/>\n    <i class=\"a-icon a-icon-text-separator\" aria-label=\"|\">\n      <span class=\"a-icon-alt\">|</span>\n    </i>\n    <span class=\"a-letter-space\"/>\n    <span class=\"a-size-base cr-vote\">\n      <span class=\"cr-vote-buttons\">\n        <span class=\"a-color-secondary\"><span class=\"review-votes\">\n          2 people found this helpful.\n        </span>\n      Was this review helpful to you?</span>\n        <span class=\"a-letter-space\"/>\n        <span class=\"a-button a-button-beside-text a-button-small cr-vote-button cr-vote-yes\">\n          <span class=\"a-button-inner\">\n            <a href=\"https://www.amazon.com/ap/signin?openid.return_to=https%3A%2F%2Fwww.amazon.com%2FBaby-Fanatic-DOZ501-Dozer-Tangerine%2Fproduct-reviews%2FB00JCAAH8Y%2Fref%3Dcm_cr_getr_d_vote_lft%3Fie%3DUTF8%26voteInstanceId%3DR46ML61UKWC8H%26voteValue%3D1%26csrfT%3DgAMqI5Ph5ZKW%252BMUvPHJ1XCE23PT%252BXgfNFP0%252BtVcAAAAJAAAAAFeYRw5yYXcAAAAA%26sortBy%3Dhelpful=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=usflex=checkid_setup=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0\" class=\"a-button-text\" role=\"button\">Yes</a>\n          </span>\n        </span>\n        <span class=\"a-letter-space\"/>\n        <span class=\"a-button a-button-beside-text a-button-small cr-vote-button cr-vote-no\">\n          <span class=\"a-button-inner\">\n            <a href=\"https://www.amazon.com/ap/signin?openid.return_to=https%3A%2F%2Fwww.amazon.com%2FBaby-Fanatic-DOZ501-Dozer-Tangerine%2Fproduct-reviews%2FB00JCAAH8Y%2Fref%3Dcm_cr_getr_d_vote_rgt%3Fie%3DUTF8%26voteInstanceId%3DR46ML61UKWC8H%26voteValue%3D-1%26csrfT%3DgAMqI5Ph5ZKW%252BMUvPHJ1XCE23PT%252BXgfNFP0%252BtVcAAAAJAAAAAFeYRw5yYXcAAAAA%26sortBy%3Dhelpful=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=usflex=checkid_setup=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0\" class=\"a-button-text\" role=\"button\">No</a>\n          </span>\n        </span>\n      </span>\n    </span>\n    <span>\n      <span class=\"a-letter-space\"/>\n      <span class=\"a-declarative\" data-action=\"cr-popup\" data-cr-popup=\"{&quot;width&quot;:&quot;580&quot;,&quot;title&quot;:&quot;ReportAbuse&quot;,&quot;url&quot;:&quot;/gp/voting/cast/Reviews/2115/R46ML61UKWC8H/Inappropriate/1/ref=cm_cr_getr_d_rvw_hlp?ie=UTF8&amp;target=L3NzL2N1c3RvbWVyLXJldmlld3MvYWpheC9yZXZpZXdzL2dldC9yZWY9Y21fY3JfYXJwX2Rfdmlld3BudF9yZ3Qj3D&amp;token=68B94CFB601564F8EAC360C790A3E5EF67323B27&amp;voteAnchorName=R46ML61UKWC8H.2115.Inappropriate.Reviews&amp;voteSessionID=163-6847787-8369742&amp;type=popup&quot;,&quot;height&quot;:&quot;380&quot;}\">\n        <a class=\"a-size-base a-link-normal a-color-secondary report-abuse-link a-text-normal\" href=\"/gp/voting/cast/Reviews/2115/R46ML61UKWC8H/Inappropriate/1/ref=cm_cr_getr_d_rvw_hlp?ie=UTF8=L3NzL2N1c3RvbWVyLXJldmlld3MvYWpheC9yZXZpZXdzL2dldC9yZWY9Y21fY3JfYXJwX2Rfdmlld3BudF9yZ3Qj3D=68B94CFB601564F8EAC360C790A3E5EF67323B27=R46ML61UKWC8H.2115.Inappropriate.Reviews=163-6847787-8369742=popup\">Report abuse</a>\n      </span>\n    </span>\n    <div aria-expanded=\"false\" class=\"a-expander-content a-spacing-top-base  a-spacing-large a-expander-inline-content a-expander-inner\" style=\"display:none\">\n      <div class=\"a-section a-spacing-base comment-submission\">\n        <span class=\"a-declarative\" data-action=\"reviews:input-comment\" data-reviews:input-comment=\"{}\">\n          <input type=\"hidden\" name=\"csrfT\" value=\"gAMqI5Ph5ZKW+MUvPHJ1XCE23PT+XgfNFP0+tVcAAAAJAAAAAFeYRw5yYXcAAAAA\">\n            <div data-reftag=\"cm_cr_getr_d_cmt_txt\" class=\"a-input-text-wrapper a-spacing-top-mini comment-text-area\">\n              <textarea placeholder=\"Talk about why you like this review, or ask a question.\" rows=\"2\" disabled=\"disabled\" class=\"a-form-disabled\"/>\n            </div>\n          </input>\n          <div class=\"a-row a-spacing-top-small a-grid-vertical-align a-grid-top\">\n            <div class=\"a-column a-span8\">\n              <div class=\"a-box a-alert-inline a-alert-inline-error comment-no-text-error aok-hidden\">\n                <div class=\"a-box-inner a-alert-container\">\n                  <i class=\"a-icon a-icon-alert\"/>\n                  <div class=\"a-alert-content\">Please write at least one word</div>\n                </div>\n              </div>\n              <div class=\"a-box a-alert-inline a-alert-inline-error comment-prs-error aok-hidden\">\n                <div class=\"a-box-inner a-alert-container\">\n                  <i class=\"a-icon a-icon-alert\"/>\n                  <div class=\"a-alert-content\">You must purchase at least one item from Amazon to post a comment</div>\n                </div>\n              </div>\n              <div class=\"a-box a-alert-inline a-alert-inline-error comment-submit-error aok-hidden\">\n                <div class=\"a-box-inner a-alert-container\">\n                  <i class=\"a-icon a-icon-alert\"/>\n                  <div class=\"a-alert-content\">A problem occurred while submitting your comment. Please try again later.</div>\n                </div>\n              </div>\n            </div>\n            <div class=\"a-column a-span4 a-text-right a-span-last\">\n              <span class=\"a-button submit-comment-button sign-in\">\n                <span class=\"a-button-inner\">\n                  <a href=\"https://www.amazon.com/ap/signin?openid.return_to=https%3A%2F%2Fwww.amazon.com%2FBaby-Fanatic-DOZ501-Dozer-Tangerine%2Fproduct-reviews%2FB00JCAAH8Y%2Fref%3Dcm_cr_getr_d_cmt_btn%3Fie%3DUTF8%26expandedComment%3DR46ML61UKWC8H%26openCommentSubmission%3Dfalse%26sortBy%3Dhelpful=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select=usflex=checkid_setup=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0\" class=\"a-button-text\" role=\"button\">Sign in and comment</a>\n                </span>\n              </span>\n            </div>\n          </div>\n        </span>\n        <div class=\"a-row a-spacing-mini review-comments-header aok-hidden\"><ul class=\"a-viewoptions-list a-viewoptions-section a-span12\">\n    <div class=\"a-row a-spacing-none a-grid-vertical-align a-grid-center\"><div class=\"a-column a-span6\"><span class=\"a-size-base a-viewoptions-list-label\">Showing <span class=\"review-comment-count\">0</span> of <span class=\"review-comment-total\">0</span> comments</span></div><div class=\"a-column a-span6 a-text-right a-span-last\"><span class=\"a-size-base a-viewoptions-list-label\">Sort by:<span class=\"a-letter-space\"/></span><span class=\"a-declarative\" data-action=\"reviews:sort-comments\" data-reviews:sort-comments=\"{}\"><li class=\"sort-newest a-viewoptions-list-item a-selected a-color-state\">\n            <a data-reftag=\"cm_cr_getr_d_cmt_lft\" class=\"a-link-normal a-selected a-color-state\" href=\"#\">Newest</a></li>\n          <li class=\"sort-oldest a-viewoptions-list-item\">\n            <a data-reftag=\"cm_cr_getr_d_cmt_rgt\" class=\"a-link-normal\" href=\"#\">Oldest</a></li>\n        </span></div></div></ul>\n</div>\n        <div class=\"a-section a-spacing-extra-large a-spacing-top-medium a-text-center comment-load-error aok-hidden\">\n          <div class=\"a-box a-alert a-alert-error cr-error\">\n            <div class=\"a-box-inner a-alert-container\">\n              <h4 class=\"a-alert-heading\">There was a problem loading comments right now. Please try again later.</h4>\n              <i class=\"a-icon a-icon-alert\"/>\n              <div class=\"a-alert-content\"/>\n            </div>\n          </div>\n        </div>\n        <div class=\"a-section a-spacing-none review-comments\"/>\n        <div class=\"a-spinner-wrapper comment-loading aok-hidden a-spacing-top-medium a-spacing-extra-large\">\n          <span class=\"a-spinner a-spinner-medium\"/>\n        </div>\n        <hr class=\"a-spacing-none a-spacing-top-large a-divider-normal\"/>\n      </div>\n    </div>\n  </div>\n</div>","I gave it an extra star just because someone saw a need for something like this. As a space-challenged NYC apartment dweller I do my best not to clutter what square footage we have so I was excited to see that I might still be able to gently rock our baby girl to sleep without buying a whole new chair. If the Dozer had worked even half as well as I had hoped, I'd have given it high marks...<br/><br/>It did not.<br/><br/>First, the thing is WAY too noisy. Is that what the package is selling as \"soothing white noise\"? If anything \"soothing\" is coming from this thing it's completely drowned out by the grinding, repetative motor-noise. Really annoying.<br/><br/>Second, We had hoped for a smoother, more pronounced rocking motion but it didn't deliver. The rocking motion is jerky and just made our baby cry louder...which thankfully drowned out the noise of the Dozer.<br/><br/>We might have another kid so we'll be happy to try out the next version, but this one is going back.","Purchased two... first one came used and broken. Returned. Then we purchased again and it didn't work at all. It didn't rock the carseat... it more like jolted it and it sounds terrible. We were super excited about this and so the disappointment was big :(","In anticipation of having to travel soon with my 4 month old who almost only naps in her swing, and unable to bring swing, I read a lot of \" rave reviews\" of this product on many mommy blog websites, thinking it would solve my problems. In fairness, they all did clearly say that the product had been given to them for review, and were all pretty positive (big surprise). But I figured with Prime and Free Returns, it was worth a try.  Arrived just in time to try for a nap, so put kiddo in car seat and set it up. To say the motion was jerky and inconsistent would be charitable. For something that is supposed to replace your foot or hand rocking carseat back and forth, it did not mimic that motion AT ALL. And the noise! It is supposed to be a \"white noise\" to soothe baby, but really, it just sounds like an old engine trying to turn over while scraping fingernails on a chalkboard. Thank goodness for Free Returns...","Pros: battery power lasted for up to two weeks, stabilizing hook kept the car seat from moving all over the place, and ac input saved battery power when not going out.<br/><br/>Cons: the noise the rocker would make was annoying to us, but it helped put baby to sleep, so that's  probably a pro; when using the ac  adapter, the rocker would go at Super sonic speeds and there was no way to adjust the speed,  so we used quite a bit of batteries and then we finally bought rechargeable  batteries and had no problem.<br/><br/>All in all ,this is a great product and I would highly recommend it to anyone. If you have your baby in a car seat, always monitor them to make sure they are in the correct reclined position to breathe properly.","I really wanted to like this product. I've been thinking about buying it since my 2 year old was an infant. I decided to try it for my newborn, but the other bad reviews are right. It's a great idea but a bad design. At best, if you find just the right placement under the car seat, you get a small, jerky motion, but in most of the places I tried to put the dozer, it gradually fell out of position and stopped rocking or there was no motion due to the weight of the car seat (I have a 7lb car seat and a 10 lb. 1 month old baby). When I first turned it on I didn't think the noise was that bad, but after a few minutes it gets really irritating. I use a white noise machine to help my babe sleep but even that didn't drown out the annoying noise of the dozer. I wish they would figure out a way to improve the design and reduce the noise. I think I'm going to return it."],"images":{"small":"http://ecx.images-amazon.com/images/I/113Wbhc-JpL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/113Wbhc-JpL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/113Wbhc-JpL.jpg"}},{"name":"Rival Microwave Oven 0.7 Cu Ft, White","asin":"B0056HMPNC","price":"$64.34","stars":"2.1","reviews":["I shall begin by saying it's my own fault!  I should have read the reviews others had left before I purchased this metal box of poo!  Despite what other people think of Walmart I HAD defended Walmart.  They offer products priced so that the lower income shopper has a place to purchase goods.  They employ people that may not be employable elsewhere.  HOWEVER it is obvious that of late the quality of customer service has gone in the toilet.<br/><br/>I owned this microwave for about 8 months.  The moisture that accumulates inside of the microwave caused the paint to peel underneath glass turntable which exposed the metal underneath making it unusable.  I called the 800 number on the back of the WALMART product and explained to them what happened.<br/><br/>In their infinite wisdom of how to KEEP a customer happy told me if I did not have the receipt I couldn't get my money back.  I didn't have my receipt and I was NOT looking to get money back.  I simply wanted a replacement.  The young woman was very polite but her message was clear...Sucks to be you.  Oh well.  Bye.<br/><br/>This isn't the first time I have had an issue with Walmart and their customer service.  Have you ever tried to call a Walmart to get an answer to a question?  You might as well call the Chinese embassy.  You MIGHT get a more reliable answer.","This microwave was awesome for the first 6 months.  It was compact and evenly heated our food, although it did require a bit more time due to the low power 700 watts.<br/><br/>After 6 months, it started randomly turning off turning cooking.  We found that we had to slightly lift the door in the area closest to the control buttons in order for it to resume working.  It's really annoying to have to do, but at least it's still somewhat functional.<br/><br/>Another strange occurrence related to the problem with the door, is that the microwave has randomly turned on without warning.  Creepy at best, dangerous at worst.<br/><br/>I contacted Rival directly and because I no longer had my receipt, they would not do anything to help.  You get what you pay for I guess...","This Rival 900w Microwave rusted so bad the door wouldn't shut properly.  Sometimes it wouldn't start and sometimes it would start on its own, and sometimes it would run fine.  It also rusted in the tray track leaving 1\" long HOLES in the bottom.  2 years!!!  Unbelievable.  To think I had a microwave that was about 12 years old and still working, but I ditched it because it \"looked\" old.  Ugh!","had this for a year from Walmart. Investigating offensive odor to observe that the interior coating had melted. after reading other reviews, i am just going toss it...am worried about breathing melted material. i give it one star because this site requires it. i would personally not give it anything!","This unit is a piece of junk!!  We used this less than ten times for quick warm ups.  It suddenly made a large \"crunching\" noise (the gears under the rotating tray completely broke) and the glass plate stopped rotating, never to work again.  It still heats, but the tray won't rotate.  We bought the unit to take to our new home in Florida and simply lost the purchase receipt.  It was six months until we used it for the first time.  Contacted Rival and got a boiler plate response.  I realize it is a cheap unit, but I thought I might get a year or so out of it.....not just a few uses.  Fool me once, shame on you.  Fool me twice, shame on me.  I'm done with any future Rival product.  I have to give this one star to submit this review.  If I could I'd just leave all five blank!","Bought for $45 bucks and should of known!<br/>Fine for around six months but developed rust inside ceiling, side walls and believe it or not, lower OUTER door!<br/>Humidity builds up and if your not cleaning it regularly, The Stench Begins.<br/>I guess the Rival manufactures want you to leave the door open to avoid this issues.????<br/>Stopped using it when it stated arching electricity one time!<br/>Threw it into my recycling pile.<br/>Keep your receipt  buy warranty if you can't afford anything better.<br/>I didn't and bit the bullet.<br/><br/>Control panel is pretty good but overall....Hell Noooo!","Market demands and price determine the quality of items. Same brand have different level of same product within that particular market, with different prices. Also we as costumers buy any products base on our necessity and within our budget limitation.<br/>I moved to new apartment where there wasn't a microwave. So I went wall mart and bought this microwave with cheap price. I goal was to get a cheap and small microwave , where I picked Rival as my first choice.<br/>Advantages:<br/>1.Very Cheap and Light weight.<br/>2. Easy to use and move around.<br/>3. Fits for small apartment and small area in kitchen.<br/>4. Easy to clean<br/><br/>Disadvantages:<br/>1. Its kind of small that big pot doesn't go inside.<br/>2. Not good for big family.<br/>3.Small means -less power and takes time to cook large amount of food.<br/><br/>I know we can get lots better microwave than this in the market today.But the question is -can we afford that or what do we actually needs.<br/>For small family this is the perfect microwave with less money and better quality.","Like another poster here, mine had the bottom of the microwave come apart where the wheels run. That along with the very slow cooking time makes this a poor choice for a microwave. Rival is off my list.","I bought this microwave a month ago.  It is completely useless. Don't waste your time and money, and buy another model.","I bought this exact microwave at walmart for around $45, and although I haven't had any problems with it for the 10 months we have been using it, it just doesn't cook very fast at all which has only been tolerable for us since we really don't use a microwave too often. It seems fairly cheap in build quality, and the glass tray is VERY easy to knock off it's track when putting something in/ taking something out which must be realigned if you want it to rotate to cook evenly. You will also have to double the time to cook something on this microwave as compared to a higher wattage one. And when your food is done it will beep 5 times very loudly no matter if the door is opened or not. This can be good if you want to hear it is done cooking but to me is annoying so I usually stop it before it rings if I can.<br/><br/>It is a great size for a small apartment, it does have a good button layout, the popcorn function works surprisingly well, and it has an easy to read green numbered clock in the dark. With the push of just one of the number buttons it starts cooking that number of minutes which works great since the difference between 1 minute of cook time and 2 minutes isn't too significant (so I suppose it is harder to overcook your food with this microwave which could be considered good if you have that sort of problem often). It has been able to fit everything I needed inside of it, but at times I wished I would have returned it during the return period and got one made a little better with higher wattage."],"images":{"small":"http://ecx.images-amazon.com/images/I/415Gv3bQaeL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/415Gv3bQaeL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/415Gv3bQaeL.jpg"}},{"name":"Vktech Baby Kids Musical Educational Animal Farm Piano Developmental Music Toy","asin":"B00NYKINEI","price":"$7.67","stars":"1.9","reviews":["Product came scratched and the box completely destroyed. The product did still work despite it's condition but was extremely loud. I have asked for a refund but have yet to see it. Would not recommend to anyone.","Got for my granddaughter for her birthday,,,my daughter just called me to tell me she was sure I didn't know but it's a piece of junk!!!  Speaks in an Asian language!!  So disappointed in Amazon and myself for not doing enough research!!!  Do not purchase!!","The toy is plastic, all the buttons and sound works. great fun for my two year old granddaughter. Great size for her to carry around and play with. The packing needs help as mine came in all busted up had to through the box away and wrap without it. I would recommend as it works and she enjoys it.<br/><br/>I did purchase at full asking price at time of purchase and I am providing my honest unbiased opinion based on my own experience.","Piece of junk I actually didn't even open it I just threw it away...  It arrived in a torn and damaged box and just didn't look like something I would want my baby to play with.  Do not buy this item!","Box was destroyed. Not the same brand name,toy was scratched and looked used. Very bad...","really cheep toy, do not like the quality at all. It was shipped from China which i did not know it was coming from there, i would have never pruchased it. We have better quality of these in stores around town. will always make sure next time where it is coming from.<br/>i just hope the color on it, is not toxic paint","This item took weeks to arrive from China and when it finally arrived, the box was destroyed. Aside from the poor packaging, the toy itself feels very cheap. I'm not giving this toy to my child because I'm worried the tiny pieces will come off. When we added this toy to the registry, we didn't realize it was NOT from the U.S. It's not even worth the trouble to send it back, we'll most likely donate this toy. Batteries NOT included.","Toy was cheaply made and not to mention the sound was horrible. Threw it in the garbage, disappointed that Amazon would even sell junk like this.","only lights up, doesn't make any sounds.","the box was completely destroyed and was from a totally different company. it looks like its been used already. not impressed at all. will never recommend to anyone."],"images":{"small":"http://ecx.images-amazon.com/images/I/51rs5y4UE4L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51rs5y4UE4L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51rs5y4UE4L.jpg"}},{"name":"Rival 6 Speed Blender","asin":"B00G5DRTOG","price":"$19.99","stars":"2.1","reviews":["I bought one of these from Wal-mart and it stopped working after 10 minutes.  I didn't have the receipt so I couldn't take it back.  Thinking that it might have been a fluke that the first blender stopped working so quickly, I went back and bought another one of the same model.  It also stopped working after 10 minutes.  In both instances I was blending up hot peppers I'd grown myself...and so the blender didn't stop working due to being put under stress.  If I could give this a zero star rating I would.  BUY SOME OTHER BLENDER BUT NOT THIS ONE!!","We used this blender in one of our lab experiments at school to test for things like sound level, vibration, and motor temperature. We found that the blender running at full speed for two minutes caused the blade shaft assembly to heat up so much that it melted the surrounding plastic. It seemed to work fine for small jobs but I wouldn't attempt peanut butter or guac. Be careful with this thing!","If you need a cheap, decently-made blender for occasional use, it's hard to go wrong with this model. Nothing fancy, it just blends. A little loud maybe. And a little leaky. But it has a pulse feature aside from the 6 speeds. The blender comes apart for easy dishwasher cleaning. Not sure what all the hoo-hah is from the negative reviews. For our needs -- blending thick potato-leek soup or making a smoothie once in a while, it is fine.<br/><br/>My standards for low-end appliances are not high -- I don't expect them to have anything but a relatively short lifespan. And I refuse to shill out big dollars for a stupid machine. So for 10-15 bucks, any time beyond a year is gravy.<br/><br/>Ergo, this Rival blender fits the bill. Done.","It is loud, but I really don't mind the noise- it is a blender after all...it will be loud! The part that drives me crazy is that it simply doesn't blend!! I like to make fruit smoothies with frozen fruit, water, and stevia (doesn't sound too hard, right?!) but this blender is awful at doing anything. I put so much water in to compensate for the frozen fruit and even that it won't blend even if I leave it going for 5 minutes straight. The only way I can get it to work is if I put lots of water in and constantly stop it and stir. Stop and stir. Sooooooo frustrating (and then it tastes watered down-which is is..)! Save your $17 and put it towards a good blender! Looking at more expensive blenders now because I am FED UP!","This was a gift; yes, I also have the Rival brand toaster oven that I get a lot of use. I love using it for my fruit smoothies. I&#x2019;ve also used it to make cocktails and if you have one or two guests you can easily get two or three drinks&#x2019; worth out of it. First of all, it holds a fair amount of liquid/puree (about a liter). I also appreciate the fact that the container part is shatter-proof. I&#x2019;m one to enjoy the look of glass, but as far as functionality goes I would rather have plastic for something in the kitchen.<br/><br/>Ok, I find the torque is a little limited (I use the standard &#x201C;mix&#x201D; and &#x201C;blend&#x201D; functions most of the time) as when I am using ice cubes, I find that pieces of them remain in the mixture unless I persist a little. Sometimes a piece of banana or fresh pineapple needs a little more action. I&#x2019;ve added my ingredients about two at a time to kind of minimize this unblended chunk problem.  I use the moon-shaped ice cubes which are kind of fragile, more so than block cubes, that grind up faster.<br/><br/>It does get dingy looking (well mine is, anyway-it&#x2019;s white, after all) I have to wash the carafe thoroughly&#x2026;I use an old toothbrush to get into the grooves easily, including the lid.  If and when it does konk out, however, I&#x2019;m probably going to replace it with a black, chrome or red model, as white is so bad to show dirt, especially in an offwhite kitchen!","This blender worked just fine - in fact, the base unit still works fine - but the carafe developed a leak after I took it apart for cleaning, and now it will not hold liquid.  I bought this blender based on price; guess I got what I paid for.","I am not sure why my experience was different. I bought this for $13.47 elsewhere and this blender is great. I use it everyday as I make a smoothie every single morning.  It works like a charm. It is pretty easy to clean (the blade is at the bottom of the plastic pitcher so careful). I have never had a single problem with it, such as leakage or not blending properly.  I put the ice in last and it does blend it (I like my smoothie ice cold). I do notice that the consistency can vary, but my ingredients vary, too. Rarely do I find anything lumpy left in the pitcher. To make sure I don't, I let heavy things sink to the bottom and then \"pulse\" them.<br/><br/>Unfortunately, my roommate dropped the plastic pitcher on the floor. It broke. So I am getting another.  At this price, it is a miracle that it works at all. But it does.","My mother bought one of these from Wal-Mart. Please save your money and don't buy this product. I was trying out one of the recipes in booklet it came along with and it called for 4 ice cubes. I let the ice cubes soften up for about 6 minutes. Guess what? It messed up the blades!! It bent one of them badly and it takes forever to blend and leaves large unchopped chunks that can't be blended any further like tomatoes for example.","This is an far more amazing blender than expected. Makes amazing smoothies!!!! Used to make smoothies at least twice a day for an entire year and it never failed. Sure it's not very powerful device but a few seconds of chopping then liquify for about 2 mins and you have a silky smooth, still chilled smoothie. My way more expensive Nutra Ninja couldn't even completely liquify kale and banana and left my smoothies hot and grainy. Washed every time in the dishwasher and everything maintained it's original quality. Blended hot peppers for menudo sauce perfectly, protein shakes with frozen fruit and sometimes ice and never had an issue. Recently packed up the $100 nutra ninja I received as a bday gift and went back to using this one. Now that should seriously tell you something!","This is one of those products where \"getting (less than) what you pay for\" was never truer. I paid $14.00 and it is worth roughly nothing. All the negative reviews posted here are true, and then some. My favorite part of the blender is when, every 4 or 5 seconds, the machine makes a loud cracking noise as if it has actually come in contact with solid matter - like ice - or a soft bean. It is so startling, I half-way expect the brittle plastic pitcher to break open. I have made two recipes so far, which include a chickpea hummus (fairly soft bean) and a smoothie. I ended up having to mash the hummus with a potato masher after 'blending' it for several minutes and the smoothie required two cups of milk in order to coax the blades to even partly mix some of the ingredients. Apparently, the blade spins so fast for a couple of rotations it creates a fan effect - keeping all the ingredients plastered on the sides of pitcher and nowhere near the blades. Total piece of crap. I have a couple of other Rival products which aren't great but this takes the cake. Made in China. Shame."],"images":{"small":"http://ecx.images-amazon.com/images/I/41W2l8n0WNL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41W2l8n0WNL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41W2l8n0WNL.jpg"}},{"name":"American Red Cross - Rapid Read Ear Thermometer","asin":"B000LZFZT0","price":"$8.42$13.33$3.99$25.40$9.90$5.99$4.99","stars":"1.5","reviews":["When I first bought and used this thermometer, it worked the way it was supposed to work. About 4 months after, I tried to use this again because my 9-mo old baby had a fever, and it first read 96.1F ... then I redo it again thinking maybe I didn't do it correctly, and it then read 90.7F. I KNOW the readings were wrong because my baby was burning up! Reading the instructions again and redoing didn't help. So I had my spouse goto Walgreens (at 11:30p) and picked up a Vicks Pro-Style thermometer for $17 -- at least $10 less than this piece of junk!! btw, the Vicks read 101.3F. If I could give a negative star for this American Red Cross product, I gladly would!","I bought this from Target for about $30 dollars and from the very first use it's always given me inaccurate readings. I don't mean small inaccuracies, it will range from 97.7 one try and then the next may read 100.3. If I repeatedly take my sons temperature 5 times in a row it will be different by whole degrees on every reading. I've tested it angling it at the same direction every time and on an adult ear and it always does the same thing. If I could give this item 0 stars I would. I'm surprised that this product hasn't been taken off the shelves.","The item I received arrived with a coroded battery, the small screw to the battery compartment is difficult to remove and the phillips screwhead strips easily.  Was able to replace the coroded battery, but the item failed entirely a week later. While it was operational, it was difficult to use with a child who was squirming and twisting, but did produce accurate temperature readings quickly. It does not have an automatic on and off feature, and this could contribute to early battery failure if you are not careful to turn it off manually.","When I first bought and used this thermometer, it worked the way it was supposed to work. About 4 months after, I tried to use this again because my 9-mo old baby had a fever, and it first read 96.1F ... then I redo it again thinking maybe I didn't do it correctly, and it then read 90.7F. I KNOW the readings were wrong because my baby was burning up! Reading the instructions again and redoing didn't help. So I had my spouse goto Walgreens (at 11:30p) and picked up a Vicks Pro-Style thermometer for $17 -- at least $10 less than this piece of junk!! btw, the Vicks read 101.3F. If I could give a negative star for this American Red Cross product, I gladly would!","It seemed to work OK at first but quickly became completely unreliable. Variances of 3 or more degrees if you take the temperature twice within minute of each other and neither reading likely to be accurate. Threw it away.","When my daughter was sick, this would give very different readings each time I tried it.  I would take the temperature about 5 times each time just to get an idea.  I wound up buying the Braun Thermoscan for about $40.  It is worth the $ because now I know what her temperature is when ever she is not feeling well and know if she is really sick or not.","This is the most useless thermometer ever. I really can't believe they still sell it, let alone for over $20. What a piece of junk. I have never gotten an accurate reading with it. It said 92.6 when my three year-old definitely did have a fever, and read 101.4 when I tested it on myself and I felt perfectly fine. I threw it in the trash. How could you ever trust it? Going with the Exergen infrared instead. It at least sounds like it's worth the price tag.","I have never imagined that I can have so many complaints over something with only one simple function - give you a temperature reading.<br/><br/>1. Inaccurate. I am felling perfectly fine today, and my 5 reading from this thermometer in 1 minutes goes like this: 99.5, 100.2 102.4 98.5 99.4. Which reading should I believe in? Or should I average it to get my \"accurate\" reading? I still remember having to use this thermometer at 3AM for our baby. Nothing you will want to mess with when you want to know how hot your overheated child is.<br/><br/>2. Non-user friendly. You may think that a thermometer should be easy to use. Not this one. There are two buttons on this machine, one says \"start\" and one has no label. Press the start button and you can... check your old readings! It doesn't matter if it is a long press or a short press, when you press start you don't get started. You have to press the start button and the unlabeled button ( which is meant for \"off\") together to start measuring your temperature. Talk about literate! And exactly how to change between C and F? I forgot. I do not think you will enjoy searching and reading the manual, or memorizing the totally not user friendly interface when you have a overheated kid.<br/><br/>This thermometer probably will suit better for your kid when they want to play the doctor game.","I registered for this when I was expecting.  Luckily, I've only had to use it for 2 illnesses and my son just turned 1, but after using it tonight I came on amazon to find a replacement...<br/><br/>As other reviews have stated, you do get a variety of readings, though I'm sure taking it in the ear just isn't as accuarate as under the tongue (or elsewhere!), as you probably are varying your angle each time.  Overall I found it to give readings all within the same range...100.3, 100.7, etc. (as long as my husband is helping me hold him still!)<br/><br/>My biggest two issues with it are in its flawed design.  First of all, the dang thing doesn't stand up!  It says it does, but it's very top heavy, so unless you carefully place it on a surface, it just falls over.  And even then, you could sneeze and it will topple over anyway.<br/><br/>But more importantly, the digital display does not light up!  Considering I use it the majority of the time in the middle of the night, this would be an awfully handy feature.<br/><br/>Please don't waste your money when there are so many other options out there!","I received this thermometer as a gift when my baby was born. The first time I used it, it said my baby had a temperature of 104.1. I panicked and prepared to rush him to the emergency room. I tried a second reading (in the same ear), and that reading showed 97.9; the third reading was 100.5, followed by 102.7. I then switched to a cheap oral thermometer that cost less than $10, and that one showed a consistent reading of 100.3. I am very disappointed in the poor quality and unreliability of the rapid read ear thermometer. The worst part is, if I hadn't been lucky enough to have a cheap spare thermometer, I would not have known whether my baby actually had a fever, and, if so, how high the fever was. My rapid read ear thermometer is now in the garbage, where it belongs."],"images":{"small":"http://ecx.images-amazon.com/images/I/31RVQHH8MSL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/31RVQHH8MSL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/31RVQHH8MSL.jpg"}},{"name":"Wine Enthusiast EuroCave SoWine Home Wine Bar","asin":"B001F2W65E","price":"$503.42","stars":"2.1","reviews":["I carefully researched the product prior to purchase and was concerned about some of the negative reviews that I read. However, the ability to store AND preserve a couple of open bottles was all too tempting to pass up! I was well aware about the \"condensation\" issues many reviewers complained about. I was NOT prepared for problems a mere 5 months after purchasing the system.<br/><br/>It started with the power cord and charger malfunctioning. There is no means by which to contact Eurocave directly. There is no phone number on their web site. I was not able to get assisstance through the vendor I bought the product from since they are not a distributor. I ended up calling  the Wineenthusiast for help. They were wonderful and fixed the issued by selling me a new charger and power cord.<br/>Now the indicator light on the control panel is flashing red continually and the oxygen vacuum extraction system no longer works. The Wineenthusiast has no solution except for buying another one to replace mine. Another $400 some dollars for a potentially malfunctioning system??? I am still in shock that there is no recourse to address the problem. I DO NOT recommend this product, nor the vendor as they have non-existent customer service.","Bought this for my husband for Christmas and loved it for 10 days until it malfunctioned.  Thus far I have been unsuccessful in my attempts to reach Wine Enthusiast.  I have been left on hold indefinitely and no one has responded to my e-mail.  Customer support has been more disappointing than the actual wine bar itself.  Still stuck with a broken expensive product.","Purchased this item August of '08 from Wine Enthusiast. Worked wonderfully until just after the 12 month warranty expiration then no longer would cool or suction and simply stopped working altogether. I E-mailed Wine Enthusiast in mid-October, received a reply about 3 weeks later. They were nice enough to offer me their apologies and a 25% discount on the purchase of a replacement but I am having second thoughts about investing even that much into a new unit if dependability remains at question. This is not what I had anticipated with all the hype with regard to \"EuroCave\".","This product is great until it stops working. Mine has been repaired twice and still does not work properly. It is evidently a very delicate product that does not stand heavy use. Better buy a regular wine fridge and a manual pump..","Bottom line - Don't buy this!<br/><br/>You can imagine my excitement the day I opened my EuroCave SoWine  wine preserver.  I could now safely store open bottles of both red and white wine in an attractive, boastful mechanical marvel.  The gift was for Christmas 2009 and showed a manufacturing date of 9/2008.  Coming from a small wine shop, I guess that they did not sell a lot of these.<br/><br/>I plugged the unit in per the instructions, and immediately I heard a loud clattering noise and the indicator lights began flashing in error.  I understand how products sometimes are defective, especially when they are imported from faraway locations as France.<br/><br/>It went back to the wine shop in January 2010.  Of course they did not have a replacement on hand, but ordered one for me.  The new one arrived in March 2010, again with a manufacturing date of 9/2008.  They must have made a lot of these back then.<br/><br/>It worked great!  My white wines were chilled to perfection, the reds kept at room temperature.  Three months later the indicator lights started flashing in error again, the vacuum pump refused to turn off and the chiller stopped working.<br/><br/>I went back to the wine shop in June 2010 for another replacement.  This time it took 4 months for the new one to arrive.  As I unpacked it, I noticed the manufacturing date - again 9/2008!!  This one seemed to do the trick, but only lasted 3 months.  The left hand indicator light stays on the white wine setting, the left on the red wine setting.  They both flashed and could not be changed.  It didn't matter as the cooler and warmer didn't work anyway.  The pump continued to run and the sound of the machine was annoying.<br/><br/>When I returned to the wine shop, they were out of business.  I tried contacting the manufacturer in France without success.  There are no service centers in the United States.  The Wine Enthusiast company (The name appearing on the box) are only retailers and offered me a discount on a new one.<br/><br/>I unplugged this piece of crap and now store red wine in it as it does keep it at room temperature - so does my kitchen counter for that matter.<br/><br/>My advice:  If you are thinking about buying this, you would be better purchasing a $334.78 bottle of fine wine, knowing in advance that you will be pissing your money away the next morning.","Bought a brand new Eurocave Sowine chiller and I was so thrilled at first. However my unit was problematic from the start.  It was constantly running at a very high volume and within a day of use, the right side of the chiller completely stopped cooling.  In the next couple of days, the left working side started having a lot of condensation and dripping a lot of water.  The dripping was so excessive, that I actually had to place an absorbent towel under the unit to prevent my entire counter from dripping water. By the 5th day or so, the left working side completely stopped cooling like the right side.  So within a week or so, the entire unit was useless. I would not recommend this item as it is very expensive and it was completely broken in a matter of just a week or so.  Tried to get help from manufacturer but was told that the unit would cost more to repair than the original cost of the unit because all the parts come from France!!! Do Not waste your money of this item.","I bought this item for my husband for Christmas 2008. It works great and extends the life of wine enabling you to have a glass of white or red or preserve two reds. The \"malfunctioning\" of the air seal mentioned is not really a malfunction if you push one of the tops down. It will continue to try to suck the air out of a bottle that's not there. Also, you need to remove the foil at the top of the bottle so it can seal properly. I'm surprised that one customer had a hard time with Wine Enthusiast. I had some questions for them regarding this unit and they were very helpful. Very satisfied with this product.","This is a wonderful product......as long as it works. The final result is the same for all; it stops working after a while and there is no way to replace or repair it. I bought mine on Amazon for $424.00. It was worth it at first, because it really is a good design and a good idea.Unfortunately it stopped working after 2 years in my case. I guess, after reading the other reviews, that I was lucky that it lasted that long.<br/><br/>Bottom line: if you buy this you will like it; but; plan to spend $200+ a year replacing it with another.<br/><br/>It really is a shame that this product is so unreliable because there is nothing else like it. Maybe another more reliable manufacturer will pick up on the idea and make one which will work! Oh well, out to the trash bin.","The device malfunctioned leaving permanent liquid stains on granite counter and eventually the motor just gave out.  Not worth the price given the mechanical problems.  I will not buy from Wine Enthusiast again.  Customer service never returned my call regarding the product while it was still under warranty and never responded to emails when I had additional problems.  Do not recommend buying this product and do not recommend buying items from Wine Enthusiast.","My Sowine wine bar arrived three weeks ago.  Two weeks ago one side stopped cooling.  While I am working on getting a replacement, it is hard to believe that Eurocave makes this product.  It is horribly overpriced for what it does and the poor reliability."],"images":{"small":"http://ecx.images-amazon.com/images/I/41vPkN0QhAL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41vPkN0QhAL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41vPkN0QhAL.jpg"}},{"name":"GE CVM1790SSSS Cafe 1.7 Cu. Ft. Stainless Steel Over-the-Range Microwave - Convection","asin":"B005JA0AII","price":"","stars":"2.1","reviews":["In all seriousness... shame on you GE.<br/>I purchased this microwave a little more than a year ago. And of course it is now out of warrantee. And thus falling apart... LITERALLY!<br/>The \"metal\" handle is not actually metal, it is cheap plastic with metallic-looking tape on it. And the tape is peeling off. When i called GE they said \"it's probably due to the heat from the stove below.\" I told them, \"It's an over-the-range microwave!!! It should not fall apart because of heat.\" To which they replied, \"Sorry. New handle is $100 bucks plus another $100 for someone to come out and install it.\"<br/>I wish I could post a picture of the defective part here but the site doesn't allow me.<br/>After a lifetime of thinking GE was the go-to brand for good quality products... this microwave will be the last GE appliance i ever buy.","I chose this microwave to go along with the GE Cafe range I purchased at the same time. I read multiple poor reviews of this microwave online, but decided to risk it because I wanted the microwave to match the range. Bad choice! After owning the microwave just over a year, the magnetron konked out. Luckily, that particular part was covered under a 5-year warranty, but I still paid nearly $200 for labor. Now, just a couple of years later, the touchpad has expired and will need to be replaced. The service department tells me this repair will be a minimum of $250. (\"Touchpads start at $150.\")<br/><br/>I have never had so many problems with an appliance. The refrigerator I bought at the same time has never required service. The washer and dryer I bought nearly ten years earlier have only once required service. Yet this microwave has required two expensive repairs within just a few years of purchase. Before I bought this GE Cafe microwave, I had a cheap, unremarkable countertop model. I don't even remember the brand. But it was still working when I \"upgraded\" to the GE Cafe, so even though it was nearly 20 years old I was able to pass it on it to a neighbor whose child was starting college. At this point, I wish I'd kept the old one! I will never buy GE Cafe again.","We bought GE Cafe appliances for our remodel and have had nothing but problems.  Out of 4 separate kitchen appliances, 3 have had problems within 2 to 3 years of ownership.  The GE Cafe microwave suddenly stopped heating and we had to have a repairman come replace the magnetron and diode.  It worked a few weeks but stopped working again.  Then we found out it costs more to repair than to buy a new one.  We traced a workaround to the problem ourselves and found that the microwave works as long as we turn on the stove exhaust fan.  So now, every time we use our microwave, you need to turn on the exhaust fan.  Nice!  Numerous other reviews have complained about the keypad burning out as well, so if you buy, make sure to buy a long term multi-year warranty.  Our GE failures happened shortly after the 1 year warranty expired, and parts/labor for most repairs adds up to the purchase of a new appliance.","In Dec 2012 we installed a GE Cafe Microwave model #CVM2072SM2SS in our new kitchen. That microwave lasted 5 1/2 months. The issue with that Cafe microwave was that the touchpad died. We contacted GE via phone to complain and without issue they delivered and installed at no charge the GE Cafe CVM1790SSSS (seen above here). When the second Cafe microwave was installed in mid July 2013, the service men told us we were not the only ones in our neighborhood getting a Cafe replacement that day. Instead of a touchpad this new model has a dial that you turn to program and then press and then press start. As of mid Sept, 2013 the straight part of the handle is peeling from the heat of the stove below. We are beginning to see white plastic rather than what we thought was a stainless steel handle. All very frustrating and irritating. If I could have seen the future of what would happen to the GE Cafe appliances, I never would have purchased them. We also have the matching Cafe range and that has its own negative issues.<br/><br/>Update: April, 2014: The peeling worsened, scraps of it falling into the food on the stove. As of 5 months ago, GE replaced the microwave door. Hoping the handle does not peel the way the most recent one did. We continue to be disappointed with our GE purchases (Cafe Microwave  Cafe Range).","Display didn't light up so unit wasn't usable when it first arrived. GE service was pleasant and resolved after 2nd visit.  A few days later, the light under the microwave stopped working.  2 issues in less than a month doesn't bode well..  Also you can only heat in 15 sec increments when using the time dial.  But the good news...options for preconfigured settings for various items and their cooking times (potato, veg, etc...)  are fairly substantial and works efficiently.  HOWEVER.... I wouldn't recommend installing the microwave above your stove. Since the microwave is faced in stainless steel, the door handle and face of microwave gets extremely hot to the touch while cooking on the stovetop.  Speaking of the stove, I had much better luck with GEs Caf Dual Range Gas stove.  Bought at the same time. No issues. Works great. Highly recommend stove without any hesitation. Absolutely love it!!!!! Wish I felt the same about the microwave.","This microwave fits perfectly with our GE Cafe gas range, which is why we bought it. It's quite heavy - apparently due to the built-in convection oven. Disappointing is the plastic handle, which look like stainless steel, but isn't.  I expect more from an $800 appliance.  Also, if you plan to vent this into the kitchen, make sure you have a cabinet over the microwave that is not more than 13 inches deep.  The microwave vents are on top of the front of the microwave and blow straight up.  Other microwaves have vents that fold open, which is a really cool idea. Again, the GE Cafe falls short here.  Hence, only three stars for now.  I will update this as we use it more.","Received with damages in the back and on the sides. Contacted seller with no response. I needed a microwave so I didn't return the item. It is overpriced, but I was desperate because my old microwave stopped working. I gave it 3 stars because I think this is a refurbished item that shouldn't be claimed as new. Also, the handle is made of plastic, not stainless steel as it appears to be. The Tape (made to look like stainless steel), keeps peeling from the heat of the range, and exposing the plastic more everyday. I have had this microwave for 8 months now, and half of the tape wrapped around the plastic handle is gone. It is functional, but looks really tacky.","I've owned mine for over a year. So far no war entry issues, but if you looking for a unit over-the-range for the exhaust don't go here. I have thru the wall exhaust and had to seal the micro up with duct tape and get an under the micro extension to get the damn thing to suck resonalbly well! Now the cheap finish is coming off the handle. That's the straw that made me post this review. I paid $850 for this piece of s*** to match my oven and refrigiderator.","CVM1790SSSS replaced our old Caf series microwave AT NO COST (within 5 years of purchase) as part of GE's \"Touchpad Replacement Program\"...(Kudos to GE for doing the right thing for that):<br/><br/>Pro's:<br/>-Touchpad completely redesigned (obviously less heat sensitive).<br/>-Inside is stainless vs. enamel like the old one.  That is an obvious upgrade - for sure.<br/>-The goofy tilt open top bar of the old unit is replaced with a fixed plate and top vents.<br/>-Shortcut buttons are more useful for us vs. the old set-up.<br/><br/>Con's (would have given a 5 Star except for):<br/>-Control panel redesign includes a dial.  It is very easy to use, so only a con for being less attractive.<br/>-Handle is plastic covered with metal looking coating vs. real metal like the old unit.  It seems very stout and the GE rep said the peeling was addressed this year, so we are hoping for the best.<br/>-Emblem is now black vs. the original red like all the other pieces in the Caf set (easy fix - below).<br/><br/>*We talked the installers into letting us keep the old emblem - The red emblem is held on by just 1 screw (easily removed).  The red emblem cap (metal) was easily separated from the mount plug with a knife and affixed on-top of the new/black emblem with some gentle adhesive...an easy fix and no damage to the black emblem or stainless fascia.","I would give it one star but I do like the functionality of it. Otherwise, the megatron died after one year exactly, absolutely tired of poor quality appliances. Not a single appliance has been worth its grain and salt. Spending 800.00 just was not good enough, needless to say, never buying another GE product again."],"images":{"small":"http://ecx.images-amazon.com/images/I/312MQcUA18L._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/312MQcUA18L._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/312MQcUA18L.jpg"}},{"name":"Cars 2 Race Car Head Set","asin":"B004URS3H6","price":"$4.07$2.70$14.95$5.00$42.50$2.00","stars":"1.6","reviews":["Terrible product for little ones. A little cheep is ok. I'm not that picky. This was false advertising and I ended up paying about $10 after shipping.  Its literally thin hollow plastic like a birthday novelty hat and has to be put together and doesn't stay together.  No kid wants this. Not like the picture is describing it.  Not worth the money charged.","This is so cheap and put together poorley.  The plastic around the ears is sharp and very uncomfortable.  The head band comes in three pieces that is held together with velcro that doesn't work well.....","The description does not say its plastic at all. You can go to the Disney Store and get a real one for under 12.00.. Very flimsy, not good for small children. The Description needs to be clearer. Not worth the price nor to even have the headset since is cheap plastic. Being a mystery shopper this is very poor","Very underwhelmed by this product.  The velcro that holds it together is strong, but it was not comfortable at all for my son to wear.  He wore it long enough to take a photo, but didn't want it to trick or treat with.","I was unaware that this item was plastic, similar to a plastic party cup. It had to be put together and the only things securing it together is Velcro. I was under the assumption it would be a better quality/ durable plastic.","It arrived quickly but the whole design is so cheap.  I am a little upset I paid almost $10 for this piece of plastic.  I suppose it'll have to do for Halloween  but other than that it won't get much play.  It is a very cheap made headset and the plastic is sharp and does not really have much form to it.","This item is different than it appears in the picture.  It is 4 thin plastic pieces held together by velcro.<br/><br/>The velcro does not hold very well and the item is flimsy at best.<br/><br/>This would be a good buy at $2 or $3, but is very overpriced at the $8 I spent.","Cheap price for a cheaply made product, but it served it's one day purpose.  If you buy this item, be sure to press the velcro pieces together well or you'll be missing pieces, mainly the microphone. The actual head piece probably would've fit better if my son was 7 and not 2-years old.","It gets easily detached. And it is not very safe for  young kids, it is made of plastic and the edges can be very sharp.","If I could give it negative stars I would - please save yourself the time of effort of buying and returning. Worse quality then a happy meal toy!!"],"images":{"small":"http://ecx.images-amazon.com/images/I/517shGkOKKL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/517shGkOKKL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/517shGkOKKL.jpg"}},{"name":"Oster TSSTTV0000 Versatile Countertop Oven (Toaster Oven)","asin":"B004RAUATK","price":"","stars":"2.1","reviews":["Like the last commenter, I bought the Oster TSSTTV0000 a year ago to replace one that we'd had for years. It worked great for about a year; its features suited our needs fine. But yesterday I was baking cookies and the first batch started burning after only three minutes in the oven. I thought I'd lost track of time, so I put in the second batch.  I checked them after about two minutes and those were beginning to burn.  I lowered the temp setting and adjusted the function dial but both upper and lower elements remained bright red.  Bottom line: Whatever regulates the temperature had stopped working; no matter what I set the oven to it baked at the same extremely high temperature. I, also, need to see if replacement is covered under warranty.  Advice: Don't buy this product, and whenever you buy any product keep the receipt and warranty info. with the instruction booklet and store it all in a file of such things so you can access it quickly and easily.  When I make purchases like this I expect the items to last a long time.  In recent years I've found that too many purchases don't live up to this expectation :(","Bought this toaster oven to replace an Oster I had for over five years. After a year it stopped working properly. It began to burn anything I put in it. Even on the lowest setting. I'm working on seeing if it is still under one kind of warranty. :(","Do not buy this oven.  The walls are so thin you will burn yourself if you touch the outside.  We were baking a pie and I just tried to open the door and the handle burned my fingers!  This is getting returned tomorrow!","Osfire: Stay away unless you're looking to collect on insurance as a result of your house burning down. Same issue as other reviewers; there is now only one setting; incinerate. I'm sure Satan was the lead on design and development of this little fireball. Worked well for roughly a year, then decided on its own that we liked everything extra well done. Must be popular with the Cajuns, as it does everything \"blackened\". Smoke is not a good sign in the kitchen, and when you can't even turn the \"burn contents to hell and back\" setting down or off, because the knob has literally melted and is dangling, it's reason for pause..and to keep a fire extinguisher handy. Not at all kidding about the knob. I'm sure I'll get greater satisfaction throwing this disaster into the neighbor's swimming pool than I will exploring any sort of warranty resolution.","Nice size toaster oven - plenty of room inside.  The crumb pan is a great bonus.  Easy to clean.  However, watch out for the handle.  It gets awfully hot during oven use. Additionally, drip pan is very flimsy and the grating does not fit well - it slides off the pan easily.  Watch out if you have food on it!  Also, the dials are extremely hard to read.","For what it's worth, most of these \"brand names\" such as Oster have been bought by large corporations and are only a shadow of their former selves. Don't expect the quality we used to get, as most of these types of products are cheaply made in China. As far as this Oster oven, it was the worst toaster oven purchase I've ever made, solely because it broke down right after the warranty expired. The temperature regulator seems to be the culprit.<br/><br/>I spoke to an \"authorized\" repair center, whose number Oster had given me. The repair man told me he didn't understand why Oster sent me to him since there are NO replacement parts available other than knobs, racks, that sort of thing. So these products are throw away products. He claimed that this was true of other brands as well. To Oster's credit, he said Oster is the easiest to deal with UNDER WARRANTY, as they will allow an exchange, while most other brands require the customer to pay to ship the product in. It's ironic that this, the most expensive toaster oven I have ever purchased hardly lasted a year (1 year warranty) while the cheaper Black and Deckers I've had typically lasted several years.","This oven is too big, the back protrudes about 2 inches setting the oven so far off the backslash that it looks ill fitting. When the door is completely open it hits/rests over the edge of your counterop making cracking the glass a concern.","Looks like I'm not alone, regarding my opinion of this toaster oven.<br/><br/>Ours lasted about 2yrs, and it was the timer that failed...nothing happens after turning the dial.<br/><br/>I simply by-passed the timer by installing an electrical switch, which allows us to continue using it until it's replaced.<br/><br/>I'm afraid our next toaster oven won't be an oster.","Had this oven about a year now  knock wood temp gauge still functioning. I like others bought this to replace an oven that the heating coils failed, miss the old one. Chose this oven because the control dials were very smooth! better than any I've owned, also had a rounded back so cooking small pizza was possible. What I don't like about this model 1. the glass door doesn't have a stop so when you open the door it keeps going, I put a 1 cup metal measuring cup in front to stop the door at 90 degrees. 2. there's a metal strip on top of the glass door that I keep getting burnt by, and believe me that sucker is hot (reason I'm writing this review). 3. it doesn't heat evenly, the back left side of mine is the hot spot. Otherwise it works  the knobs are deliciously smooth!","Was very happy with this toaster oven for about 3 years - it worked great, good settings, I like the size both interior and exterior.  Also attractive.  However, after 3 years the thermostat broke, as acknowledged by other reviewers."],"images":{"small":"http://ecx.images-amazon.com/images/I/51paaHEuJKL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51paaHEuJKL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51paaHEuJKL.jpg"}},{"name":"The Original Microwave Grill - PERFECT MICRO GRILL: Backyard Grilling Quality","asin":"B006C6PY84","price":"$14.99","stars":"2.2","reviews":["Anything between two paper towels in the mircowave does as good if not better.  I thought from the description it would give grill marks........  no chance.  Give it little more time in the microwave?  ... it just drys out the food and overcooks.  I used this product twice and threw it in the garbage.... worthless.","I have bought other \"grill\" pans for the microwave and had great success with them.  This is not one of those.  It was cheaply made and only cooked around the edges.  The rest of the steak was still raw.  Fortunately, it didn't cost much.  Instead of wasting more time and money sending it back, I trashed it.  Do not waste you money on this.","The first time I used the grill the bottom plastic melted! The food was dried out, even my dog did'nt eat it. In my opinion this is a very inferior product. I wasted the price of the grill + shipping and had to throw the grill away after first usage. NOT GOOD!!","Don't spend the money.  A paper plate covered with a paper towel<br/>will do better.  It is very small and cheaply made.","It didn't brown the meat.  I was very unhappy with this product.  I would not recommend it to anyone. A waste of money.","This item did not measure up to description.  Food never tasted grilled. Item was returned for refund. Do not order","a complete waste of money would never buy again would not recommend you to buy it  it does not work as stated","Take a look at a very similar product: Ronco ST8000WHGEN Showtime GrillWave Microwave Griller. This one has very bad reviews also. I wanted one so bad, but after doing my research, I think that I will pass","As a person who loves to cook everything from a chicken breast and pork chop to hamburgers for a quick dinner, this is the greatest thing. Food is thoroughly cooked in 5 minutes in most cases. I do recommend you use Pam to spray under the panels and the panels themselves for easy cleaning.","Biggest waste of money---------EVERl!!!  ---Bought  one for each of my girls--  not even worth the postage to return...... Thoroughly disgusted !!!!t."],"images":{"small":"http://ecx.images-amazon.com/images/I/51cEu1xJDaL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51cEu1xJDaL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51cEu1xJDaL.jpg"}},{"name":"Tommee Tippee Closer to Nature Pacifier Holders, 2 Count (Colors May Vary)","asin":"B00I0M8QU6","price":"$11.22$7.67$12.47$25.60$5.99$12.98$6.95$58.87$19.95$8.64$41.98$13.50$14.24$12.88$15.80 - $20.00","stars":"1.9","reviews":["The picture shows blue and gray clips. I received bright pink clips. Please allow people to choose the colors.","I assumed I would receive pink clips as shown in the image. It's my fault for assuming, and not reading reviews, or in the description. I received the most boyish clips ever w little trucks. They are fine, but I'd rather the image as shown. Or at least the option to choose.","I bought these for my baby because I wanted the matching brand to the pacifiers. Well... Long story short I don't use them.  The clip is huge and it clips on the close on the same side where the pacifier string is. It's hard to clip it on and it's hard to take it off. I went to Walmart and got the lil cheap simple clips and they work great. Don't waist your money on this one.","Yes, it is my mistake for not reading more carefully. It said colors may vary, but it should at least be for a boy or a girl. Colors don't matter, but I really do not want tractors for the twin girls. It should at least be broken down to what gender you would like your random colors from.","These do not clip - they slide...and thus my baby can pull them right off, which defeats the purpose. Next time I will get one that actually clips.","As others said, what you see is definitely not what you get. You see blue and/or gray then get some sort of purple and pink butterfly explosion.","They are nice; however, I would say they are a bit too large to put on my newborn but will use them in the future.","The holders shown are not the ones I received. I got a green and orange one with animals on it. Not thrilled that I didn't get what was shown. Those are the ones I thought I paid for.","A little hard to use.","I really would like to place an order but I won't order this product without being able to choose which color I want."],"images":{"small":"http://ecx.images-amazon.com/images/I/51YQ1T61BPL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/51YQ1T61BPL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/51YQ1T61BPL.jpg"}},{"name":"Schrade SCKIT2 Advant-Edge Knife Sharpening System","asin":"B003DTEFTC","price":"$38.20","stars":"2.2","reviews":["The idea is good, but the execution is poor.  The main screw upon which the clamp pivots was nearly impossible to turn on my copy.  As a result, the knife does not clamp well.  The thumbscrew clamp also is hard to turn.  The angles are unmarked and the actual angle depends on how far out the knife blade sticks from the clamp.  The clamp is not deep, so for large knives it is hard to position the blade consistently.  Overall, I was pretty disappointed.","<a class=\"a-link-normal\" href=\"/Schrade-SCKIT2-Advant-Edge-Knife-Sharpening-System/dp/B003DTEFTC/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Schrade SCKIT2 Advant-Edge Knife Sharpening System</a><br/><br/>I was at first impressed by this KIT. Instead of the usual jumble of parts  pieces, in a useless blister pac, it come in a very useful, Practicle roll up case.<br/>Then the disapointment started.<br/>The \"Special Schrade Oil\" Bottle was empty. Looks like there never was any oil in the bottle.<br/>The KIT totally lacked any instructions as to how to use the sharpener. There was a paper on how to assemble it, just not how to use it! I went to the schrade web site and found a video about it.<br/>I spent over an hour trying to sharpen my Schrade Lockback knife.<br/>The Clamp is very poor design and very poorly contructed.<br/>the Clamp will not adjust, because the adjusting screws are stripped out at the factory! Forget using this on very big knives, it just will not hold a knife bigger than 3-4 inches.<br/>Schrade should take this OFF the market and take their name OFF the product!<br/>I sent this KIT back and got a refund.","I had no illusions I could get an Edge Pro system for 1/5 the price.  But I thought I could get a functional knife sharpening system.  Ultimately I had to return this system because I couldn't get it to sharpen knives.<br/><br/>For a medium size pocket knife blade (2.5\" long x 1\" wide,) I could not see a way to adjust the machine so the stone would hit the blade edge before it would drag on the top of the clamp. (Unless I set the machine to sharpen at a ridiculously high angle.) For a larger knife such as an 8\" chef's, the machine is so small that the sharpening angle changes significantly at each end of the knife.<br/><br/>I didn't see anything particularly cheap about the construction given the price.  Actually, the rods are nicely made polished steel and the clamp is aluminum.  The choice of stones is a bit perplexing... 70, 120, 600, and 1000 grit.  The jump from the 120 to 600 stones is pretty big, and I wouldn't expect to use a 70.","While it can be a valuable addition to your sharpening tool collection, you should know going in that it's not really a knife sharpening system. That is, unless your knives are only sharpened on one side.<br/><br/>The Schrade Advant Edge knife sharpening system is a strange hybrid, a cross between a Lansky style clamp system and the Edge Pro sharpening system. The problem is that unlike a Lansky system, you can't turn the knife over to alternate sharpening strokes from each side. It's not like an Edge Pro either, in that the blade can't be moved to keep the blade in the correct position.<br/><br/>Naturally, you can open the clamp to turn the knife over, but since you'll never be able to reposition it precisely enough, you lose most of the advantage of using a sharpening system.<br/><br/>What it IS good for, is truing up the edge grind on a knife. The Schrade system allows for precise edge shaping on one side at a time, and works better than most sharpeners on small or narrow blades. It's just that after doing the preliminary work on the Schrade, you'll be better off if you have another sharpener to use to actually put an edge on the knife.<br/><br/>Unlike other reviewers, I had no problem with the tightening bolts. Just remember, they're designed to hold the blade snugly, not in a vise like grip. Tighten them like a gorilla, and you'll just ruin them.<br/><br/>My set arrived with a full bottle of honing oil included.","I bought this in spite of the previous poor reviews. I'm not disappointed at all. In my experience you'll get more than your moneys worth with this sharpener.  There is a learning curve, but spend some time with it and you'll be producing great bevels and extremely sharp edges.  In my opinion you would have to spend a couple of hundred dollars for an Edge Pro or a Wicked Edge to to get the kind of an edge you can produce on the Schrade.  Both of the aforementioned machines are better designed and better quality but that comes at a pretty steep price. Catch the sharpening videos on you tube and you will learn a lot.  Good luck.....","This is a copy of the Apex EdgePro done on a smaller scale with lousy materials. The principal problem is the stone holding system - stones themselves are glued to cheap plastic and will pop off. The clamps are also cheap plastic and will break. Between thses two facts the system will shortly be useless.","It looks cool, but not as good as a Lansky kit.  The clamp is not engineered well and it is a pain to adjust each time you switch the side you are sharpening, which is often.  It is nice to have a fully variable angle selection, but not worth the reduced usability.  I suggest this<a class=\"a-link-normal\" href=\"/Lansky-3-Hone-Sharpening-System-LKC03/dp/B000B8L6LI/ref=cm_cr_getr_d_rvw_txt?ie=UTF8\">Lansky 3-Hone Sharpening System (LKC03)</a>","this sharpener does infact work. the knife doesnt mount very solid. i had to attach the sharpener to a 2x4 to make it stable enough to use. and you have to remove the knife and remount it to sharpen the other side of the blade. i use this product only for working on very damaged blades before putting it on my lansky.","Well where do I begin to tell y'all how bad this kit is. Don't get me wrong I have older kits from Scharade that work a helluva lot better than this little jewel. This kit is tinny not made to sharpen anything bigger than a nail clipper (a bit of an exaggeration but I wouldn't even trust it to sharpen a nail clipper). I read about the stones coming off the bases if overtightened, I placed special care not to do so, and when I installed the coarse stone on it, I watched it bow out with the slightest of adjustments. Also, there's no info in the kit that says what angle pertain to any marks. Btw that bar with the angle marks didn't fit right at all, the sliding piece not only couldn't be adjusted tight enough to hold the stones without bowing out or without falling out of it, but also, too tight to slide in and out to effortlessly sharpen any knife. Now let's talk about the base... Jesus! Whomever designed this is an idiot, I have a Benchmade pocket knife and this thing tips over easily, the grip on the knife holder is crappy at best and if any tighter it'll scratch your blade. Sure there are things that could be done to prevent all this, but for that I'd buy the slightly more expensive kit and have to do nothing at all but sharpen the hell out of a blade. I could keep going on and on about how bad this kit is, but \"ain't nobody got time fo'dat!!\" So people, trust me on this one... This kit is a PASS!!! Get the AGPtek professional kit works F$@ing great!!","I figured this wouldn't be as good as the Edge Pro but also figured that if it doesn't work well, it's only 40 bux vs the Edge Pro's $2XX+.<br/><br/>I had no issues with build quality, nothing popped off, it came with a bottle of honing oil... I had no real issues, it was able to sharpen my henckels two man kitchen knives to maybe about 80%-85% of factory new edge.<br/><br/>I have to agree with the other comments:<br/><br/>-it's too small, so not real good for large knives, the weight of the knives will tip the sharpener over, also because its small, you have to move large knives so that the proper angles are maintained when sharpening the blade<br/><br/>-if you're not careful, you can push the stone off the blade and over your knife, scratching the sides<br/><br/>-The clamping mechanism works, it's not great, and does not facilitate moving the knife easily, ala Edge Pro, also there is no guide like the Edge Pro so depending on how far out you clamp the blade, the sharpening angle will ever so slightly change<br/><br/>-The guide markings are just guides, there's no indication of where 20 degree or 15 degree is... I had to use the marker trick to figure out how high to set the angle to maintain factory angle<br/><br/>All in all, for the price, it's not bad... for those on a budget, you can get pretty close to factory edge, as long as you're careful, take your time and have a solid understanding of the mechanics of how this works. Personally if I had to do it over again, I'd just spring for the Edge Pro, but that's me cuz I want close to a 95% factory edge..."],"images":{"small":"http://ecx.images-amazon.com/images/I/41Pgmn0KCCL._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/41Pgmn0KCCL._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/41Pgmn0KCCL.jpg"}},{"name":"Avanti WC1500DSS 30-Bottle Wine Chiller with Electronic Display","asin":"B001C5AWR8","price":"$636.24","stars":"2.1","reviews":["The fridge is fine, but NO customer service. The first one leaked freon from the moment it was plugged in. They finally replaced it.... but what a nightmare!  Their people are unhelpful, do not return messages, and give you zero support. When they finally shipped the replacement, I couldn't understand why it was WEEKS late. Finally I tracked it down -- first, they'd shipped it late, second, they hadn't bothered to tell me when it was being shipped, and finally -- I love this part, since it's  a snapshot of the whole process --- even when I got ahold of them, they never told me that it was a special delivery and UPS would hang onto it until I called them and arranged a special delivery. I tried to complain, the service dept wouldn't take my calls, even the President refused to take calls. If you have any choice, don't do business with Avanti -- decent products, terrible service and treatment of customers.<br/><br/>ADDENDUM  So, it's now 3 months since the replacement arrived and this one is going bad too. Apparently the fan is shot. Just not quality products. My advice is spend the extra and buy from one of the better manufacturers.","Buy it, enjoy it, pray it never needs service.  Because if you ever need a part, more than likely, you are going to be flat out of luck.<br/><br/>I have a 35-bottle Avanti cooler that is a few years old.  The thermostat went out on it.  I called Avanti.<br/><br/>Them: That unit has been discontinued.<br/>Me: OK, how do I go about getting a replacement thermostat?<br/>Them: That unit has been discontinued.<br/>Me: Can you recommend an appliance parts store that may have a replacement thermostat?<br/>Them: No.<br/><br/>Hoping that I had just had the bad luck to have drawn a service rep who was having a bad day, I called again later.  Same story.<br/><br/>I spent hours searching the Internet for a replacement part.  No luck there, either.<br/><br/>So, buy it, enjoy it, and pray you never need service.","I enjoy the product, but when it was shipped it was dented and falling apart.  I would have returned it but the box had to be broken to open it and it weighed so much it was unfeasible to put it in my car to take it to the post office.","I purchased this model to replace a trash compactor in my kitchen during a remodel 2 years ago.  When the cooler was first installed, it was kind of loud, but not too bad. Over time the motor has gotten measurably louder.  Now, when it kicks on, it sounds like a garbage disposal.  I've turned it off and am looking to replace it as soon as possible.  I cannot recommend this unit.","Avanti does not support its products after one year and does not even offer service providers who can fix their products after that one year period.  The customer service department is unhelpful and unapologetic.  I found this out after my wine refrigerator broke (about 3 years after I purchased it, it simply shuts off periodically for no apparent reason, which is not good for something you purchase for the sole reason of maintaining a constant temperature) and still have been unable to get it fixed properly.  I would avoid their products.","We bought the wine cooler to replace a trash compactor that we never used. It's not quiet (quite noticable when it's running) but I can live with that.  What annoys me is that when the power goes out (happens a lot in Houston) the cooler resets to factory defaults, ignoring any temperature you set and forgetting other settings like Celcius versus Fahrenhiet.  Since I use it to store red wine this results in the wine being much colder than it should be.  For this reason I cannot recommend this product to anyone serious about red wine.","We ordered and installed this wine chiller six months ago and we are greatly enjoying it.  My only wish is that there was a way to lock the controls.  They are so sensitive, that any random touch can change the settings, and even turn the unit off.  Other than that, it is a great little built in unit.","Update 7/16/2011 - So far we've had no huge issues with this cooler. Still running quieter than our fridge. The light on this unit is bright at night. I think someone mentioned that in a prior review. We're still pleased with this purchase.<br/><br/>This cooler was delivered in perfect condition. I installed this by myself. It was very easy after reading the instructions. We have a 30 year old kitchen and this fit perfectly where the old trash compactor used to be. I have not added the handle yet. I kind of like the flush mount look. The control functions are easy to use. You cannot accidentally change any of the settings by just bumping up against the unit. The controls have a locking feature where you must press and hold 2 buttons for 3 seconds to unlock and either change the temp or turn the interior light on/off. It came with 2 keys for locking the door - very nice/secure feature. The unit runs quiet, much quieter than our fridge. I've only had this for a few days and will update my review again after a few months of use.","This item was purchased ahead of time to make sure it would fit into the cabinet we were having custom built to install it. Just got around to unpack it, well after Amazon one month return policy and the stainless trim is damaged. I am pretty sure that part of the responsibility lies with the carrier, it was not UPS. We will not be able to actually test the cooler until the kitchen is installed. Worse combination ever. Which re-enforces me in my belief that perhaps appliances should be bought locally, even if that implies paying a little premium. Much cheaper than having the problems I am now having. Sad experience which will not be repeated!","I bought this unit because it is just the perfect size to replace my unused kitchen trash compactor.  It is also good looking and it worked OK for more than a year.  But now, after a several years of use, it no longer keeps cool enough.  Lowest attainable temperature is now around 52 degree Fahrenheit, or about 25 degrees below ambient room temperature.  This is maybe 5 degrees above the ideal temperature for serving white wines like  chardonnay or chablis.  Still, its ok if you don't mind shifting your wine to another cooler or refrigerator a couple of hours before serving."],"images":{"small":"http://ecx.images-amazon.com/images/I/419w%2BXzSFML._SL75_.jpg","medium":"http://ecx.images-amazon.com/images/I/419w%2BXzSFML._SL160_.jpg","large":"http://ecx.images-amazon.com/images/I/419w%2BXzSFML.jpg"}}];

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(171);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(18);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMInstrumentation = __webpack_require__(201);
	var ReactInstrumentation = __webpack_require__(9);
	
	var quoteAttributeValueForBrowser = __webpack_require__(241);
	var warning = __webpack_require__(3);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onCreateMarkupForProperty(name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onSetValueForProperty(node, name, value);
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(18);
	var ReactElement = __webpack_require__(11);
	
	var emptyFunction = __webpack_require__(13);
	var traverseAllChildren = __webpack_require__(75);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var ReactComponent = __webpack_require__(58);
	var ReactElement = __webpack_require__(11);
	var ReactPropTypeLocations = __webpack_require__(64);
	var ReactPropTypeLocationNames = __webpack_require__(63);
	var ReactNoopUpdateQueue = __webpack_require__(62);
	
	var emptyObject = __webpack_require__(28);
	var invariant = __webpack_require__(1);
	var keyMirror = __webpack_require__(43);
	var keyOf = __webpack_require__(20);
	var warning = __webpack_require__(3);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(52);
	var ReactDOMIDOperations = __webpack_require__(199);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {}
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(76);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DisabledInputUtils = __webpack_require__(38);
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(12);
	
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(12);
	var Transaction = __webpack_require__(33);
	
	var emptyFunction = __webpack_require__(13);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(182);
	var ChangeEventPlugin = __webpack_require__(184);
	var DefaultEventPluginOrder = __webpack_require__(186);
	var EnterLeaveEventPlugin = __webpack_require__(187);
	var HTMLDOMPropertyConfig = __webpack_require__(189);
	var ReactComponentBrowserEnvironment = __webpack_require__(99);
	var ReactDOMComponent = __webpack_require__(195);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMEmptyComponent = __webpack_require__(196);
	var ReactDOMTreeTraversal = __webpack_require__(207);
	var ReactDOMTextComponent = __webpack_require__(205);
	var ReactDefaultBatchingStrategy = __webpack_require__(103);
	var ReactEventListener = __webpack_require__(209);
	var ReactInjection = __webpack_require__(210);
	var ReactReconcileTransaction = __webpack_require__(214);
	var SVGDOMPropertyConfig = __webpack_require__(219);
	var SelectEventPlugin = __webpack_require__(220);
	var SimpleEventPlugin = __webpack_require__(221);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(203);
	
	var containsNode = __webpack_require__(245);
	var focusNode = __webpack_require__(125);
	var getActiveElement = __webpack_require__(126);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(232);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var DOMLazyTree = __webpack_require__(26);
	var DOMProperty = __webpack_require__(27);
	var ReactBrowserEventEmitter = __webpack_require__(39);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMContainerInfo = __webpack_require__(101);
	var ReactDOMFeatureFlags = __webpack_require__(198);
	var ReactElement = __webpack_require__(11);
	var ReactFeatureFlags = __webpack_require__(106);
	var ReactInstanceMap = __webpack_require__(31);
	var ReactInstrumentation = __webpack_require__(9);
	var ReactMarkupChecksum = __webpack_require__(109);
	var ReactReconciler = __webpack_require__(23);
	var ReactUpdateQueue = __webpack_require__(66);
	var ReactUpdates = __webpack_require__(12);
	
	var emptyObject = __webpack_require__(28);
	var instantiateReactComponent = __webpack_require__(72);
	var invariant = __webpack_require__(1);
	var setInnerHTML = __webpack_require__(42);
	var shouldUpdateReactComponent = __webpack_require__(74);
	var warning = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context);
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by devtools!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    if (false) {
	      // The instance here is TopLevelWrapper so we report mount for its child.
	      ReactInstrumentation.debugTool.onMountRootComponent(componentInstance._renderedComponent._debugID);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(43);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactElement = __webpack_require__(11);
	
	var invariant = __webpack_require__(1);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(11);
	var ReactPropTypeLocationNames = __webpack_require__(63);
	var ReactPropTypesSecret = __webpack_require__(65);
	
	var emptyFunction = __webpack_require__(13);
	var getIteratorFn = __webpack_require__(120);
	var warning = __webpack_require__(3);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(18);
	var Transaction = __webpack_require__(33);
	var ReactInstrumentation = __webpack_require__(9);
	var ReactServerUpdateQueue = __webpack_require__(218);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(112);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	var escapeTextContentForBrowser = __webpack_require__(41);
	var setInnerHTML = __webpack_require__(42);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(13);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 125 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 126 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(193);


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(204);


/***/ },
/* 129 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TAG_NAMES = {
	    HTML: "htmlAttributes",
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script",
	    STYLE: "style"
	};
	
	exports.TAG_NAMES = TAG_NAMES;
	var TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src",
	    INNER_HTML: "innerHTML",
	    CSS_TEXT: "cssText"
	};
	
	exports.TAG_PROPERTIES = TAG_PROPERTIES;
	var REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv"
	};
	exports.REACT_TAG_MAP = REACT_TAG_MAP;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PlainComponent = (function (_React$Component) {
	    _inherits(PlainComponent, _React$Component);
	
	    function PlainComponent() {
	        _classCallCheck(this, PlainComponent);
	
	        _get(Object.getPrototypeOf(PlainComponent.prototype), "constructor", this).apply(this, arguments);
	    }
	
	    _createClass(PlainComponent, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PlainComponent;
	})(_react2["default"].Component);
	
	exports["default"] = PlainComponent;
	module.exports = exports["default"];

/***/ },
/* 131 */
[256, 133, 132],
/* 132 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 133 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 134 */
4,
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbjsLibExecutionEnvironment = __webpack_require__(136);
	
	var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);
	
	var _fbjsLibShallowEqual = __webpack_require__(137);
	
	var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(79);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(80);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(17);
	
	var _InternalPropTypes = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(17);
	
	var _InternalPropTypes = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(88);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(37);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(46);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(21);
	
	var _RouterContext = __webpack_require__(34);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(17);
	
	var _RouterUtils = __webpack_require__(81);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(34);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(44);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(34);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  var withContext = middlewares.map(function (m) {
	    return m.renderRouterContext;
	  }).filter(function (f) {
	    return f;
	  });
	  var withComponent = middlewares.map(function (m) {
	    return m.renderRouteComponent;
	  }).filter(function (f) {
	    return f;
	  });
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(160);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(83);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(24);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(44);
	
	var _makeStateWithLocation = __webpack_require__(84);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(24);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(88);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(83);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(24);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(82);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(46);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(17);
	
	var _RouterUtils = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(44);
	
	var _makeStateWithLocation = __webpack_require__(84);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(24);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(37);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(46);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(7);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(168);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent) {
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    render: function render() {
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { router: this.context.router }));
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(25);
	
	var _PathUtils = __webpack_require__(22);
	
	var _ExecutionEnvironment = __webpack_require__(36);
	
	var _DOMUtils = __webpack_require__(48);
	
	var _DOMStateStorage = __webpack_require__(86);
	
	var _createDOMHistory = __webpack_require__(87);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(25);
	
	var _PathUtils = __webpack_require__(22);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(22);
	
	var _Actions = __webpack_require__(25);
	
	var _createHistory = __webpack_require__(89);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 163 */
[256, 165, 164],
/* 164 */
132,
/* 165 */
133,
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(167);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 167 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 168 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 169 */
14,
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(179).enable();
	  window.Promise = __webpack_require__(178);
	}
	
	__webpack_require__(180);


/***/ },
/* 171 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	var BrowserMutationObserver = global.MutationObserver || global.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(47);
	
	var _Emojione_1F4A = __webpack_require__(177);
	
	var _Emojione_1F4A2 = _interopRequireDefault(_Emojione_1F4A);
	
	__webpack_require__(175);
	
	var _reactHelmet = __webpack_require__(78);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _database = __webpack_require__(92);
	
	var _database2 = _interopRequireDefault(_database);
	
	var _Asin = __webpack_require__(91);
	
	var _Asin2 = _interopRequireDefault(_Asin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import logo from './logo.svg';
	
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'App-header' },
	  _react2.default.createElement(
	    _reactRouter.Link,
	    { to: '/' },
	    _react2.default.createElement('img', { src: _Emojione_1F4A2.default, className: 'App-logo', alt: 'logo' })
	  ),
	  _react2.default.createElement(
	    'h2',
	    null,
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/' },
	      'low-rated things from amazon'
	    )
	  )
	);
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(App).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var meta = {
	        meta: [{ property: 'twitter:card', content: 'summary_large_image' }, { property: 'og:title', content: 'best worst amzn reviews' }, { property: 'og:url', content: 'http://www.amzn.dance' }, { property: 'og:description', content: 'the worst products, reviewed' }, { property: 'og:image', content: 'https://s-media-cache-ak0.pinimg.com/236x/4b/25/a4/4b25a4c9229955532af0e1000be91082.jpg' }]
	      };
	
	      var items = _database2.default.map(function (item, i) {
	        return _react2.default.createElement(_Asin2.default, _extends({ key: i }, item));
	      });
	
	      var children = this.props.children || _react2.default.createElement(
	        'div',
	        { className: 'items' },
	        items
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(_reactHelmet2.default, meta),
	        _ref,
	        children
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _database = __webpack_require__(92);
	
	var _database2 = _interopRequireDefault(_database);
	
	var _Asin = __webpack_require__(91);
	
	var _Asin2 = _interopRequireDefault(_Asin);
	
	var _reactHelmet = __webpack_require__(78);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsinPage = function (_Component) {
	  _inherits(AsinPage, _Component);
	
	  function AsinPage() {
	    _classCallCheck(this, AsinPage);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(AsinPage).apply(this, arguments));
	  }
	
	  _createClass(AsinPage, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // const meta = {
	      //   title: 'Some Meta Title',
	      //   description: 'I am a description, and I can create multiple tags',
	      //   canonical: 'http://example.com/path/to/page',
	      //   meta: {
	      //     charset: 'utf-8',
	      //     name: {
	      //       keywords: this.props.params.asin
	      //     }
	      //   }
	      // };
	
	      // <Helmet
	      //                 htmlAttributes={{"lang": "en", "amp": undefined}} // amp takes no value
	      //                 title="My Title"
	      //                 titleTemplate="MySite.com - %s"
	      //                 defaultTitle="My Default Title"
	      //                 base={{"target": "_blank", "href": "http://mysite.com/"}}
	      //                 meta={[
	      //                     {"name": "description", "content": "Helmet application"},
	      //                     {"property": "og:type", "content": "article"}
	      //                 ]}
	      //                 link={[
	      //                     {"rel": "canonical", "href": "http://mysite.com/example"},
	      //                     {"rel": "apple-touch-icon", "href": "http://mysite.com/img/apple-touch-icon-57x57.png"},
	      //                     {"rel": "apple-touch-icon", "sizes": "72x72", "href": "http://mysite.com/img/apple-touch-icon-72x72.png"}
	      //                 ]}
	      //                 script={[
	      //                   {"src": "http://include.com/pathtojs.js", "type": "text/javascript"},
	      //                   {"type": "application/ld+json", innerHTML: `{ "@context": "http://schema.org" }`}
	      //                 ]}
	      //                 onChangeClientState={(newState) => console.log(newState)}
	      //             />
	
	      var item = _database2.default.find(function (item) {
	        return item.asin === _this2.props.params.asin;
	      });
	
	      var meta = {
	        meta: [{ property: 'og:title', content: item.name }, { property: 'og:url', content: 'http://www.amzn.dance/asin/' + this.props.params.asin }, { property: 'og:description', content: item.reviews[0] }, { property: 'og:image', content: item.images.small }]
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, meta),
	        _react2.default.createElement(_Asin2.default, item)
	      );
	    }
	  }]);
	
	  return AsinPage;
	}(_react.Component);
	
	exports.default = AsinPage;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(127);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(47);
	
	var _App = __webpack_require__(172);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _AsinPage = __webpack_require__(173);
	
	var _AsinPage2 = _interopRequireDefault(_AsinPage);
	
	__webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.ReactDOMServer = __webpack_require__(128);
	window.ReactDOMComponentTree = __webpack_require__(6);
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRouter.Router,
	  { history: _reactRouter.browserHistory },
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '/', component: _App2.default },
	    _react2.default.createElement(_reactRouter.Route, { path: '/asin/:asin', component: _AsinPage2.default })
	  )
	), document.getElementById('root'));

/***/ },
/* 175 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 176 */
175,
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Emojione_1F4A9.b4b64574.svg";

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(93);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(93);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 180 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var focusNode = __webpack_require__(125);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(15);
	var EventPropagators = __webpack_require__(30);
	var ExecutionEnvironment = __webpack_require__(10);
	var FallbackCompositionState = __webpack_require__(188);
	var SyntheticCompositionEvent = __webpack_require__(224);
	var SyntheticInputEvent = __webpack_require__(227);
	
	var keyOf = __webpack_require__(20);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(94);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactInstrumentation = __webpack_require__(9);
	
	var camelizeStyleName = __webpack_require__(244);
	var dangerousStyleValue = __webpack_require__(234);
	var hyphenateStyleName = __webpack_require__(251);
	var memoizeStringOnly = __webpack_require__(255);
	var warning = __webpack_require__(3);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(15);
	var EventPluginHub = __webpack_require__(29);
	var EventPropagators = __webpack_require__(30);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(12);
	var SyntheticEvent = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(71);
	var isEventSupported = __webpack_require__(73);
	var isTextInputElement = __webpack_require__(122);
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var DOMLazyTree = __webpack_require__(26);
	var ExecutionEnvironment = __webpack_require__(10);
	
	var createNodesFromMarkup = __webpack_require__(247);
	var emptyFunction = __webpack_require__(13);
	var invariant = __webpack_require__(1);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(20);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(15);
	var EventPropagators = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(6);
	var SyntheticMouseEvent = __webpack_require__(40);
	
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(18);
	
	var getTextContentAccessor = __webpack_require__(121);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactChildren = __webpack_require__(97);
	var ReactComponent = __webpack_require__(58);
	var ReactPureComponent = __webpack_require__(213);
	var ReactClass = __webpack_require__(98);
	var ReactDOMFactories = __webpack_require__(197);
	var ReactElement = __webpack_require__(11);
	var ReactPropTypes = __webpack_require__(113);
	var ReactVersion = __webpack_require__(67);
	
	var onlyChild = __webpack_require__(240);
	var warning = __webpack_require__(3);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(23);
	
	var instantiateReactComponent = __webpack_require__(72);
	var KeyEscapeUtils = __webpack_require__(56);
	var shouldUpdateReactComponent = __webpack_require__(74);
	var traverseAllChildren = __webpack_require__(75);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(60);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeDevtool) {
	      ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	    }
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // __DEV__ only
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var ReactComponentEnvironment = __webpack_require__(59);
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactElement = __webpack_require__(11);
	var ReactErrorUtils = __webpack_require__(61);
	var ReactInstanceMap = __webpack_require__(31);
	var ReactInstrumentation = __webpack_require__(9);
	var ReactNodeTypes = __webpack_require__(112);
	var ReactPropTypeLocations = __webpack_require__(64);
	var ReactReconciler = __webpack_require__(23);
	
	var checkReactTypeSpec = __webpack_require__(233);
	var emptyObject = __webpack_require__(28);
	var invariant = __webpack_require__(1);
	var shallowEqual = __webpack_require__(77);
	var shouldUpdateReactComponent = __webpack_require__(74);
	var warning = __webpack_require__(3);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function invokeComponentDidMountWithTimer() {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	  publicInstance.componentDidMount();
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	}
	
	function invokeComponentDidUpdateWithTimer(prevProps, prevState, prevContext) {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	  publicInstance.componentDidUpdate(prevProps, prevState, prevContext);
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidMountWithTimer, this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function (component) {
	          return ReactInstrumentation.debugTool.onComponentHasMounted(_this._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	    var instanceOrElement;
	    if (doConstruct) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	      instanceOrElement = new Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	    } else {
	      // This can still be an instance in case of factory components
	      // but we'll count this as time spent rendering as the more common case.
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	      instanceOrElement = Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	    }
	    return instanceOrElement;
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onError();
	        }
	      }
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      inst.componentWillMount();
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	    if (false) {
	      if (child._debugID !== 0 && this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	      }
	    }
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context));
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	      inst.componentWillReceiveProps(nextProps, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          if (this._debugID !== 0) {
	            ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	          }
	        }
	        shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        if (false) {
	          if (this._debugID !== 0) {
	            ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	          }
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidUpdateWithTimer.bind(this, prevProps, prevState, prevContext), this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasUpdated(_this2._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	      if (false) {
	        if (child._debugID !== 0 && this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	        }
	      }
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context));
	
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	    var renderedComponent = inst.render();
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDefaultInjection = __webpack_require__(104);
	var ReactMount = __webpack_require__(110);
	var ReactReconciler = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(12);
	var ReactVersion = __webpack_require__(67);
	
	var findDOMNode = __webpack_require__(235);
	var getHostComponentFromComposite = __webpack_require__(119);
	var renderSubtreeIntoContainer = __webpack_require__(242);
	var warning = __webpack_require__(3);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	module.exports = ReactDOM;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(38);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(181);
	var CSSPropertyOperations = __webpack_require__(183);
	var DOMLazyTree = __webpack_require__(26);
	var DOMNamespaces = __webpack_require__(53);
	var DOMProperty = __webpack_require__(27);
	var DOMPropertyOperations = __webpack_require__(96);
	var EventConstants = __webpack_require__(15);
	var EventPluginHub = __webpack_require__(29);
	var EventPluginRegistry = __webpack_require__(54);
	var ReactBrowserEventEmitter = __webpack_require__(39);
	var ReactComponentBrowserEnvironment = __webpack_require__(99);
	var ReactDOMButton = __webpack_require__(194);
	var ReactDOMComponentFlags = __webpack_require__(100);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMInput = __webpack_require__(200);
	var ReactDOMOption = __webpack_require__(202);
	var ReactDOMSelect = __webpack_require__(102);
	var ReactDOMTextarea = __webpack_require__(206);
	var ReactInstrumentation = __webpack_require__(9);
	var ReactMultiChild = __webpack_require__(211);
	var ReactServerRenderingTransaction = __webpack_require__(114);
	
	var emptyFunction = __webpack_require__(13);
	var escapeTextContentForBrowser = __webpack_require__(41);
	var invariant = __webpack_require__(1);
	var isEventSupported = __webpack_require__(73);
	var keyOf = __webpack_require__(20);
	var shallowEqual = __webpack_require__(77);
	var validateDOMNesting = __webpack_require__(76);
	var warning = __webpack_require__(3);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setContentChildForInstrumentation = emptyFunction;
	if (false) {
	  setContentChildForInstrumentation = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    var contentDebugID = debugID + '#text';
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    this._contentDebugID = contentDebugID;
	    var text = '' + content;
	
	    ReactInstrumentation.debugTool.onSetDisplayName(contentDebugID, '#text');
	    ReactInstrumentation.debugTool.onSetParent(contentDebugID, debugID);
	    ReactInstrumentation.debugTool.onSetText(contentDebugID, text);
	
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = null;
	  this._domID = null;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setContentChildForInstrumentation.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the containing DOM component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasMounted(_this._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var _this2 = this;
	
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasUpdated(_this2._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setContentChildForInstrumentation.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setContentChildForInstrumentation.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._domID = null;
	    this._wrapperState = null;
	
	    if (false) {
	      setContentChildForInstrumentation.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = null;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(11);
	
	var mapObject = __webpack_require__(254);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    var ReactElementValidator = require('./ReactElementValidator');
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(52);
	var ReactDOMComponentTree = __webpack_require__(6);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var DisabledInputUtils = __webpack_require__(38);
	var DOMPropertyOperations = __webpack_require__(96);
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(12);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked !== undefined : props.value !== undefined;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	    if (props.type !== 'submit' && props.type !== 'reset') {
	      node.value = node.value;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDOMDebugTool = require('./ReactDOMDebugTool');
	  debugTool = ReactDOMDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactChildren = __webpack_require__(97);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactDOMSelect = __webpack_require__(102);
	
	var warning = __webpack_require__(3);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var getNodeForCharacterOffset = __webpack_require__(238);
	var getTextContentAccessor = __webpack_require__(121);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(104);
	var ReactServerRendering = __webpack_require__(217);
	var ReactVersion = __webpack_require__(67);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(52);
	var DOMLazyTree = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(9);
	
	var escapeTextContentForBrowser = __webpack_require__(41);
	var invariant = __webpack_require__(1);
	var validateDOMNesting = __webpack_require__(76);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = null;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetText(this._debugID, this._stringText);
	
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	
	        if (false) {
	          ReactInstrumentation.debugTool.onSetText(this._debugID, nextStringText);
	        }
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2),
	    _assign = __webpack_require__(4);
	
	var DisabledInputUtils = __webpack_require__(38);
	var LinkedValueUtils = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(12);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(29);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(124);
	var ExecutionEnvironment = __webpack_require__(10);
	var PooledClass = __webpack_require__(18);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(12);
	
	var getEventTarget = __webpack_require__(71);
	var getUnboundedScrollPosition = __webpack_require__(249);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	var EventPluginHub = __webpack_require__(29);
	var EventPluginUtils = __webpack_require__(55);
	var ReactComponentEnvironment = __webpack_require__(59);
	var ReactClass = __webpack_require__(98);
	var ReactEmptyComponent = __webpack_require__(105);
	var ReactBrowserEventEmitter = __webpack_require__(39);
	var ReactHostComponent = __webpack_require__(107);
	var ReactUpdates = __webpack_require__(12);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactComponentEnvironment = __webpack_require__(59);
	var ReactInstanceMap = __webpack_require__(31);
	var ReactInstrumentation = __webpack_require__(9);
	var ReactMultiChildUpdateTypes = __webpack_require__(111);
	
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactReconciler = __webpack_require__(23);
	var ReactChildReconciler = __webpack_require__(191);
	
	var emptyFunction = __webpack_require__(13);
	var flattenChildren = __webpack_require__(236);
	var invariant = __webpack_require__(1);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setParentForInstrumentation = emptyFunction;
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setParentForInstrumentation = function (child) {
	    if (child._debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetParent(child._debugID, getDebugID(this));
	    }
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          if (false) {
	            setParentForInstrumentation.call(this, child);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactComponent = __webpack_require__(58);
	var ReactNoopUpdateQueue = __webpack_require__(62);
	
	var emptyObject = __webpack_require__(28);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(95);
	var PooledClass = __webpack_require__(18);
	var ReactBrowserEventEmitter = __webpack_require__(39);
	var ReactInputSelection = __webpack_require__(108);
	var ReactInstrumentation = __webpack_require__(9);
	var Transaction = __webpack_require__(33);
	var ReactUpdateQueue = __webpack_require__(66);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(212);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
	    // If owner changes but we have an unchanged function ref, don't update refs
	    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 216 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactDOMContainerInfo = __webpack_require__(101);
	var ReactDefaultBatchingStrategy = __webpack_require__(103);
	var ReactElement = __webpack_require__(11);
	var ReactInstrumentation = __webpack_require__(9);
	var ReactMarkupChecksum = __webpack_require__(109);
	var ReactReconciler = __webpack_require__(23);
	var ReactServerBatchingStrategy = __webpack_require__(216);
	var ReactServerRenderingTransaction = __webpack_require__(114);
	var ReactUpdates = __webpack_require__(12);
	
	var emptyObject = __webpack_require__(28);
	var instantiateReactComponent = __webpack_require__(72);
	var invariant = __webpack_require__(1);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject);
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(66);
	var Transaction = __webpack_require__(33);
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 219 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(15);
	var EventPropagators = __webpack_require__(30);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInputSelection = __webpack_require__(108);
	var SyntheticEvent = __webpack_require__(16);
	
	var getActiveElement = __webpack_require__(126);
	var isTextInputElement = __webpack_require__(122);
	var keyOf = __webpack_require__(20);
	var shallowEqual = __webpack_require__(77);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var EventConstants = __webpack_require__(15);
	var EventListener = __webpack_require__(124);
	var EventPropagators = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(6);
	var SyntheticAnimationEvent = __webpack_require__(222);
	var SyntheticClipboardEvent = __webpack_require__(223);
	var SyntheticEvent = __webpack_require__(16);
	var SyntheticFocusEvent = __webpack_require__(226);
	var SyntheticKeyboardEvent = __webpack_require__(228);
	var SyntheticMouseEvent = __webpack_require__(40);
	var SyntheticDragEvent = __webpack_require__(225);
	var SyntheticTouchEvent = __webpack_require__(229);
	var SyntheticTransitionEvent = __webpack_require__(230);
	var SyntheticUIEvent = __webpack_require__(32);
	var SyntheticWheelEvent = __webpack_require__(231);
	
	var emptyFunction = __webpack_require__(13);
	var getEventCharCode = __webpack_require__(69);
	var invariant = __webpack_require__(1);
	var keyOf = __webpack_require__(20);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  return '.' + inst._rootNodeID;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(40);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(32);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(32);
	
	var getEventCharCode = __webpack_require__(69);
	var getEventKey = __webpack_require__(237);
	var getEventModifierState = __webpack_require__(70);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(32);
	
	var getEventModifierState = __webpack_require__(70);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(40);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 232 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactPropTypeLocationNames = __webpack_require__(63);
	var ReactPropTypesSecret = __webpack_require__(65);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(60);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeDevtool) {
	            ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(94);
	var warning = __webpack_require__(3);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactCurrentOwner = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(6);
	var ReactInstanceMap = __webpack_require__(31);
	
	var getHostComponentFromComposite = __webpack_require__(119);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(3);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(56);
	var traverseAllChildren = __webpack_require__(75);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(60);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeDevtool) {
	        ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	      }
	      process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(69);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 238 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(2);
	
	var ReactElement = __webpack_require__(11);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : _prodInvariant('23') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(41);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(110);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 243 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(243);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(253);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var createArrayFromMixed = __webpack_require__(246);
	var getMarkupWrap = __webpack_require__(248);
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 249 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 250 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(250);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 252 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(252);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 254 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 255 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var isArguments = __webpack_require__(__webpack_module_template_argument_1__);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.be09127b.js
 **/